// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/award.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/briefcase.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/logout.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/file.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/file-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/file-approved.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/file-review.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/images/file-error.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/images/file-incomplete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/images/share.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  max-width: 1300px;
  width: 100%; }

.disabled {
  opacity: 0.6;
  cursor: unset !important; }

.cards-step-2 .body-card {
  color: #6e7889;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 4px; }

.cards-step-2 iframe {
  width: 100%;
  height: 120px;
  border: none;
  background-color: transparent; }

.cards-step-2 .UploadDocs .input-content {
  height: 78px; }
  .cards-step-2 .UploadDocs .input-content input {
    height: 78px; }

.card__generic {
  border-radius: 10px;
  border: 1px solid #929fb0;
  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);
  width: 100%;
  padding: 16px; }

.form-item__input,
.form-item .ant-input {
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid #404859;
  border-radius: 0; }
  .form-item__input::placeholder,
  .form-item .ant-input::placeholder {
    color: #404859;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal; }

.card-upload {
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  padding: 12px 16px;
  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18); }
  .card-upload .link {
    color: #6e7889;
    text-align: right;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline; }
  .card-upload p {
    margin: 10px 0; }

.text-modal {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px !important;
  text-align: left;
  color: #404859 !important; }

.flex-btw {
  display: flex;
  justify-content: space-between; }

.flex-center {
  display: flex;
  justify-content: center; }

.flex-end {
  display: flex;
  justify-content: flex-end; }

.flex-start {
  display: flex;
  justify-content: flex-start; }

.flex-col {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column; }

.mt--10 {
  margin-top: -20px !important; }

.mt-20 {
  margin-top: 20px; }

.mt-25 {
  margin-top: 25px; }

.mt-30 {
  margin-top: 30px; }

.mt-40 {
  margin-top: 40px; }

.mt-50 {
  margin-top: 50px; }

.mt-60 {
  margin-top: 60px; }

.mt-12 {
  margin-top: 12px; }

.mt-6 {
  margin-top: 6px; }

.mt-5 {
  margin-top: 5px; }

.mt-10 {
  margin-top: 10px; }

.mt-15 {
  margin-top: 15px; }

.mb-20 {
  margin-bottom: 20px; }

.mb-25 {
  margin-bottom: 25px; }

.mb-30 {
  margin-bottom: 30px; }

.mb-40 {
  margin-bottom: 40px; }

.mb-50 {
  margin-bottom: 50px; }

.mb-60 {
  margin-bottom: 60px; }

.mb-12 {
  margin-bottom: 12px; }

.mb-6 {
  margin-bottom: 6px; }

.mb-5 {
  margin-bottom: 5px; }

.mb-10 {
  margin-bottom: 10px; }

.mb-15 {
  margin-bottom: 15px; }

.divider-top {
  border-top: 1px solid #afbdcc; }

.input-transparent {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0; }

.input-number {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  background: #fff; }
  .input-number .ant-input-number-input-wrap {
    height: 45px; }
    .input-number .ant-input-number-input-wrap .ant-input-number-input {
      height: 45px; }
  .input-number .ant-input-prefix {
    color: #404859;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400; }
  .input-number input::placeholder {
    color: #929fb0;
    font-family: Inter;
    font-size: 16px;
    font-style: italic;
    font-weight: 400; }

.input-placeholder-bold::placeholder {
  color: #9bbceb;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  line-height: normal; }

.body-placeholder::placeholder {
  color: #929fb0;
  font-family: Inter;
  font-size: 14px;
  font-style: italic;
  font-weight: 600;
  line-height: normal; }

.body-placeholder-w4::placeholder {
  font-weight: 400; }

.fz-14 {
  font-size: 14px; }

.fz-12 {
  font-size: 12px; }

.children {
  padding-bottom: 20px; }

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0-modified | 20110126
   License: none (public domain)
*/
* {
  box-sizing: border-box; }

html,
body,
#root {
  margin: 0;
  height: 100%; }

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline; }

/* make sure to set some focus styles for accessibility */
:focus {
  outline: 0; }

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block; }

body {
  line-height: 1; }

ol,
ul {
  list-style: none; }

blockquote,
q {
  quotes: none; }

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none; }

table {
  border-collapse: collapse;
  border-spacing: 0; }

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -moz-appearance: none; }

input[type="search"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: content-box; }

textarea {
  overflow: auto;
  vertical-align: top;
  resize: vertical; }

/**
   * Correct \`inline-block\` display not defined in IE 6/7/8/9 and Firefox 3.
   */
audio,
canvas,
video {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  max-width: 100%; }

/**
   * Prevent modern browsers from displaying \`audio\` without controls.
   * Remove excess height in iOS 5 devices.
   */
audio:not([controls]) {
  display: none;
  height: 0; }

/**
   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.
   * Known issue: no IE 6 support.
   */
[hidden] {
  display: none; }

/**
   * 1. Correct text resizing oddly in IE 6/7 when body \`font-size\` is set using
   *    \`em\` units.
   * 2. Prevent iOS text size adjust after orientation change, without disabling
   *    user zoom.
   */
html {
  font-size: 100%;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -ms-text-size-adjust: 100%;
  /* 2 */ }

/**
   * Address \`outline\` inconsistency between Chrome and other browsers.
   */
a:focus {
  outline: thin dotted; }

/**
   * Improve readability when focused and also mouse hovered in all browsers.
   */
a:active,
a:hover {
  outline: 0; }

/**
   * 1. Remove border when inside \`a\` element in IE 6/7/8/9 and Firefox 3.
   * 2. Improve image quality when scaled in IE 7.
   */
img {
  border: 0;
  /* 1 */
  -ms-interpolation-mode: bicubic;
  /* 2 */ }

/**
   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.
   */
figure {
  margin: 0; }

/**
   * Correct margin displayed oddly in IE 6/7.
   */
form {
  margin: 0; }

/**
   * Define consistent border, margin, and padding.
   */
fieldset {
  border: 0px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em; }

/**
   * 1. Correct color not being inherited in IE 6/7/8/9.
   * 2. Correct text not wrapping in Firefox 3.
   * 3. Correct alignment displayed oddly in IE 6/7.
   */
legend {
  border: 0;
  /* 1 */
  padding: 0;
  white-space: normal;
  /* 2 */
  *margin-left: -7px;
  /* 3 */ }

/**
   * 1. Correct font size not being inherited in all browsers.
   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,
   *    and Chrome.
   * 3. Improve appearance and consistency in all browsers.
   */
button,
input,
select,
textarea {
  font-size: 100%;
  /* 1 */
  margin: 0;
  /* 2 */
  vertical-align: baseline;
  /* 3 */
  *vertical-align: middle;
  /* 3 */ }

/**
   * Address Firefox 3+ setting \`line-height\` on \`input\` using \`!important\` in
   * the UA stylesheet.
   */
button,
input {
  line-height: normal; }

/**
   * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
   * All other form control elements do not inherit \`text-transform\` values.
   * Correct \`button\` style inheritance in Chrome, Safari 5+, and IE 6+.
   * Correct \`select\` style inheritance in Firefox 4+ and Opera.
   */
button,
select {
  text-transform: none; }

/**
   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
   *    and \`video\` controls.
   * 2. Correct inability to style clickable \`input\` types in iOS.
   * 3. Improve usability and consistency of cursor style between image-type
   *    \`input\` and others.
   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.
   *    Known issue: inner spacing remains in IE 6.
   */
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  /* 2 */
  cursor: pointer;
  /* 3 */
  *overflow: visible;
  /* 4 */ }

/**
   * Re-set default cursor for disabled elements.
   */
button[disabled],
html input[disabled] {
  cursor: default; }

/**
   * 1. Address box sizing set to content-box in IE 8/9.
   * 2. Remove excess padding in IE 8/9.
   * 3. Remove excess padding in IE 7.
   *    Known issue: excess padding remains in IE 6.
   */
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
  *height: 13px;
  /* 3 */
  *width: 13px;
  /* 3 */ }

/**
   * 1. Address \`appearance\` set to \`searchfield\` in Safari 5 and Chrome.
   * 2. Address \`box-sizing\` set to \`border-box\` in Safari 5 and Chrome
   *    (include \`-moz\` to future-proof).
   */
input[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  /* 2 */
  box-sizing: content-box; }

/**
   * Remove inner padding and search cancel button in Safari 5 and Chrome
   * on OS X.
   */
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

/**
   * Remove inner padding and border in Firefox 3+.
   */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0; }

/**
   * 1. Remove default vertical scrollbar in IE 6/7/8/9.
   * 2. Improve readability and alignment in all browsers.
   */
textarea {
  overflow: auto;
  /* 1 */
  vertical-align: top;
  /* 2 */ }

/**
   * Remove most spacing between table cells.
   */
table {
  border-collapse: collapse;
  border-spacing: 0; }

html,
button,
input,
select,
textarea {
  color: #222; }

::selection {
  background: #b3d4fc;
  text-shadow: none; }

img {
  vertical-align: middle; }

fieldset {
  border: 0;
  margin: 0;
  padding: 0; }

textarea {
  resize: vertical; }

.chromeframe {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0; }

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace; }

.h1 {
  color: #404859;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal; }

.h2 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; }
  .h2-w8 {
    font-weight: 800; }

.h3 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 135%; }

.h4 {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%; }
  .h4-cp {
    text-transform: capitalize; }
  .h4-w4 {
    font-weight: 400; }
  .h4-w5 {
    font-weight: 500; }

.title-blue-bold {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #355c7d; }

.body-regular {
  color: #404859;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; }
  .body-regular-italic {
    font-style: italic; }
  .body-regular-up {
    text-transform: uppercase; }
  .body-regular-bold, .body-regular-w6 {
    font-weight: 600; }
  .body-regular-w5 {
    font-weight: 500; }

.placeholder {
  color: #404859;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; }
  .placeholder-w6 {
    font-weight: 600; }

.button-txt-big {
  color: #f5faff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.24px; }

.body-small {
  color: #404859;
  font-family: Inter;
  font-size: 10px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal; }
  .body-small-w4 {
    font-weight: 400; }
  .body-small-w6 {
    font-weight: 600; }
  .body-small-up {
    text-transform: uppercase; }

.small-detail {
  color: #6e7889;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; }

.body-card {
  color: #404859;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; }
  .body-card-bold-line {
    font-weight: 700;
    text-decoration-line: underline; }
  .body-card-w6 {
    font-weight: 600; }
  .body-card-w7 {
    font-weight: 700; }
  .body-card-w5 {
    font-weight: 500; }
  .body-card-REVIEW {
    color: #693B6F !important; }
  .body-card-REQUEST_ERROR {
    color: #712220 !important; }
  .body-card-APPROVED {
    color: #1F4222 !important; }

.blue-bold {
  color: #5e8eb7;
  cursor: pointer;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; }
  .blue-bold img {
    height: 10px;
    margin-left: 5px; }

.bold {
  font-weight: 600;
  color: #2A2F3C !important; }

.bold-little {
  font-weight: 500; }

.fw-400 {
  font-weight: 400; }

.cursor {
  cursor: pointer; }

.text-error-note {
  color: #8F2F2C;
  font-size: 14px;
  font-weight: 600; }
  .text-error-note span {
    color: #C94F4A;
    font-weight: 400; }

.link {
  cursor: pointer; }
  .link-underline {
    text-decoration: underline !important; }

.disabled {
  color: #2A2F3C !important; }
  .disabled div {
    border-color: #AFBDCC !important; }

.button {
  height: 32px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal; }
  .button-empty {
    background-color: transparent;
    padding: 0;
    border: none;
    box-shadow: none; }
    .button-empty span {
      color: #404859 !important;
      font-family: Inter;
      font-size: 10px !important;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
      letter-spacing: 0.2px; }
  .button-modal-ok {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ffc857 !important;
    background: #ffc857 !important;
    height: 40px;
    color: #66564d !important;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.21px; }
  .button-modal-cancel {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ddaa42 !important;
    background: #fff9ee !important;
    height: 40px;
    color: #3c302a !important;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.21px; }
  .button-primary {
    width: 100%;
    height: 48px;
    flex-shrink: 0;
    border-radius: 6px;
    border: 1px solid #162e43;
    background: #162e43;
    border: none; }
    .button-primary:hover {
      border: none;
      color: #f5faff !important;
      background: #162e43 !important; }
  .button-secondary {
    width: 179px;
    border-radius: 6px;
    border: 1px solid #355c7d;
    color: #355c7d; }
    .button-secondary:hover {
      color: #f5faff !important;
      border: 1px solid #355c7d !important;
      background: #162e43 !important; }
  .button-grey {
    color: #6e7889 !important;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.18px;
    border-radius: 6px;
    border: 1px solid #eff3f5 !important;
    background: #eff3f5;
    width: 100%; }
  .button-transparent {
    padding: 0;
    background-color: transparent;
    border: none;
    box-shadow: none;
    color: #48759a; }
    .button-transparent .anticon {
      color: #48759a; }
    .button-transparent:hover {
      color: #48759a !important; }
  .button-gray {
    padding: 0;
    background-color: transparent;
    border: none;
    box-shadow: none;
    border-radius: 6px;
    color: #afbdcc; }
    .button-gray .anticon {
      color: #afbdcc; }
    .button-gray:hover {
      color: #afbdcc !important; }
  .button-card {
    width: 100%;
    color: #000000;
    border: 1px solid #ccd3db; }
    .button-card:hover {
      color: #000000 !important;
      border: 1px solid #ccd3db !important; }
  .button-submit {
    border-radius: 6px;
    border: 1px solid #162E43;
    background: #162E43;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.18px;
    width: 100%; }
    .button-submit:disabled {
      background-color: #EFF3F5 !important;
      border-color: #EFF3F5 !important; }
      .button-submit:disabled span {
        color: #6E7889 !important; }
      .button-submit:disabled:hover {
        background-color: #EFF3F5 !important;
        border-color: #EFF3F5 !important; }
        .button-submit:disabled:hover span {
          color: #6E7889 !important; }
    .button-submit:hover {
      background-color: #EBF6FF !important;
      border: 1px solid #97BCF0 !important;
      box-shadow: 2px 2px 12px 0px #0B131A1A; }
      .button-submit:hover span {
        color: #244560 !important; }
      .button-submit:hover:active {
        border: 1px solid #355C7D !important;
        box-shadow: none; }
    .button-submit-error {
      background-color: #FFD4CF !important;
      border-color: #FFD4CF !important; }
      .button-submit-error b {
        color: #610805 !important; }
      .button-submit-error:hover {
        border-color: #FFD4CF !important;
        background-color: #FFD4CF !important; }
    .button-submit-red-dark {
      background-color: #C13934 !important;
      border-color: #C13934 !important; }
      .button-submit-red-dark:hover {
        border-color: #C13934 !important;
        background-color: #C13934 !important; }
        .button-submit-red-dark:hover span {
          color: white !important; }
    .button-submit-yellow {
      border-radius: 6px;
      background: #FFEDC8 !important;
      border-color: #FFEDC8 !important; }
      .button-submit-yellow:hover {
        background: #FFEDC8 !important;
        border-color: #FFEDC8 !important; }
      .button-submit-yellow:disabled {
        background: #EFF3F5 !important;
        border-color: #EFF3F5 !important; }
      .button-submit-yellow span {
        color: black;
        font-weight: 600; }
  .button-link {
    width: 100%;
    background-color: transparent;
    border: none;
    box-shadow: none;
    font-weight: 400;
    color: #000000; }
    .button-link:hover {
      color: #000000 !important; }
    .button-link-REVIEW {
      color: #161616 !important; }
    .button-link-REQUEST_ERROR {
      color: #8A130F; }
      .button-link-REQUEST_ERROR:hover {
        color: #8A130F !important; }
  .button-link-border {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #162E43 !important;
    background: none;
    color: #3c302a !important;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.21px; }
    .button-link-border:disabled {
      background-color: #EFF3F5 !important;
      border-color: #EFF3F5 !important;
      color: #929FB0 !important; }
  .button-link-blue {
    color: #5E8EB7; }
    .button-link-blue span {
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-decoration-line: underline; }
    .button-link-blue:hover {
      color: #5E8EB7 !important; }
  .button-link-error {
    color: #8A130F;
    border: none; }
    .button-link-error span {
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-decoration-line: underline; }
    .button-link-error:hover {
      color: #8A130F !important; }
  .button-blue {
    color: #5E8EB7 !important; }
    .button-blue span {
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal; }
    .button-blue:hover {
      color: #5E8EB7 !important; }
  .button-open-modal {
    width: 100%; }
    .button-open-modal span {
      font-family: Inter;
      font-weight: 500;
      font-size: 12px;
      line-height: 14.52px; }
    .button-open-modal:disabled {
      background-color: #EFF3F5 !important;
      border-color: #EFF3F5 !important; }
      .button-open-modal:disabled span {
        color: #6E7889 !important;
        font-weight: 600 !important; }
      .button-open-modal:disabled:hover {
        background-color: #EFF3F5 !important;
        border-color: #EFF3F5 !important; }
        .button-open-modal:disabled:hover span {
          color: #6E7889 !important;
          font-weight: 600 !important; }
    .button-open-modal:hover {
      border-color: #ccd3db !important;
      color: #000000 !important; }
    .button-open-modal-INCOMPLETE {
      background-color: #B6DCFC;
      border-color: #48759A;
      color: #122536; }
      .button-open-modal-INCOMPLETE:hover {
        background-color: #48759A !important;
        border-color: #48759A !important;
        color: #F5FAFF !important; }
    .button-open-modal-REVIEW {
      background-color: #EAD6FF;
      border-color: #A278B3; }
      .button-open-modal-REVIEW span {
        color: #241226; }
      .button-open-modal-REVIEW:hover {
        border-color: #AC78B3 !important;
        background-color: #A278B3 !important; }
        .button-open-modal-REVIEW:hover span {
          color: #FAF9FC !important; }
    .button-open-modal-REQUEST_ERROR {
      background-color: #FFC6BF;
      border-color: #8A130F;
      color: #260F0C; }
      .button-open-modal-REQUEST_ERROR:hover {
        border-color: #8A130F !important;
        background-color: #A31C17 !important;
        color: #FCF8F7 !important; }
    .button-open-modal-APPROVED {
      border-color: #3F9545;
      background-color: #C2F0C5;
      color: #241226; }
      .button-open-modal-APPROVED:hover {
        border-color: #3F9545 !important;
        background-color: #3F9545 !important;
        color: #FCF8F7 !important; }
    .button-open-modal-DRAFT {
      background-color: #FFFFFF;
      border-color: #6E7889; }
      .button-open-modal-DRAFT span {
        color: #2A2F3C; }
      .button-open-modal-DRAFT:hover {
        background-color: #404859 !important;
        border-color: #404859 !important; }
        .button-open-modal-DRAFT:hover span {
          color: white !important; }

.select-primary {
  width: 100%;
  height: 40px; }
  .select-primary .ant-select-selector {
    height: 40px !important;
    padding: 2px 11px !important;
    border-radius: 10px !important;
    border: 1px solid #5e8eb7 !important; }
    .select-primary .ant-select-selector .ant-select-selection-search-input {
      height: 40px !important; }

.circle {
  background-color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #2a2f3c;
  display: flex;
  justify-content: center;
  align-items: center; }
  .circle .upload {
    width: auto;
    height: 18px;
    object-fit: cover; }

.circles-tags {
  display: flex;
  align-items: end;
  gap: 10px; }

.circle {
  width: 20px;
  height: 20px; }
  .circle-APPROVED {
    background-color: #C2F0C5;
    border-color: #92c295; }
    .circle-APPROVED:hover {
      background-color: #4CA852; }
  .circle-REVIEW {
    background-color: #AC78B3;
    border-color: #AC78B3; }
    .circle-REVIEW:hover {
      background-color: #855791; }
  .circle-REQUEST_ERROR {
    background-color: #FFD4CF;
    border-color: #c94f4a; }
    .circle-REQUEST_ERROR:hover {
      background-color: #c94f4a; }

.circle-state-tooltip {
  padding: 6px 7px !important;
  opacity: 1 !important; }
  .circle-state-tooltip b {
    font-weight: 600; }
  .circle-state-tooltip span {
    margin-top: 10px; }
  .circle-state-tooltip-APPROVED {
    background-color: #4CA852 !important; }
  .circle-state-tooltip-DRAFT {
    background-color: #404859 !important; }
  .circle-state-tooltip-REQUEST_ERROR {
    background-color: #c94f4a !important; }
  .circle-state-tooltip-REVIEW {
    background-color: #855791 !important; }

.tag-state-blue {
  width: max-content;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  border-radius: 15px;
  border: 2px solid #355C7D;
  color: #355C7D;
  font-size: 10px !important;
  font-weight: 700 !important; }

.state-tag {
  width: max-content;
  border-radius: 76px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px; }
  .state-tag .check {
    margin-right: 2px; }
  .state-tag .tag-name {
    font-weight: 600;
    font-family: Inter;
    line-height: 11px;
    letter-spacing: 0.02em;
    font-size: 10px; }
  .state-tag-APPROVED {
    border-color: #C2F0C5;
    background: #C2F0C5; }
    .state-tag-APPROVED .tag-name {
      color: #404859 !important; }
  .state-tag-REVIEW {
    border-color: #e3ddf0;
    background: #e3ddf0; }
    .state-tag-REVIEW .tag-name {
      color: #161616 !important; }
  .state-tag-REQUEST_ERROR {
    border-color: #FFD4CF;
    background: #FFD4CF; }
    .state-tag-REQUEST_ERROR .tag-name {
      color: #712220 !important; }
  .state-tag-INCOMPLETE {
    border-color: #404859;
    background: #404859; }
    .state-tag-INCOMPLETE .tag-name {
      color: white !important; }
  .state-tag-DRAFT {
    border-color: #EFF3F5;
    background: #EFF3F5; }
    .state-tag-DRAFT .tag-name {
      font-weight: 600;
      color: #2a2f3c !important; }

.card-upload-response {
  border-radius: 10px;
  border: 1px solid #2A2F3C;
  padding: 10px 16px; }
  .card-upload-response .template {
    margin-bottom: 10px; }
    .card-upload-response .template .arrow-right {
      width: 14px;
      margin-left: 5px; }
    .card-upload-response .template button {
      padding: 0; }
  .card-upload-response .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px; }
    .card-upload-response .header .h4 {
      display: flex;
      align-items: center; }
    .card-upload-response .header .link {
      padding: 0;
      color: #6e7889;
      font-size: 12px; }
      .card-upload-response .header .link span {
        text-decoration: underline; }
      .card-upload-response .header .link:hover {
        color: #6e7889; }
  .card-upload-response .description {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 12px; }
    .card-upload-response .description .description-button-link {
      padding-left: 0;
      text-decoration: underline; }
      .card-upload-response .description .description-button-link:hover {
        color: #5e8eb7; }
  .card-upload-response-REVIEW {
    border: 1px solid #AC78B3;
    background-color: #FDFCFF; }
    .card-upload-response-REVIEW .h4 {
      color: #161616 !important; }
    .card-upload-response-REVIEW .description {
      color: #161616 !important; }
    .card-upload-response-REVIEW .link {
      color: #161616 !important; }
  .card-upload-response-APPROVED {
    border: 1px solid #92c295;
    background-color: white; }
    .card-upload-response-APPROVED .h4 {
      color: #404859 !important; }
    .card-upload-response-APPROVED .description {
      color: #404859 !important; }
    .card-upload-response-APPROVED .link {
      color: #404859 !important; }
  .card-upload-response-REQUEST_ERROR {
    border: 1px solid #c94f4a;
    background-color: #FFFFFF; }
    .card-upload-response-REQUEST_ERROR .h4 {
      color: #404859 !important; }
    .card-upload-response-REQUEST_ERROR .description {
      color: #404859 !important; }
    .card-upload-response-REQUEST_ERROR .link {
      color: #404859 !important; }

.DrodownBlue {
  height: 20px;
  padding: 1px 3px !important;
  display: flex;
  align-items: center; }
  .DrodownBlue:hover {
    background-color: #5E8EB7 !important;
    color: white !important; }
    .DrodownBlue:hover span {
      text-decoration-line: none !important; }
  .DrodownBlue:disabled {
    background-color: white !important;
    color: #6E7889 !important; }
    .DrodownBlue:disabled span {
      text-decoration-line: underline !important; }
  .DrodownBlue-blue {
    border: 1px solid #9BBCEB;
    border-radius: 5px; }
    .DrodownBlue-blue .ant-dropdown-menu {
      padding: 0px; }
    .DrodownBlue-blue .ant-dropdown-menu-item:hover {
      background-color: #EBF6FF !important; }
      .DrodownBlue-blue .ant-dropdown-menu-item:hover .ant-dropdown-menu-title-content {
        color: #355c7d;
        font-weight: 600; }
    .DrodownBlue-blue .ant-dropdown-menu-title-content {
      color: #5E8EB7;
      font-weight: 400; }
      .DrodownBlue-blue .ant-dropdown-menu-title-content:hover {
        color: #355c7d;
        font-weight: 600; }

.error-box {
  width: 100%;
  height: 53px;
  top: 615px;
  left: 126px;
  border-width: 1px;
  border-radius: 6px;
  border: 1px solid #C13934;
  background: #FCF8F7;
  padding: 15px 0 15px 0; }
  .error-box span {
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 145%;
    padding: 15px  24px 15px 16px;
    color: #610805; }
  .error-box img {
    padding-left: 22px; }

.Layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; }
  .Layout .content {
    width: 100%; }
  .Layout .BarLogin {
    padding: 16px;
    background-color: #eff3f5;
    width: 64px;
    height: 100vh;
    border-right: 1px solid #dfe4eb; }
    .Layout .BarLogin .logo {
      width: 32px; }

.BarDashboard-space {
  width: 64px;
  height: calc(100vh - 56px); }

.BarDashboard {
  padding: 0px 0px;
  background-color: #eff3f5;
  width: 64px;
  height: calc(100vh - 56px);
  border-right: 1px solid #dfe4eb;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: fixed;
  top: 56px;
  left: 0; }
  .BarDashboard .box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 33%; }
    .BarDashboard .box .notification {
      position: relative;
      max-width: 30px;
      margin-top: 20px; }
      .BarDashboard .box .notification .number-ammoint {
        position: absolute;
        width: 15.467px;
        height: 15.469px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #355c7d;
        right: -3px;
        top: -5px;
        border-radius: 50%; }
        .BarDashboard .box .notification .number-ammoint span {
          color: #f9fafb;
          text-align: center;
          font-family: Inter;
          font-size: 10px;
          font-style: normal;
          font-weight: 600;
          line-height: 10px; }
    .BarDashboard .box .link {
      width: 100%;
      text-decoration: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center; }
      .BarDashboard .box .link span {
        color: #929fb0;
        font-size: 10px;
        font-weight: 500;
        line-height: 115%; }
      .BarDashboard .box .link .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%; }
        .BarDashboard .box .link .avatar span {
          font-size: 12px;
          font-weight: 500; }
        .BarDashboard .box .link .avatar-blue {
          background-color: #B6DCFC;
          border-color: #7FADD4; }
          .BarDashboard .box .link .avatar-blue span {
            color: #244560; }
          .BarDashboard .box .link .avatar-blue:hover {
            background-color: #97BCF0;
            border-color: #5E8EB7; }
            .BarDashboard .box .link .avatar-blue:hover span {
              color: #122536; }
        .BarDashboard .box .link .avatar-yellow {
          background-color: #FFC857;
          border-color: #DDAA42; }
          .BarDashboard .box .link .avatar-yellow span {
            color: #2B1F05; }
          .BarDashboard .box .link .avatar-yellow:hover {
            background-color: #DDAA42;
            border-color: #BB8D2F; }
        .BarDashboard .box .link .avatar-purple {
          background-color: #D7B8E5;
          border-color: #C59ED5; }
          .BarDashboard .box .link .avatar-purple span {
            color: #241226; }
          .BarDashboard .box .link .avatar-purple:hover {
            background-color: #C59ED5;
            border-color: #A278B3; }
    .BarDashboard .box-medium {
      justify-content: center;
      align-items: center; }
    .BarDashboard .box-end {
      justify-content: flex-end;
      align-items: center; }
    .BarDashboard .box .menu-item {
      width: 100%; }
    .BarDashboard .box .link {
      height: 63px;
      border-radius: 10px;
      outline: none; }
      .BarDashboard .box .link-with-hover:hover {
        background: #D0E8FD; }
        .BarDashboard .box .link-with-hover:hover .award,
        .BarDashboard .box .link-with-hover:hover .brief,
        .BarDashboard .box .link-with-hover:hover .icon-logout {
          background-color: #355C7D; }
        .BarDashboard .box .link-with-hover:hover span {
          color: #355C7D !important; }
  .BarDashboard .award {
    width: 24px;
    height: 24px;
    background-color: #929FB0;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/contain; }
  .BarDashboard .brief {
    width: 24px;
    height: 24px;
    background-color: #929FB0;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center/contain; }
  .BarDashboard .icon-logout {
    width: 24px;
    height: 24px;
    background-color: #929FB0;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center/contain; }
  .BarDashboard .link-active {
    background: #D0E8FD; }
    .BarDashboard .link-active .award,
    .BarDashboard .link-active .brief,
    .BarDashboard .link-active .icon-logout {
      background-color: #355C7D; }
    .BarDashboard .link-active span {
      color: #355C7D !important; }

.right-scenes {
  position: fixed;
  background: rgba(42, 47, 60, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  top: 0;
  left: 70px;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center; }
  .right-scenes-content {
    position: relative;
    width: calc(100% - 70px);
    /* Ancho de la pantalla menos 70px */
    background-color: #fff;
    height: 100%;
    animation: slideIn 1s forwards; }

@keyframes slideIn {
  from {
    transform: translateX(calc(-100% + 70px)); }
  to {
    transform: translateX(0); } }
  .right-scenes .button-close-mask {
    width: 30%;
    height: 100%;
    background-color: rgba(255, 0, 0, 0);
    box-shadow: none;
    border: none; }
    .right-scenes .button-close-mask:hover, .right-scenes .button-close-mask:active, .right-scenes .button-close-mask:focus {
      background-color: rgba(255, 0, 0, 0) !important;
      box-shadow: none;
      border: none; }

.Header {
  height: 56px;
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9fafb;
  border-bottom: 1px solid #dfe4eb; }
  .Header .box .logo {
    height: 36px;
    width: auto; }
  .Header .box .logo-c {
    height: 32px;
    width: 32px; }
  .Header .logo-const {
    height: 32px;
    width: auto; }

.HeaderHome {
  left: 0;
  top: 0;
  position: fixed;
  z-index: 200;
  width: 100%; }
  .HeaderHome .content {
    height: 56px;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f9fafb;
    border-bottom: 1px solid #dfe4eb;
    gap: 8px; }
    .HeaderHome .content .logo {
      height: 32px; }
    .HeaderHome .content .logo-c {
      height: 32px;
      width: 32px; }
    .HeaderHome .content .box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px; }
      .HeaderHome .content .box .logo {
        height: 32px; }
      .HeaderHome .content .box .logo-c {
        height: 32px;
        width: 32px; }

.HeaderHome-space {
  height: 56px;
  width: 100%; }
  .HeaderHome-space.processing {
    height: 97px; }
  .HeaderHome-space button {
    border-radius: 6px; }

.CardProfile {
  width: 276px;
  height: 85px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #f9fafb;
  position: relative; }
  .CardProfile .link {
    position: absolute;
    right: 12px;
    top: 8px; }
  .CardProfile__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;
    padding-top: 0; }
    .CardProfile__content .avatar {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      margin-top: -5px;
      margin-bottom: 4px; }
    .CardProfile__content .link {
      color: #5e8eb7;
      text-align: right;
      font-family: Inter;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-decoration-line: underline; }
    .CardProfile__content .text {
      color: #6e7889;
      text-align: center;
      font-family: Inter;
      font-style: normal;
      font-size: 12px;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 2px; }
      .CardProfile__content .text-bold {
        color: #2a2f3c;
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 6px; }
      .CardProfile__content .text-small {
        text-transform: none;
        text-decoration: none;
        color: #404859;
        margin-bottom: 0px; }
    .CardProfile__content--bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%; }
    .CardProfile__content .tooltip-button-loan-officer {
      background: #355C7D;
      opacity: 1;
      font-family: Inter;
      line-height: 100%;
      letter-spacing: 0px; }
      .CardProfile__content .tooltip-button-loan-officer .loan-officer {
        font-weight: 400;
        font-size: 8px;
        color: #B7DDFD; }
      .CardProfile__content .tooltip-button-loan-officer p {
        font-weight: 600;
        font-size: 12px;
        color: #F5FAFF; }

.SectionError {
  border-radius: 10px;
  border: 1px solid #c94f4a;
  padding: 12px 15px;
  background-color: #FCF8F7; }
  .SectionError .flex-end button {
    height: 30px; }
  .SectionError .description {
    overflow: hidden; }
    .SectionError .description .body-regular {
      color: #2A2F3C;
      display: -webkit-box;
      /* Utiliza el modelo de caja flexible de tipo webkit */
      -webkit-box-orient: vertical;
      /* Orientación vertical */
      -webkit-line-clamp: 2;
      /* Número máximo de líneas */
      overflow: hidden;
      /* Oculta el contenido que sobresale */ }
  .SectionError .flex-btw {
    margin-bottom: 5px; }
  .SectionError .body-regular-title {
    color: #8F2F2C; }
  .SectionError .button {
    color: #712220;
    text-align: right;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; }
    .SectionError .button .anticon {
      color: #712220;
      margin-top: 2px; }
    .SectionError .button span {
      color: #712220; }
    .SectionError .button:hover {
      border: none; }

.SectionSuccessTask {
  border-radius: 10px;
  border: 1px solid #4CA852;
  padding: 12px 15px;
  background-color: #FAFCFA; }
  .SectionSuccessTask .flex-btw {
    margin-bottom: 0px !important; }
  .SectionSuccessTask .body-regular {
    color: #2A2F3C; }
  .SectionSuccessTask .body-regular-title {
    color: #466849;
    font-size: 16px; }
  .SectionSuccessTask .button {
    color: #466849;
    text-align: right;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; }
    .SectionSuccessTask .button .anticon {
      color: #466849;
      margin-top: 2px; }
    .SectionSuccessTask .button span {
      color: #466849; }
    .SectionSuccessTask .button:hover {
      border: none; }

.collapse-issues {
  background-color: white;
  width: 85%;
  max-width: 640px; }
  .collapse-issues-absolute {
    position: absolute;
    bottom: 0; }
  .collapse-issues-fixed {
    position: fixed; }
  .collapse-issues .ant-collapse {
    overflow-x: hidden;
    /* Track */
    /* Handle */
    /* Handle on hover */ }
    .collapse-issues .ant-collapse-close {
      overflow-y: hidden; }
    .collapse-issues .ant-collapse-open .ant-collapse-content-box {
      padding: 0 16px 0 0; }
    .collapse-issues .ant-collapse-open .ant-collapse-header {
      padding: 15px 0 0 0; }
    .collapse-issues .ant-collapse .ant-collapse-header {
      padding: 15px 0 10px 0; }
    .collapse-issues .ant-collapse .ant-collapse-header-text {
      font-weight: 600; }
    .collapse-issues .ant-collapse::-webkit-scrollbar {
      width: 8px;
      border-radius: 5px; }
    .collapse-issues .ant-collapse::-webkit-scrollbar-track {
      background: #f1f1f1; }
    .collapse-issues .ant-collapse::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 5px; }
    .collapse-issues .ant-collapse::-webkit-scrollbar-thumb:hover {
      background: #555; }
  .collapse-issues .ant-collapse-expand-icon {
    gap: 5px; }
  .collapse-issues .card-issues {
    border-radius: 6px;
    border: 1px solid #929FB0;
    padding: 12px 15px;
    background-color: #FFFFFF;
    height: auto;
    margin-top: 15px;
    min-width: 565px; }
    .collapse-issues .card-issues .description {
      height: 40px;
      overflow: hidden; }
      .collapse-issues .card-issues .description .body-regular {
        color: #2A2F3C;
        display: -webkit-box;
        /* Utiliza el modelo de caja flexible de tipo webkit */
        -webkit-box-orient: vertical;
        /* Orientación vertical */
        -webkit-line-clamp: 2;
        /* Número máximo de líneas */
        overflow: hidden;
        /* Oculta el contenido que sobresale */ }
    .collapse-issues .card-issues .flex-btw {
      margin-bottom: 5px; }
    .collapse-issues .card-issues .body-regular-title {
      color: #404859; }
    .collapse-issues .card-issues button {
      color: #404859;
      font-size: 14px; }
      .collapse-issues .card-issues button :hover {
        color: #404859; }

.add-another-doc {
  margin-top: 10px; }
  .add-another-doc .button-link-blue {
    padding: 0; }
    .add-another-doc .button-link-blue span {
      font-weight: 500;
      display: flex;
      text-decoration: none; }
    .add-another-doc .button-link-blue:disabled {
      color: rgba(0, 0, 0, 0.25) !important; }
  .add-another-doc .card-create-doc {
    position: relative;
    border-radius: 10px;
    border: 1px solid #929FB0;
    padding: 10px 16px 0px; }
    .add-another-doc .card-create-doc .form-doc-name input {
      font-size: 16px !important;
      font-weight: 400 !important;
      color: black !important; }
    .add-another-doc .card-create-doc .form-doc-name::placeholder {
      font-size: 16px !important;
      font-weight: 400 !important; }
    .add-another-doc .card-create-doc .form-doc-description {
      font-size: 14px !important;
      font-weight: 400 !important;
      font-style: italic !important;
      color: black !important; }
      .add-another-doc .card-create-doc .form-doc-description::placeholder {
        font-size: 14px !important;
        font-weight: 400 !important;
        font-style: italic !important; }
    .add-another-doc .card-create-doc .form .doc-info .ant-form-item {
      margin-bottom: 0; }
    .add-another-doc .card-create-doc .form .doc-info .ant-form-item-control-input {
      min-height: 25px; }
    .add-another-doc .card-create-doc .form .placeholder {
      margin-top: 20px;
      font-style: italic; }

.progress {
  display: flex;
  gap: 5px;
  margin-top: 5px; }
  .progress .bar {
    width: 100%;
    background-color: #dfe4eb;
    height: 8px;
    border-radius: 8px;
    display: flex; }
    .progress .bar :first-child {
      border-bottom-left-radius: 8px;
      border-top-left-radius: 8px; }
    .progress .bar :last-child {
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px; }
    .progress .bar-percentage {
      height: 8px; }
      .progress .bar-percentage-success {
        background: #4CA852; }
      .progress .bar-percentage-error {
        background: #C13934; }
      .progress .bar-percentage-progress {
        background: #B6DCFC; }
      .progress .bar-percentage-review {
        background: #AC78B3; }

.LoanProgress {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px; }
  .LoanProgress .tab {
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; }
    .LoanProgress .tab .popover-label {
      display: flex;
      align-items: center;
      flex-direction: column; }
    .LoanProgress .tab .bar-status {
      cursor: pointer;
      width: 100%;
      width: calc(100% + 20px);
      height: 8px;
      border-radius: 16px;
      margin-top: 6px;
      background-color: #dfe4eb; }
    .LoanProgress .tab-complete .text-status {
      color: #141F15; }
    .LoanProgress .tab-complete .body-small {
      color: #2D7032; }
    .LoanProgress .tab-complete .bar-status {
      background-color: #4CA852; }
      .LoanProgress .tab-complete .bar-status-selected {
        background-color: #2D7032; }
        .LoanProgress .tab-complete .bar-status-selected:hover {
          background-color: #2D7032 !important; }
      .LoanProgress .tab-complete .bar-status:hover {
        background-color: #3F9545; }
        .LoanProgress .tab-complete .bar-status:hover .body-small {
          color: #2D7032; }
    .LoanProgress .tab-blocked .body-small {
      color: #8A130F; }
    .LoanProgress .tab-blocked .text-status {
      color: #610805; }
    .LoanProgress .tab-blocked .bar-status {
      background-color: #C13934; }
      .LoanProgress .tab-blocked .bar-status-selected {
        background-color: #8A130F; }
        .LoanProgress .tab-blocked .bar-status-selected:hover {
          background-color: #8A130F !important; }
      .LoanProgress .tab-blocked .bar-status:hover {
        background-color: #A31C17; }
        .LoanProgress .tab-blocked .bar-status:hover .body-small {
          color: #8A130F; }
    .LoanProgress .tab-error .body-small {
      color: #8A130F; }
    .LoanProgress .tab-error .text-status {
      color: #610805; }
    .LoanProgress .tab-error .bar-status {
      background-color: #FFDAD6; }
      .LoanProgress .tab-error .bar-status-selected {
        background-color: #8A130F; }
        .LoanProgress .tab-error .bar-status-selected:hover {
          background-color: #8A130F !important; }
      .LoanProgress .tab-error .bar-status:hover {
        background-color: #C13934; }
        .LoanProgress .tab-error .bar-status:hover .body-small {
          color: #8A130F; }
    .LoanProgress .tab-progress .text-status {
      color: #122536; }
    .LoanProgress .tab-progress .body-small {
      color: #404859; }
    .LoanProgress .tab-progress .bar-status {
      background-color: #5E8EB7; }
      .LoanProgress .tab-progress .bar-status-selected {
        background-color: #355C7D; }
        .LoanProgress .tab-progress .bar-status-selected:hover {
          background-color: #355C7D !important; }
      .LoanProgress .tab-progress .bar-status:hover {
        background-color: #48759A; }
        .LoanProgress .tab-progress .bar-status:hover .body-small {
          color: #404859; }
    .LoanProgress .tab-not-started .bar-status {
      background-color: white;
      border: 1px solid #404859; }
      .LoanProgress .tab-not-started .bar-status-selected {
        background-color: #404859; }
        .LoanProgress .tab-not-started .bar-status-selected:hover {
          background-color: #404859 !important; }
      .LoanProgress .tab-not-started .bar-status:hover {
        background-color: #929FB0; }
    .LoanProgress .tab-open-content {
      position: absolute;
      border: 1px solid #929FB0;
      box-shadow: 2px 2px 10px 0px #0000001A;
      height: auto;
      min-height: 253px;
      width: 825px;
      background: white;
      top: 150px;
      border-radius: 10px;
      z-index: 99; }
      .LoanProgress .tab-open-content .content-bar-status {
        width: 823px;
        height: 68px;
        background: white;
        border-radius: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: start;
        gap: 8px;
        padding-left: 8px;
        padding-top: 3px; }
        .LoanProgress .tab-open-content .content-bar-status .tab .body-small {
          font-size: 12px !important; }
        .LoanProgress .tab-open-content .content-bar-status .tab-error span {
          color: #610805; }
        .LoanProgress .tab-open-content .content-bar-status .bar-status {
          width: -webkit-fill-available;
          height: 16px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center; }
          .LoanProgress .tab-open-content .content-bar-status .bar-status .text-status {
            display: flex;
            align-items: center;
            gap: 3px; }
            .LoanProgress .tab-open-content .content-bar-status .bar-status .text-status span {
              font-family: Inter;
              font-size: 10px;
              font-weight: 600; }
          .LoanProgress .tab-open-content .content-bar-status .bar-status:hover span {
            display: none; }
          .LoanProgress .tab-open-content .content-bar-status .bar-status:hover .text-status {
            display: none; }
        .LoanProgress .tab-open-content .content-bar-status .tab {
          margin: 0 0; }
        .LoanProgress .tab-open-content .content-bar-status .tab:nth-child(1) {
          width: 10%; }
        .LoanProgress .tab-open-content .content-bar-status .tab:nth-child(2) {
          width: 22%; }
        .LoanProgress .tab-open-content .content-bar-status .tab:nth-child(3) {
          width: 38%; }
        .LoanProgress .tab-open-content .content-bar-status .tab:nth-child(4) {
          width: 14%; }
        .LoanProgress .tab-open-content .content-bar-status .tab:nth-child(5) {
          width: 11%; }
      .LoanProgress .tab-open-content .content-phase-select {
        width: 823px;
        height: auto;
        min-height: 183px;
        border-radius: 10px;
        background: #F9FAFB;
        border-top: 1px solid #DFE4EB; }
        .LoanProgress .tab-open-content .content-phase-select-complete {
          background: #F8FFF8;
          border-top: 1px solid #C2F0C5; }
          .LoanProgress .tab-open-content .content-phase-select-complete .tag-state {
            background: #C2F0C5; }
            .LoanProgress .tab-open-content .content-phase-select-complete .tag-state b,
            .LoanProgress .tab-open-content .content-phase-select-complete .tag-state span {
              color: #141F15; }
          .LoanProgress .tab-open-content .content-phase-select-complete .content-phase b {
            color: #1F4222; }
          .LoanProgress .tab-open-content .content-phase-select-complete .content-phase p {
            color: #1F4222 !important; }
          .LoanProgress .tab-open-content .content-phase-select-complete .content-phase-first b {
            color: #2D7032; }
        .LoanProgress .tab-open-content .content-phase-select-blocked {
          background: #FCF8F7;
          border-top: 1px solid #FFC6BF; }
          .LoanProgress .tab-open-content .content-phase-select-blocked .tag-state {
            background: #FFD4CF; }
            .LoanProgress .tab-open-content .content-phase-select-blocked .tag-state b,
            .LoanProgress .tab-open-content .content-phase-select-blocked .tag-state span {
              color: #610805; }
          .LoanProgress .tab-open-content .content-phase-select-blocked .content-phase b {
            color: #2A2F3C; }
          .LoanProgress .tab-open-content .content-phase-select-blocked .content-phase-first b {
            color: #610805; }
        .LoanProgress .tab-open-content .content-phase-select-error {
          background: #FCF8F7;
          border-top: 1px solid #FFC6BF; }
          .LoanProgress .tab-open-content .content-phase-select-error .tag-state {
            background: #FFD4CF; }
            .LoanProgress .tab-open-content .content-phase-select-error .tag-state b,
            .LoanProgress .tab-open-content .content-phase-select-error .tag-state span {
              color: #610805; }
          .LoanProgress .tab-open-content .content-phase-select-error .content-phase b {
            color: #2A2F3C; }
          .LoanProgress .tab-open-content .content-phase-select-error .content-phase-first b {
            color: #610805; }
        .LoanProgress .tab-open-content .content-phase-select-progress {
          background: #F5FAFF;
          border-top: 1px solid #B6DCFC; }
          .LoanProgress .tab-open-content .content-phase-select-progress .tag-state {
            background: #B6DCFC; }
            .LoanProgress .tab-open-content .content-phase-select-progress .tag-state b,
            .LoanProgress .tab-open-content .content-phase-select-progress .tag-state span {
              color: #122536; }
          .LoanProgress .tab-open-content .content-phase-select-progress .content-phase b {
            color: #2A2F3C; }
          .LoanProgress .tab-open-content .content-phase-select-progress .content-phase-first b {
            color: #244560; }
        .LoanProgress .tab-open-content .content-phase-select-not-started .tag-state {
          border: 1px solid #404859; }
        .LoanProgress .tab-open-content .content-phase-select .tag-state {
          height: 16px;
          width: max-content;
          display: flex;
          align-items: center;
          gap: 3.5px;
          border-radius: 10px;
          padding: 3px 7px;
          margin: 16px 23px; }
          .LoanProgress .tab-open-content .content-phase-select .tag-state b {
            font-size: 10px;
            font-weight: 600; }
          .LoanProgress .tab-open-content .content-phase-select .tag-state span {
            font-size: 10px;
            font-weight: 400; }
        .LoanProgress .tab-open-content .content-phase-select .divider {
          border: 0.7px solid #929FB0;
          height: auto; }
        .LoanProgress .tab-open-content .content-phase-select .content-phase {
          margin: 0px 24px;
          padding-bottom: 23px; }
          .LoanProgress .tab-open-content .content-phase-select .content-phase b {
            font-size: 12px;
            font-weight: 600; }
          .LoanProgress .tab-open-content .content-phase-select .content-phase p {
            font-size: 12px;
            font-weight: 400;
            color: #2A2F3C;
            margin-top: 6px; }
          .LoanProgress .tab-open-content .content-phase-select .content-phase-first {
            width: 270px; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase-first b {
              font-size: 16px;
              font-weight: 600; }
          .LoanProgress .tab-open-content .content-phase-select .content-phase-second {
            width: 240px;
            margin-left: 20px; }
          .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item {
            display: flex;
            align-items: center;
            gap: 5px;
            margin-top: 4px;
            width: max-content;
            border-radius: 4px;
            padding: 2px 3px; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item span {
              font-family: Inter;
              font-size: 12px; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item b {
              font-family: Inter;
              font-weight: 500; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .bold {
              font-weight: 600 !important; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item .circle {
              width: 12px;
              height: 12px;
              border: 1px solid #6E7889;
              border-radius: 50%; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED {
              background-color: #D5F7E2; }
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED span,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED b,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-APPROVED strong {
                color: #2D7032; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED {
              background: #FFC6BF; }
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR span,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR b,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REQUEST_ERROR strong, .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED span,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED b,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-BLOCKED strong {
                color: #610805; }
            .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW {
              background: #F7EDFC; }
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW span,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW b,
              .LoanProgress .tab-open-content .content-phase-select .content-phase .task-item-REVIEW strong {
                color: #855791; }

.TaskProgress .bar {
  width: 100%;
  background-color: #dfe4eb;
  height: 8px;
  border-radius: 8px;
  display: flex; }
  .TaskProgress .bar :first-child {
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px; }
  .TaskProgress .bar :last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px; }
  .TaskProgress .bar-percentage {
    height: 8px; }

.TaskProgress .h4 {
  color: #404859 !important;
  text-transform: none; }

.MinimumProgressVertical {
  margin-top: 24px;
  height: 90%; }
  .MinimumProgressVertical .content-bar {
    display: flex;
    align-items: start;
    gap: 16px;
    height: 90%; }
    .MinimumProgressVertical .content-bar .bar {
      width: 16px;
      height: 100%;
      background-color: #dfe4eb;
      border-radius: 8px;
      display: flex;
      flex-direction: column-reverse;
      position: relative; }
      .MinimumProgressVertical .content-bar .bar-percentage {
        height: auto;
        width: 16px;
        position: relative;
        padding-top: 10px; }
        .MinimumProgressVertical .content-bar .bar-percentage::before {
          content: '';
          position: absolute;
          top: -5px;
          width: 100%;
          height: 8px;
          background-color: inherit;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px; }
        .MinimumProgressVertical .content-bar .bar-percentage::after {
          content: '';
          position: absolute;
          bottom: -8px;
          width: 100%;
          height: 8px;
          background-color: inherit;
          border-bottom-right-radius: 10px;
          border-bottom-left-radius: 10px; }
  .MinimumProgressVertical .h4 {
    color: #404859 !important;
    text-transform: none; }
  .MinimumProgressVertical .label-price {
    width: 150px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 4px; }
    .MinimumProgressVertical .label-price-draft {
      position: absolute;
      bottom: 20px; }
    .MinimumProgressVertical .label-price-reject {
      position: absolute;
      bottom: 20px; }
      .MinimumProgressVertical .label-price-reject span {
        color: #8A130F !important; }
    .MinimumProgressVertical .label-price-approved {
      position: absolute;
      bottom: 20px; }
      .MinimumProgressVertical .label-price-approved span {
        color: #2D7032 !important; }
    .MinimumProgressVertical .label-price-review {
      position: absolute;
      bottom: 20px; }
      .MinimumProgressVertical .label-price-review span {
        color: #855791 !important; }
    .MinimumProgressVertical .label-price .label {
      font-family: Inter;
      font-weight: 500;
      font-size: 16px;
      color: #2A2F3C; }
      .MinimumProgressVertical .label-price .label-remaining {
        font-weight: 400;
        color: #404859; }
      .MinimumProgressVertical .label-price .label-rejected {
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0%;
        color: #8A130F; }
    .MinimumProgressVertical .label-price .price {
      font-weight: 600 !important;
      font-style: normal !important;
      line-height: 100% !important;
      letter-spacing: 0;
      color: #2A2F3C !important; }
      .MinimumProgressVertical .label-price .price-remaining {
        font-weight: 400 !important;
        color: #404859 !important; }

.ButtonTabsFilters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px; }
  .ButtonTabsFilters .tab {
    border-radius: 100px;
    background: #dfe4eb;
    color: #404859;
    text-align: right;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    border: none;
    box-shadow: none;
    height: 24px; }
    .ButtonTabsFilters .tab .number {
      font-weight: 400;
      margin-left: 3px; }
    .ButtonTabsFilters .tab:hover {
      background: #5E8EB7 !important;
      color: white !important; }
    .ButtonTabsFilters .tab-active {
      background-color: #355c7d;
      color: #ffffff; }
      .ButtonTabsFilters .tab-active:hover {
        background-color: #355c7d !important;
        color: #ffffff !important; }
  .ButtonTabsFilters .disabled {
    pointer-events: none; }

.CardLoanTasks {
  width: 396px;
  height: 220px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #6e7889;
  background: #fdfeff;
  padding: 12px 20px;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: margin 300ms; }
  .CardLoanTasks-isHighlight {
    margin-top: -10px;
    border: 1px solid #e67f73 !important;
    box-shadow: 2px 2px 16px 0px #2603001f; }
  .CardLoanTasks .state-tooltip {
    display: flex; }
  .CardLoanTasks .circle-state-tooltip {
    padding: 6px 7px;
    opacity: 1; }
    .CardLoanTasks .circle-state-tooltip b {
      font-weight: 600; }
    .CardLoanTasks .circle-state-tooltip span {
      margin-top: 10px; }
    .CardLoanTasks .circle-state-tooltip-APPROVED {
      background-color: #4CA852; }
    .CardLoanTasks .circle-state-tooltip-DRAFT {
      background-color: #404859; }
    .CardLoanTasks .circle-state-tooltip-REQUEST_ERROR {
      background-color: #c94f4a; }
    .CardLoanTasks .circle-state-tooltip-REVIEW {
      background-color: #855791; }
  .CardLoanTasks .docs-section {
    margin-top: 15px; }
    .CardLoanTasks .docs-section .labels {
      display: flex;
      justify-content: space-between; }
    .CardLoanTasks .docs-section .circles-tags {
      display: flex;
      align-items: end;
      gap: 20px;
      margin-top: 5px; }
    .CardLoanTasks .docs-section .circle {
      width: 20px;
      height: 20px;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
      background-repeat: no-repeat;
      background-position: center; }
      .CardLoanTasks .docs-section .circle:hover {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
        background-repeat: no-repeat;
        background-position: center; }
      .CardLoanTasks .docs-section .circle-APPROVED {
        border: 1px solid #3F9545;
        background-color: #C2F0C5;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
        background-repeat: no-repeat;
        background-position: center; }
        .CardLoanTasks .docs-section .circle-APPROVED:hover {
          background-color: #3F9545;
          border: 1px solid #3F9545; }
      .CardLoanTasks .docs-section .circle-REVIEW {
        background-color: #E0CCE3 !important;
        border: 1px solid #8A5791;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
        background-repeat: no-repeat;
        background-position: center; }
        .CardLoanTasks .docs-section .circle-REVIEW:hover {
          background-color: #855791 !important;
          border: 1px solid #855791; }
      .CardLoanTasks .docs-section .circle-REQUEST_ERROR {
        background-color: #FFC6BF;
        border: 1px solid #8A130F;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
        background-repeat: no-repeat;
        background-position: center; }
        .CardLoanTasks .docs-section .circle-REQUEST_ERROR:hover {
          background-color: #A31C17;
          border: 1px solid #A31C17; }
      .CardLoanTasks .docs-section .circle-INCOMPLETE {
        background-color: #B6DCFC;
        border: 1px solid #48759A;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
        background-repeat: no-repeat;
        background-position: center; }
        .CardLoanTasks .docs-section .circle-INCOMPLETE:hover {
          background-color: #48759A;
          border: 1px solid #48759A; }
      .CardLoanTasks .docs-section .circle-DRAFT:hover {
        background-color: #404859; }
  .CardLoanTasks .state-name {
    color: #404859;
    font-family: Inter;
    font-size: 12px !important;
    font-style: normal;
    font-weight: 500;
    line-height: normal; }
    .CardLoanTasks .state-name-w6 {
      font-weight: 600; }
  .CardLoanTasks .withBorder {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #ccd3db;
    background: #fff;
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal; }
  .CardLoanTasks .withOutBorder {
    width: 100%;
    border-radius: 4px;
    border: none;
    background: none;
    box-shadow: none;
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal; }
  .CardLoanTasks .message-state-error {
    margin-top: 8px;
    border-radius: 6px;
    padding: 7px 8px;
    background-color: #fff4f3;
    color: #8A130F;
    border: 1px solid #FFD4CF;
    font-size: 12px; }
  .CardLoanTasks .message-state-success {
    margin-top: 8px;
    border-radius: 6px;
    padding: 7px 8px;
    background-color: #f5faf7;
    color: #1F4222;
    border: 1px solid #92c295;
    font-size: 12px; }
  .CardLoanTasks .box-message-state-review {
    margin-top: 8px;
    padding: 7px 8px;
    font-size: 12px;
    background-color: #FDFCFF;
    color: #855791;
    border: 1px solid #D7B8E5; }
  .CardLoanTasks .box-message-state-approved {
    margin-top: 8px;
    padding: 7px 8px;
    font-size: 12px;
    color: #466849;
    border: 1px solid #92c295; }
  .CardLoanTasks .body-card-bold-line {
    text-decoration-line: unset; }
    .CardLoanTasks .body-card-bold-line-REVIEW {
      background-color: #e3ddf0;
      color: #241226; }
    .CardLoanTasks .body-card-bold-line-APPROVED {
      color: black;
      background-color: #C2F0C5; }
    .CardLoanTasks .body-card-bold-line-REQUEST_ERROR {
      background-color: #FFD4CF; }
  .CardLoanTasks__top__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px; }
    .CardLoanTasks__top__head .flex-end {
      display: flex;
      justify-content: flex-end;
      gap: 4px;
      align-items: center; }
      .CardLoanTasks__top__head .flex-end .body-small {
        font-size: 12px !important; }
      .CardLoanTasks__top__head .flex-end .circle {
        width: 20px;
        height: 20px; }
        .CardLoanTasks__top__head .flex-end .circle:hover {
          background-color: #404859; }
        .CardLoanTasks__top__head .flex-end .circle-complete {
          background: #C2F0C5;
          border: 1px solid #4CA852; }
          .CardLoanTasks__top__head .flex-end .circle-complete:hover {
            background: #4CA852; }
        .CardLoanTasks__top__head .flex-end .circle-incomplete {
          background: #7FADD4;
          border: 1px solid #5E8EB7; }
          .CardLoanTasks__top__head .flex-end .circle-incomplete:hover {
            background: #48759A;
            border: 1px solid #48759A; }
        .CardLoanTasks__top__head .flex-end .circle-error {
          background: #FFC6BF;
          border: 1px solid #c94f4a; }
          .CardLoanTasks__top__head .flex-end .circle-error:hover {
            background: #c94f4a; }
        .CardLoanTasks__top__head .flex-end .circle-review {
          background: #E9D6FF;
          border: 1px solid #ac78b3; }
          .CardLoanTasks__top__head .flex-end .circle-review:hover {
            background: #ac78b3; }
      .CardLoanTasks__top__head .flex-end .svg-grid {
        height: 12px;
        width: 12px;
        fill: none; }
      .CardLoanTasks__top__head .flex-end .quick-task path {
        stroke: #6e7889; }
        .CardLoanTasks__top__head .flex-end .quick-task path:first-child {
          fill: #6e7889; }
      .CardLoanTasks__top__head .flex-end .major-task path {
        stroke: #6e7889;
        fill: #6e7889; }
    .CardLoanTasks__top__head .card-state-tooltip {
      padding: 6px 7px !important;
      opacity: 1 !important;
      background-color: #404859; }
      .CardLoanTasks__top__head .card-state-tooltip b {
        font-family: Inter;
        font-style: normal;
        font-weight: 800; }
      .CardLoanTasks__top__head .card-state-tooltip span {
        font-weight: 600;
        font-family: Inter;
        font-size: 12px;
        font-style: normal; }
      .CardLoanTasks__top__head .card-state-tooltip-complete {
        background-color: #4CA852; }
      .CardLoanTasks__top__head .card-state-tooltip-error {
        background-color: #c94f4a !important; }
      .CardLoanTasks__top__head .card-state-tooltip-review {
        background-color: #855791; }
      .CardLoanTasks__top__head .card-state-tooltip-incomplete {
        background-color: #48759A; }
  .CardLoanTasks__top .h4 {
    margin-bottom: 6px;
    font-size: 18px !important; }
  .CardLoanTasks__top .text {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start; }
    .CardLoanTasks__top .text .body-card {
      font-size: 14px !important; }
  .CardLoanTasks__top .body-card-full {
    margin: 0 5px;
    font-weight: 700;
    border-radius: 2px; }
  .CardLoanTasks .TaskProgress {
    margin-top: 10px; }
  .CardLoanTasks__bottom {
    display: flex;
    flex-direction: column;
    gap: 5px; }
    .CardLoanTasks__bottom .body-small-up {
      color: #587e5b;
      margin-bottom: 8px; }
    .CardLoanTasks__bottom .flex-betwen .body-card {
      color: #587e5b; }
  .CardLoanTasks-buttons-actions {
    display: flex;
    justify-content: space-between; }
    .CardLoanTasks-buttons-actions .button-open-modal span {
      font-size: 14px !important; }
  .CardLoanTasks-APPROVED {
    border-color: #6eac72; }
    .CardLoanTasks-APPROVED .state {
      border-radius: 76px;
      background: #c5f0c8;
      padding: 4px 8px 4px 7px;
      display: flex;
      justify-content: center;
      align-items: center; }
      .CardLoanTasks-APPROVED .state .check {
        margin-right: 2px; }
      .CardLoanTasks-APPROVED .state .state-name {
        color: #355137; }
    .CardLoanTasks-APPROVED .body-card-full {
      background-color: #c5f0c8;
      color: #466849; }
    .CardLoanTasks-APPROVED .flex-end .svg-grid path {
      stroke: #6eac72; }
      .CardLoanTasks-APPROVED .flex-end .svg-grid path:first-child {
        fill: #6eac72; }
    .CardLoanTasks-APPROVED .flex-end .major-task path {
      stroke: #6eac72;
      fill: #6eac72; }
    .CardLoanTasks-APPROVED .flex-end .state-name {
      color: #6eac72; }
    .CardLoanTasks-APPROVED .button-card {
      border: 1px solid #6eac72;
      background: #fafcfc;
      color: #466849;
      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02); }
  .CardLoanTasks-REVIEW {
    border-color: #ac78b3;
    background: #FDFCFF; }
    .CardLoanTasks-REVIEW .h4 {
      color: #241226; }
    .CardLoanTasks-REVIEW .body-card-full {
      color: #48244d;
      background: #e3ddf0; }
    .CardLoanTasks-REVIEW .body-card--green {
      background-color: #e3ddf0; }
    .CardLoanTasks-REVIEW .state-name {
      color: #8a5791; }
    .CardLoanTasks-REVIEW .body-small-up {
      color: #8a5791; }
    .CardLoanTasks-REVIEW .CardLoanTasks__top__head .flex-end .major-task path {
      stroke: #ac78b3;
      fill: #ac78b3; }
    .CardLoanTasks-REVIEW .state {
      border-radius: 76px;
      background: #EAD6FF;
      padding: 4px 8px 4px 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px; }
      .CardLoanTasks-REVIEW .state .state-name {
        color: #48244d; }
    .CardLoanTasks-REVIEW .body-card {
      color: black; }
    .CardLoanTasks-REVIEW .button-card {
      color: #693b6f;
      border-radius: 4px;
      border: 1px solid #ac78b3;
      background: #fdfcff;
      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03); }
    .CardLoanTasks-REVIEW .docs-section .labels p {
      color: #653B6F; }
    .CardLoanTasks-REVIEW .flex-end .svg-grid path {
      stroke: #855791; }
      .CardLoanTasks-REVIEW .flex-end .svg-grid path:first-child {
        fill: #855791; }
    .CardLoanTasks-REVIEW .flex-end .major-task path {
      stroke: #855791;
      fill: #855791; }
    .CardLoanTasks-REVIEW .flex-end .state-name {
      color: #855791; }
  .CardLoanTasks-AWAITING_ACTION {
    border-color: #ac78b3;
    background: #FDFCFF; }
    .CardLoanTasks-AWAITING_ACTION .body-card-full {
      color: #48244d;
      background: #e3ddf0; }
    .CardLoanTasks-AWAITING_ACTION .body-card--green {
      background-color: #e3ddf0; }
    .CardLoanTasks-AWAITING_ACTION .state-name {
      color: #8a5791; }
    .CardLoanTasks-AWAITING_ACTION .body-small-up {
      color: #8a5791; }
    .CardLoanTasks-AWAITING_ACTION .CardLoanTasks__top__head .flex-end .major-task path {
      stroke: #ac78b3;
      fill: #ac78b3; }
    .CardLoanTasks-AWAITING_ACTION .state {
      border-radius: 76px;
      background: #e3ddf0;
      padding: 4px 8px 4px 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px; }
      .CardLoanTasks-AWAITING_ACTION .state .state-name {
        color: #48244d; }
    .CardLoanTasks-AWAITING_ACTION .body-card {
      color: black; }
    .CardLoanTasks-AWAITING_ACTION .button-card {
      color: #693b6f;
      border-radius: 4px;
      border: 1px solid #ac78b3;
      background: #fdfcff;
      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03); }
    .CardLoanTasks-AWAITING_ACTION .docs-section .labels p {
      color: #653B6F; }
    .CardLoanTasks-AWAITING_ACTION .flex-end .svg-grid path {
      stroke: #855791; }
      .CardLoanTasks-AWAITING_ACTION .flex-end .svg-grid path:first-child {
        fill: #855791; }
    .CardLoanTasks-AWAITING_ACTION .flex-end .major-task path {
      stroke: #855791;
      fill: #855791; }
    .CardLoanTasks-AWAITING_ACTION .flex-end .state-name {
      color: #855791; }
  .CardLoanTasks-INCOMPLETE {
    border-color: #929fb0;
    background-color: #F5FAFF; }
    .CardLoanTasks-INCOMPLETE .circle-REVIEW {
      background-color: #7FADD4 !important;
      border-color: #AC78B3 !important; }
      .CardLoanTasks-INCOMPLETE .circle-REVIEW:hover {
        background-color: #48759A !important;
        border-color: #AC78B3 !important; }
    .CardLoanTasks-INCOMPLETE .circle-state-tooltip-REVIEW {
      background-color: #AC78B3 !important; }
    .CardLoanTasks-INCOMPLETE .state {
      border-radius: 76px;
      background: #B6DCFC;
      padding: 4px 8px 4px 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px; }
      .CardLoanTasks-INCOMPLETE .state .state-name {
        color: #122536; }
    .CardLoanTasks-INCOMPLETE .h4 {
      color: #244560; }
    .CardLoanTasks-INCOMPLETE .body-small-up {
      color: #48759A; }
    .CardLoanTasks-INCOMPLETE .flex-end .svg-grid path {
      stroke: #48759A; }
      .CardLoanTasks-INCOMPLETE .flex-end .svg-grid path:first-child {
        fill: #48759A; }
    .CardLoanTasks-INCOMPLETE .flex-end .major-task path {
      stroke: #48759A;
      fill: #48759A; }
    .CardLoanTasks-INCOMPLETE .flex-end .state-name {
      color: #855791; }
  .CardLoanTasks-COMING_SOON .state {
    border: 1px solid #6e7889;
    border-radius: 76px;
    background: white;
    padding: 4px 8px 4px 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px; }
  .CardLoanTasks-NEW_TASK .state {
    border: 1px solid #8f2f2c;
    border-radius: 76px;
    background: white;
    padding: 4px 8px 4px 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px; }
    .CardLoanTasks-NEW_TASK .state .state-name {
      color: #8f2f2c; }
  .CardLoanTasks-REQUEST_ERROR {
    border-color: #c94f4a; }
    .CardLoanTasks-REQUEST_ERROR .body-card-w5 {
      color: #ac3e3a; }
    .CardLoanTasks-REQUEST_ERROR .state {
      border-radius: 76px;
      background: #ffd4cf;
      padding: 4px 8px 4px 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px; }
      .CardLoanTasks-REQUEST_ERROR .state .state-name {
        color: #712220; }
    .CardLoanTasks-REQUEST_ERROR .button-open-modal {
      border-color: #c94f4a; }
    .CardLoanTasks-REQUEST_ERROR .body-small-up {
      color: #712220; }
    .CardLoanTasks-REQUEST_ERROR .body-card {
      color: black; }
      .CardLoanTasks-REQUEST_ERROR .body-card-text-2 {
        color: #ac3e3a; }
      .CardLoanTasks-REQUEST_ERROR .body-card-text-2 {
        color: #ac3e3a; }
    .CardLoanTasks-REQUEST_ERROR .button-card {
      border-color: #c94f4a; }
    .CardLoanTasks-REQUEST_ERROR .flex-betwen .button,
    .CardLoanTasks-REQUEST_ERROR .flex-betwen .button-link {
      color: #712220; }
    .CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path {
      stroke: #c94f4a; }
      .CardLoanTasks-REQUEST_ERROR .flex-end .svg-grid path:first-child {
        fill: #c94f4a; }
    .CardLoanTasks-REQUEST_ERROR .flex-end .major-task path {
      stroke: #c94f4a;
      fill: #c94f4a; }
    .CardLoanTasks-REQUEST_ERROR .flex-end .state-name {
      color: #c94f4a; }
  .CardLoanTasks-beginTask .ModalCardState {
    width: 100% !important; }

.InputAmount {
  border-radius: 4px;
  border: 1px solid #929fb0;
  background: #fff;
  padding: 13px 16px; }
  .InputAmount .h4 {
    color: #404859; }
  .InputAmount .button-operation {
    padding: 0;
    height: 23px;
    border: 0;
    background: none;
    box-shadow: none; }
    .InputAmount .button-operation .anticon {
      color: #5e8eb7; }
      .InputAmount .button-operation .anticon-full {
        display: none; }
    .InputAmount .button-operation:hover .anticon {
      color: #5e8eb7;
      display: none; }
      .InputAmount .button-operation:hover .anticon-full {
        display: block;
        margin-left: 0; }
  .InputAmount .flex {
    display: flex;
    justify-content: flex-end;
    gap: 16px; }
    .InputAmount .flex .h4 {
      color: #929fb0; }
    .InputAmount .flex span {
      color: #929fb0;
      font-family: Inter;
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: normal; }
    .InputAmount .flex .text-bold {
      color: #5e8eb7;
      font-weight: 600;
      font-style: normal; }
    .InputAmount .flex .input-edit {
      all: unset;
      color: #6E7889;
      animation: none;
      cursor: pointer;
      font-style: italic;
      font-weight: 400;
      line-height: 19.36px;
      text-align: right;
      text-underline-position: from-font;
      text-decoration-skip-ink: none; }
  .InputAmount .button-edit {
    all: unset;
    border: none;
    color: #5E8EB7;
    animation: none;
    cursor: pointer;
    margin-left: 10px; }
    .InputAmount .button-edit span {
      margin-left: 5px;
      font-weight: 500;
      color: #5E8EB7;
      font-family: Inter;
      font-style: normal; }

.SelectPrimary .body-regular {
  color: #2a2f3c;
  font-weight: 500; }

.SelectPrimary .ant-space-item {
  width: 100%; }

.UploadDocs {
  position: relative;
  height: 100%; }
  .UploadDocs .modal-see-file {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: red; }
  .UploadDocs .contenedor-flex {
    height: 100%; }
  .UploadDocs .button-upload {
    height: 78px;
    width: 100%;
    border: 1px dashed #6e7889; }
    .UploadDocs .button-upload p {
      color: #2a2f3c;
      font-family: Inter;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: normal; }
      .UploadDocs .button-upload p span {
        font-size: 10px;
        color: #4e8aff; }
  .UploadDocs .circles {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px; }
    .UploadDocs .circles .circle {
      border-radius: 50%;
      width: 16px;
      height: 16px;
      border: 1px solid #404859; }
      .UploadDocs .circles .circle:hover {
        background: #404859; }
      .UploadDocs .circles .circle-request_error {
        background-color: #FFD4CF;
        border-color: #c94f4a; }
        .UploadDocs .circles .circle-request_error:hover {
          background-color: #c94f4a; }
      .UploadDocs .circles .circle-review {
        background-color: #AC78B3;
        border-color: #AC78B3; }
        .UploadDocs .circles .circle-review:hover {
          background-color: #855791; }
      .UploadDocs .circles .circle-approved {
        background-color: #C2F0C5;
        border-color: #92c295; }
        .UploadDocs .circles .circle-approved:hover {
          background-color: #4CA852; }
  .UploadDocs .ant-upload {
    width: 100%;
    margin-bottom: 12px; }
  .UploadDocs .button {
    border-radius: 6px;
    border: #122536;
    background: #122536;
    width: 100%;
    height: 32px;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.18px; }
    .UploadDocs .button-transparent {
      background-color: transparent;
      border: none !important;
      box-shadow: none !important; }
    .UploadDocs .button:disabled {
      color: #929FB0; }
  .UploadDocs .body-small {
    font-weight: 700 !important;
    font-family: Inter;
    font-size: 10px;
    font-weight: 600;
    line-height: 12.1px;
    text-align: left; }
    .UploadDocs .body-small .blue {
      color: #4e8aff;
      text-decoration: underline; }
  .UploadDocs .upload {
    width: 20px;
    height: 20px;
    margin-bottom: 7px; }
  .UploadDocs .empty-input {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; }
    .UploadDocs .empty-input .small-detail {
      margin-top: 4px; }
  .UploadDocs--container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    height: 100%;
    flex-direction: column; }
  .UploadDocs .cont-files {
    width: 100%; }
  .UploadDocs .disabled {
    opacity: 0.5; }
  .UploadDocs .input-content {
    position: relative;
    min-height: 128px;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    background: var(--colors-gradient);
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #6e7889; }
    .UploadDocs .input-content-drag {
      border: 2px solid #1f52ca;
      background: #edf2fe; }
    .UploadDocs .input-content input {
      height: 126px;
      width: 100%;
      border-radius: 10px;
      background-color: rgba(255, 0, 0, 0);
      font-size: 0 !important;
      position: absolute;
      z-index: 2;
      top: 0;
      cursor: pointer; }
      .UploadDocs .input-content input:disabled {
        cursor: unset !important; }
    .UploadDocs .input-content input[type='file'] {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer; }
    .UploadDocs .input-content .custom-file-input input[type='file'] {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer; }
    .UploadDocs .input-content .cont-img {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff; }
      .UploadDocs .input-content .cont-img img {
        width: 100px; }
    .UploadDocs .input-content-wh {
      background: var(--colors-white);
      box-shadow: -3px 1px 10px -7px var(--colors-black);
      margin: 30px 40px; }
    .UploadDocs .input-content .edit {
      position: absolute;
      bottom: 0;
      height: auto;
      width: 99px;
      border-radius: 0; }
  .UploadDocs .content-flex {
    align-items: flex-start;
    gap: 16px; }
    .UploadDocs .content-flex .input-content,
    .UploadDocs .content-flex .file-ok {
      width: 50% !important; }
  .UploadDocs .spinner-container {
    display: flex;
    align-items: center;
    justify-content: center; }
  .UploadDocs .spinner {
    position: relative;
    width: 70px;
    height: 70px; }
  .UploadDocs .spinner-ring {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    border-radius: 50%;
    animation: spin 2s linear infinite; }
  .UploadDocs .spinner-percentage {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    font-weight: 400; }

@keyframes spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.CustomInput .ant-input-affix-wrapper {
  width: 100%;
  height: 48px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #2a2f3c;
  padding: 8px 16px; }

.CustomInput input {
  color: #929fb0;
  font-family: Inter;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: normal; }
  .CustomInput input::placeholder {
    color: #929fb0;
    font-family: Inter;
    font-size: 16px;
    font-style: italic !important;
    font-weight: 400;
    line-height: normal; }

.circle-tag .circle {
  width: 20px;
  height: 20px; }
  .circle-tag .circle-APPROVED {
    border-color: #92c295;
    background-color: #C2F0C5; }
    .circle-tag .circle-APPROVED:hover {
      background-color: #4CA852; }
  .circle-tag .circle-REVIEW {
    background-color: #AC78B3 !important;
    border-color: #AC78B3 !important; }
    .circle-tag .circle-REVIEW:hover {
      background-color: #855791 !important; }
  .circle-tag .circle-REQUEST_ERROR {
    background-color: #FFD4CF;
    border-color: #c94f4a; }
    .circle-tag .circle-REQUEST_ERROR:hover {
      background-color: #c94f4a; }

.CardDetailInformationBank {
  border-radius: 4px;
  border: 1px solid #929fb0;
  background: #fff;
  padding: 20px 16px; }
  .CardDetailInformationBank .h4 {
    margin-bottom: 24px; }
  .CardDetailInformationBank .label {
    color: #6e7889;
    margin-bottom: 4px; }
  .CardDetailInformationBank .info {
    color: #929fb0;
    font-style: italic; }
  .CardDetailInformationBank .row {
    display: flex;
    justify-content: center;
    align-items: center; }
    .CardDetailInformationBank .row .column {
      width: 50%; }
  .CardDetailInformationBank .column {
    margin-bottom: 20px; }
    .CardDetailInformationBank .column-line {
      border-bottom: 1px solid #dfe4eb;
      padding-bottom: 16px; }

.CardAlertError {
  border-radius: 6px;
  border: 1px solid #d7b8e5;
  background: #f7edfc;
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
  padding: 18px 24px; }
  .CardAlertError .h4-w5 {
    color: #241226;
    margin-bottom: 5px; }
  .CardAlertError .h4-w4 {
    color: #653b6f;
    margin-bottom: 30px; }

.CardSomeoneElse {
  margin-top: 10px;
  width: 100%; }
  .CardSomeoneElse input {
    background-color: #ebf6ff !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0;
    color: #48759a !important;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal; }
    .CardSomeoneElse input::placeholder {
      color: #9BBCEB;
      background-color: #ebf6ff !important;
      font-family: Inter;
      font-size: 16px;
      font-style: italic;
      font-weight: 500;
      line-height: normal; }
  .CardSomeoneElse .ant-form-item {
    width: 100%;
    margin-bottom: 15px; }
  .CardSomeoneElse .row {
    display: flex;
    justify-content: center;
    align-items: center; }
    .CardSomeoneElse .row .ant-form-item {
      width: 100%; }

.Switch {
  background: #afbdcc;
  min-width: auto;
  height: 14px;
  width: 24px; }
  .Switch .ant-switch-handle {
    width: 10px;
    height: 10px; }
  .Switch .ant-switch-handle {
    inset-inline-start: calc(100% - 20px); }

button.ant-switch.Switch.css-dev-only-do-not-override-nnuwmp.ant-switch-checked .ant-switch-handle {
  inset-inline-start: calc(100% - 13px) !important; }

.ant-switch.Switch.ant-switch-checked,
.ant-switch.Switch.ant-switch-checked:hover {
  background: #5e8eb7; }

.modal-basic {
  border-radius: 10px;
  border: 1px solid white;
  background: white;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 0;
  width: 556px !important;
  top: 202px !important; }
  .modal-basic .coin {
    width: 55px;
    height: 45px; }
  .modal-basic .ant-modal-content {
    background-color: transparent;
    padding: 32px; }
    .modal-basic .ant-modal-content .h2 {
      margin-top: 15px;
      margin-bottom: 5px; }
    .modal-basic .ant-modal-content .buttons {
      margin-top: 25px; }
    .modal-basic .ant-modal-content .ant-modal-footer {
      display: none; }
  .modal-basic .anticon {
    color: #6e7889; }
  .modal-basic .ant-checkbox-wrapper {
    margin-top: 10px; }
    .modal-basic .ant-checkbox-wrapper span {
      color: #244560;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.18px; }
  .modal-basic .ant-modal-content .h2 {
    color: #162e43; }
  .modal-basic .ant-modal-content .h4 {
    color: #48759a; }
  .modal-basic .ant-modal-content .buttons .button-modal-ok {
    border: 1px solid #162E43 !important;
    background: #162E43 !important;
    color: #ffffff !important; }
    .modal-basic .ant-modal-content .buttons .button-modal-ok:hover {
      background-color: #EBF6FF !important;
      border: 1px solid #97BCF0 !important;
      box-shadow: 2px 2px 12px 0px #0B131A1A; }
      .modal-basic .ant-modal-content .buttons .button-modal-ok:hover span {
        color: #244560 !important; }
      .modal-basic .ant-modal-content .buttons .button-modal-ok:hover:active {
        border: 1px solid #355C7D !important;
        box-shadow: none; }
  .modal-basic .ant-modal-content .buttons .button-modal-cancel {
    border: 1px solid #162e43 !important;
    color: #162e43 !important; }
  .modal-basic .button {
    margin-top: 16px;
    height: 40px !important;
    width: 100%;
    border-radius: 6px;
    height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 600; }
    .modal-basic .button--white {
      color: #122536 !important;
      background: white !important;
      border-color: #122536 !important; }
    .modal-basic .button--red {
      color: white !important;
      background: #A31C17 !important;
      border-color: #A31C17 !important; }

.modal-basic--small-screen {
  width: 375px !important;
  height: 270px !important;
  background-color: #FFF9EE;
  border: 1px solid #FFD47D;
  box-shadow: 0px 0px 4px 0px #00000026; }
  .modal-basic--small-screen .ant-modal-content {
    background-color: transparent;
    padding: 24px; }
    .modal-basic--small-screen .ant-modal-content .ant-modal-close-x {
      display: none; }
    .modal-basic--small-screen .ant-modal-content .ant-modal-footer {
      display: none; }
  .modal-basic--small-screen .modal-end-submit__content .h2 {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #3C302A; }
  .modal-basic--small-screen .modal-end-submit__content .h4 {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    margin-top: 6px; }
  .modal-basic--small-screen .modal-end-submit__content .buttons {
    width: 100%;
    margin-top: 32px; }
    .modal-basic--small-screen .modal-end-submit__content .buttons .button {
      background-color: #FFC857 !important;
      color: #66564D !important;
      font-weight: 600;
      font-size: 14px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px; }
      .modal-basic--small-screen .modal-end-submit__content .buttons .button::before {
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
        background-size: contain;
        background-repeat: no-repeat; }

.cont-modal {
  width: 100%; }

.ModalTask {
  position: fixed;
  background: rgba(42, 47, 60, 0.55);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  display: flex;
  justify-content: center;
  align-items: center; }
  .ModalTask .content-add {
    margin-top: 50px; }
  .ModalTask-content {
    width: 70%;
    background-color: #fff;
    height: 100%; }
  .ModalTask .button-close-mask {
    width: 30%;
    height: 100%;
    background-color: transparent;
    box-shadow: none;
    border: none; }
    .ModalTask .button-close-mask:hover, .ModalTask .button-close-mask:active, .ModalTask .button-close-mask:focus {
      background-color: transparent !important;
      box-shadow: none;
      border: none; }
  .ModalTask .content-modal {
    padding-bottom: 0; }
    .ModalTask .content-modal .modal-title {
      width: 100%;
      padding: 40px;
      padding-bottom: 0; }
      .ModalTask .content-modal .modal-title .flex-btw {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid #404859; }
      .ModalTask .content-modal .modal-title button,
      .ModalTask .content-modal .modal-title button:hover,
      .ModalTask .content-modal .modal-title button:active,
      .ModalTask .content-modal .modal-title button:focus {
        background-color: transparent;
        border: none !important;
        padding: 0 !important;
        box-shadow: none !important;
        color: #404859 !important; }
      .ModalTask .content-modal .modal-title .body-card {
        color: #404859;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        /* 133.333% */
        letter-spacing: 0.24px; }
    .ModalTask .content-modal .task-tracker-summary {
      width: 25%;
      padding: 48px 32px;
      border-right: 1px solid #DFE4EB; }
      .ModalTask .content-modal .task-tracker-summary .title-summary {
        font-family: Inter;
        font-weight: 500;
        font-size: 16px;
        line-height: 19.36px;
        letter-spacing: 0%;
        color: #2A2F3C; }
      .ModalTask .content-modal .task-tracker-summary .task-title {
        margin-top: 15px;
        font-family: Inter;
        font-weight: 500;
        font-size: 24px;
        line-height: 29.05px;
        letter-spacing: 0%;
        color: #404859; }
      .ModalTask .content-modal .task-tracker-summary .description {
        font-family: Inter;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        color: #404859; }
      .ModalTask .content-modal .task-tracker-summary .tag-blue {
        padding: 3px 7px;
        background: #5E8EB7;
        border-radius: 8px;
        color: white; }
      .ModalTask .content-modal .task-tracker-summary .link-blue {
        color: #5E8EB7;
        text-decoration: underline;
        font-size: 24px;
        font-family: Inter;
        font-weight: 600; }
        .ModalTask .content-modal .task-tracker-summary .link-blue span {
          font-size: 24px;
          font-family: Inter;
          font-weight: 600; }
      .ModalTask .content-modal .task-tracker-summary .placeholder {
        font-family: Inter;
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        color: #404859; }
      .ModalTask .content-modal .task-tracker-summary .price {
        display: block;
        font-family: Inter;
        font-weight: 400;
        font-style: italic;
        font-size: 24px;
        line-height: 29.05px;
        color: #929FB0; }
    .ModalTask .content-modal .modal-container {
      position: relative;
      width: 80%;
      height: 90vh;
      display: flex;
      flex-grow: 1;
      justify-content: center;
      align-items: flex-start;
      overflow-y: auto;
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;
      /* Internet Explorer 10+ */ }
      .ModalTask .content-modal .modal-container::-webkit-scrollbar {
        display: none;
        /* Safari and Chrome */ }
      .ModalTask .content-modal .modal-container .dots {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 45%;
        left: 30px;
        gap: 9px; }
        .ModalTask .content-modal .modal-container .dots .tooltip-button {
          opacity: 1;
          display: flex;
          border: none;
          background: transparent;
          font-family: Inter;
          font-weight: 600;
          font-size: 8px;
          line-height: 10px;
          letter-spacing: 0.16px; }
          .ModalTask .content-modal .modal-container .dots .tooltip-button-approved {
            color: #3F9545; }
          .ModalTask .content-modal .modal-container .dots .tooltip-button-draft {
            color: #3F9545; }
          .ModalTask .content-modal .modal-container .dots .tooltip-button-review {
            color: #855791; }
          .ModalTask .content-modal .modal-container .dots .tooltip-button-error {
            color: #AC3E3A; }
          .ModalTask .content-modal .modal-container .dots .tooltip-button-complete-ownerships {
            color: #3F9545; }
          .ModalTask .content-modal .modal-container .dots .tooltip-button-request_error {
            color: #AC3E3A; }
        .ModalTask .content-modal .modal-container .dots-button {
          padding: 0;
          border: 1.5px solid #6e7889;
          background: #fff;
          width: 10px;
          height: 10px;
          border-radius: 50%; }
          .ModalTask .content-modal .modal-container .dots-button-disabled-REVIEW:disabled {
            border: 2px dotted #A278B3 !important; }
          .ModalTask .content-modal .modal-container .dots-button-prev-hover:hover {
            height: 25px;
            width: 25px;
            background: #fff;
            border: 2px dotted #6eac72; }
          .ModalTask .content-modal .modal-container .dots-button-success {
            border: 1px solid #6eac72;
            background: #c5f0c8; }
          .ModalTask .content-modal .modal-container .dots-button-success-review {
            border: 1px solid #A278B3;
            background: #A278B3; }
          .ModalTask .content-modal .modal-container .dots-button-success-error {
            height: 25px;
            width: 25px;
            border: 2px dotted #C13934 !important; }
          .ModalTask .content-modal .modal-container .dots-button-active {
            height: 25px;
            width: 25px;
            border: 2px dotted #ddaa42 !important; }
          .ModalTask .content-modal .modal-container .dots-button-review-active {
            height: 25px;
            width: 25px;
            border: 2px dotted #855791 !important;
            color: #855791; }
          .ModalTask .content-modal .modal-container .dots-button-error-active {
            height: 25px;
            width: 25px;
            border: 2px dotted #AC3E3A !important; }
          .ModalTask .content-modal .modal-container .dots-button-approved-active {
            height: 25px;
            width: 25px;
            border: 2px dotted #4CA852; }
      .ModalTask .content-modal .modal-container .modal-title {
        border-bottom: 0;
        align-items: flex-end; }
        .ModalTask .content-modal .modal-container .modal-title button {
          height: 18px;
          text-transform: uppercase;
          color: #8a5791 !important; }
          .ModalTask .content-modal .modal-container .modal-title button img {
            margin-top: -0.9px;
            margin-right: 3px; }
      .ModalTask .content-modal .modal-container .text {
        margin-top: 5px; }
        .ModalTask .content-modal .modal-container .text a {
          margin-left: 6px; }
          .ModalTask .content-modal .modal-container .text a:hover {
            color: #2a2f3c; }
      .ModalTask .content-modal .modal-container .modal-cards {
        width: 100%;
        height: 100%;
        padding: 64px 50px 20px 70px;
        overflow: auto;
        max-width: 576px;
        /* Track */
        /* Handle */
        /* Handle on hover */ }
        .ModalTask .content-modal .modal-container .modal-cards--full {
          max-width: none;
          display: flex;
          justify-content: center; }
        .ModalTask .content-modal .modal-container .modal-cards-mx-w {
          max-width: 576px;
          width: 100%;
          padding-bottom: 20px; }
        .ModalTask .content-modal .modal-container .modal-cards .flex-btw {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-bottom: 12px; }
          .ModalTask .content-modal .modal-container .modal-cards .flex-btw .button {
            text-transform: uppercase;
            color: #404859;
            text-align: right;
            font-family: Inter;
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            text-transform: uppercase; }
            .ModalTask .content-modal .modal-container .modal-cards .flex-btw .button .anticon {
              color: #404859; }
        .ModalTask .content-modal .modal-container .modal-cards .title {
          background: #e3ddf0;
          border-radius: 140px;
          display: flex;
          padding: 5px 12px 5px 10px;
          justify-content: center;
          align-items: center;
          gap: 4px; }
          .ModalTask .content-modal .modal-container .modal-cards .title .body-regular {
            color: #48244d; }
        .ModalTask .content-modal .modal-container .modal-cards .h2 {
          margin-top: 12px; }
          .ModalTask .content-modal .modal-container .modal-cards .h2-lite {
            font-weight: 600; }
          .ModalTask .content-modal .modal-container .modal-cards .h2 .bold {
            font-weight: 800; }
        .ModalTask .content-modal .modal-container .modal-cards .h2-w8 {
          color: #ac78b3; }
        .ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar {
          width: 8px;
          border-radius: 5px; }
        .ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-track {
          background: #f1f1f1; }
        .ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 5px; }
        .ModalTask .content-modal .modal-container .modal-cards::-webkit-scrollbar-thumb:hover {
          background: #555; }
  .ModalTask .modal-review-task__footer {
    border-top: 1px solid #dfe4eb;
    height: 180px; }
    .ModalTask .modal-review-task__footer .text-footer .placeholder {
      color: #6e7889; }
      .ModalTask .modal-review-task__footer .text-footer .placeholder span {
        color: #f5faff;
        font-weight: 600;
        background-color: #5e8eb7;
        padding: 0 5px;
        border-radius: 3px; }
    .ModalTask .modal-review-task__footer .footer-grey .h4 {
      color: #6e7889;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 170%; }
    .ModalTask .modal-review-task__footer .body-regular {
      color: #6e7889; }
    .ModalTask .modal-review-task__footer .footer_dost {
      align-items: center; }
      .ModalTask .modal-review-task__footer .footer_dost .body-regular {
        color: #404859; }
      .ModalTask .modal-review-task__footer .footer_dost .circles {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 24px; }
    .ModalTask .modal-review-task__footer .modal-container {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
      padding: 0px 50px 0px 70px; }
      .ModalTask .modal-review-task__footer .modal-container .modal-cards {
        width: 100%;
        height: 100%;
        max-width: 576px;
        padding: 20px 0; }
        .ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 {
          color: #ac78b3;
          margin-bottom: 10px; }
          .ModalTask .modal-review-task__footer .modal-container .modal-cards .h4-w4 .h4 {
            color: #6e7889; }
        .ModalTask .modal-review-task__footer .modal-container .modal-cards .flex {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%; }
          .ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 24px; }
            .ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle {
              border-radius: 100%;
              border: 1px solid #8a5791;
              background: #dfb8e5;
              width: 20px;
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center; }
              .ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active {
                border: 1px solid #587e5b;
                background: #6eac72; }
                .ModalTask .modal-review-task__footer .modal-container .modal-cards .flex .circles .circle-active img {
                  display: none; }

.ModalTask-content-right {
  width: 35%;
  background-color: #fff;
  height: 100%;
  border-left: 1px solid #ccd3db;
  padding: 60px 45px 25px 30px; }
  .ModalTask-content-right .w-md-editor .title {
    line-height: unset !important;
    font-size: unset !important;
    font-weight: unset !important; }
  .ModalTask-content-right .type {
    font-size: 14px; }
  .ModalTask-content-right .rejected-information {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 20px; }
    .ModalTask-content-right .rejected-information b {
      font-size: 14px; }
    .ModalTask-content-right .rejected-information .content-files {
      margin-top: 6px; }
    .ModalTask-content-right .rejected-information .content-text-data {
      position: relative;
      background-color: #FFD4CF;
      border: 1px solid #C13934;
      border-radius: 10px;
      margin-top: 10px; }
      .ModalTask-content-right .rejected-information .content-text-data .text-data {
        padding: 5px 27px 12px;
        display: block; }
        .ModalTask-content-right .rejected-information .content-text-data .text-data .row {
          display: flex;
          justify-content: space-between;
          margin-top: 8px; }
          .ModalTask-content-right .rejected-information .content-text-data .text-data .row span {
            font-family: Inter;
            font-weight: 400;
            font-size: 14px;
            line-height: 14.52px;
            letter-spacing: 0px;
            color: #8A130F; }
          .ModalTask-content-right .rejected-information .content-text-data .text-data .row b {
            font-family: Inter;
            font-weight: 600;
            font-size: 12px;
            line-height: 14.52px;
            letter-spacing: 0px;
            text-align: right;
            color: #610805; }
      .ModalTask-content-right .rejected-information .content-text-data .circle-input {
        display: flex;
        position: absolute;
        height: 100%;
        left: -7px;
        justify-content: center;
        align-items: center; }
    .ModalTask-content-right .rejected-information .reject-documents-label {
      margin-top: 10px;
      font-size: 14px;
      color: #C13934; }
  .ModalTask-content-right .button-close {
    position: absolute;
    top: 10px;
    right: 10px;
    color: black; }
    .ModalTask-content-right .button-close:hover {
      color: black !important; }
  .ModalTask-content-right .quill {
    height: 350px; }
    .ModalTask-content-right .quill .ql-editor strong {
      font-weight: bold; }
    .ModalTask-content-right .quill .ql-editor em {
      font-style: italic; }

.QuestionBasic .body-regular {
  color: #6e7889; }

.QuestionBasic .h3 {
  margin-bottom: 40px; }

.QuestionBasic .options {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px; }
  .QuestionBasic .options .content-left {
    display: flex;
    flex-direction: column; }
  .QuestionBasic .options .Button-option {
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    border-radius: 10px;
    border: 1px solid #ccd3db;
    background: #f9fafb;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
    min-height: 56px;
    height: auto;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 19px 24px; }
    .QuestionBasic .options .Button-option-text {
      color: #2a2f3c !important;
      display: flex; }
    .QuestionBasic .options .Button-option .flex-btw {
      margin-bottom: 0 !important; }
      .QuestionBasic .options .Button-option .flex-btw.wide > * {
        flex: 1 1; }
    .QuestionBasic .options .Button-option .flex-start {
      display: none; }
    .QuestionBasic .options .Button-option .ml-3 {
      margin-left: 4px; }
    .QuestionBasic .options .Button-option .sub-title-no {
      display: none; }
  .QuestionBasic .options .option-hover-blue:hover {
    border-radius: 6px;
    border: 1px solid #9bbceb;
    background: #ebf6ff;
    box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1); }
    .QuestionBasic .options .option-hover-blue:hover .flex-start {
      display: flex;
      gap: 6px;
      align-items: flex-start; }
      .QuestionBasic .options .option-hover-blue:hover .flex-start img {
        margin-top: 3px; }
      .QuestionBasic .options .option-hover-blue:hover .flex-start .body-regular {
        max-width: 300px; }
    .QuestionBasic .options .option-hover-blue:hover h4 {
      color: #355c7d !important; }
    .QuestionBasic .options .option-hover-blue:hover .body-regular {
      color: #5e8eb7; }
    .QuestionBasic .options .option-hover-blue:hover .sub-title {
      font-weight: 500; }
  .QuestionBasic .options .option-hover-purpure:hover {
    border-radius: 6px;
    border: 1px solid #8A5791;
    background: #f2edfc;
    box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1); }
    .QuestionBasic .options .option-hover-purpure:hover .flex-start {
      display: flex;
      gap: 6px;
      align-items: flex-start; }
      .QuestionBasic .options .option-hover-purpure:hover .flex-start img {
        margin-top: 3px; }
      .QuestionBasic .options .option-hover-purpure:hover .flex-start .body-regular {
        max-width: 300px; }
    .QuestionBasic .options .option-hover-purpure:hover h4-w5 {
      color: #48244d; }
    .QuestionBasic .options .option-hover-purpure:hover h4-w4 {
      color: #693b6f;
      margin-top: 5px;
      line-height: 150%;
      margin-bottom: 4px; }
    .QuestionBasic .options .option-hover-purpure:hover span {
      color: #8A5791 !important; }
    .QuestionBasic .options .option-hover-purpure:hover p {
      color: #8A5791 !important; }
  .QuestionBasic .options .option-active {
    border-radius: 6px;
    box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1); }
    .QuestionBasic .options .option-active .flex-start {
      display: flex;
      gap: 6px;
      align-items: flex-start; }
      .QuestionBasic .options .option-active .flex-start img {
        margin-top: 3px; }
      .QuestionBasic .options .option-active .flex-start .body-regular {
        max-width: 300px; }
    .QuestionBasic .options .option-active .sub-title {
      font-weight: 500; }
    .QuestionBasic .options .option-active-blue {
      border: 1px solid #9bbceb;
      background: #ebf6ff; }
      .QuestionBasic .options .option-active-blue h4 {
        color: #355c7d !important; }
      .QuestionBasic .options .option-active-blue .body-regular {
        color: #5e8eb7; }
      .QuestionBasic .options .option-active-blue .Button-option-text {
        color: #355c7d !important; }
      .QuestionBasic .options .option-active-blue-description {
        color: #5e8eb7 !important;
        font-size: 14px; }
    .QuestionBasic .options .option-active-purpure {
      border: 1px solid #8a5791;
      background: #f2edfc; }
      .QuestionBasic .options .option-active-purpure h4 {
        color: #48244d; }
      .QuestionBasic .options .option-active-purpure .Button-option-text {
        color: #48244D !important; }

.QuestionBasic .list {
  list-style-type: disc;
  list-style: disc;
  padding-left: 25px;
  margin-top: 15px; }
  .QuestionBasic .list .h4 {
    color: #404859;
    line-height: 145%; }

.ModalCloseTask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  background-color: transparent;
  text-align: left; }
  .ModalCloseTask-mask {
    position: absolute;
    z-index: 2;
    background-color: #00000057;
    border: none !important;
    border-radius: 0 !important;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0; }
    .ModalCloseTask-mask:hover {
      background-color: #00000057 !important; }
  .ModalCloseTask .modal-end-submit__content {
    position: relative;
    z-index: 20;
    background-color: #ffffff;
    background-clip: padding-box;
    border: 0;
    border-radius: 10px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    pointer-events: auto;
    padding: 25px 24px;
    padding-bottom: 30px;
    width: 550px; }
    .ModalCloseTask .modal-end-submit__content .button-close {
      padding: 0;
      position: absolute;
      right: 15px;
      border: none;
      top: 10px; }
    .ModalCloseTask .modal-end-submit__content .coin {
      height: 34px;
      width: auto;
      margin-bottom: 15px; }
    .ModalCloseTask .modal-end-submit__content h2 {
      color: #244560 !important; }
    .ModalCloseTask .modal-end-submit__content .h4 {
      color: #404859;
      margin-top: 5px; }
    .ModalCloseTask .modal-end-submit__content .buttons {
      margin-top: 50px;
      gap: 15px;
      display: grid; }
      .ModalCloseTask .modal-end-submit__content .buttons .button-modal-ok {
        background-color: #162e43 !important;
        border-color: #162e43 !important;
        color: #fff !important; }
      .ModalCloseTask .modal-end-submit__content .buttons .button-modal-cancel {
        background-color: #fff !important;
        border: 1px solid #48759a !important; }
    .ModalCloseTask .modal-end-submit__content .ant-checkbox-wrapper {
      color: #244560; }
      .ModalCloseTask .modal-end-submit__content .ant-checkbox-wrapper:hover .ant-checkbox-inner {
        border: 1px solid #5E8EB7 !important; }
      .ModalCloseTask .modal-end-submit__content .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #5E8EB7 !important; }
    .ModalCloseTask .modal-end-submit__content .ant-checkbox,
    .ModalCloseTask .modal-end-submit__content .ant-checkbox-input {
      border: none; }
      .ModalCloseTask .modal-end-submit__content .ant-checkbox:hover .ant-checkbox-inner,
      .ModalCloseTask .modal-end-submit__content .ant-checkbox-input:hover .ant-checkbox-inner {
        border: 1px solid #5E8EB7 !important; }
      .ModalCloseTask .modal-end-submit__content .ant-checkbox:hover .ant-checkbox-checked .ant-checkbox-inner,
      .ModalCloseTask .modal-end-submit__content .ant-checkbox-input:hover .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #5E8EB7 !important; }
    .ModalCloseTask .modal-end-submit__content .ant-checkbox-inner {
      width: 18px;
      height: 18px;
      border: 1px solid #5E8EB7; }
    .ModalCloseTask .modal-end-submit__content .ant-checkbox-disabled .ant-checkbox-inner {
      border-radius: 2px;
      background: #DFE4EB !important;
      border: 1px solid #DFE4EB; }
    .ModalCloseTask .modal-end-submit__content .ant-checkbox-checked:hover .ant-checkbox-inner {
      background-color: #5E8EB7 !important; }
    .ModalCloseTask .modal-end-submit__content .ant-checkbox-checked .ant-checkbox-inner {
      border-radius: 2px;
      background: #5E8EB7; }

.InputBorderNone .input {
  color: #775614;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal; }

.InputBorderNone .body-placeholder-w4 {
  color: #775614;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; }

.InputBorderNone .error {
  font-weight: 400;
  color: #C13934; }
  .InputBorderNone .error::placeholder {
    color: #929fb0;
    font-size: 14px;
    font-weight: 400; }

.InputBorderNone .border-error {
  border-bottom: 1px solid #C13934; }

.InputBorderNone .bold-lith {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400; }
  .InputBorderNone .bold-lith::placeholder {
    color: #929fb0;
    font-family: Inter;
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 145%; }

.InputBorderNone .bold {
  color: #2a2f3c;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600; }

.InputBorderNone .percentage-bottom {
  border: 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #afbdcc;
  padding-top: 1px;
  margin-bottom: 10px !important;
  width: 90% !important; }
  .InputBorderNone .percentage-bottom .body-regular span {
    font-size: 12px; }

.InputBorderNone .ant-input-number-input {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  padding: 5px 0px !important; }
  .InputBorderNone .ant-input-number-input .default {
    font-weight: 400;
    color: #404859; }
  .InputBorderNone .ant-input-number-input .warning {
    font-weight: 600;
    color: #775614; }
  .InputBorderNone .ant-input-number-input::placeholder {
    color: #929fb0;
    font-family: Inter;
    font-style: italic !important;
    font-weight: 400; }

.view-entities {
  padding: 24px 25px; }
  .view-entities .title {
    color: var(800-grey, #404859);
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal; }
    .view-entities .title > span {
      cursor: pointer;
      color: var(--blue60, #5E8EB7);
      font-family: Inter;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-decoration-line: underline; }
  .view-entities-header {
    display: flex;
    justify-content: space-between; }
    .view-entities-header .search-box {
      cursor: pointer;
      box-sizing: border-box;
      width: 384px;
      padding: 5px 18px 5px 8px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 10px;
      border: 1px solid #CCD3DB;
      background: #F9FAFB;
      color: #6E7889;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; }
      .view-entities-header .search-box > input {
        all: unset;
        width: 100%;
        margin-left: 8px; }
  .view-entities-content {
    margin-top: 35px;
    display: flex;
    flex-direction: row;
    gap: 20px; }
    .view-entities-content .card-entity {
      width: 510px;
      background: #FDFEFF;
      border: 1px solid #929FB0;
      border-radius: 10px;
      box-shadow: 2px 2px 8px 0px #00000005;
      padding: 14px 16px; }
      .view-entities-content .card-entity-button {
        border-radius: 6px;
        margin-top: 10px; }
      .view-entities-content .card-entity-header {
        border-bottom: 1px solid #CCD3DB; }
        .view-entities-content .card-entity-header h3 {
          font-family: Inter;
          font-size: 16px;
          font-weight: 600;
          line-height: 18.4px;
          text-align: left;
          margin-bottom: 6px; }
        .view-entities-content .card-entity-header p {
          font-family: Inter;
          font-size: 12px;
          font-weight: 400;
          line-height: 16.8px;
          text-align: left;
          margin-bottom: 8px; }
        .view-entities-content .card-entity-header-description {
          display: flex; }
        .view-entities-content .card-entity-header .see-loan {
          height: 15px;
          margin-left: 3px; }
          .view-entities-content .card-entity-header .see-loan span {
            font-size: 12px; }
      .view-entities-content .card-entity-content {
        margin-top: 12px; }
        .view-entities-content .card-entity-content-resume {
          display: flex;
          flex-direction: column; }
          .view-entities-content .card-entity-content-resume label {
            font-family: Inter;
            font-size: 12px;
            font-weight: 600;
            line-height: 14.52px;
            text-align: left; }
          .view-entities-content .card-entity-content-resume span {
            margin-top: 3px;
            font-family: Inter;
            font-size: 12px;
            font-weight: 400;
            line-height: 12.1px;
            text-align: left;
            color: #6E7889; }
        .view-entities-content .card-entity-content-guarantors {
          display: flex;
          justify-content: space-between; }
          .view-entities-content .card-entity-content-guarantors .box-shadow {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 475px;
            height: 32px;
            cursor: pointer; }
            .view-entities-content .card-entity-content-guarantors .box-shadow:hover {
              background-color: rgba(223, 228, 235, 0.6);
              -webkit-backdrop-filter: blur(3px);
                      backdrop-filter: blur(3px);
              box-shadow: 2px 1px 5px 0px #00000014; }
              .view-entities-content .card-entity-content-guarantors .box-shadow:hover span {
                display: block; }
            .view-entities-content .card-entity-content-guarantors .box-shadow span {
              display: none;
              color: #2A2F3C;
              font-weight: 600;
              line-height: 14.52px; }
          .view-entities-content .card-entity-content-guarantors .guarantors-names {
            font-family: Inter;
            font-size: 12px;
            font-weight: 500;
            line-height: 14px;
            text-align: left;
            width: 200px; }
        .view-entities-content .card-entity-content-documents {
          display: flex;
          justify-content: space-between;
          margin-top: 12px; }
          .view-entities-content .card-entity-content-documents .doc-states {
            width: 200px; }

.item-loan {
  display: flex;
  justify-content: space-between;
  width: 460px; }
  .item-loan-state {
    width: 110px; }
  .item-loan-name {
    font-size: 12px;
    margin-right: auto;
    display: flex;
    align-items: center; }
    .item-loan-name b {
      color: #355C7D;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 1.2;
      width: 140px; }
      .item-loan-name b:hover {
        color: #355C7D !important; }

.dropdown-item-loan {
  display: flex;
  justify-content: space-between;
  width: 460px; }
  .dropdown-item-loan-state {
    width: 110px; }
  .dropdown-item-loan-name {
    font-size: 12px;
    margin-right: auto;
    display: flex;
    align-items: center; }
    .dropdown-item-loan-name b {
      color: #355C7D;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 1.2;
      width: 200px; }
      .dropdown-item-loan-name b:hover {
        color: #355C7D !important; }

.view-loans {
  padding: 24px 25px;
  position: relative;
  height: 100%; }
  .view-loans .title {
    color: var(800-grey, #404859);
    font-size: 32px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px; }
    .view-loans .title button {
      height: 32px; }
      .view-loans .title button span {
        font-size: 32px; }
  .view-loans-filters {
    margin-top: 30px;
    display: flex;
    justify-content: flex-start; }
  .view-loans-header {
    display: flex;
    justify-content: space-between; }
    .view-loans-header .search-box {
      cursor: pointer;
      box-sizing: border-box;
      width: 384px;
      padding: 5px 18px 5px 8px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 10px;
      border: 1px solid #CCD3DB;
      background: #F9FAFB;
      color: #6E7889;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; }
      .view-loans-header .search-box > input {
        all: unset;
        width: 100%;
        margin-left: 8px; }
  .view-loans-content {
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    gap: 20px; }
    .view-loans-content .card-loan {
      width: 510px;
      background: #FDFEFF;
      border: 1px solid #929FB0;
      border-radius: 10px;
      box-shadow: 2px 2px 8px 0px #00000005;
      padding: 14px 16px; }
      .view-loans-content .card-loan-error {
        border: 1px solid #C94F4A; }
        .view-loans-content .card-loan-error .card-loan-button {
          border: 1px solid #AC3E3A !important;
          color: #712220 !important; }
      .view-loans-content .card-loan-button {
        border-radius: 6px;
        margin-top: 10px; }
      .view-loans-content .card-loan-pre-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px; }
        .view-loans-content .card-loan-pre-header-description p {
          font-size: 12px; }
          .view-loans-content .card-loan-pre-header-description p b {
            font-weight: 600;
            letter-spacing: 0.03em; }
        .view-loans-content .card-loan-pre-header .state-tag {
          border-radius: 76px;
          padding: 4px 8px 4px 7px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px; }
          .view-loans-content .card-loan-pre-header .state-tag-INCOMPLETE {
            background: #404859; }
            .view-loans-content .card-loan-pre-header .state-tag-INCOMPLETE .tag-name {
              color: #f9fafb; }
      .view-loans-content .card-loan-header {
        border-bottom: 1px solid #CCD3DB; }
        .view-loans-content .card-loan-header h3 {
          font-family: Inter;
          font-size: 16px;
          font-weight: 600;
          line-height: 18.4px;
          text-align: left;
          margin-bottom: 6px; }
        .view-loans-content .card-loan-header p {
          font-family: Inter;
          font-size: 12px;
          font-weight: 400;
          line-height: 16.8px;
          text-align: left;
          margin-bottom: 8px; }
        .view-loans-content .card-loan-header-description {
          display: flex; }
        .view-loans-content .card-loan-header .see-loan {
          height: 15px;
          margin-left: 3px; }
          .view-loans-content .card-loan-header .see-loan span {
            font-size: 12px; }
      .view-loans-content .card-loan-content {
        margin-top: 12px; }
        .view-loans-content .card-loan-content-resume {
          display: flex;
          flex-direction: column;
          width: 100%; }
          .view-loans-content .card-loan-content-resume label {
            font-family: Inter;
            font-size: 12px;
            font-weight: 600;
            line-height: 14.52px;
            text-align: left; }
          .view-loans-content .card-loan-content-resume span {
            margin-top: 3px;
            font-family: Inter;
            font-size: 12px;
            font-weight: 400;
            line-height: 12.1px;
            text-align: left;
            color: #6E7889; }
        .view-loans-content .card-loan-content-guarantors {
          display: flex;
          justify-content: space-between; }
          .view-loans-content .card-loan-content-guarantors .box-shadow {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 475px;
            height: 32px;
            cursor: pointer; }
            .view-loans-content .card-loan-content-guarantors .box-shadow:hover {
              background-color: rgba(223, 228, 235, 0.6);
              -webkit-backdrop-filter: blur(3px);
                      backdrop-filter: blur(3px);
              box-shadow: 2px 1px 5px 0px #00000014; }
              .view-loans-content .card-loan-content-guarantors .box-shadow:hover span {
                display: block; }
            .view-loans-content .card-loan-content-guarantors .box-shadow span {
              display: none;
              color: #2A2F3C;
              font-weight: 600;
              line-height: 14.52px; }
          .view-loans-content .card-loan-content-guarantors .guarantors-names {
            font-family: Inter;
            font-size: 12px;
            font-weight: 500;
            line-height: 14px;
            text-align: left;
            width: 200px; }
        .view-loans-content .card-loan-content-documents {
          display: flex;
          justify-content: space-between;
          margin-top: 12px; }
          .view-loans-content .card-loan-content-documents .doc-states {
            width: 200px;
            display: flex;
            flex-wrap: wrap;
            /* Para que los círculos pasen a la siguiente línea */
            max-width: 100%;
            /* Ajusta el ancho máximo si es necesario */
            gap: 10px;
            /* Espacio entre los círculos */
            justify-content: flex-start; }
          .view-loans-content .card-loan-content-documents .circles-tags {
            display: flex;
            flex-wrap: wrap;
            /* Para que los círculos pasen a la siguiente línea */
            max-width: 100%;
            /* Ajusta el ancho máximo si es necesario */
            gap: 10px;
            /* Espacio entre los círculos */
            justify-content: flex-start; }

.button-actions-pagination {
  position: absolute;
  top: 50%;
  right: -10px;
  display: flex;
  flex-direction: column;
  z-index: 99; }
  .button-actions-pagination button {
    width: 24px;
    padding: 0;
    border: 1px solid #CCD3DB;
    border-radius: 6px; }
    .button-actions-pagination button:first-child {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px; }
    .button-actions-pagination button:nth-child(2) {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px; }
    .button-actions-pagination button svg {
      color: #6E7889; }
    .button-actions-pagination button:hover {
      border: 1px solid #CCD3DB !important; }
    .button-actions-pagination button:disabled {
      background: white; }
      .button-actions-pagination button:disabled svg {
        opacity: 0.2; }

.dropdown-item-loan {
  display: flex;
  justify-content: space-between;
  width: 460px; }
  .dropdown-item-loan-state {
    width: 110px; }
  .dropdown-item-loan-name {
    font-size: 12px;
    margin-right: auto;
    display: flex;
    align-items: center; }
    .dropdown-item-loan-name b {
      color: #355C7D;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 1.2;
      width: 200px; }

.view-profile {
  padding: 24px 15px; }
  .view-profile-header .title {
    color: #404859;
    font-size: 32px;
    font-weight: 600;
    gap: 5px; }
    .view-profile-header .title button {
      height: 32px; }
      .view-profile-header .title button span {
        font-size: 32px; }
  .view-profile .button-r,
  .view-profile .button-r:hover {
    width: 58px;
    height: 20px;
    border: 1px solid #bb8d2f;
    color: #bb8d2f;
    border-radius: 76px;
    padding: 0;
    font-family: Inter;
    font-size: 10px;
    font-weight: 600;
    line-height: 12.1px;
    margin: 0 15px; }
  .view-profile .button-delete,
  .view-profile .button-delete:hover {
    height: 20px;
    border: none;
    color: #c94f4a;
    padding: 0;
    font-family: Inter;
    font-size: 10px;
    font-weight: 600;
    line-height: 12.1px;
    margin: 0 15px; }
  .view-profile .flex-2-col {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    width: 100%;
    gap: 30px; }
    .view-profile .flex-2-col .box {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 50%; }
  .view-profile .gap-3 {
    gap: 6px; }
  .view-profile .card-profile-generic {
    border: 1px solid #afbdcc;
    border-radius: 10px;
    padding: 15px;
    width: 100%; }
    .view-profile .card-profile-generic .card-title {
      font-family: Inter;
      font-size: 24px;
      font-weight: 400;
      line-height: 29.05px;
      text-align: left; }
    .view-profile .card-profile-generic .table {
      width: 100%;
      margin-top: 10px; }
      .view-profile .card-profile-generic .table-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 7px; }
        .view-profile .card-profile-generic .table-row .title {
          font-family: Inter;
          font-size: 12px;
          font-weight: 400;
          line-height: 14.52px;
          text-align: left;
          color: #6e7889; }
        .view-profile .card-profile-generic .table-row .flex {
          display: flex;
          justify-content: space-between; }
          .view-profile .card-profile-generic .table-row .flex .col {
            width: 50%; }
            .view-profile .card-profile-generic .table-row .flex .col .italic {
              font-family: Inter;
              font-size: 14px;
              font-style: italic;
              font-weight: 400;
              line-height: 16.94px;
              text-align: left;
              color: #929fb0; }
    .view-profile .card-profile-generic .avatar .ant-avatar-string {
      font-size: 25px; }
    .view-profile .card-profile-generic .avatar .ant-upload {
      width: 68px !important;
      height: 68px !important; }
    .view-profile .card-profile-generic .ant-upload-wrapper.ant-upload-picture-circle-wrapper {
      width: auto; }
    .view-profile .card-profile-generic .title-bold {
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      line-height: 16.94px;
      text-align: left;
      color: #404859; }
      .view-profile .card-profile-generic .title-bold .bold {
        font-weight: 600; }
    .view-profile .card-profile-generic .body-bold {
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      line-height: 16.94px;
      text-align: right; }
    .view-profile .card-profile-generic .button-transparent {
      padding: 0;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #8A130F; }
      .view-profile .card-profile-generic .button-transparent:hover {
        color: #8A130F !important; }
    .view-profile .card-profile-generic .button-round {
      width: 75px;
      height: 20px;
      padding: 0;
      border-radius: 76px;
      border: 2px solid #404859;
      font-family: Inter;
      font-size: 10px;
      font-weight: 600; }
    .view-profile .card-profile-generic .button-edit,
    .view-profile .card-profile-generic .button-edit:hover {
      font-family: Inter;
      font-size: 10px;
      font-weight: 500;
      line-height: 12px;
      text-align: left;
      color: #5e8eb7; }
      .view-profile .card-profile-generic .button-edit .edit,
      .view-profile .card-profile-generic .button-edit:hover .edit {
        width: 10px;
        height: 10px;
        margin-right: 3px; }
    .view-profile .card-profile-generic .link {
      padding: 0;
      height: 25px; }
      .view-profile .card-profile-generic .link span {
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        line-height: 16.94px;
        text-align: left;
        color: #5e8eb7;
        text-decoration: none; }
      .view-profile .card-profile-generic .link .arrow {
        width: 15px;
        margin-left: 5px; }
    .view-profile .card-profile-generic .text-footer {
      font-family: Inter;
      font-size: 12px;
      font-weight: 400;
      line-height: 14.52px;
      text-align: left;
      color: #6e7889;
      margin-top: 14px; }
      .view-profile .card-profile-generic .text-footer span {
        color: #4e8aff; }

.issues-task-response .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px; }
  .issues-task-response .row .box {
    width: 40%; }
    .issues-task-response .row .box .body-card {
      margin-bottom: 4px; }
  .issues-task-response .row .issue-text {
    flex-grow: 1;
    display: flex;
    align-items: center;
    overflow: hidden; }
    .issues-task-response .row .issue-text h3 {
      white-space: nowrap; }
    .issues-task-response .row .issue-text span {
      padding-left: 3px;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis; }
  .issues-task-response .row button {
    width: auto !important;
    flex-shrink: 0; }
  .issues-task-response .row .button-link-error {
    color: #8A130F !important;
    background: none !important;
    border: none !important;
    box-shadow: none !important; }
    .issues-task-response .row .button-link-error span {
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-decoration-line: underline; }
    .issues-task-response .row .button-link-error:hover {
      color: #8A130F !important; }

.issues-task-response .divider {
  margin-top: 10px;
  border-top: 1px solid #ffd4cf;
  padding-top: 8px; }
  .issues-task-response .divider-dark {
    border-top: 1px solid #E87C70; }

.SectionNewBank .h4,
.SectionNewBank .body-regular {
  margin-bottom: 8px;
  color: #2a2f3c;
  line-height: 145%; }

.SectionNewBank .button {
  width: auto !important;
  font-size: 20px;
  font-weight: 600; }

.SectionNewBank .button-block {
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center; }

.card-add-account {
  border-radius: 10px;
  border: 1px solid #2a2f3c;
  padding: 7px 16px;
  margin-top: 16px; }
  .card-add-account .ModalEndSubmit .button {
    margin-bottom: 5px; }
  .card-add-account .flex-btw {
    margin-bottom: 0 !important; }
    .card-add-account .flex-btw .box {
      height: 100%; }
  .card-add-account .UploadDocs .flex-btw {
    border: none; }
  .card-add-account .body-card {
    color: #404859 !important; }
  .card-add-account .box {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between; }
    .card-add-account .box .h4 {
      color: #929fb0;
      font-style: italic;
      margin-bottom: 16px; }
    .card-add-account .box .ModalEndSubmit .button {
      display: none; }
  .card-add-account .button-submit {
    margin-bottom: 20px;
    border-radius: 6px; }
    .card-add-account .button-submit span {
      color: #fff;
      text-align: center;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0.18px; }
  .card-add-account .top-InfoExpand {
    border-top: 1px solid #afbdcc; }
    .card-add-account .top-InfoExpand .body-card {
      max-width: 420px; }
  .card-add-account .setcion-grid {
    display: grid !important;
    width: 100%;
    justify-content: normal !important;
    grid-template-columns: repeat(2, 1fr);
    padding-bottom: 10px; }
    .card-add-account .setcion-grid .box {
      height: 100%;
      min-width: 270px;
      width: 100% !important;
      margin-top: 7px; }
    .card-add-account .setcion-grid .box:last-child {
      margin-top: 0;
      transform: translateX(10px); }

.CardStateAccount {
  border-radius: 10px;
  border: 1px solid #7b7b7b;
  padding: 12px 16px; }
  .CardStateAccount .label {
    border-radius: 100px;
    min-width: 81px;
    width: auto;
    max-width: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 4px;
    gap: 4px;
    margin-bottom: 8px;
    background: #969696; }
    .CardStateAccount .label .body-small {
      margin-bottom: 0; }
  .CardStateAccount_head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%; }
  .CardStateAccount .box {
    width: 300px !important; }
    .CardStateAccount .box .body-card {
      margin-bottom: 6px; }
    .CardStateAccount .box .file-ok {
      margin-top: 0 !important; }
    .CardStateAccount .box-error .flex .button:last-child {
      display: none !important; }
    .CardStateAccount .box-success .flex .button:last-child {
      display: none !important; }
  .CardStateAccount .divider {
    border-top: 1px solid #afbdcc;
    margin-top: 20px; }
  .CardStateAccount--inReview {
    background: #fdfcff;
    border: 1px solid #ac78b3; }
    .CardStateAccount--inReview .label {
      background: #e3ddf0; }
      .CardStateAccount--inReview .label .body-small {
        color: #48244d; }
    .CardStateAccount--inReview .box .body-card {
      color: #48244d; }
      .CardStateAccount--inReview .box .body-card-dark {
        color: #2a2f3c; }
    .CardStateAccount--inReview .box .body-regular {
      color: #48244d; }
    .CardStateAccount--inReview .file-ok .file-content .name {
      color: #693b6f !important; }
    .CardStateAccount--inReview .file-ok .file-content .anticon {
      color: #693b6f !important; }
  .CardStateAccount--error {
    border: 1px solid #c94f4a; }
    .CardStateAccount--error .label {
      background: #ffd4cf; }
      .CardStateAccount--error .label img {
        margin-top: 1px; }
      .CardStateAccount--error .label .body-small {
        color: #712220; }
    .CardStateAccount--error .UploadDocs .input-content {
      border: 1px dashed #e67f73; }
    .CardStateAccount--error .row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 7px; }
      .CardStateAccount--error .row .box {
        width: 40%; }
        .CardStateAccount--error .row .box .body-card {
          margin-bottom: 4px; }
      .CardStateAccount--error .row .issue-text {
        flex-grow: 1;
        display: flex;
        align-items: center;
        overflow: hidden; }
        .CardStateAccount--error .row .issue-text h3 {
          white-space: nowrap; }
        .CardStateAccount--error .row .issue-text span {
          padding-left: 3px;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis; }
      .CardStateAccount--error .row button {
        width: auto !important;
        flex-shrink: 0; }
    .CardStateAccount--error .divider {
      margin-top: 20px;
      border-top: 1px solid #ffd4cf;
      padding-top: 8px; }
      .CardStateAccount--error .divider-dark {
        border-top: 1px solid #E87C70; }
  .CardStateAccount--approved {
    border: 1px solid #3F9545; }
    .CardStateAccount--approved .label {
      background: #C5F0C8; }
      .CardStateAccount--approved .label img {
        margin-top: 1px; }
      .CardStateAccount--approved .label .body-small {
        color: #355137; }
    .CardStateAccount--approved .UploadDocs .input-content {
      border: 1px dashed #C5F0C8; }
    .CardStateAccount--approved .row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px; }
      .CardStateAccount--approved .row .box {
        width: 40%; }
        .CardStateAccount--approved .row .box .body-card {
          margin-bottom: 4px; }
    .CardStateAccount--approved .divider {
      margin-top: 20px;
      border-top: 1px solid #C5F0C8;
      padding-top: 8px; }
    .CardStateAccount--approved .file-ok .file-content {
      border: 1px solid #75C27A !important;
      background-color: #C5F0C8 !important; }
      .CardStateAccount--approved .file-ok .file-content .name {
        color: #355137 !important; }
      .CardStateAccount--approved .file-ok .file-content .anticon {
        color: #355137 !important; }
  .CardStateAccount .row-btw .box {
    width: 100%; }
  .CardStateAccount .section-upload .UploadDocs .file-content {
    height: 28px !important;
    border-radius: 2px;
    border: 1px solid #eff3f5 !important;
    background: #eff3f5 !important;
    padding-left: 12px !important; }
  .CardStateAccount .section-upload .UploadDocs .InputUploadedFile .file-ok .file .circle {
    display: none; }

.DscrQuestionsAgreements .Step3 .h2 {
  margin-top: 4px;
  margin-bottom: 10px; }
  .DscrQuestionsAgreements .Step3 .h2 .blue-bold {
    color: #5e8eb7;
    font-weight: 800;
    text-decoration-line: underline;
    color: #2A2F3C;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 135%;
    text-decoration-line: unset; }

.DscrQuestionsAgreements .Step3 .rent-input {
  border: none;
  width: auto;
  display: inline; }
  .DscrQuestionsAgreements .Step3 .rent-input.touched {
    color: #404859; }

.DscrQuestionsAgreements .Step3 .month {
  color: var(800-grey, #404859);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; }

.DscrQuestionsAgreements .Step3 #rent-button {
  margin-top: 16px; }

.DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex {
  display: flex;
  width: 100%; }
  .DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .cont-files {
    width: 100%; }
  .DscrQuestionsAgreements .Step3 .UploadDocs .contenedor-flex .UploadDocs--container {
    gap: 20px;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
    width: 100%; }

.DscrQuestionsAgreements .InputAmount-edit {
  margin-bottom: 0px !important;
  border: none !important;
  display: flex;
  justify-content: space-between;
  gap: 16px; }
  .DscrQuestionsAgreements .InputAmount-edit .flex {
    display: flex;
    justify-content: flex-end;
    gap: 16px; }
    .DscrQuestionsAgreements .InputAmount-edit .flex .text-bold {
      color: #5e8eb7;
      font-weight: 600;
      font-style: normal; }
    .DscrQuestionsAgreements .InputAmount-edit .flex .input-edit {
      all: unset;
      color: #6E7889;
      animation: none;
      cursor: pointer;
      font-style: italic;
      font-weight: 400;
      line-height: 19.36px;
      text-align: right;
      text-underline-position: from-font;
      text-decoration-skip-ink: none; }
  .DscrQuestionsAgreements .InputAmount-edit .button-edit {
    all: unset;
    border: none;
    color: #5E8EB7;
    animation: none;
    cursor: pointer;
    margin-left: 10px; }
    .DscrQuestionsAgreements .InputAmount-edit .button-edit span {
      margin-left: 5px;
      font-weight: 500;
      color: #5E8EB7;
      font-family: Inter;
      font-style: normal; }
    .DscrQuestionsAgreements .InputAmount-edit .button-edit-disabled span {
      color: #6E7889 !important; }

.CardMarketRent {
  border-radius: 4px;
  border: 1px solid #929fb0;
  padding: 12px 16px; }
  .CardMarketRent .body-regular-italic {
    color: #929fb0; }
  .CardMarketRent .flex-btw {
    margin-bottom: 9px !important; }
  .CardMarketRent-REVIEW {
    border: 1px solid #AC78B3;
    background-color: #FDFCFF; }
  .CardMarketRent-APPROVED {
    border: 1px solid #92c295;
    background-color: white; }
    .CardMarketRent-APPROVED .h4 {
      color: #404859 !important; }
    .CardMarketRent-APPROVED .description {
      color: #404859 !important; }
    .CardMarketRent-APPROVED .link {
      color: #404859 !important; }
  .CardMarketRent-REQUEST_ERROR {
    border: 1px solid #c94f4a;
    background-color: #FFFFFF; }
    .CardMarketRent-REQUEST_ERROR .h4 {
      color: #404859 !important; }
    .CardMarketRent-REQUEST_ERROR .description {
      color: #404859 !important; }
    .CardMarketRent-REQUEST_ERROR .link {
      color: #404859 !important; }
  .CardMarketRent .ant-form {
    all: unset;
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column; }
    .CardMarketRent .ant-form .form-row {
      all: unset;
      display: flex;
      align-items: baseline;
      gap: 5px;
      max-height: 35px; }
      .CardMarketRent .ant-form .form-row .bold {
        font-weight: 600 !important;
        color: #404859 !important; }
    .CardMarketRent .ant-form .rent-container {
      display: flex;
      align-items: baseline;
      position: relative; }
    .CardMarketRent .ant-form .rent-input {
      width: auto;
      min-width: 56px;
      max-width: 58px;
      text-align: right;
      font-weight: 600;
      color: #404859;
      border: none;
      outline: none;
      background: transparent; }
    .CardMarketRent .ant-form .unit-input {
      width: 25px !important; }
    .CardMarketRent .ant-form .ant-form-item-explain-error {
      display: ruby-text; }

.CardLeaseAgreements {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #929fb0; }
  .CardLeaseAgreements .flex-btw .flex {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 28px; }
    .CardLeaseAgreements .flex-btw .flex .circle {
      border-radius: 50%;
      width: 16px;
      height: 16px;
      border: 1px solid #404859; }
      .CardLeaseAgreements .flex-btw .flex .circle--active {
        background-color: #404859; }
  .CardLeaseAgreements-REVIEW {
    border: 1px solid #AC78B3;
    background-color: #FDFCFF; }
  .CardLeaseAgreements-APPROVED {
    border: 1px solid #92c295;
    background-color: white; }
    .CardLeaseAgreements-APPROVED .h4 {
      color: #404859 !important; }
    .CardLeaseAgreements-APPROVED .description {
      color: #404859 !important; }
    .CardLeaseAgreements-APPROVED .link {
      color: #404859 !important; }
  .CardLeaseAgreements-REQUEST_ERROR {
    border: 1px solid #c94f4a;
    background-color: #FFFFFF; }
    .CardLeaseAgreements-REQUEST_ERROR .h4 {
      color: #404859 !important; }
    .CardLeaseAgreements-REQUEST_ERROR .description {
      color: #404859 !important; }
    .CardLeaseAgreements-REQUEST_ERROR .link {
      color: #404859 !important; }

.MortgagePayments .step1 .h4-w4 {
  color: #2a2f3c;
  margin-bottom: 25px; }

.MortgagePayments .step1 .section-isuranse .button-transparent {
  display: flex;
  justify-content: start;
  align-items: center;
  text-transform: uppercase;
  color: #404859;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.28px;
  margin: 10px 0; }

.MortgagePayments .UploadDocs .input-content,
.MortgagePayments .UploadDocs .input-content input {
  height: 78px; }

.CardInsuranceCompanyName {
  border-radius: 4px;
  border: 1px solid #929fb0;
  min-height: 195px;
  width: 100%;
  padding: 16px; }
  .CardInsuranceCompanyName .h4 {
    color: #929fb0;
    font-style: italic;
    margin-bottom: 16px; }
  .CardInsuranceCompanyName .body-card {
    color: #6e7889; }
  .CardInsuranceCompanyName .body-regular {
    color: #2a2f3c;
    margin-bottom: 12px; }
  .CardInsuranceCompanyName .flex-btw {
    margin-bottom: 0 !important; }
    .CardInsuranceCompanyName .flex-btw .column {
      width: 50%; }
      .CardInsuranceCompanyName .flex-btw .column .body-regular {
        color: #929fb0; }
  .CardInsuranceCompanyName .input {
    color: #2A2F3C;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 14px; }
    .CardInsuranceCompanyName .input::placeholder {
      color: #929fb0;
      font-family: Inter;
      font-size: 14px;
      font-style: italic;
      font-weight: 400;
      line-height: normal; }
  .CardInsuranceCompanyName .input-bold {
    margin-bottom: 20px; }
    .CardInsuranceCompanyName .input-bold::placeholder {
      font-size: 16px;
      font-style: italic;
      font-weight: 600; }

.InvestmentExperienceVerification {
  display: contents; }
  .InvestmentExperienceVerification .card__generic-REVIEW {
    border: 1px solid #AC78B3;
    background-color: #FDFCFF; }
  .InvestmentExperienceVerification .card__generic-REQUEST_ERROR {
    border: 1px solid #c94f4a;
    background-color: #FFFFFF; }
  .InvestmentExperienceVerification .card__generic-APPROVED {
    border: 1px solid #92c295;
    background-color: white; }
  .InvestmentExperienceVerification .card__generic .UploadDocs .input-content,
  .InvestmentExperienceVerification .card__generic .UploadDocs .input-content input {
    height: 79px; }

.ConstructionBudget .input-number:hover, .ConstructionBudget .input-number:focus, .ConstructionBudget .input-number:focus-within {
  border-color: #2a2f3c; }

.ConstructionBudget .input-number-error {
  border-color: #c94f4a; }
  .ConstructionBudget .input-number-error:hover, .ConstructionBudget .input-number-error:focus, .ConstructionBudget .input-number-error:focus-within {
    border-color: #c94f4a; }

.ConstructionBudget input::-webkit-outer-spin-button,
.ConstructionBudget input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; }

.ConstructionBudget .h2 {
  margin-top: 30px !important; }

.ConstructionBudget .UploadDocs .input-content,
.ConstructionBudget .UploadDocs .input-content input {
  height: 78px; }
  .ConstructionBudget .UploadDocs .input-content .empty-input .body-small,
  .ConstructionBudget .UploadDocs .input-content input .empty-input .body-small {
    color: #2a2f3c; }

.ConstructionBudget .card__generic .s-title .h4 {
  color: #404859; }

.ConstructionBudget .card__generic .body-regular {
  margin-bottom: 20px; }

.ConstructionBudget .link {
  color: #5e8eb7;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-decoration: none;
  line-height: 145%; }
  .ConstructionBudget .link .arrow {
    height: 10px;
    margin-left: 5px; }

.EntityGuarantorCreation {
  display: contents; }
  .EntityGuarantorCreation .under-pink {
    color: #8a5791;
    text-decoration: underline;
    font-weight: 600; }
  .EntityGuarantorCreation .task-footer .dropdown-blue-bold {
    height: 26px;
    display: unset;
    padding: 0 !important; }
    .EntityGuarantorCreation .task-footer .dropdown-blue-bold span {
      font-weight: 600;
      text-decoration-line: underline; }
  .EntityGuarantorCreation .task-footer .dropdown-review-bold {
    color: #AC78B3 !important;
    height: 26px;
    display: unset;
    padding: 0 !important; }
    .EntityGuarantorCreation .task-footer .dropdown-review-bold span {
      font-weight: 600;
      text-decoration-line: underline; }
  .EntityGuarantorCreation .task-footer .owners-tags {
    display: flex;
    justify-content: space-between;
    align-items: end; }
    .EntityGuarantorCreation .task-footer .owners-tags span {
      font-family: Inter;
      font-size: 16px;
      font-weight: 500;
      line-height: 19.36px;
      text-align: left; }
    .EntityGuarantorCreation .task-footer .owners-tags .circles-tags {
      display: flex;
      align-items: end;
      gap: 10px; }
    .EntityGuarantorCreation .task-footer .owners-tags .circle {
      width: 20px;
      height: 20px; }
    .EntityGuarantorCreation .task-footer .owners-tags .circle-step3 {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px; }
    .EntityGuarantorCreation .task-footer .owners-tags .remaining-ownerts-tooltip {
      background-color: #2A2F3C;
      color: #fff !important; }
  .EntityGuarantorCreation .tag-owner-content {
    display: flex;
    align-items: center;
    gap: 5px;
    height: 18px;
    font-size: 12px;
    padding-left: 5px;
    border-radius: 10px;
    margin-bottom: 10px; }
    .EntityGuarantorCreation .tag-owner-content button {
      font-size: 12px; }
    .EntityGuarantorCreation .tag-owner-content b {
      font-weight: 500; }
    .EntityGuarantorCreation .tag-owner-content span {
      font-weight: 400; }
    .EntityGuarantorCreation .tag-owner-content-complete {
      background: #D5F7E2;
      width: 230px;
      gap: 5px; }
      .EntityGuarantorCreation .tag-owner-content-complete b {
        color: #2D7032; }
      .EntityGuarantorCreation .tag-owner-content-complete button {
        color: #1F4222; }
        .EntityGuarantorCreation .tag-owner-content-complete button:hover {
          color: #1F4222 !important; }
      .EntityGuarantorCreation .tag-owner-content-complete-disabled {
        width: 125px; }
    .EntityGuarantorCreation .tag-owner-content-no-guarantor {
      background: #EFF3F5;
      width: 280px; }
    .EntityGuarantorCreation .tag-owner-content-next-step {
      background: #EFF3F5;
      width: 350px; }
    .EntityGuarantorCreation .tag-owner-content-incomplete {
      border: 1px solid #97BCF0;
      background: #F5FAFF;
      width: 235px; }
      .EntityGuarantorCreation .tag-owner-content-incomplete b {
        color: #48759A; }
      .EntityGuarantorCreation .tag-owner-content-incomplete .tag-description {
        color: #610805; }
      .EntityGuarantorCreation .tag-owner-content-incomplete img {
        vertical-align: bottom; }
      .EntityGuarantorCreation .tag-owner-content-incomplete button {
        color: #48759A; }
        .EntityGuarantorCreation .tag-owner-content-incomplete button:hover {
          color: #48759A !important; }
    .EntityGuarantorCreation .tag-owner-content-verify {
      border: 1px solid #97BCF0;
      background: #F5FAFF;
      width: 235px; }
      .EntityGuarantorCreation .tag-owner-content-verify b {
        color: #48759A; }
      .EntityGuarantorCreation .tag-owner-content-verify img {
        vertical-align: bottom; }
      .EntityGuarantorCreation .tag-owner-content-verify button {
        color: #48759A; }
        .EntityGuarantorCreation .tag-owner-content-verify button:hover {
          color: #48759A !important; }
    .EntityGuarantorCreation .tag-owner-content-error {
      border: 1px solid #FCA095;
      background: #FCF8F7;
      width: 330px; }
      .EntityGuarantorCreation .tag-owner-content-error b {
        color: #A31C17; }
      .EntityGuarantorCreation .tag-owner-content-error .tag-description {
        color: #610805; }
      .EntityGuarantorCreation .tag-owner-content-error img {
        vertical-align: bottom; }
      .EntityGuarantorCreation .tag-owner-content-error button {
        color: #610805; }
        .EntityGuarantorCreation .tag-owner-content-error button:hover {
          color: #610805 !important; }

.card-ownership {
  position: relative;
  border-radius: 6px; }
  .card-ownership-expand {
    width: 42em;
    z-index: 99;
    left: -50px; }
  .card-ownership .icon-delete {
    font-size: 20px;
    position: absolute;
    top: 50%;
    right: -9.5px;
    transform: translateY(-50%);
    color: #5e8eb7;
    cursor: pointer;
    visibility: hidden; }
    .card-ownership .icon-delete-disabled {
      opacity: 0.5;
      cursor: unset; }
  .card-ownership:hover .icon-delete {
    visibility: visible; }
  .card-ownership .content-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    border: 1px solid #ccd3db;
    min-height: 56px;
    height: auto;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 10px 18px 5px 16px; }
    .card-ownership .content-card-hover-removed:hover {
      border: 1px solid #ccd3db !important; }
    .card-ownership .content-card:hover {
      border: 1px dashed #404859; }
    .card-ownership .content-card .input-disabled-color input:disabled {
      color: black; }
    .card-ownership .content-card .input-disabled-color input::placeholder {
      padding-right: 1px; }
    .card-ownership .content-card-REVIEW {
      border: 1px solid #AC78B3;
      background-color: #FDFCFF; }
      .card-ownership .content-card-REVIEW:hover {
        border: 1px solid #AC78B3 !important;
        background-color: #FDFCFF !important; }
      .card-ownership .content-card-REVIEW .body-regular {
        color: #855791 !important; }
      .card-ownership .content-card-REVIEW .bold-lith {
        color: #48244D !important; }
      .card-ownership .content-card-REVIEW .tag-name {
        color: #48244D !important; }
      .card-ownership .content-card-REVIEW .name span {
        color: #48244D !important; }
      .card-ownership .content-card-REVIEW .bold-little {
        color: #48244D !important; }
      .card-ownership .content-card-REVIEW .ant-input-number-suffix {
        color: #161616 !important; }
      .card-ownership .content-card-REVIEW .ant-picker-input input {
        color: #161616 !important; }
      .card-ownership .content-card-REVIEW .ant-form-item-no-colon {
        color: #855791 !important; }
      .card-ownership .content-card-REVIEW .ant-input-number-input-wrap {
        color: #161616 !important; }
        .card-ownership .content-card-REVIEW .ant-input-number-input-wrap input {
          font-weight: 500; }
      .card-ownership .content-card-REVIEW .section-2 input {
        color: #48244D !important; }
      .card-ownership .content-card-REVIEW .identification label {
        color: #855791 !important; }
      .card-ownership .content-card-REVIEW .address input {
        color: #48244D !important; }
    .card-ownership .content-card-APPROVED {
      border: 1px solid #92c295;
      background-color: white; }
      .card-ownership .content-card-APPROVED:hover {
        border: 1px solid #92c295 !important;
        background-color: white !important; }
      .card-ownership .content-card-APPROVED .body-regular {
        color: #404859 !important; }
      .card-ownership .content-card-APPROVED .bold-lith {
        color: #404859 !important; }
      .card-ownership .content-card-APPROVED .ant-input-number-suffix {
        color: #404859 !important; }
      .card-ownership .content-card-APPROVED .ant-picker-input input {
        color: #404859 !important; }
      .card-ownership .content-card-APPROVED .ant-form-item-no-colon {
        color: #404859 !important; }
      .card-ownership .content-card-APPROVED .ant-input-number-input-wrap {
        color: #404859 !important; }
        .card-ownership .content-card-APPROVED .ant-input-number-input-wrap input {
          font-weight: 500; }
      .card-ownership .content-card-APPROVED .file-name {
        color: #404859 !important; }
    .card-ownership .content-card-REQUEST_ERROR {
      border: 1px solid #c94f4a;
      background-color: white; }
      .card-ownership .content-card-REQUEST_ERROR:hover {
        border: 1px solid #c94f4a !important;
        background-color: white !important; }
      .card-ownership .content-card-REQUEST_ERROR .ant-divider {
        background-color: #FFD4CF; }
      .card-ownership .content-card-REQUEST_ERROR .body-regular {
        color: #404859 !important; }
      .card-ownership .content-card-REQUEST_ERROR .ant-form-item-no-colon {
        color: #404859 !important; }
      .card-ownership .content-card-REQUEST_ERROR .ant-picker-input input {
        color: #E56A5C !important; }
      .card-ownership .content-card-REQUEST_ERROR .ant-input-number-suffix {
        color: #712220 !important; }
      .card-ownership .content-card-REQUEST_ERROR .ant-input-number-input-wrap {
        color: #712220 !important; }
        .card-ownership .content-card-REQUEST_ERROR .ant-input-number-input-wrap input {
          font-weight: 500; }
      .card-ownership .content-card-REQUEST_ERROR .file-name {
        color: #712220 !important; }
      .card-ownership .content-card-REQUEST_ERROR .input-content {
        border-color: #E56A5C; }
      .card-ownership .content-card-REQUEST_ERROR .file-content {
        border-color: #E56A5C !important; }
    .card-ownership .content-card .card-ownership {
      display: flex;
      justify-content: space-between;
      align-items: flex-start; }
      .card-ownership .content-card .card-ownership .section-1 {
        display: flex;
        width: 70%;
        flex-direction: column; }
        .card-ownership .content-card .card-ownership .section-1 .resume-names {
          display: flex;
          gap: 10px;
          margin-bottom: 10px;
          align-items: center; }
        .card-ownership .content-card .card-ownership .section-1 .names {
          display: flex;
          gap: 30px;
          margin-bottom: 6px; }
          .card-ownership .content-card .card-ownership .section-1 .names .name {
            display: flex;
            flex-direction: column;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: auto;
            gap: 5px; }
            .card-ownership .content-card .card-ownership .section-1 .names .name span {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              line-height: 1.2;
              font-size: 16px;
              font-weight: 600; }
            .card-ownership .content-card .card-ownership .section-1 .names .name label {
              font-size: 12px; }
        .card-ownership .content-card .card-ownership .section-1 .footer .approved {
          color: #587e5b; }
        .card-ownership .content-card .card-ownership .section-1 .footer .error {
          color: #404859; }
        .card-ownership .content-card .card-ownership .section-1 .footer button {
          color: #6e7889; }
          .card-ownership .content-card .card-ownership .section-1 .footer button .anticon {
            margin-inline-start: 4px; }
          .card-ownership .content-card .card-ownership .section-1 .footer button:hover {
            color: #6e7889; }
        .card-ownership .content-card .card-ownership .section-1 .footer span {
          font-family: Inter;
          font-size: 10px;
          font-style: normal;
          font-weight: 400;
          line-height: 15px; }
      .card-ownership .content-card .card-ownership .section-2 {
        display: flex;
        flex-direction: column;
        align-items: end; }
        .card-ownership .content-card .card-ownership .section-2 .ownership-section {
          display: flex;
          flex-direction: row;
          align-items: center; }
        .card-ownership .content-card .card-ownership .section-2 .suffix-null input {
          padding-right: 0 !important; }
        .card-ownership .content-card .card-ownership .section-2 input {
          text-align: end;
          padding-right: 2px !important; }
        .card-ownership .content-card .card-ownership .section-2 .guarantor {
          grid-area: guarantor;
          display: flex;
          align-items: center;
          justify-content: right;
          gap: 3px;
          font-size: 12px;
          margin-bottom: 7px;
          color: #BB8D2F !important;
          font-weight: 500;
          margin-top: 10px; }
        .card-ownership .content-card .card-ownership .section-2 .ant-input-number-suffix {
          margin-inline-end: 0px;
          color: black;
          margin-left: 2px !important;
          position: unset;
          inset-block-start: 0;
          inset-inline-end: 0;
          height: auto;
          margin-inline-end: 0px;
          margin-inline-start: 0px; }
    .card-ownership .content-card .form-edit {
      width: 100%;
      height: auto;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      position: relative;
      display: grid;
      grid-template-columns: 25% 30% 45%;
      grid-template-areas: 'ssn datebirth identification' 'phone email identification' 'address address address' 'submit submit submit'; }
      .card-ownership .content-card .form-edit .ant-form-item-row {
        display: block; }
      .card-ownership .content-card .form-edit .ant-form-item-label {
        text-align: start;
        height: 27px; }
        .card-ownership .content-card .form-edit .ant-form-item-label label {
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 14.52px;
          color: #6e7889; }
      .card-ownership .content-card .form-edit .ant-form-item-control-input {
        min-height: 20px; }
      .card-ownership .content-card .form-edit .ssn {
        grid-area: ssn; }
      .card-ownership .content-card .form-edit .datebirth {
        grid-area: datebirth; }
        .card-ownership .content-card .form-edit .datebirth .ant-picker-input input::placeholder {
          color: #929fb0;
          font-family: Inter;
          font-style: italic !important;
          font-weight: 400; }
        .card-ownership .content-card .form-edit .datebirth .ant-picker-input input:disabled {
          color: #48244d; }
      .card-ownership .content-card .form-edit .form-wrap {
        position: relative;
        z-index: 20; }
      .card-ownership .content-card .form-edit .textedit {
        grid-area: textedit;
        font-size: 11px;
        text-align: end;
        color: #5e8eb7;
        display: flex;
        gap: 6px;
        justify-content: end;
        margin-top: 5px; }
        .card-ownership .content-card .form-edit .textedit-ab {
          position: absolute;
          right: 0;
          top: 1px;
          z-index: 100; }
      .card-ownership .content-card .form-edit .phone {
        grid-area: phone; }
      .card-ownership .content-card .form-edit .email {
        grid-area: email; }
      .card-ownership .content-card .form-edit .address {
        width: 100% !important;
        grid-area: address;
        margin-bottom: 0px; }
        .card-ownership .content-card .form-edit .address .ant-input-group-addon {
          display: none; }
        .card-ownership .content-card .form-edit .address input {
          width: 100%;
          background-color: transparent !important;
          border: none !important;
          box-shadow: none !important;
          padding: 0;
          color: #2a2f3c;
          font-family: Inter;
          font-size: 14px;
          font-weight: 400; }
          .card-ownership .content-card .form-edit .address input::placeholder {
            color: #929fb0;
            font-family: Inter;
            font-size: 14px;
            font-style: italic;
            font-weight: 400;
            line-height: 145%; }
      .card-ownership .content-card .form-edit .identification {
        grid-area: identification; }
        .card-ownership .content-card .form-edit .identification .UploadDocs {
          height: 90%; }
        .card-ownership .content-card .form-edit .identification .file-ok {
          margin-top: 5px; }
        .card-ownership .content-card .form-edit .identification label {
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 15px;
          color: #404859; }
      .card-ownership .content-card .form-edit .submit {
        grid-area: submit;
        margin-bottom: 12px;
        margin-top: 10px; }
      .card-ownership .content-card .form-edit .verify-submits {
        display: flex;
        gap: 21px;
        margin-bottom: 10px; }
        .card-ownership .content-card .form-edit .verify-submits .button-yellow {
          border-radius: 6px;
          background: #FFEDC8 !important;
          border-color: #FFEDC8 !important; }
          .card-ownership .content-card .form-edit .verify-submits .button-yellow:disabled {
            background: #EFF3F5 !important;
            border-color: #EFF3F5 !important; }
          .card-ownership .content-card .form-edit .verify-submits .button-yellow span {
            color: black;
            font-weight: 600; }
        .card-ownership .content-card .form-edit .verify-submits .button-edit {
          background: white !important;
          border: 1px solid #48759A !important; }
          .card-ownership .content-card .form-edit .verify-submits .button-edit span {
            color: black;
            font-weight: 600; }
      .card-ownership .content-card .form-edit .button-link-border {
        border-radius: 6px;
        height: 40px;
        display: flex;
        gap: 2px; }
        .card-ownership .content-card .form-edit .button-link-border b {
          color: #244560;
          font-weight: 600; }
        .card-ownership .content-card .form-edit .button-link-border span {
          color: #244560;
          font-weight: 400; }

.step-1 .h3 .blue-bold {
  font-size: 20px;
  font-weight: 600;
  text-decoration-line: underline; }

.step-1 .h3 .dropdown-blue-bold {
  height: 26px;
  display: unset;
  padding: 0 !important; }
  .step-1 .h3 .dropdown-blue-bold span {
    font-size: 20px;
    font-weight: 600;
    text-decoration-line: underline; }

.step-1 .bold-blue {
  font-weight: 600; }
  .step-1 .bold-blue span {
    font-weight: 400 !important; }

.step-1 .section-loand .text-blue {
  color: #5e8eb7 !important; }
  .step-1 .section-loand .text-blue img {
    margin-top: -3px;
    margin-right: 4px; }

.step-1 .content-entity-input {
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px; }
  .step-1 .content-entity-input input {
    width: 100%;
    margin-bottom: 4px; }

.loader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center; }

.item-selected {
  font-weight: 700 !important; }

.step-2 .blue-bold {
  font-size: 24px;
  font-style: normal;
  font-weight: 800; }

.step-2 .lienzo {
  position: relative; }

.step-2 .dropdown-blue-bold {
  height: 26px;
  display: unset;
  padding: 0 !important; }
  .step-2 .dropdown-blue-bold span {
    font-size: 24px;
    font-weight: 600;
    text-decoration-line: underline; }

.step-2 .submits {
  display: flex;
  justify-content: space-between;
  gap: 15px; }
  .step-2 .submits section {
    width: 100%; }

.step-2 .content-cards {
  display: flex;
  flex-direction: column;
  gap: 12px; }

.step-2 .content-owner-new {
  display: flex;
  justify-content: space-between;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal; }
  .step-2 .content-owner-new button {
    padding: 0; }
  .step-2 .content-owner-new .text-add {
    display: flex;
    gap: 5px;
    align-items: center; }
  .step-2 .content-owner-new .total {
    display: flex;
    gap: 10px;
    align-items: center; }
    .step-2 .content-owner-new .total span {
      font-weight: 400;
      font-size: 13px; }
    .step-2 .content-owner-new .total b {
      font-weight: 600;
      font-size: 16px; }
    .step-2 .content-owner-new .total-error span {
      color: #A31C17; }
    .step-2 .content-owner-new .total-error b {
      color: #8A130F;
      font-style: italic; }

.step-3 .blue-bold {
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  text-decoration: underline; }

.step-3 .owner-REVIEW {
  color: #855791; }

.step-3 .owner-APPROVED {
  color: #466849; }

.step-3 .owner-REQUEST_ERROR {
  color: #C13934; }

.step-3 .content-cards {
  display: flex;
  flex-direction: column;
  gap: 12px; }

.step-3 .content-owner-new {
  display: flex;
  justify-content: space-between;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal; }
  .step-3 .content-owner-new button {
    padding: 0; }
  .step-3 .content-owner-new .text-add {
    display: flex;
    gap: 5px;
    align-items: center; }
  .step-3 .content-owner-new .total {
    display: flex;
    gap: 10px;
    align-items: center; }
    .step-3 .content-owner-new .total span {
      font-weight: 400;
      font-size: 13px; }
    .step-3 .content-owner-new .total b {
      font-weight: 600;
      font-size: 16px; }
    .step-3 .content-owner-new .total-error span {
      color: #A31C17; }
    .step-3 .content-owner-new .total-error b {
      color: #8A130F;
      font-style: italic; }

.card-ownership-edit {
  position: relative;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ccd3db;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
  height: auto;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 10px 24px 5px;
  display: grid;
  grid-template-columns: 20% 20% 40% 20%;
  grid-template-areas: 'names lastname . ownership' 'owner-state owner-state owner-state guarantor' 'ssn . datebirth .' 'phone . email email' 'address address address address' 'identification identification identification identification' 'submit submit submit submit' 'submit-draft submit-draft submit-draft submit-draft'; }
  .card-ownership-edit .ant-form-item-row {
    display: block; }
  .card-ownership-edit .icon-delete {
    font-size: 20px;
    position: absolute;
    top: 50%;
    right: -9.5px;
    transform: translateY(-50%);
    color: #5e8eb7;
    cursor: pointer;
    visibility: hidden; }
  .card-ownership-edit:hover {
    border: 1px dashed #404859; }
    .card-ownership-edit:hover .icon-delete {
      visibility: visible; }
  .card-ownership-edit .ant-form-item-label {
    text-align: start;
    height: 27px; }
    .card-ownership-edit .ant-form-item-label label {
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14.52px;
      color: #6e7889; }
  .card-ownership-edit .ant-form-item-control-input {
    min-height: 20px; }
  .card-ownership-edit .ant-form-item {
    margin-bottom: 10px; }
  .card-ownership-edit .tag-owner-state {
    grid-area: owner-state; }
  .card-ownership-edit .tag-guarantor {
    grid-area: guarantor;
    display: flex;
    align-items: center;
    justify-content: right;
    gap: 3px;
    font-size: 12px;
    margin-bottom: 7px;
    color: #BB8D2F;
    font-weight: 500; }
  .card-ownership-edit .name {
    grid-area: names; }
  .card-ownership-edit .lastname {
    grid-area: lastname; }
  .card-ownership-edit .ownership {
    grid-area: ownership; }
    .card-ownership-edit .ownership input {
      text-align: end;
      padding-right: 14px !important; }
    .card-ownership-edit .ownership .ant-input-number-suffix {
      margin-inline-end: 0px;
      color: black; }
    .card-ownership-edit .ownership label {
      text-align: end; }
      .card-ownership-edit .ownership label::after {
        margin-inline-start: unset;
        margin-inline-end: unset; }
    .card-ownership-edit .ownership .ant-form-item-label {
      text-align: end; }
  .card-ownership-edit .ssn {
    grid-area: ssn; }
  .card-ownership-edit .datebirth {
    grid-area: datebirth; }
    .card-ownership-edit .datebirth .ant-picker-input input::placeholder {
      color: #929fb0;
      font-family: Inter;
      font-style: italic !important;
      font-weight: 400; }
  .card-ownership-edit .phone {
    grid-area: phone; }
  .card-ownership-edit .email {
    grid-area: email; }
  .card-ownership-edit .address {
    grid-area: address;
    margin-bottom: 2px; }
    .card-ownership-edit .address .ant-input-group-addon {
      display: none; }
    .card-ownership-edit .address input {
      width: 100%;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0;
      color: #2a2f3c;
      font-family: Inter;
      font-size: 14px;
      font-weight: 400; }
      .card-ownership-edit .address input::placeholder {
        color: #929fb0;
        font-family: Inter;
        font-size: 14px;
        font-style: italic;
        font-weight: 400;
        line-height: 145%; }
  .card-ownership-edit .identification {
    grid-area: identification;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px; }
    .card-ownership-edit .identification .contenedor-flex {
      height: auto; }
    .card-ownership-edit .identification label {
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      color: #6e7889; }
    .card-ownership-edit .identification .UploadDocs {
      margin-top: 0px !important; }
  .card-ownership-edit .submit {
    grid-area: submit; }
    .card-ownership-edit .submit button {
      font-size: 12px;
      border-radius: 6px; }
  .card-ownership-edit .submit-draft {
    grid-area: submit-draft; }
    .card-ownership-edit .submit-draft button {
      font-size: 12px;
      border-radius: 6px; }

.EntityDocs {
  display: contents; }
  .EntityDocs .task-footer .dropdown-blue-bold {
    height: 26px;
    display: unset;
    padding: 0 !important; }
    .EntityDocs .task-footer .dropdown-blue-bold span {
      font-weight: 600;
      text-decoration-line: underline; }
  .EntityDocs .task-footer .dropdown-review-bold {
    color: #AC78B3 !important;
    height: 26px;
    display: unset;
    padding: 0 !important; }
    .EntityDocs .task-footer .dropdown-review-bold span {
      font-weight: 600;
      text-decoration-line: underline; }
  .EntityDocs .task-footer .owners-tags {
    display: flex;
    justify-content: space-between;
    align-items: end; }
    .EntityDocs .task-footer .owners-tags .circles-tags {
      display: flex;
      align-items: end;
      gap: 10px; }
    .EntityDocs .task-footer .owners-tags .circle {
      width: 20px;
      height: 20px; }
      .EntityDocs .task-footer .owners-tags .circle-APPROVED {
        border-color: #92c295;
        background-color: #C2F0C5; }
      .EntityDocs .task-footer .owners-tags .circle-REVIEW {
        background-color: #AC78B3;
        border-color: #AC78B3; }
      .EntityDocs .task-footer .owners-tags .circle-REQUEST_ERROR {
        background-color: #FFD4CF;
        border-color: #c94f4a; }

.step-1 .main {
  position: relative;
  border-radius: 10px; }
  .step-1 .main .content-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    border: 1px solid #ccd3db;
    min-height: 56px;
    height: auto;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 10px 18px 5px 16px; }
    .step-1 .main .content-card .section-1 {
      display: flex;
      width: 100%;
      flex-direction: column; }
      .step-1 .main .content-card .section-1 .name {
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 1.2;
        overflow: hidden;
        width: auto;
        margin-top: 10px;
        margin-bottom: 18px; }
        .step-1 .main .content-card .section-1 .name span {
          white-space: nowrap;
          text-overflow: ellipsis;
          line-height: 1.2;
          overflow: hidden;
          font-size: 16px;
          font-weight: 600; }
      .step-1 .main .content-card .section-1 .footer {
        padding-top: 3px;
        border-top: 1px solid #dfe4eb; }
        .step-1 .main .content-card .section-1 .footer-info {
          display: flex;
          justify-content: space-between; }
        .step-1 .main .content-card .section-1 .footer span {
          font-family: Inter;
          font-size: 11px;
          font-style: normal;
          font-weight: 400;
          line-height: 15px; }
        .step-1 .main .content-card .section-1 .footer .guarantor {
          margin-top: 7px;
          color: #5e8eb7; }
        .step-1 .main .content-card .section-1 .footer .owners {
          margin-left: 5px; }
      .step-1 .main .content-card .section-1 .list-owners {
        display: flex;
        flex-direction: column;
        margin: 15px auto;
        gap: 10px; }
        .step-1 .main .content-card .section-1 .list-owners .owner {
          display: flex;
          justify-content: space-between;
          padding: 0; }
          .step-1 .main .content-card .section-1 .list-owners .owner .owner-name {
            font-size: 15px; }
          .step-1 .main .content-card .section-1 .list-owners .owner .owner-percentage {
            font-size: 15px; }

.entity-docs-step-2 .section-1 span {
  font-size: 20px !important; }

.entity-docs-step-2 .dropdown-blue-bold {
  display: unset;
  height: auto; }

.entity-docs-step-2 .dropdown-review-bold {
  color: #AC78B3 !important;
  display: unset;
  padding: 0 !important; }
  .entity-docs-step-2 .dropdown-review-bold span {
    text-decoration-line: underline; }

.entity-docs-step-2 .submits {
  display: flex;
  justify-content: space-between;
  gap: 15px; }
  .entity-docs-step-2 .submits section {
    width: 100%; }

.title-company-step-1 {
  border-radius: 10px;
  border: 1px solid #ccd3db;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
  padding: 16px 24px 5px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal; }
  .title-company-step-1 .ant-form {
    margin-top: 10px;
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: 50% 5% 45%;
    grid-template-areas: 'titleCompany titleCompany titleCompany' 'name name .' 'phone . email' 'submit submit submit'; }
  .title-company-step-1-REVIEW {
    border: 1px solid #AC78B3;
    background-color: #FDFCFF; }
    .title-company-step-1-REVIEW .h4 {
      color: #161616 !important; }
    .title-company-step-1-REVIEW .description {
      color: #161616 !important; }
    .title-company-step-1-REVIEW .link {
      color: #161616 !important; }
  .title-company-step-1-APPROVED {
    border: 1px solid #92c295;
    background-color: white; }
    .title-company-step-1-APPROVED .h4 {
      color: #404859 !important; }
    .title-company-step-1-APPROVED .description {
      color: #404859 !important; }
    .title-company-step-1-APPROVED .link {
      color: #404859 !important; }
  .title-company-step-1-REQUEST_ERROR {
    border: 1px solid #c94f4a;
    background-color: #FFFFFF; }
    .title-company-step-1-REQUEST_ERROR .h4 {
      color: #404859 !important; }
    .title-company-step-1-REQUEST_ERROR .description {
      color: #404859 !important; }
    .title-company-step-1-REQUEST_ERROR .link {
      color: #404859 !important; }
  .title-company-step-1 .ant-form-item-row {
    display: block; }
  .title-company-step-1 .ant-form-item-label {
    text-align: start;
    height: 27px; }
    .title-company-step-1 .ant-form-item-label label {
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14.52px;
      color: #6e7889; }
  .title-company-step-1 .ant-form-item-control-input {
    min-height: 20px; }
  .title-company-step-1 .ant-form-item {
    margin-bottom: 15px; }
  .title-company-step-1 .titleCompany {
    grid-area: titleCompany; }
    .title-company-step-1 .titleCompany input {
      font-size: 16px !important; }
  .title-company-step-1 .name {
    grid-area: name; }
  .title-company-step-1 .phone {
    grid-area: phone; }
  .title-company-step-1 .email {
    grid-area: email; }
  .title-company-step-1 .submit {
    grid-area: submit; }
    .title-company-step-1 .submit button {
      border-radius: 6px; }

.insurance-step-2 .ant-collapse-header-text {
  max-width: 335px;
  margin-inline-end: unset !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600; }

.insurance-step-2 .ant-collapse-expand-icon {
  padding-inline-start: 0px !important; }

.payoff-footer .dropdown-blue-bold {
  display: unset;
  padding: 0 !important;
  border: none !important; }
  .payoff-footer .dropdown-blue-bold span {
    background-color: white !important;
    color: #5E8EB7 !important;
    padding: 0 !important;
    font-size: 24px !important; }

.payoff-footer .is-review {
  color: #AC78B3 !important; }

.purchase-footer .owners-tags {
  display: flex;
  justify-content: space-between;
  align-items: end; }
  .purchase-footer .owners-tags .circles-tags {
    display: flex;
    align-items: end;
    gap: 10px; }
  .purchase-footer .owners-tags .circle {
    width: 20px;
    height: 20px; }
    .purchase-footer .owners-tags .circle-APPROVED {
      border-color: #92c295;
      background-color: #C2F0C5; }
    .purchase-footer .owners-tags .circle-REVIEW {
      background-color: #AC78B3;
      border-color: #AC78B3; }
    .purchase-footer .owners-tags .circle-REQUEST_ERROR {
      background-color: #FFD4CF;
      border-color: #c94f4a; }

.InputUploadedFile .file-ok {
  margin: 10px 0; }
  .InputUploadedFile .file-ok .file {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative; }
    .InputUploadedFile .file-ok .file-content {
      height: 28px;
      border-radius: 10px;
      border: 1px solid #2a2f3c;
      background-color: #f9fafb;
      width: 100%;
      padding: 0 20px;
      padding-right: 12px; }
      .InputUploadedFile .file-ok .file-content-approved {
        border: 1px solid #92c295 !important;
        background: #f5faf7 !important; }
      .InputUploadedFile .file-ok .file-content-request_error {
        border: 1px solid #c94f4a;
        background: #fff4f3 !important; }
        .InputUploadedFile .file-ok .file-content-request_error .name,
        .InputUploadedFile .file-ok .file-content-request_error .anticon {
          color: #712220 !important; }
      .InputUploadedFile .file-ok .file-content-review {
        border: 1px solid #AC78B3 !important;
        background: #e3ddf0 !important; }
        .InputUploadedFile .file-ok .file-content-review .name,
        .InputUploadedFile .file-ok .file-content-review .anticon {
          color: #693B6F !important; }
    .InputUploadedFile .file-ok .file .file-name {
      width: 80%;
      display: flex;
      justify-content: start;
      align-items: center;
      gap: 7px; }
      .InputUploadedFile .file-ok .file .file-name .name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 1.2; }
      .InputUploadedFile .file-ok .file .file-name .anticon {
        font-size: 15px; }
    .InputUploadedFile .file-ok .file .content-buttons {
      display: flex;
      justify-content: end;
      align-items: center;
      gap: 7px; }
      .InputUploadedFile .file-ok .file .content-buttons .anticon {
        font-size: 15px; }
      .InputUploadedFile .file-ok .file .content-buttons button {
        height: auto; }
        .InputUploadedFile .file-ok .file .content-buttons button:hover {
          background-color: transparent; }
    .InputUploadedFile .file-ok .file .flex {
      width: 80%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      gap: 12px; }
      .InputUploadedFile .file-ok .file .flex:first-child {
        gap: 4px; }
    .InputUploadedFile .file-ok .file .upload {
      margin-bottom: 0; }
    .InputUploadedFile .file-ok .file .flex-btw {
      margin-bottom: 0;
      height: 100%;
      border-bottom: none; }
    .InputUploadedFile .file-ok .file .circle-input {
      background-color: #fff;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 1px solid #2a2f3c;
      display: flex;
      position: absolute;
      left: 0;
      justify-content: center;
      align-items: center; }
      .InputUploadedFile .file-ok .file .circle-input .upload {
        width: auto;
        height: 20px;
        object-fit: cover; }

.MinimumLiquidity {
  padding-bottom: 30px; }
  .MinimumLiquidity .h4 {
    color: #404859 !important; }
  .MinimumLiquidity .divider-top {
    padding-top: 10px; }
  .MinimumLiquidity .h4-error {
    color: #8F2F2C !important;
    margin-bottom: 7px; }
    .MinimumLiquidity .h4-error span {
      font-weight: 400 !important; }

.AddAdditionalDocument .UploadDocs--container .input-content {
  height: 80px; }
  .AddAdditionalDocument .UploadDocs--container .input-content input {
    height: 80px; }

.AddAdditionalDocument .button-transparent {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px; }

.AddAdditionalDocument .InputBorderNone .input {
  margin-bottom: 6px; }

.link-add-additional-document:hover {
  color: #355C7D !important; }
  .link-add-additional-document:hover path {
    stroke: #355C7D !important; }

.modal-end-submit {
  border-radius: 10px;
  border: 1px solid #FFC857;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 0;
  width: 556px !important;
  top: 202px !important; }
  .modal-end-submit .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #162e43 !important;
    border-color: #162e43 !important; }
  .modal-end-submit .coin {
    width: 49.334px;
    height: 34px; }
  .modal-end-submit .ant-modal-content {
    background-color: transparent;
    padding: 32px; }
    .modal-end-submit .ant-modal-content .h2 {
      margin-top: 15px;
      margin-bottom: 5px; }
    .modal-end-submit .ant-modal-content .h4 {
      color: #66564d; }
    .modal-end-submit .ant-modal-content .divider {
      border-top: 1px solid #ddaa42;
      padding-top: 20px;
      margin-top: 26px; }
    .modal-end-submit .ant-modal-content .buttons {
      margin-top: 25px; }
    .modal-end-submit .ant-modal-content .button {
      margin-top: 16px;
      height: 40px !important; }
    .modal-end-submit .ant-modal-content .ant-modal-footer {
      display: none; }
  .modal-end-submit .anticon {
    color: #997120; }
  .modal-end-submit .ant-checkbox-wrapper {
    margin-top: 10px; }
    .modal-end-submit .ant-checkbox-wrapper span {
      color: #244560;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.18px; }
  .modal-end-submit--white {
    background: #fff;
    border-color: #fff; }
    .modal-end-submit--white .anticon {
      color: #6e7889; }
    .modal-end-submit--white .ant-modal-content .h2 {
      color: #162e43; }
    .modal-end-submit--white .ant-modal-content .h4 {
      color: #48759a; }
    .modal-end-submit--white .ant-modal-content .buttons .button-modal-ok {
      border-radius: 6px;
      border: 1px solid #162E43 !important;
      background: #162E43 !important;
      color: #ffffff !important; }
      .modal-end-submit--white .ant-modal-content .buttons .button-modal-ok:hover {
        background-color: #EBF6FF !important;
        border: 1px solid #97BCF0 !important;
        box-shadow: 2px 2px 12px 0px #0B131A1A; }
        .modal-end-submit--white .ant-modal-content .buttons .button-modal-ok:hover span {
          color: #355D7D !important; }
        .modal-end-submit--white .ant-modal-content .buttons .button-modal-ok:hover:active {
          border: 1px solid #355C7D !important;
          box-shadow: none; }
    .modal-end-submit--white .ant-modal-content .buttons .button-modal-cancel {
      border: 1px solid #162e43 !important;
      background: #fff !important;
      color: #162e43 !important; }

.view-change-password .ant-form-item {
  margin-bottom: 15px; }

.view-change-password .button {
  margin-top: 50px !important; }
  .view-change-password .button span {
    font-weight: 600;
    font-size: 16px; }

.view-change-password .description {
  font-weight: 400;
  font-size: 20px;
  color: #404859; }

.view-change-password .link {
  padding: 0; }
  .view-change-password .link:hover {
    color: #404859 !important; }

.ResetPassword .message-error {
  color: #C13934;
  margin-bottom: 10px; }

.ResetPassword .ant-form-item {
  margin-bottom: 10px; }

.ResetPassword button {
  margin-top: 60px !important; }

@keyframes horizontal-shaking {
  0% {
    transform: translateX(0); }
  25% {
    transform: translateX(-3px); }
  50% {
    transform: translateX(3px); }
  75% {
    transform: translateX(-1px); }
  100% {
    transform: translateX(1px); } }

.Login {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 56px); }
  .Login-form,
  .Login .rigth {
    width: 50%; }
  .Login-form {
    padding: 32px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    position: relative; }
    .Login-form .coin {
      margin-bottom: 13px; }
    .Login-form .h1 {
      margin-bottom: 24px; }
    .Login-form .ant-form {
      width: 100%; }
    .Login-form .error-message {
      margin-top: 50px;
      color: #8f2f2c; }
    .Login-form .button {
      margin-top: 10px; }
    .Login-form .link:hover {
      color: #404859; }
    .Login-form .link .body-regular-bold {
      text-decoration: underline; }
    .Login-form .link-absolute {
      position: absolute;
      bottom: 30px;
      left: 32px;
      text-decoration: none; }
      .Login-form .link-absolute .body-regular-bold {
        text-decoration: underline; }
  .Login .rigth {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    padding-left: 60px;
    padding-top: 64px;
    background-color: #f9fafb; }
    .Login .rigth .bottom-flex {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      max-width: 700px; }
    .Login .rigth .h2 {
      margin-bottom: 12px;
      max-width: 520px; }
    .Login .rigth .body-regular {
      max-width: 520px;
      margin-bottom: 30px;
      font-weight: 400;
      font-size: 16px;
      line-height: 125%;
      color: #777b83; }
    .Login .rigth .back {
      padding: 7px;
      padding-bottom: 0;
      padding-right: 0;
      background-color: #355c7d;
      border-top-left-radius: 10px;
      width: 100%; }
    .Login .rigth img {
      bottom: 0;
      width: 100%; }
  @media (min-height: 735px) {
    .Login .bottom-flex {
      height: 470px; }
      .Login .bottom-flex img {
        height: 100%; } }

.Dashboard--container {
  display: flex; }

.Dashboard__column {
  width: 100%; }

.Dashboard__label {
  padding: 12px 32px;
  padding-top: 0;
  border-bottom: 1px solid grey-border; }
  .Dashboard__label .body-small {
    font-size: 14px !important; }

.Dashboard__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0px 32px;
  height: 153px; }
  .Dashboard__head .box-title .red-title {
    color: #c94f4a;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.36px;
    margin-bottom: 5px; }
  .Dashboard__head .body-regular {
    margin-bottom: 5px; }
  .Dashboard__head .body-small {
    margin-top: 5px;
    font-size: 14px !important; }
  .Dashboard__head .content-progress {
    display: flex;
    gap: 19px;
    align-items: flex-start;
    justify-content: flex-start; }
  .Dashboard__head-tabs {
    height: auto;
    margin-bottom: 20px; }

.Dashboard .content-link {
  padding: 0 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px; }
  .Dashboard .content-link .cont-modal {
    width: auto !important; }
  .Dashboard .content-link .link {
    text-decoration: none;
    color: #5e8eb7;
    display: flex;
    align-items: center; }
    .Dashboard .content-link .link .plus {
      margin-right: 8px; }

.Dashboard .content-flex-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
  padding: 0px 32px; }

.Dashboard .first-section {
  padding-top: 32px;
  padding-bottom: 32px; }
  .Dashboard .first-section-DONE {
    background-color: #FAFCFA; }
    .Dashboard .first-section-DONE .h2 {
      color: #3F9545; }
    .Dashboard .first-section-DONE .red-title {
      color: #3F9545; }

.Dashboard .second-section {
  padding-top: 32px;
  padding-bottom: 32px;
  border-top: 1px solid #CCD3DB; }
  .Dashboard .second-section-DO_LATER {
    border-top: 1px solid #CCD3DB;
    background-color: #F9FAFB; }
    .Dashboard .second-section-DO_LATER .h2 {
      color: #6E7889; }
    .Dashboard .second-section-DO_LATER .red-title {
      color: #6E7889; }
  .Dashboard .second-section-DONE {
    background-color: #FAFCFA;
    border-top: 1px solid #91D997; }
    .Dashboard .second-section-DONE .h2 {
      color: #3F9545; }
    .Dashboard .second-section-DONE .red-title {
      color: #3F9545; }
`, "",{"version":3,"sources":["webpack://./src/main.scss","webpack://./src/sass/base/_generic.scss","webpack://./src/sass/utils/_variables.scss","webpack://./src/sass/base/_reset.scss","webpack://./src/sass/base/_typography.scss","webpack://./src/sass/base/_Buttons.scss","webpack://./src/sass/base/_Selects.scss","webpack://./src/sass/base/_Tags.scss","webpack://./src/components/Atoms/Tags/StateTag/StateTag.scss","webpack://./src/components/Atoms/Cards/CardUploadResponse/CardUploadResponse.scss","webpack://./src/components/Atoms/Dropdown/DropdownBlue/DropdownBlue.scss","webpack://./src/components/Atoms/Alerts/ErrorBox.scss","webpack://./src/scenes/Public/components/Layout/Layout.scss","webpack://./src/scenes/Private/components/Menu/BarDashboard/BarDashboard.scss","webpack://./src/scenes/Private/components/Menu/BarDashboard/RightScenes/RightScenes.scss","webpack://./src/scenes/Public/components/Header/Header.scss","webpack://./src/scenes/Private/components/Menu/HeaderDashboard/HeaderDashboard.scss","webpack://./src/scenes/Private/components/CardProfile/CardProfile.scss","webpack://./src/scenes/Private/components/SectionErrorTask/SectionError/SectionError.scss","webpack://./src/scenes/Private/components/SectionSuccessTask/SectionSuccessTask.scss","webpack://./src/scenes/Private/components/CollapseIssues/CollapseIssues.scss","webpack://./src/scenes/Private/components/AddAnotherDoc/AddAnotherDoc.scss","webpack://./src/components/Atoms/Progress/Progress/Progress.scss","webpack://./src/components/Atoms/Progress/LoanProgress/LoanProgress.scss","webpack://./src/components/Atoms/Progress/TaskProgress/TaskProgress.scss","webpack://./src/components/Atoms/Progress/MinimumProgressVertical/MinimumProgressVertical.scss","webpack://./src/components/Atoms/ButtonTabsFilters/ButtonTabsFilters.scss","webpack://./src/components/Atoms/Cards/CardLoanTasks/CardLoanTasks.scss","webpack://./src/components/Atoms/Inputs/InputAmount/InputAmount.scss","webpack://./src/components/Atoms/Selects/SelectPrimary/SelectPrimary.scss","webpack://./src/components/Atoms/UploadDocs/UploadDocs.scss","webpack://./src/components/Atoms/Inputs/CustomInput/CustomInput.scss","webpack://./src/components/Atoms/Tags/CircleTag/CircleTag.scss","webpack://./src/components/Atoms/Cards/CardDetailInformationBank/CardDetailInformationBank.scss","webpack://./src/components/Atoms/Cards/CardAlertError/CardAlertError.scss","webpack://./src/components/Atoms/Cards/CardSomeoneElse/CardSomeoneElse.scss","webpack://./src/components/Atoms/Switch/Switch.scss","webpack://./src/components/Organisms/Modals/ModalBasic/ModalBasic.scss","webpack://./src/components/Organisms/Modals/ModalTask/ModalTask.scss","webpack://./src/components/Organisms/Modals/ModalTask/SectionRight/SectionRight.scss","webpack://./src/components/Organisms/QuestionBasic/QuestionBasic.scss","webpack://./src/components/Organisms/Modals/ModalCloseTask/ModalCloseTask.scss","webpack://./src/components/Atoms/Inputs/InputBorderNone/InputBorderNone.scss","webpack://./src/scenes/Private/Entities/Entities.scss","webpack://./src/scenes/Private/Loans/Loans.scss","webpack://./src/scenes/Private/Profile/Profile.scss","webpack://./src/scenes/Private/components/IssuesTaskResponse/IssuesTaskResponse.scss","webpack://./src/scenes/Private/Dashboard/components/MinimumLiquidity/Step2/SectionNewBank/SectionNewBank.scss","webpack://./src/scenes/Private/Dashboard/components/MinimumLiquidity/Step2/CardStateAccount/CardStateAccount.scss","webpack://./src/scenes/Private/Dashboard/components/DscrQuestionsAgreements/DscrQuestionsAgreements.scss","webpack://./src/scenes/Private/Dashboard/components/DscrQuestionsAgreements/Step2/CardMarketRent/CardMarketRent.scss","webpack://./src/scenes/Private/Dashboard/components/DscrQuestionsAgreements/Step2/CardLeaseAgreements/CardLeaseAgreements.scss","webpack://./src/scenes/Private/Dashboard/components/MortgagePayments/MortgagePayments.scss","webpack://./src/scenes/Private/Dashboard/components/MortgagePayments/Step1/CardInsuranceCompanyName/CardInsuranceCompanyName.scss","webpack://./src/scenes/Private/Dashboard/components/InvestmentExperienceVerification/InvestmentExperienceVerification.scss","webpack://./src/scenes/Private/Dashboard/components/ConstructionBudget/ConstructionBudget.scss","webpack://./src/scenes/Private/Dashboard/components/EntityGuarantorCreation/EntityGuarantorCreation.scss","webpack://./src/scenes/Private/Dashboard/components/EntityGuarantorCreation/CardOwnership/CardOwnership.scss","webpack://./src/scenes/Private/Dashboard/components/EntityGuarantorCreation/Step1/Step1.scss","webpack://./src/scenes/Private/Dashboard/components/EntityGuarantorCreation/Step2/Step2.scss","webpack://./src/scenes/Private/Dashboard/components/EntityGuarantorCreation/Step3/Step3.scss","webpack://./src/scenes/Private/Dashboard/components/EntityGuarantorCreation/Step2/CardOwnershipEdit/CardOwnershipEdit.scss","webpack://./src/scenes/Private/Dashboard/components/EntityDocs/EntityDocs.scss","webpack://./src/scenes/Private/Dashboard/components/EntityDocs/Step1/Step1.scss","webpack://./src/scenes/Private/Dashboard/components/EntityDocs/Step2/Step2.scss","webpack://./src/scenes/Private/Dashboard/components/TitleCompany/Step1/Step1.scss","webpack://./src/scenes/Private/Dashboard/components/Insurance/Step2/Step2.scss","webpack://./src/scenes/Private/Dashboard/components/Payoff/Payoff.scss","webpack://./src/scenes/Private/Dashboard/components/Purchase/Purchase.scss","webpack://./src/components/Atoms/Inputs/InputUploadedFile/InputUploadedFile.scss","webpack://./src/scenes/Private/Dashboard/components/MinimumLiquidity/MinimunLiquidity.scss","webpack://./src/scenes/Private/Dashboard/components/AddAdditionalDocument/AddAdditionalDocument.scss","webpack://./src/components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit.scss","webpack://./src/scenes/Public/ChangePassword/ChangePassword.scss","webpack://./src/scenes/Public/ResetPassword/ResetPassword.scss","webpack://./src/sass/utils/_animations.scss","webpack://./src/scenes/Public/Login/Login.scss","webpack://./src/scenes/Private/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,iBAAiB;EACjB,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,wBAAwB,EAAA;;AAG1B;EAEI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAA;;AARtB;EAWI,WAAW;EACX,aAAa;EACb,YAAY;EACZ,6BAA6B,EAAA;;AAdjC;EAiBI,YAAY,EAAA;EAjBhB;IAoBM,YAAY,EAAA;;AAKhB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,WAAW;EACX,aAAa,EAAA;;AAKb;;EAEE,eAAe;EACf,SAAS;EACT,gCCxCc;EDyCd,gBAAgB,EAAA;EALjB;;IAOG,cCzCkB;ID0ClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;;AAK3B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD,EAAA;EAJpD;IAMI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B,EAAA;EAbnC;IAgBI,cAAc,EAAA;;AAGlB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,8BAA8B,EAAA;;AAEhC;EACE,aAAa;EACb,uBAAuB,EAAA;;AAEzB;EACE,aAAa;EACb,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,2BAA2B,EAAA;;AAE7B;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB,EAAA;;AAExB;EACE,4BAA4B,EAAA;;AAG5B;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAEjB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAIlB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAErB;EACE,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB,EAAA;;AAEpB;EACE,mBAAmB,EAAA;;AAErB;EACE,mBAAmB,EAAA;;AAGvB;EACE,6BAA6B,EAAA;;AAK7B;EACE,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU,EAAA;;AAEZ;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;EALjB;IAOG,YAAY,EAAA;IAPf;MASK,YAAY,EAAA;EATjB;IAaG,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;EAhBnB;IAoBK,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB,EAAA;;AAIrB;EAEG,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAIzB;EAEI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAEpB;EAEG,gBAAgB,EAAA;;AAItB;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAGjB;EACE,oBAAoB,EAAA;;AElQtB;;;CHuOC;AGnOD;EACE,sBAAsB,EAAA;;AAGxB;;;EAGE,SAAS;EACT,YAAY,EAAA;;AAGd;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB,EAAA;;AAG1B,yDAAA;AACA;EACE,UAAU,EAAA;;AAGZ,gDAAA;AACA;;;;;;;;;;;EAWE,cAAc,EAAA;;AAGhB;EACE,cAAc,EAAA;;AAGhB;;EAEE,gBAAgB,EAAA;;AAGlB;;EAEE,YAAY,EAAA;;AAGd;;;;EAIE,WAAW;EACX,aAAa,EAAA;;AAGf;EACE,yBAAyB;EACzB,iBAAiB,EAAA;;AAGnB;;;;EAIE,wBAAwB;EACxB,qBAAqB,EAAA;;AAGvB;EACE,wBAAwB;EACxB,qBAAqB;EAGrB,uBAAuB,EAAA;;AAGzB;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;;IHyNI;AGrNJ;;;EAGE,qBAAqB;GHuNrB,eGtNgB;GHuNhB,OGtNQ;EACR,eAAe,EAAA;;AAGjB;;;IHwNI;AGnNJ;EACE,aAAa;EACb,SAAS,EAAA;;AAGX;;;IHsNI;AACJ;EGjNE,aAAa,EAAA;;AAGf;;;;;IHsNI;AG/MJ;EACE,eAAe;EAAE,MAAA;EACjB,8BAA8B;EAAE,MAAA;EAChC,0BAA0B;EAAE,MAAA,EAAO;;AAGrC;;IHoNI;AGhNJ;EACE,oBAAoB,EAAA;;AAGtB;;IHkNI;AG9MJ;;EAEE,UAAU,EAAA;;AAGZ;;;IHiNI;AG5MJ;EACE,SAAS;EAAE,MAAA;EACX,+BAA+B;EAAE,MAAA,EAAO;;AAG1C;;IHgNI;AG5MJ;EACE,SAAS,EAAA;;AAGX;;IH8MI;AG1MJ;EACE,SAAS,EAAA;;AAGX;;IH4MI;AGxMJ;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B,EAAA;;AAGhC;;;;IH4MI;AGtMJ;EACE,SAAS;EAAE,MAAA;EACX,UAAU;EACV,mBAAmB;EAAE,MAAA;GH0MrB,iBGzMkB;EAAE,MAAA,EAAO;;AAG7B;;;;;IH8MI;AGvMJ;;;;EAIE,eAAe;EAAE,MAAA;EACjB,SAAS;EAAE,MAAA;EACX,wBAAwB;EAAE,MAAA;GH4M1B,sBG3MuB;EAAE,MAAA,EAAO;;AAGlC;;;IH8MI;AGzMJ;;EAEE,mBAAmB,EAAA;;AAGrB;;;;;IH8MI;AGvMJ;;EAEE,oBAAoB,EAAA;;AAGtB;;;;;;;;IH+MI;AGrMJ;;;;EAIE,0BAA0B;EAAE,MAAA;EAC5B,eAAe;EAAE,MAAA;GHyMjB,iBGxMkB;EAAE,MAAA,EAAO;;AAG7B;;IH0MI;AGtMJ;;EAEE,eAAe,EAAA;;AAGjB;;;;;IH2MI;AGpMJ;;EAEE,sBAAsB;EAAE,MAAA;EACxB,UAAU;EAAE,MAAA;GHwMZ,YGvMa;EAAE,MAAA;GHyMf,WGxMY;EAAE,MAAA,EAAO;;AAGvB;;;;IH4MI;AGtMJ;EACE,6BAA6B;EAAE,MAAA;EAEE,MAAA;EACjC,uBAAuB,EAAA;;AAGzB;;;IH2MI;AGtMJ;;EAEE,wBAAwB,EAAA;;AAG1B;;IHwMI;AGpMJ;;EAEE,SAAS;EACT,UAAU,EAAA;;AAGZ;;;IHuMI;AGlMJ;EACE,cAAc;EAAE,MAAA;EAChB,mBAAmB;EAAE,MAAA,EAAO;;AAG9B;;IHsMI;AGlMJ;EACE,yBAAyB;EACzB,iBAAiB,EAAA;;AAGnB;;;;;EAKE,WAAW,EAAA;;AAQb;EACE,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,SAAS;EACT,8JAC4C;EAC5C,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,+EAA+E,EAAA;;ACldjF;EACE,cFQkB;EEPlB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAErB;EACE,cFKkB;EEJlB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;EACjB;IACE,gBAAgB,EAAA;;AAGpB;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;;AAEnB;EACE,cFdkB;EEelB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;EACjB;IACE,0BAA0B,EAAA;EAE5B;IACE,gBAAgB,EAAA;EAElB;IACE,gBAAgB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cFnCuB,EAAA;;AEqCzB;EACE,cF5CkB;EE6ClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EACnB;IACE,kBAAkB,EAAA;EAEpB;IACE,yBAAyB,EAAA;EAE3B;IAEE,gBAAgB,EAAA;EAElB;IACE,gBAAgB,EAAA;;AAIpB;EACE,cFhEwB;EEiExB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EACnB;IACE,gBAAgB,EAAA;;AAGpB;EACE,cFzEwB;EE0ExB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB,EAAA;;AAExB;EACE,cFvFkB;EEwFlB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EACnB;IACE,gBAAgB,EAAA;EAElB;IACE,gBAAgB,EAAA;EAElB;IACE,yBAAyB,EAAA;;AAG7B;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAErB;EACE,cFhHkB;EEiHlB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;EACjB;IACE,gBAAgB;IAChB,+BAA+B,EAAA;EAEjC;IACE,gBAAgB,EAAA;EAElB;IACE,gBAAgB,EAAA;EAElB;IACE,gBAAgB,EAAA;EAElB;IACE,yBAAoC,EAAA;EAEtC;IACE,yBAAmC,EAAA;EAErC;IACE,yBAA2C,EAAA;;AAG/C;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;EAPnB;IASI,YAAY;IACZ,gBAAgB,EAAA;;AAIpB;EACE,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB,EAAA;EAHlB;IAMM,cAAc;IACd,gBAAgB,EAAA;;AAItB;EACE,eAAe,EAAA;EAEf;IACE,qCAAqC,EAAA;;AAIzC;EACE,yBAAyB,EAAA;EAD3B;IAII,gCAAgC,EAAA;;AC5MpC;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAGnB;IACE,6BAA6B;IAC7B,UAAU;IACV,YAAY;IACZ,gBAAgB,EAAA;IAJjB;MAMG,yBAAyB;MACzB,kBAAkB;MAClB,0BAA0B;MAC1B,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,qBAAqB,EAAA;EAIzB;IACE,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB,EAAA;EAExB;IACE,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;IAC9B,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB,EAAA;EAExB;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,yBHhD0B;IGiD1B,mBHjD0B;IGkD1B,YAAY,EAAA;IAPb;MASG,YAAY;MACZ,yBAAmC;MACnC,8BAA4C,EAAA;EAGhD;IACE,YAAY;IACZ,kBAAkB;IAClB,yBHzDqB;IG0DrB,cH1DqB,EAAA;IGsDtB;MAOG,yBAAmC;MACnC,oCAA6C;MAC7C,8BAA4C,EAAA;EAGhD;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW,EAAA;EAEb;IACE,UAAU;IACV,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,cAAc,EAAA;IALf;MAOG,cAAc,EAAA;IAPjB;MAUG,yBAAyB,EAAA;EAG7B;IACE,UAAU;IACV,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,cAAc,EAAA;IANf;MAQG,cAAc,EAAA;IARjB;MAWG,yBAAyB,EAAA;EAG7B;IACE,WAAW;IACX,cH1GW;IG2GX,yBHxGiB,EAAA;IGqGlB;MAKG,yBAAwB;MACxB,oCAAyC,EAAA;EAG7C;IACE,kBAAkB;IAClB,yBHrD2B;IGsD3B,mBHvD+B;IGwD/B,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW,EAAA;IAZZ;MAeG,oCAAwD;MACxD,gCAAgD,EAAA;MAhBnD;QAmBK,yBAAwC,EAAA;MAnB7C;QAuBK,oCAAwD;QACxD,gCAAgD,EAAA;QAxBrD;UA2BO,yBAAwC,EAAA;IA3B/C;MAiCG,oCAA6D;MAC7D,oCAAyD;MACzD,sCAAsC,EAAA;MAnCzC;QAsCK,yBAAyB,EAAA;MAtC9B;QA0CK,oCAA0D;QAC1D,gBAAgB,EAAA;IAIpB;MACE,oCAAoD;MACpD,gCAAgD,EAAA;MAFjD;QAIG,yBAAyB,EAAA;MAJ5B;QAQG,gCAAgD;QAChD,oCAAoD,EAAA;IAIxD;MACE,oCAA8C;MAC9C,gCAA0C,EAAA;MAF3C;QAKG,gCAA0C;QAC1C,oCAA8C,EAAA;QANjD;UASK,uBAAuB,EAAA;IAK7B;MACE,kBAAkB;MAClB,8BAAqC;MACrC,gCAAuC,EAAA;MAHxC;QAMG,8BAAqC;QACrC,gCAAuC,EAAA;MAP1C;QAWG,8BAA8B;QAC9B,gCAAgC,EAAA;MAZnC;QAgBG,YAAY;QACZ,gBAAgB,EAAA;EAKtB;IACE,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,cHvNW,EAAA;IGiNZ;MASG,yBAAwB,EAAA;IAG1B;MACE,yBAAoC,EAAA;IAGtC;MACE,cH9LyB,EAAA;MG6L1B;QAIG,yBAAwC,EAAA;EAK9C;IACE,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB,EAAA;IAZvB;MAeG,oCAAwD;MACxD,gCAAgD;MAChD,yBAA+B,EAAA;EAInC;IACE,cAAc,EAAA;IADf;MAGG,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B,EAAA;IARlC;MAYG,yBAAyB,EAAA;EAI7B;IACE,cH5O2B;IG6O3B,YAAY,EAAA;IAFb;MAKG,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B,EAAA;IAVlC;MAcG,yBAAwC,EAAA;EAI5C;IACE,yBAAyB,EAAA;IAD1B;MAGG,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAA;IAPtB;MAWG,yBAAyB,EAAA;EAI7B;IACE,WAAW,EAAA;IADZ;MAIG,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,oBAAoB,EAAA;IAPvB;MAWG,oCAAwD;MACxD,gCAAgD,EAAA;MAZnD;QAeK,yBAAwC;QACxC,2BAA2B,EAAA;MAhBhC;QAoBK,oCAAwD;QACxD,gCAAgD,EAAA;QArBrD;UAwBO,yBAAwC;UACxC,2BAA2B,EAAA;IAzBlC;MA+BG,gCAAqC;MACrC,yBAAwB,EAAA;IAG1B;MACE,yBAAyB;MACzB,qBAAqB;MACrB,cAAc,EAAA;MAHf;QAMG,oCAAoC;QACpC,gCAAgC;QAChC,yBAAyB,EAAA;IAI7B;MACE,yBAAyB;MACzB,qBAAqB,EAAA;MAFtB;QAKG,cHpVwB,EAAA;MG+U3B;QASG,gCAAgC;QAChC,oCAAoC,EAAA;QAVvC;UAaK,yBAAyB,EAAA;IAK/B;MACE,yBAAyB;MACzB,qBAAqB;MACrB,cAAc,EAAA;MAHf;QAMG,gCAAgC;QAChC,oCAAoC;QACpC,yBAAyB,EAAA;IAI7B;MACE,qBAAqB;MACrB,yBAAyB;MACzB,cAAc,EAAA;MAHf;QAMG,gCAAgC;QAChC,oCAAoC;QACpC,yBAAyB,EAAA;IAI7B;MACE,yBAAyB;MACzB,qBAAqB,EAAA;MAFtB;QAIG,cAAc,EAAA;MAJjB;QAQG,oCAAoC;QACpC,gCAAgC,EAAA;QATnC;UAWK,uBAAuB,EAAA;;ACra/B;EACE,WAAW;EACX,YAAY,EAAA;EAFb;IAIG,uBAAuB;IACvB,4BAA4B;IAC5B,8BAA8B;IAC9B,oCAAoC,EAAA;IAPvC;MASK,uBAAuB,EAAA;;ACV/B;EACI,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EARvB;IAWQ,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;;AAIzB;EACI,aAAa;EACb,gBAAgB;EAChB,SAAS,EAAA;;AAGb;EACI,WAAW;EACX,YAAY,EAAA;EAEZ;IACI,yBLmB2B;IKlB3B,qBLYsB,EAAA;IKdzB;MAKO,yBLUwB,EAAA;EKNhC;IACI,yBLNqB;IKOrB,qBLTc,EAAA;IKOjB;MAKO,yBLNgB,EAAA;EKUxB;IACI,yBLUwB;IKTxB,qBLIoB,EAAA;IKNvB;MAKO,yBLCgB,EAAA;;AKI5B;EACI,2BAA2B;EAC3B,qBAAqB,EAAA;EAFzB;IAKQ,gBAAgB,EAAA;EALxB;IASQ,gBAAgB,EAAA;EAGpB;IACI,oCAAwD,EAAA;EAG5D;IACI,oCAA+C,EAAA;EAGnD;IACI,oCAAgD,EAAA;EAGpD;IACI,oCAAgD,EAAA;;AAIxD;EACI,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,2BAA2B,EAAA;;AC/F/B;EACI,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ,EAAA;EAPZ;IAUQ,iBAAiB,EAAA;EAVzB;IAcQ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe,EAAA;EAGnB;IACI,qBNyB2B;IMxB3B,mBNwB2B,EAAA;IM1B9B;MAKO,yBAAsC,EAAA;EAI9C;IACI,qBNMyB;IMLzB,mBNKyB,EAAA;IMP5B;MAKO,yBAAoC,EAAA;EAI5C;IACI,qBNgBwB;IMfxB,mBNewB,EAAA;IMjB3B;MAKO,yBAAmC,EAAA;EAI3C;IACI,qBNtBmB;IMuBnB,mBNvBmB,EAAA;IMqBtB;MAKO,uBAAuB,EAAA;EAI/B;IACI,qBNW4B;IMV5B,mBNU4B,EAAA;IMZ/B;MAKO,gBAAgB;MAChB,yBAA6B,EAAA;;AC/DzC;EACC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB,EAAA;EAHnB;IAME,mBAAmB,EAAA;IANrB;MASG,WAAW;MACX,gBAAgB,EAAA;IAVnB;MAcG,UAAU,EAAA;EAdb;IAmBE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB,EAAA;IArBpB;MAwBG,aAAa;MACb,mBAAmB,EAAA;IAzBtB;MA6BG,UAAU;MACV,cAA6B;MAC7B,eAAe,EAAA;MA/BlB;QAkCI,0BAA0B,EAAA;MAlC9B;QAsCI,cAA6B,EAAA;EAtCjC;IA4CE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB,EAAA;IAlDrB;MAqDM,eAAe;MACf,0BAA0B,EAAA;MAtDhC;QAyDQ,cAAa,EAAA;EAKpB;IACC,yBPhC2B;IOiC3B,yBP1BqC,EAAA;IOwBrC;MAKC,yBAAoC,EAAA;IALrC;MASC,yBAAoC,EAAA;IATrC;MAaC,yBAAoC,EAAA;EAItC;IACC,yBPvC4B;IOwC5B,uBPjCqC,EAAA;IO+BrC;MAKC,yBAAsC,EAAA;IALvC;MASC,yBAAsC,EAAA;IATvC;MAaC,yBAAsC,EAAA;EAIxC;IACC,yBP9C0B;IO+C1B,yBPzCoC,EAAA;IOuCpC;MAKC,yBAAmC,EAAA;IALpC;MASC,yBAAmC,EAAA;IATpC;MAaC,yBAAmC,EAAA;;AC7GtC;EACI,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB,EAAA;EAJvB;IAOQ,oCAAyC;IACzC,uBAAuB,EAAA;IAR/B;MAWY,qCAAqC,EAAA;EAXjD;IAgBQ,kCAAkC;IAClC,yBAAyB,EAAA;IAjBjC;MAoBY,0CAA0C,EAAA;EAIlD;IACI,yBAAyB;IACzB,kBAAkB,EAAA;IAFrB;MAKO,YAAY,EAAA;IALnB;MAUW,oCAAoC,EAAA;MAV/C;QAae,cRtBK;QQuBL,gBAAgB,EAAA;IAd/B;MAoBO,cR6BS;MQ5BT,gBAAgB,EAAA;MArBvB;QAwBW,cRjCS;QQkCT,gBAAgB,EAAA;;ACjDhC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB,EAAA;EATxB;IAWI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc,EAAA;EAhBlB;IAmBI,kBAAkB,EAAA;;ACnBtB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB,EAAA;EAHzB;IAKI,WAAW,EAAA;EALf;IAQI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,+BAA+B,EAAA;IAZnC;MAcM,WAAW,EAAA;;ACdjB;EACE,WAAW;EACX,0BAA0B,EAAA;;AAG5B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,OAAO,EAAA;EAXT;IAcI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW,EAAA;IAlBf;MAqBM,kBAAkB;MAClB,eAAe;MACf,gBAAgB,EAAA;MAvBtB;QA0BQ,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,yBAAyB;QACzB,WAAW;QACX,SAAS;QACT,kBAAkB,EAAA;QAnC1B;UAsCU,cAAc;UACd,kBAAkB;UAClB,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,iBAAiB,EAAA;IA5C3B;MAkDM,WAAW;MACX,qBAAqB;MACrB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB,EAAA;MAvD7B;QA0DQ,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB,EAAA;MA7DzB;QAiEQ,WAAW;QACX,YAAY;QACZ,kBAAkB,EAAA;QAnE1B;UAsEU,eAAe;UACf,gBAAgB,EAAA;QAvE1B;UA2EU,yBAAyB;UACzB,qBAAqB,EAAA;UA5E/B;YA+EY,cAAc,EAAA;UA/E1B;YAmFY,yBAAyB;YACzB,qBAAqB,EAAA;YApFjC;cAuFc,cAAc,EAAA;QAvF5B;UA6FU,yBAAyB;UACzB,qBAAqB,EAAA;UA9F/B;YAiGY,cAAc,EAAA;UAjG1B;YAqGY,yBAAyB;YACzB,qBAAqB,EAAA;QAtGjC;UA2GU,yBAAyB;UACzB,qBAAqB,EAAA;UA5G/B;YA+GY,cAAc,EAAA;UA/G1B;YAmHY,yBAAyB;YACzB,qBAAqB,EAAA;IApHjC;MA2HM,uBAAuB;MACvB,mBAAmB,EAAA;IA5HzB;MAgIM,yBAAyB;MACzB,mBAAmB,EAAA;IAjIzB;MAqIM,WAAW,EAAA;IArIjB;MAyIM,YAAY;MACZ,mBAAmB;MACnB,aAAa,EAAA;MA3InB;QA+IU,mBAAmB,EAAA;QA/I7B;;;UAoJY,yBAAyB,EAAA;QApJrC;UAwJY,yBAAyB,EAAA;EAxJrC;IAgKI,WAAW;IACX,YAAY;IACZ,yBAAyB;IAEzB,sEAA4E,EAAA;EApKhF;IAwKI,WAAW;IACX,YAAY;IACZ,yBAAyB;IAEzB,sEAAgF,EAAA;EA5KpF;IAgLI,WAAW;IACX,YAAY;IACZ,yBAAyB;IAEzB,sEAA6E,EAAA;EApLjF;IAwLI,mBAAmB,EAAA;IAxLvB;;;MA6LM,yBAAyB,EAAA;IA7L/B;MAiMM,yBAAyB,EAAA;;ACtM/B;EACE,eAAe;EACf,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EAEnB;IACE,kBAAkB;IAClB,wBAAwB;IAAE,oCAAA;IAC1B,sBAAsB;IACtB,YAAY;IACZ,8BAA8B,EAAA;;AAGhC;EACE;IACE,yCAAyC,EAAA;EAE3C;IACE,wBAAwB,EAAA,EAAA;EA1B9B;IA+BI,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,YAAY,EAAA;IAnChB;MAwCM,+CAA+C;MAC/C,gBAAgB;MAChB,YAAY,EAAA;;AC1ClB;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC,EAAA;EAPlC;IAUM,YAAY;IACZ,WAAW,EAAA;EAXjB;IAcM,YAAY;IACZ,WAAW,EAAA;EAfjB;IAoBI,YAAY;IACZ,WAAW,EAAA;;ACrBf;EACE,OAAO;EACP,MAAM;EACN,eAAe;EACf,YAAY;EACZ,WAAW,EAAA;EALb;IAOI,YAAY;IACZ,eAAe;IAEf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;IAChC,QAAQ,EAAA;IAfZ;MAiBM,YAAY,EAAA;IAjBlB;MAoBM,YAAY;MACZ,WAAW,EAAA;IArBjB;MAyBM,aAAa;MACb,2BAA2B;MAC3B,mBAAmB;MACnB,QAAQ,EAAA;MA5Bd;QA8BQ,YAAY,EAAA;MA9BpB;QAiCQ,YAAY;QACZ,WAAW,EAAA;;AAKnB;EACE,YAAY;EAIZ,WAAW,EAAA;EALb;IAGI,YAAY,EAAA;EAHhB;IAOI,kBAAkB,EAAA;;AC9CtB;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB,EAAA;EANpB;IAQI,kBAAkB;IAClB,WAAW;IACX,QAAQ,EAAA;EAEV;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,cAAc,EAAA;IALf;MAOG,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB,EAAA;IAXrB;MAcG,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B,EAAA;IArBlC;MAwBG,cf1BgB;Me2BhB,kBAAkB;MAClB,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB,EAAA;MA/BrB;QAiCK,cf/BY;QegCZ,eAAe;QACf,gBAAgB;QAChB,kBAAkB,EAAA;MApCvB;QAuCK,oBAAoB;QACpB,qBAAqB;QACrB,cf5CY;Qe6CZ,kBAAkB,EAAA;IAGtB;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,WAAW,EAAA;IAjDd;MAqDG,mBAAmB;MACnB,UAAU;MACV,kBAAkB;MAClB,iBAAiB;MACjB,mBAAmB,EAAA;MAzDtB;QA2DK,gBAAgB;QAChB,cAAc;QACd,cAAc,EAAA;MA7DnB;QAgEK,gBAAgB;QAChB,eAAe;QACf,cAAc,EAAA;;AC9EtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB,EAAA;EAJ3B;IAQM,YAAY,EAAA;EARlB;IAaI,gBAAgB,EAAA;IAbpB;MAgBM,cAAc;MACd,oBAAoB;MAAE,sDAAA;MACtB,4BAA4B;MAAE,yBAAA;MAC9B,qBAAqB;MAAE,4BAAA;MACvB,gBAAgB;MAAE,sCAAA,EAAuC;EApB/D;IAyBI,kBAAkB,EAAA;EAzBtB;IA6BI,cAAc,EAAA;EA7BlB;IAgCI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAA;IAtCrB;MAwCM,cAAc;MACd,eAAe,EAAA;IAzCrB;MA6CM,cAAc,EAAA;IA7CpB;MAiDM,YAAY,EAAA;;ACjDlB;EACI,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB,EAAA;EAJ7B;IAOQ,6BAA6B,EAAA;EAPrC;IAWQ,cAAc,EAAA;EAXtB;IAeQ,cAAc;IACd,eAAe,EAAA;EAhBvB;IAoBQ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAA;IA1BzB;MA6BY,cAAc;MACd,eAAe,EAAA;IA9B3B;MAkCY,cAAc,EAAA;IAlC1B;MAsCY,YAAY,EAAA;;ACtCxB;EAEE,uBAAuB;EACvB,UAAU;EACV,gBAAgB,EAAA;EAEhB;IACE,kBAAkB;IAClB,SAAS,EAAA;EAGX;IACE,eAAe,EAAA;EAZnB;IAgBI,kBAAkB;IA6BlB,UAAA;IAKA,WAAA;IAMA,oBAAA,EAAqB;IAxDzB;MAmBM,kBAAkB,EAAA;IAnBxB;MAwBQ,mBAAmB,EAAA;IAxB3B;MA4BQ,mBAAmB,EAAA;IA5B3B;MAiCM,sBAAsB,EAAA;IAjC5B;MAqCM,gBAAgB,EAAA;IArCtB;MAyCM,UAAU;MACV,kBAAkB,EAAA;IA1CxB;MA+CM,mBAAmB,EAAA;IA/CzB;MAoDM,gBAAgB;MAChB,kBAAkB,EAAA;IArDxB;MA0DM,gBAAgB,EAAA;EA1DtB;IA+DI,QAAQ,EAAA;EA/DZ;IAmEI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB,EAAA;IAzEpB;MA4EM,YAAY;MACZ,gBAAgB,EAAA;MA7EtB;QAgFQ,cAAc;QACd,oBAAoB;QACpB,sDAAA;QACA,4BAA4B;QAC5B,yBAAA;QACA,qBAAqB;QACrB,4BAAA;QACA,gBAAgB;QAChB,sCAAA,EAAuC;IAxF/C;MA6FM,kBAAkB,EAAA;IA7FxB;MAiGM,cAAc,EAAA;IAjGpB;MAqGM,cAAc;MACd,eAAe,EAAA;MAtGrB;QAyGQ,cAAc,EAAA;;ACzGtB;EAEE,gBAAgB,EAAA;EAFlB;IAKI,UAAU,EAAA;IALd;MAQM,gBAAgB;MAChB,aAAa;MACb,qBAAqB,EAAA;IAV3B;MAcM,qCAAqC,EAAA;EAd3C;IAmBI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB,EAAA;IAtB1B;MA2BU,0BAA0B;MAC1B,2BAA2B;MAC3B,uBAAuB,EAAA;IA7BjC;MAiCU,0BAA0B;MAC1B,2BAA2B,EAAA;IAlCrC;MAuCQ,0BAA0B;MAC1B,2BAA2B;MAC3B,6BAA6B;MAC7B,uBAAuB,EAAA;MA1C/B;QA6CU,0BAA0B;QAC1B,2BAA2B;QAC3B,6BAA6B,EAAA;IA/CvC;MAqDU,gBAAgB,EAAA;IArD1B;MAwDU,gBAAgB,EAAA;IAxD1B;MA6DQ,gBAAgB;MAChB,kBAAkB,EAAA;;AC9D1B;EACE,aAAa;EACb,QAAQ;EACR,eAAe,EAAA;EAHjB;IAMI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa,EAAA;IAVjB;MAYM,8BAA8B;MAC9B,2BAA2B,EAAA;IAbjC;MAgBM,+BAA+B;MAC/B,4BAA4B,EAAA;IAjBlC;MAoBM,WAAW,EAAA;MApBjB;QAuBQ,mBpBmB4B,EAAA;MoB1CpC;QA2BQ,mBpB4BkB,EAAA;MoBvD1B;QA+BQ,mBpB6BsB,EAAA;MoB5D9B;QAmCQ,mBpBNc,EAAA;;AqB7BtB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ,EAAA;EAJV;IAOI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB,EAAA;IAXvB;MAcM,aAAa;MACb,mBAAmB;MACnB,sBAAsB,EAAA;IAhB5B;MAoBM,eAAe;MACf,WAAW;MACX,wBAAwB;MACxB,WAAW;MACX,mBAAmB;MACnB,eAAe;MACf,yBrBVoB,EAAA;IqBhB1B;MA+BQ,cAAc,EAAA;IA/BtB;MAmCQ,cAAc,EAAA;IAnCtB;MAuCQ,yBAAyB,EAAA;MAvCjC;QA0CU,yBAAyB,EAAA;QA1CnC;UA6CY,oCAAoC,EAAA;MA7ChD;QAkDU,yBAAyB,EAAA;QAlDnC;UAqDY,cAAc,EAAA;IArD1B;MA6DQ,cAAc,EAAA;IA7DtB;MAiEQ,cAAc,EAAA;IAjEtB;MAqEQ,yBAAyB,EAAA;MArEjC;QAwEU,yBAAyB,EAAA;QAxEnC;UA2EY,oCAAoC,EAAA;MA3EhD;QAgFU,yBAAyB,EAAA;QAhFnC;UAmFY,cAAc,EAAA;IAnF1B;MA2FQ,cAAc,EAAA;IA3FtB;MA+FQ,cAAc,EAAA;IA/FtB;MAmGQ,yBAAyB,EAAA;MAnGjC;QAsGU,yBAAyB,EAAA;QAtGnC;UAyGY,oCAAoC,EAAA;MAzGhD;QA8GU,yBAAyB,EAAA;QA9GnC;UAiHY,cAAc,EAAA;IAjH1B;MA0HQ,cAAc,EAAA;IA1HtB;MA8HQ,cAAc,EAAA;IA9HtB;MAkIQ,yBAAyB,EAAA;MAlIjC;QAqIU,yBAAyB,EAAA;QArInC;UAwIY,oCAAoC,EAAA;MAxIhD;QA6IU,yBAAyB,EAAA;QA7InC;UAgJY,cAAc,EAAA;IAhJ1B;MAwJQ,uBAAuB;MACvB,yBAAyB,EAAA;MAzJjC;QA4JU,yBAAyB,EAAA;QA5JnC;UA+JY,oCAAoC,EAAA;MA/JhD;QAoKU,yBAAyB,EAAA;IApKnC;MA0KM,kBAAkB;MAClB,yBAAyB;MACzB,sCAAsC;MACtC,YAAY;MACZ,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;MACjB,UAAU;MACV,mBAAmB;MACnB,WAAW,EAAA;MAnLjB;QAuLU,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,kBAAkB;QAClB,QAAQ;QACR,iBAAiB;QACjB,gBAAgB,EAAA;QAhM1B;UAoMc,0BAA0B,EAAA;QApMxC;UAyMgB,cAAc,EAAA;QAzM9B;UA+MY,6BAA6B;UAC7B,YAAY;UACZ,mBAAmB;UACnB,aAAa;UACb,mBAAmB;UACnB,uBAAuB,EAAA;UApNnC;YAuNc,aAAa;YACb,mBAAmB;YACnB,QAAQ,EAAA;YAzNtB;cA4NgB,kBAAkB;cAClB,eAAe;cACf,gBAAgB,EAAA;UA9NhC;YAqOgB,aAAa,EAAA;UArO7B;YAyOgB,aAAa,EAAA;QAzO7B;UA+OY,WAAW,EAAA;QA/OvB;UAmPY,UAAU,EAAA;QAnPtB;UAuPY,UAAU,EAAA;QAvPtB;UA2PY,UAAU,EAAA;QA3PtB;UA+PY,UAAU,EAAA;QA/PtB;UAmQY,UAAU,EAAA;MAnQtB;QAwQU,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,6BAA6B,EAAA;QA7QvC;UAgRY,mBAAmB;UACnB,6BAA6B,EAAA;UAjRzC;YAoRc,mBAAmB,EAAA;YApRjC;;cAwRgB,cAAc,EAAA;UAxR9B;YA8RgB,cAAc,EAAA;UA9R9B;YAkSgB,yBAAyB,EAAA;UAlSzC;YAuSkB,cAAc,EAAA;QAvShC;UA+SY,mBAAmB;UACnB,6BAA6B,EAAA;UAhTzC;YAmTc,mBAAmB,EAAA;YAnTjC;;cAuTgB,cAAc,EAAA;UAvT9B;YA6TgB,cAAc,EAAA;UA7T9B;YAkUkB,cAAc,EAAA;QAlUhC;UAyUY,mBAAmB;UACnB,6BAA6B,EAAA;UA1UzC;YA6Uc,mBAAmB,EAAA;YA7UjC;;cAiVgB,cAAc,EAAA;UAjV9B;YAuVgB,cAAc,EAAA;UAvV9B;YA4VkB,cAAc,EAAA;QA5VhC;UAmWY,mBAAmB;UACnB,6BAA6B,EAAA;UApWzC;YAuWc,mBAAmB,EAAA;YAvWjC;;cA2WgB,cAAc,EAAA;UA3W9B;YAiXgB,cAAc,EAAA;UAjX9B;YAsXkB,cAAc,EAAA;QAtXhC;UA8Xc,yBAAyB,EAAA;QA9XvC;UAmYY,YAAY;UACZ,kBAAkB;UAClB,aAAa;UACb,mBAAmB;UACnB,UAAU;UACV,mBAAmB;UACnB,gBAAgB;UAChB,iBAAiB,EAAA;UA1Y7B;YA6Yc,eAAe;YACf,gBAAgB,EAAA;UA9Y9B;YAkZc,eAAe;YACf,gBAAgB,EAAA;QAnZ9B;UAwZY,2BAA2B;UAC3B,YAAY,EAAA;QAzZxB;UA6ZY,gBAAgB;UAChB,oBAAoB,EAAA;UA9ZhC;YAiac,eAAe;YACf,gBAAgB,EAAA;UAla9B;YAsac,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,eAAe,EAAA;UAza7B;YA6ac,YAAY,EAAA;YA7a1B;cAgbgB,eAAe;cACf,gBAAgB,EAAA;UAjbhC;YAsbc,YAAY;YACZ,iBAAiB,EAAA;UAvb/B;YA2bc,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,kBAAkB;YAClB,kBAAkB;YAClB,gBAAgB,EAAA;YAjc9B;cAocgB,kBAAkB;cAClB,eAAe,EAAA;YArc/B;cAycgB,kBAAkB;cAClB,gBAAgB,EAAA;YA1chC;cA8cgB,2BAA2B,EAAA;YA9c3C;cAkdgB,WAAW;cACX,YAAY;cACZ,yBAAyB;cACzB,kBAAkB,EAAA;YArdlC;cAydgB,yBAAyB,EAAA;cAzdzC;;;gBA8dkB,cAAc,EAAA;YA9dhC;cAoegB,mBAAmB,EAAA;cApenC;;;;;gBAyekB,cAAc,EAAA;YAzehC;cA8egB,mBAAmB,EAAA;cA9enC;;;gBAmfkB,cAAc,EAAA;;ACnfhC;EAEI,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,aAAa,EAAA;EANjB;IAQM,8BAA8B;IAC9B,2BAA2B,EAAA;EATjC;IAYM,+BAA+B;IAC/B,4BAA4B,EAAA;EAblC;IAgBM,WAAW,EAAA;;AAhBjB;EAoBI,yBAAyB;EACzB,oBAAoB,EAAA;;ACrBxB;EAEE,gBAAgB;EAChB,WAAW,EAAA;EAHb;IAMI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW,EAAA;IATf;MAYM,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;MACb,8BAA8B;MAC9B,kBAAkB,EAAA;MAlBxB;QAqBQ,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,iBAAiB,EAAA;QAxBzB;UA6BU,WAAW;UACX,kBAAkB;UAClB,SAAS;UACT,WAAW;UACX,WAAW;UACX,yBAAyB;UACzB,4BAA4B;UAC5B,6BAA6B,EAAA;QApCvC;UAwCU,WAAW;UACX,kBAAkB;UAClB,YAAY;UACZ,WAAW;UACX,WAAW;UACX,yBAAyB;UACzB,gCAAgC;UAChC,+BAA+B,EAAA;EA/CzC;IAsDI,yBAAyB;IACzB,oBAAoB,EAAA;EAvDxB;IA2DI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ,EAAA;IA/DZ;MAkEM,kBAAkB;MAClB,YAAY,EAAA;IAnElB;MAuEM,kBAAkB;MAClB,YAAY,EAAA;MAxElB;QA2EQ,yBAAyB,EAAA;IA3EjC;MAgFM,kBAAkB;MAClB,YAAY,EAAA;MAjFlB;QAoFQ,yBAAyB,EAAA;IApFjC;MAyFM,kBAAkB;MAClB,YAAY,EAAA;MA1FlB;QA6FQ,yBAAyB,EAAA;IA7FjC;MAkGM,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,cAAc,EAAA;MArGpB;QAwGQ,gBAAgB;QAChB,cAAc,EAAA;MAzGtB;QA6GQ,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,cAAc,EAAA;IAjHtB;MAsHM,2BAA2B;MAC3B,6BAA6B;MAC7B,4BAA4B;MAC5B,iBAAiB;MACjB,yBAAyB,EAAA;MA1H/B;QA6HQ,2BAA2B;QAC3B,yBAAyB,EAAA;;AC9HjC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS,EAAA;EAJX;IAMI,oBAAoB;IACpB,mBxBSsB;IwBRtB,cxBCgB;IwBAhB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,YAAY,EAAA;IAjBhB;MAmBM,gBAAgB;MAChB,gBAAgB,EAAA;IApBtB;MAuBM,8BAA8B;MAC9B,uBAAuB,EAAA;IAxB7B;MA2BM,yBxBZmB;MwBanB,cxBXS,EAAA;MwBjBf;QA8BQ,oCAA6C;QAC7C,yBAAwB,EAAA;EA/BhC;IAoCI,oBAAoB,EAAA;;ACpCxB;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB,EAAA;EAExB;IACE,iBAAiB;IACjB,oCAAoC;IACpC,sCAAsC,EAAA;EAjB1C;IAqBI,aAAa,EAAA;EArBjB;IAyBI,gBAAgB;IAChB,UAAU,EAAA;IA1Bd;MA6BM,gBAAgB,EAAA;IA7BtB;MAiCM,gBAAgB,EAAA;IAjCtB;MAqCM,yBzBK8B,EAAA;IyB1CpC;MAyCM,yBzBdqB,EAAA;IyB3B3B;MA6CM,yBzBMsB,EAAA;IyBnD5B;MAiDM,yBzBdsB,EAAA;EyBnC5B;IAsDI,gBAAgB,EAAA;IAtDpB;MAyDM,aAAa;MACb,8BAA8B,EAAA;IA1DpC;MA8DM,aAAa;MACb,gBAAgB;MAChB,SAAS;MACT,eAAe,EAAA;IAjErB;MAqEM,WAAW;MACX,YAAY;MACZ,yDAA2D;MAC3D,4BAA4B;MAC5B,2BAA2B,EAAA;MAzEjC;QA4EQ,yDAAiE;QACjE,4BAA4B;QAC5B,2BAA2B,EAAA;MA9EnC;QAmFQ,yBAAyB;QACzB,yBzBrC2B;QyBsC3B,yDAAoE;QACpE,4BAA4B;QAC5B,2BAA2B,EAAA;QAvFnC;UA2FU,yBAAyB;UACzB,yBAAyB,EAAA;MA5FnC;QAiGQ,oCAAoC;QACpC,yBAAyB;QACzB,yDAAkE;QAClE,4BAA4B;QAC5B,2BAA2B,EAAA;QArGnC;UAwGU,oCAAgD;UAChD,yBzBtEkB,EAAA;MyBnC5B;QAgHQ,yBAAyB;QACzB,yBAAyB;QACzB,yDAAiE;QACjE,4BAA4B;QAC5B,2BAA2B,EAAA;QApHnC;UAwHU,yBAAyB;UACzB,yBAAyB,EAAA;MAzHnC;QAgIQ,yBAAyB;QACzB,yBAAyB;QACzB,yDAAsE;QACtE,4BAA4B;QAC5B,2BAA2B,EAAA;QApInC;UAuIU,yBzBrEsB;UyBsEtB,yBzBtEsB,EAAA;MyBlEhC;QA8IU,yBzBnHiB,EAAA;EyB3B3B;IAqJI,czB5IgB;IyB6IhB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;IA1JvB;MA6JM,gBAAgB,EAAA;EA7JtB;IAkKI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;EA5KvB;IAgLI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;EA3LvB;IA+LI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBzBhJiB;IyBiJjB,czB7I2B;IyB8I3B,yBzB5I4B;IyB6I5B,eAAe,EAAA;EArMnB;IAyMI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBzBpKoB;IyBqKpB,czB/J8B;IyBgK9B,yBzBrK0B;IyBsK1B,eAAe,EAAA;EA/MnB;IAoNM,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBzBjLiC;IyBkLjC,czBrLsB;IyBsLtB,yBzBzLyB,EAAA;EyBhC/B;IA6NM,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,czBpLuB;IyBqLvB,yBzBxLwB,EAAA;EyBzC9B;IAsOI,2BAA2B,EAAA;IAtO/B;MAyOM,yBzBpM2B;MyBqM3B,czBxM0B,EAAA;IyBlChC;MA8OM,YAAY;MACZ,yBzBhM6B,EAAA;IyB/CnC;MAmPM,yBzB3L0B,EAAA;EyBgM5B;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB,EAAA;IAJnB;MAOG,aAAa;MACb,yBAAyB;MACzB,QAAQ;MACR,mBAAmB,EAAA;MAVtB;QAaK,0BAA0B,EAAA;MAb/B;QAiBK,WAAW;QACX,YAAY,EAAA;QAlBjB;UAqBO,yBzBlPe,EAAA;QyB6NtB;UAyBO,mBAAmB;UACnB,yBAAyB,EAAA;UA1BhC;YA6BS,mBAAmB,EAAA;QA7B5B;UAkCO,mBzB1NgC;UyB2NhC,yBzB1N4B,EAAA;UyBuLnC;YAsCS,mBzB5NkB;YyB6NlB,yBzB7NkB,EAAA;QyBsL3B;UA4CO,mBAAmB;UACnB,yBAAyB,EAAA;UA7ChC;YAgDS,mBAAmB,EAAA;QAhD5B;UAqDO,mBAAmB;UACnB,yBAAyB,EAAA;UAtDhC;YAyDS,mBAAmB,EAAA;MAzD5B;QA+DK,YAAY;QACZ,WAAW;QACX,UAAU,EAAA;MAjEf;QAsEO,eAAe,EAAA;QAtEtB;UAyES,aAAa,EAAA;MAzEtB;QAgFO,eAAe;QACf,aAAa,EAAA;IAjFpB;MAuFG,2BAA2B;MAC3B,qBAAqB;MACrB,yBzBtTmB,EAAA;MyB6NtB;QA4FK,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB,EAAA;MA9FrB;QAkGK,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,kBAAkB,EAAA;MArGvB;QAyGK,yBzBvT0B,EAAA;MyB8M/B;QA6GK,oCAAgD,EAAA;MA7GrD;QAiHK,yBzBtUkB,EAAA;MyBqNvB;QAqHK,yBzB3SsB,EAAA;EyBqL7B;IA4HG,kBAAkB;IAClB,0BAA0B,EAAA;EA7H7B;IAiIG,aAAa;IACb,2BAA2B;IAC3B,uBAAuB,EAAA;IAnI1B;MAsIK,0BAA0B,EAAA;EAtI/B;IA2IG,aAAa;IACb,gBAAgB;IAChB,kBAAkB,EAAA;EApYxB;IAyYI,gBAAgB,EAAA;EAGlB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;IAHT;MAMG,cAAc;MACd,kBAAkB,EAAA;IAPrB;MAYK,cAAc,EAAA;EAKpB;IACE,aAAa;IACb,8BAA8B,EAAA;IAF/B;MAKG,0BAA0B,EAAA;EAI9B;IACE,qBAAqB,EAAA;IADtB;MAIG,mBAAmB;MACnB,mBAAmB;MACnB,wBAAwB;MACxB,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;MATtB;QAYK,iBAAiB,EAAA;MAZtB;QAgBK,cAAc,EAAA;IAhBnB;MAqBG,yBAAyB;MACzB,cAAc,EAAA;IAtBjB;MA4BO,eAAe,EAAA;MA5BtB;QA+BS,aAAa,EAAA;IA/BtB;MAsCO,eAAe;MACf,aAAa,EAAA;IAvCpB;MA4CK,cAAc,EAAA;IA5CnB;MAiDG,yBAAyB;MACzB,mBAAmB;MACnB,cAAc;MACd,+CAA+C,EAAA;EAInD;IACE,qBAAqB;IACrB,mBzB1bmC,EAAA;IyBwbpC;MAKG,cAAc,EAAA;IALjB;MASG,cAAc;MACd,mBAAmB,EAAA;IAVtB;MAcG,yBAAyB,EAAA;IAd5B;MAkBG,cAAc,EAAA;IAlBjB;MAsBG,cAAc,EAAA;IAtBjB;MA0BG,eAAe;MACf,aAAa,EAAA;IA3BhB;MA+BG,mBAAmB;MACnB,mBAAmB;MACnB,wBAAwB;MACxB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,QAAQ,EAAA;MArCX;QAwCK,cAAc,EAAA;IAxCnB;MA6CG,YAAY,EAAA;IA7Cf;MAiDG,cAAc;MACd,kBAAkB;MAClB,yBAAyB;MACzB,mBAAmB;MACnB,gDAAgD,EAAA;IArDnD;MA2DO,cAAc,EAAA;IA3DrB;MAmEO,ezB9fkB,EAAA;MyB2bzB;QAsES,azBjgBgB,EAAA;IyB2bzB;MA6EO,ezBxgBkB;MyBygBlB,azBzgBkB,EAAA;IyB2bzB;MAmFK,czB9gBoB,EAAA;EyBmhB1B;IACE,qBAAqB;IACrB,mBzBlhBmC,EAAA;IyBghBpC;MAKG,cAAc;MACd,mBAAmB,EAAA;IANtB;MAUG,yBAAyB,EAAA;IAV5B;MAcG,cAAc,EAAA;IAdjB;MAkBG,cAAc,EAAA;IAlBjB;MAsBG,eAAe;MACf,aAAa,EAAA;IAvBhB;MA2BG,mBAAmB;MACnB,mBAAmB;MACnB,wBAAwB;MACxB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,QAAQ,EAAA;MAjCX;QAoCK,cAAc,EAAA;IApCnB;MAyCG,YAAY,EAAA;IAzCf;MA6CG,cAAc;MACd,kBAAkB;MAClB,yBAAyB;MACzB,mBAAmB;MACnB,gDAAgD,EAAA;IAjDnD;MAuDO,cAAc,EAAA;IAvDrB;MA+DO,ezBllBkB,EAAA;MyBmhBzB;QAkES,azBrlBgB,EAAA;IyBmhBzB;MAyEO,ezB5lBkB;MyB6lBlB,azB7lBkB,EAAA;IyBmhBzB;MA+EK,czBlmBoB,EAAA;EyBumB1B;IACE,qBAAqB;IACrB,yBzBzkB2B,EAAA;IyBukB5B;MAKG,oCAAgE;MAChE,gCAAgC,EAAA;MANnC;QASK,oCAAoD;QACpD,gCAAgC,EAAA;IAVrC;MAeG,oCAAoC,EAAA;IAfvC;MAmBG,mBAAmB;MACnB,mBzBlmBwB;MyBmmBxB,wBAAwB;MACxB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,QAAQ,EAAA;MAzBX;QA4BK,czBzmBuB,EAAA;IyB6kB5B;MAiCG,czB5mB2B,EAAA;IyB2kB9B;MAqCG,czBjnB2B,EAAA;IyB4kB9B;MA2CO,ezBvnBuB,EAAA;MyB4kB9B;QA8CS,azB1nBqB,EAAA;IyB4kB9B;MAqDO,ezBjoBuB;MyBkoBvB,azBloBuB,EAAA;IyB4kB9B;MA2DK,czBlqBoB,EAAA;EyBuqBzB;IAEG,yBzBlsBgB;IyBmsBhB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ,EAAA;EAIX;IAMG,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ,EAAA;IAbX;MAGK,cAAc,EAAA;EAcpB;IACE,qBAAqB,EAAA;IADtB;MAIG,cAAc,EAAA;IAJjB;MAQG,mBAAmB;MACnB,mBAAmB;MACnB,wBAAwB;MACxB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,QAAQ,EAAA;MAdX;QAiBK,cAAc,EAAA;IAjBnB;MAsBG,qBzB3sBsB,EAAA;IyBqrBzB;MA0BG,cAAc,EAAA;IA1BjB;MA8BG,YAAY,EAAA;MA9Bf;QAiCK,cAAc,EAAA;MAjCnB;QAqCK,cAAc,EAAA;IArCnB;MA0CG,qBAAqB,EAAA;IA1CxB;;MAiDK,cAAc,EAAA;IAjDnB;MAwDO,eAAe,EAAA;MAxDtB;QA2DS,aAAa,EAAA;IA3DtB;MAkEO,eAAe;MACf,aAAa,EAAA;IAnEpB;MAwEK,cAAc,EAAA;EAKnB;IAEG,sBAAsB,EAAA;;ACvzB5B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB,EAAA;EAJpB;IAMI,cAAc,EAAA;EANlB;IASI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,gBAAgB,EAAA;IAbpB;MAeM,cAAc,EAAA;MAfpB;QAiBQ,aAAa,EAAA;IAjBrB;MAsBQ,cAAc;MACd,aAAa,EAAA;MAvBrB;QAyBU,cAAc;QACd,cAAc,EAAA;EA1BxB;IAgCI,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA;IAlCb;MAoCM,cAAc,EAAA;IApCpB;MAuCM,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAA;IA5CzB;MA+CM,cAAc;MACd,gBAAgB;MAChB,kBAAkB,EAAA;IAjDxB;MAqDM,UAAU;MACV,cAAc;MACd,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,kCAAkC;MAClC,8BAA8B,EAAA;EA9DpC;IAkEI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB,EAAA;IAvErB;MA0EM,gBAAgB;MAChB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,kBAAkB,EAAA;;AC9ExB;EAEI,cAAc;EACd,gBAAgB,EAAA;;AAHpB;EAMI,WAAW,EAAA;;ACNf;EACE,kBAAkB;EAClB,YAAY,EAAA;EAFd;IAKI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB,EAAA;EARzB;IAYI,YAAY,EAAA;EAZhB;IAgBI,YAAY;IACZ,WAAW;IACX,0BAA0B,EAAA;IAlB9B;MAqBM,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAA;MA1BzB;QA6BQ,eAAe;QACf,cAAc,EAAA;EA9BtB;IAoCI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAA;IAvCb;MA0CM,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,yBAAyB,EAAA;MA7C/B;QAgDQ,mB5BrBmB,EAAA;M4B3B3B;QAoDQ,yB5BIwB;Q4BHxB,qB5BFoB,EAAA;Q4BnD5B;UAwDU,yB5BLkB,EAAA;M4BnD5B;QA6DQ,yB5B9BqB;Q4B+BrB,qB5BjCc,EAAA;Q4B7BtB;UAiEU,yB5B9BkB,EAAA;M4BnC5B;QAsEQ,yB5BvB2B;Q4BwB3B,qB5B9BsB,EAAA;Q4BzC9B;UA0EU,yB5BhC0B,EAAA;E4B1CpC;IAiFI,WAAW;IACX,mBAAmB,EAAA;EAlFvB;IAsFI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB,EAAA;IAlG1B;MAqGM,6BAA6B;MAC7B,uBAAuB;MACvB,2BAA2B,EAAA;IAvGjC;MA2GM,c5BnCgB,EAAA;E4BxEtB;IAgHI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB,EAAA;IArHpB;MAwHM,cAAc;MACd,0BAA0B,EAAA;EAzHhC;IA8HI,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAA;EAhItB;IAoII,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB,EAAA;IAvI3B;MA0IM,eAAe,EAAA;EAInB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB,EAAA;EApJ1B;IAwJI,WAAW,EAAA;EAxJf;IA4JI,YAAY,EAAA;EA5JhB;IAgKI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B,EAAA;IA1K9B;MA6KM,yBAAyB;MACzB,mBAAmB,EAAA;IA9KzB;MAkLM,aAAa;MACb,WAAW;MACX,mBAAmB;MACnB,oCAAoC;MACpC,uBAAuB;MACvB,kBAAkB;MAClB,UAAU;MACV,MAAM;MACN,eAAe,EAAA;MA1LrB;QA6LQ,wBAAwB,EAAA;IA7LhC;MAkMM,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,UAAU;MACV,WAAW;MACX,YAAY;MACZ,eAAe,EAAA;IAxMrB;MA4MM,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,UAAU;MACV,WAAW;MACX,YAAY;MACZ,eAAe,EAAA;IAlNrB;MAsNM,YAAY;MACZ,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,sBAAsB,EAAA;MA3N5B;QA8NQ,YAAY,EAAA;IA9NpB;MAmOM,+BAA+B;MAC/B,kDAAkD;MAClD,iBAAiB,EAAA;IArOvB;MAyOM,kBAAkB;MAClB,SAAS;MACT,YAAY;MACZ,WAAW;MACX,gBAAgB,EAAA;EA7OtB;IAkPI,uBAAuB;IACvB,SAAS,EAAA;IAnPb;;MAuPM,qBAAqB,EAAA;EAvP3B;IA4PI,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EA9P3B;IAkQI,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAA;EApQhB;IAwQI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC,EAAA;EAhRtC;IAoRI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,gBAAgB,EAAA;;AAGlB;EACE;IACE,uBAAuB,EAAA;EAGzB;IACE,yBAAyB,EAAA,EAAA;;AClS/B;EAEI,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB,EAAA;;AAPrB;EAUI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAfvB;IAiBM,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB,EAAA;;ACtBzB;EAEI,WAAW;EACX,YAAY,EAAA;EAHhB;IAMM,qB9BmCwB;I8BlCxB,yB9BwC6B,EAAA;I8B/CnC;MAUQ,yB9BgC4B,EAAA;E8B1CpC;IAeM,oCAAiD;IACjD,gCAAsC,EAAA;IAhB5C;MAmBQ,oCAAgD,EAAA;EAnBxD;IAwBM,yB9BgC0B;I8B/B1B,qB9B0BsB,EAAA;I8BnD5B;MA4BQ,yB9BuBoB,EAAA;;A+BnD5B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB,EAAA;EAJpB;IAMI,mBAAmB,EAAA;EANvB;IASI,cAAc;IACd,kBAAkB,EAAA;EAVtB;IAaI,cAAc;IACd,kBAAkB,EAAA;EAdtB;IAiBI,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IAnBvB;MAqBM,UAAU,EAAA;EArBhB;IAyBI,mBAAmB,EAAA;IAzBvB;MA2BM,gCAAgC;MAChC,oBAAoB,EAAA;;AC5B1B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB,EAAA;EALpB;IAOI,cAAc;IACd,kBAAkB,EAAA;EARtB;IAWI,cAAc;IACd,mBAAmB,EAAA;;ACZvB;EACE,gBAAgB;EAChB,WAAW,EAAA;EAFb;IAKI,oCAAoC;IACpC,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;IAdvB;MAgBM,cAAc;MACd,oCAAoC;MACpC,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAA;EAtBzB;IA0BI,WAAW;IACX,mBAAmB,EAAA;EA3BvB;IA8BI,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IAhCvB;MAkCM,WAAW,EAAA;;AClCjB;EACE,mBAAmB;EAQnB,eAAe;EACf,YAAY;EACZ,WAAW,EAAA;EAXb;IAGI,WAAW;IACX,YAAY,EAAA;EAJhB;IAOI,qCAAqC,EAAA;;AAMzC;EAEI,gDAAgD,EAAA;;AAGpD;;EAEE,mBAAmB,EAAA;;ACpBrB;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+CAA+C;EAC/C,UAAU;EACV,uBAAuB;EACvB,qBAAqB,EAAA;EARvB;IAWI,WAAW;IACX,YAAY,EAAA;EAZhB;IAgBI,6BAA6B;IAC7B,aAAa,EAAA;IAjBjB;MAoBM,gBAAgB;MAChB,kBAAkB,EAAA;IArBxB;MAyBM,gBAAgB,EAAA;IAzBtB;MA6BM,aAAa,EAAA;EA7BnB;IAkCI,cAAc,EAAA;EAlClB;IAuCI,gBAAgB,EAAA;IAvCpB;MA0CM,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,sBAAsB,EAAA;EAhD5B;IAsDM,cAAc,EAAA;EAtDpB;IA0DM,cAAc,EAAA;EA1DpB;IA+DQ,oCAAmD;IACnD,8BAAiD;IACjD,yBAAyB,EAAA;IAjEjC;MAoEU,oCAA6D;MAC7D,oCAAyD;MACzD,sCAAsC,EAAA;MAtEhD;QAyEY,yBAAyB,EAAA;MAzErC;QA6EY,oCAA0D;QAC1D,gBAAgB,EAAA;EA9E5B;IAoFQ,oCAAoC;IACpC,yBAAyB,EAAA;EArFjC;IA2FI,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;IAlGpB;MAqGM,yBAAyB;MACzB,4BAA4B;MAC5B,gCAAgC,EAAA;IAvGtC;MA2GM,uBAAuB;MACvB,8BAAkC;MAClC,gCAAoC,EAAA;;AAK1C;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC,EAAA;EALvC;IAQI,6BAA6B;IAC7B,aAAa,EAAA;IATjB;MAYM,aAAa,EAAA;IAZnB;MAeM,aAAa,EAAA;EAfnB;IAsBM,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc,EAAA;EAzBpB;IA6BM,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe,EAAA;EAhCrB;IAoCM,WAAW;IACX,gBAAgB,EAAA;IArCtB;MAwCQ,oCAAoC;MACpC,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS,EAAA;MAhDjB;QAmDU,WAAW;QACX,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,yDAA4D;QAC5D,wBAAwB;QACxB,4BAA4B,EAAA;;AC3KtC;EACE,WAAW,EAAA;;AAGb;EACE,eAAe;EACf,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EAXrB;IAcI,gBAAgB,EAAA;EAGlB;IACE,UAAU;IACV,sBAAsB;IACtB,YAAY,EAAA;EApBhB;IAwBI,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY,EAAA;IA5BhB;MAiCM,wCAAwC;MACxC,gBAAgB;MAChB,YAAY,EAAA;EAnClB;IAyCI,iBAAiB,EAAA;IAzCrB;MA4CM,WAAW;MACX,aAAa;MACb,iBAAiB,EAAA;MA9CvB;QAiDQ,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,WAAW;QACX,gCpC9CkB,EAAA;MoCP1B;;;;QA4DQ,6BAA6B;QAC7B,uBAAuB;QACvB,qBAAqB;QACrB,2BAA2B;QAC3B,yBAA6B,EAAA;MAhErC;QAoEQ,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAA;QACA,sBAAsB,EAAA;IA3E9B;MAgFM,UAAU;MACV,kBAAkB;MAClB,+BAA+B,EAAA;MAlFrC;QAqFQ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,cAAc,EAAA;MA1FtB;QA8FQ,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,cAAc,EAAA;MApGtB;QAwGQ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc,EAAA;MA5GtB;QAgHQ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,YAAY,EAAA;MAnHpB;QAuHQ,cpC1DgC;QoC2DhC,0BAA0B;QAC1B,eAAe;QACf,kBAAkB;QAClB,gBAAgB,EAAA;QA3HxB;UA8HU,eAAe;UACf,kBAAkB;UAClB,gBAAgB,EAAA;MAhI1B;QAqIQ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc,EAAA;MAzItB;QA6IQ,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,oBAAoB;QACpB,cAAc,EAAA;IAnJtB;MAwJM,kBAAkB;MAClB,UAAU;MACV,YAAY;MAEZ,aAAa;MACb,YAAY;MACZ,uBAAuB;MACvB,uBAAuB;MAEvB,gBAAgB;MAChB,qBAAqB;MACrB,YAAA;MACA,wBAAwB;MACxB,0BAAA,EAA2B;MArKjC;QAwKQ,aAAa;QACb,sBAAA,EAAuB;MAzK/B;QA6KQ,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,QAAQ,EAAA;QApLhB;UAuLU,UAAU;UACV,aAAa;UACb,YAAY;UACZ,uBAAuB;UACvB,kBAAkB;UAClB,gBAAgB;UAChB,cAAc;UACd,iBAAiB;UACjB,sBAAsB,EAAA;UA/LhC;YAkMY,cAAc,EAAA;UAlM1B;YAsMY,cAAc,EAAA;UAtM1B;YA0MY,cAAc,EAAA;UA1M1B;YA8MY,cAAc,EAAA;UA9M1B;YAkNY,cAAc,EAAA;UAlN1B;YAsNY,cAAc,EAAA;QAtN1B;UA2NU,UAAU;UACV,2BAA2B;UAC3B,gBAAgB;UAChB,WAAW;UACX,YAAY;UACZ,kBAAkB,EAAA;UAhO5B;YAmOY,qCAAqC,EAAA;UAnOjD;YAwOc,YAAY;YACZ,WAAW;YACX,gBAAgB;YAChB,0BAA0B,EAAA;UA3OxC;YAgPY,yBAAyB;YACzB,mBAAmB,EAAA;UAjP/B;YAqPY,yBAAyB;YACzB,mBAAmB,EAAA;UAtP/B;YA0PY,YAAY;YACZ,WAAW;YACX,qCAAqC,EAAA;UA5PjD;YAgQY,YAAY;YACZ,WAAW;YACX,qCAAqC,EAAA;UAlQjD;YAsQY,YAAY;YACZ,WAAW;YACX,qCAAiD;YACjD,cAAc,EAAA;UAzQ1B;YA6QY,YAAY;YACZ,WAAW;YACX,qCAAqC,EAAA;UA/QjD;YAmRY,YAAY;YACZ,WAAW;YACX,0BpC/OwB,EAAA;MoCtCpC;QA2RQ,gBAAgB;QAChB,qBAAqB,EAAA;QA5R7B;UA+RU,YAAY;UACZ,yBAAyB;UACzB,yBAAyB,EAAA;UAjSnC;YAoSY,kBAAkB;YAClB,iBAAiB,EAAA;MArS7B;QA2SQ,eAAe,EAAA;QA3SvB;UA8SU,gBAAgB,EAAA;UA9S1B;YAiTY,cpCvSQ,EAAA;MoCVpB;QAuTQ,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,cAAc;QACd,gBAAgB;QAyEhB,UAAA;QAKA,WAAA;QAMA,oBAAA,EAAqB;QA/Y7B;UA8TU,eAAe;UACf,aAAa;UACb,uBAAuB,EAAA;QAhUjC;UAoUU,gBAAgB;UAChB,WAAW;UACX,oBAAoB,EAAA;QAtU9B;UA0UU,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,WAAW;UACX,mBAAmB,EAAA;UA9U7B;YAiVY,yBAAyB;YACzB,cAAc;YACd,iBAAiB;YACjB,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,yBAAyB,EAAA;YAzVrC;cA4Vc,cAAc,EAAA;QA5V5B;UAkWU,mBAAmB;UACnB,oBAAoB;UACpB,aAAa;UACb,0BAA0B;UAC1B,uBAAuB;UACvB,mBAAmB;UACnB,QAAQ,EAAA;UAxWlB;YA2WY,cAAc,EAAA;QA3W1B;UAgXU,gBAAgB,EAAA;UAhX1B;YAmXY,gBAAgB,EAAA;UAnX5B;YAuXY,gBAAgB,EAAA;QAvX5B;UA4XU,cAAc,EAAA;QA5XxB;UAgYU,UAAU;UACV,kBAAkB,EAAA;QAjY5B;UAsYU,mBAAmB,EAAA;QAtY7B;UA2YU,gBAAgB;UAChB,kBAAkB,EAAA;QA5Y5B;UAiZU,gBAAgB,EAAA;EAjZ1B;IAwZI,6BAA6B;IAC7B,aAAa,EAAA;IAzZjB;MA6ZQ,cAAc,EAAA;MA7ZtB;QAgaU,cAAc;QACd,gBAAgB;QAChB,yBAAyB;QACzB,cAAc;QACd,kBAAkB,EAAA;IApa5B;MA2aQ,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;IAhbzB;MAqbM,cAAc,EAAA;IArbpB;MA6bM,mBAAmB,EAAA;MA7bzB;QA0bQ,cAAc,EAAA;MA1btB;QAgcQ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS,EAAA;IAncjB;MAwcM,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,uBAAuB;MACvB,YAAY;MACZ,0BAA0B,EAAA;MA7chC;QAgdQ,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,eAAe,EAAA;QAndvB;UAsdU,cAAc;UACd,mBAAmB,EAAA;UAvd7B;YA0dY,cAAc,EAAA;QA1d1B;UA+dU,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,WAAW,EAAA;UAlerB;YAqeY,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,SAAS,EAAA;YAxerB;cA2ec,mBAAmB;cACnB,yBAAyB;cACzB,mBAAmB;cACnB,WAAW;cACX,YAAY;cACZ,aAAa;cACb,uBAAuB;cACvB,mBAAmB,EAAA;cAlfjC;gBAqfgB,yBAAyB;gBACzB,mBAAmB,EAAA;gBAtfnC;kBAyfkB,aAAa,EAAA;;AC7f/B;EACE,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAE9B,4BAA4B,EAAA;EAN9B;IASI,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B,EAAA;EAXjC;IAeI,eAAe,EAAA;EAfnB;IAmBI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB,EAAA;IAtBvB;MAyBM,eAAe,EAAA;IAzBrB;MA6BM,eAAe,EAAA;IA7BrB;MAiCM,kBAAkB;MAClB,yBrCsB0B;MqCrB1B,yBrCoBoB;MqCnBpB,mBAAmB;MACnB,gBAAgB,EAAA;MArCtB;QAwCQ,sBAAsB;QACtB,cAAc,EAAA;QAzCtB;UA4CU,aAAa;UACb,8BAA8B;UAC9B,eAAe,EAAA;UA9CzB;YAiDY,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,mBAAmB;YACnB,crCAmB,EAAA;UqCtD/B;YA0DY,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;YACf,oBAAoB;YACpB,mBAAmB;YACnB,iBAAiB;YACjB,cAAc,EAAA;MAhE1B;QAsEQ,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,uBAAuB;QACvB,mBAAmB,EAAA;IA3E3B;MAgFM,gBAAgB;MAChB,eAAe;MACf,crC3BoB,EAAA;EqCvD1B;IAuFI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY,EAAA;IA1FhB;MA6FM,uBAAuB,EAAA;EA7F7B;IAkGI,aAAa,EAAA;IAlGjB;MAqGM,iBAAiB,EAAA;IArGvB;MAwGM,kBAAkB,EAAA;;ACxGxB;EAEI,cAAc,EAAA;;AAFlB;EAMI,mBAAmB,EAAA;;AANvB;EAUI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB,EAAA;EAfpB;IAkBM,aAAa;IACb,sBAAsB,EAAA;EAnB5B;IAuBM,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB,EAAA;IAxCxB;MA2CQ,yBAAyB;MACzB,aAAa,EAAA;IA5CrB;MAgDQ,2BAA2B,EAAA;MAhDnC;QAoDY,SAAO,EAAA;IApDnB;MA0DQ,aAAa,EAAA;IA1DrB;MA8DQ,gBAAgB,EAAA;IA9DxB;MAkEQ,aAAa,EAAA;EAlErB;IAsFU,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kDAAkD,EAAA;IAzF5D;MAyEY,aAAa;MACb,QAAQ;MACR,uBAAuB,EAAA;MA3EnC;QA8Ec,eAAe,EAAA;MA9E7B;QAkFc,gBAAgB,EAAA;IAlF9B;MA4FY,yBAAyB,EAAA;IA5FrC;MAgGY,cAAc,EAAA;IAhG1B;MAoGY,gBAAgB,EAAA;EApG5B;IAyHU,kBAAkB;IAClB,yBAAwB;IACxB,mBAAmB;IACnB,kDAAkD,EAAA;IA5H5D;MA4GY,aAAa;MACb,QAAQ;MACR,uBAAuB,EAAA;MA9GnC;QAiHc,eAAe,EAAA;MAjH7B;QAqHc,gBAAgB,EAAA;IArH9B;MAgIc,cAAc,EAAA;IAhI5B;MAoIc,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,kBAAkB,EAAA;IAvIhC;MA4IY,yBAAyB,EAAA;IA5IrC;MA+IY,yBAAyB,EAAA;EA/IrC;IAqJM,kBAAkB;IAClB,kDAAkD,EAAA;IAtJxD;MAyJQ,aAAa;MACb,QAAQ;MACR,uBAAuB,EAAA;MA3J/B;QA8JU,eAAe,EAAA;MA9JzB;QAkKU,gBAAgB,EAAA;IAlK1B;MAuKQ,gBAAgB,EAAA;IAvKxB;MA2KQ,yBAAyB;MACzB,mBAAmB,EAAA;MA5K3B;QA+KU,yBAAyB,EAAA;MA/KnC;QAmLU,cAAc,EAAA;MAnLxB;QAuLU,yBAAkC,EAAA;MAvL5C;QA2LU,yBAAyB;QACzB,eAAe,EAAA;IA5LzB;MAkMQ,yBAAyB;MACzB,mBAAmB,EAAA;MAnM3B;QAsMU,cAAc,EAAA;MAtMxB;QA0MU,yBAAyB,EAAA;;AA1MnC;EAkNI,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAA;EArNpB;IAwNM,cAAc;IACd,iBAAiB,EAAA;;ACzNvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB,EAAA;EAEhB;IACE,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO,EAAA;IATR;MAYG,sCAAsC,EAAA;EAzB5C;IA8BI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,4BAA4B;IAC5B,SAAS;IACT,mBAAmB;IACnB,oHAGoC;IACpC,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY,EAAA;IA3ChB;MA8CM,UAAU;MACV,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,SAAS,EAAA;IAlDf;MAsDM,YAAY;MACZ,WAAW;MACX,mBAAmB,EAAA;IAxDzB;MA4DM,yBAAyB,EAAA;IA5D/B;MAgEM,cAAc;MACd,eAAe,EAAA;IAjErB;MAqEM,gBAAgB;MAChB,SAAS;MACT,aAAa,EAAA;MAvEnB;QA0EQ,oCAAoC;QACpC,gCAAgC;QAChC,sBAAsB,EAAA;MA5E9B;QAgFQ,iCAAiC;QACjC,oCAAoC,EAAA;IAjF5C;MAuFM,cAAc,EAAA;MAvFpB;QA2FU,oCAAoC,EAAA;MA3F9C;QAgGY,oCAAoC,EAAA;IAhGhD;;MAwGM,YAAY,EAAA;MAxGlB;;QA4GU,oCAAoC,EAAA;MA5G9C;;QAiHY,oCAAoC,EAAA;IAjHhD;MAwHM,WAAW;MACX,YAAY;MACZ,yBAAyB,EAAA;IA1H/B;MA+HQ,kBAAkB;MAClB,8BAA8B;MAC9B,yBAAyB,EAAA;IAjIjC;MAwIU,oCAAoC,EAAA;IAxI9C;MA6IQ,kBAAkB;MAClB,mBAAmB,EAAA;;AC9I3B;EAEI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAPvB;EAUI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAfvB;EAkBI,gBAAgB;EAChB,cxCoCsB,EAAA;EwCvD1B;IAqBM,cAAc;IACd,eAAe;IACf,gBAAgB,EAAA;;AAvBtB;EA4BI,gCxC2BsB,EAAA;;AwCvD1B;EAgCI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;EAnCpB;IAqCM,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAA;;AA1CvB;EA8CI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;;AAjDpB;EAoDI,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB,EAAA;EA1DzB;IA6DQ,eAAe,EAAA;;AA7DvB;EAmEI,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B,EAAA;EAvE/B;IA0EM,gBAAgB;IAChB,cxClEc,EAAA;EwCTpB;IA+EM,gBAAgB;IAChB,cxCvDiB,EAAA;EwCzBvB;IAoFM,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB,EAAA;;ACvFtB;EACE,kBAAkB,EAAA;EADpB;IAII,6BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;IATvB;MAYM,eAAe;MAEf,6BAA6B;MAC7B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B,EAAA;EAInC;IACE,aAAa;IACb,8BAA8B,EAAA;IAF/B;MAKG,eAAe;MAEf,sBAAsB;MACtB,YAAY;MACZ,yBAAyB;MAEzB,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAE3B,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MAEnB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;MAxBpB;QA2BK,UAAU;QACV,WAAW;QACX,gBAAgB,EAAA;EAKtB;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;IAJV;MAOG,YAAY;MACZ,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MACnB,qCAAqC;MACrC,kBAAkB,EAAA;MAZrB;QAeK,kBAAkB;QAClB,gBAAgB,EAAA;MAhBrB;QAqBK,gCAAgC,EAAA;QArBrC;UAwBO,kBAAkB;UAClB,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,gBAAgB;UAChB,kBAAkB,EAAA;QA7BzB;UAiCO,kBAAkB;UAClB,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,gBAAgB;UAChB,kBAAkB,EAAA;QAtCzB;UA0CO,aAAa,EAAA;QA1CpB;UA8CO,YAAY;UACZ,gBAAgB,EAAA;UA/CvB;YAkDS,eAAe,EAAA;MAlDxB;QAwDK,gBAAgB,EAAA;QAxDrB;UA2DO,aAAa;UACb,sBAAsB,EAAA;UA5D7B;YA+DS,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,oBAAoB;YACpB,gBAAgB,EAAA;UAnEzB;YAuES,eAAe;YACf,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,mBAAmB;YACnB,gBAAgB;YAChB,cAAc,EAAA;QA7EvB;UAkFO,aAAa;UACb,8BAA8B,EAAA;UAnFrC;YAsFS,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,kBAAkB;YAClB,YAAY;YACZ,YAAY;YACZ,eAAe,EAAA;YA5FxB;cA+FW,0CAA0C;cAC1C,kCAA0B;sBAA1B,0BAA0B;cAC1B,qCAAqC,EAAA;cAjGhD;gBAoGa,cAAc,EAAA;YApG3B;cAyGW,aAAa;cACb,cAAc;cACd,gBAAgB;cAChB,oBAAoB,EAAA;UA5G/B;YAiHS,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,YAAY,EAAA;QAtHrB;UA2HO,aAAa;UACb,8BAA8B;UAC9B,gBAAgB,EAAA;UA7HvB;YAgIS,YAAY,EAAA;;AAQxB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;EAEZ;IACE,YAAY,EAAA;EAGd;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB,EAAA;IAJpB;MAOG,cAAc;MACd,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY,EAAA;MAZf;QAeK,yBAAyB,EAAA;;AAMjC;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;EAEZ;IACE,YAAY,EAAA;EAGd;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB,EAAA;IAJpB;MAOG,cAAc;MACd,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY,EAAA;MAZf;QAeK,yBAAyB,EAAA;;ACxPjC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY,EAAA;EAHd;IAMI,6BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAA;IAXZ;MAcM,YAAY,EAAA;MAdlB;QAiBQ,eAAe,EAAA;EAKrB;IACE,gBAAgB;IAChB,aAAa;IACb,2BAA2B,EAAA;EAG7B;IACE,aAAa;IACb,8BAA8B,EAAA;IAF/B;MAKG,eAAe;MAEf,sBAAsB;MACtB,YAAY;MACZ,yBAAyB;MAEzB,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAE3B,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MAEnB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;MAxBpB;QA2BK,UAAU;QACV,WAAW;QACX,gBAAgB,EAAA;EAKtB;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAA;IAJV;MAOG,YAAY;MACZ,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MACnB,qCAAqC;MACrC,kBAAkB,EAAA;MAZrB;QAeK,yBAAyB,EAAA;QAf9B;UAkBO,oCAAoC;UACpC,yBAAyB,EAAA;MAnBhC;QAwBK,kBAAkB;QAClB,gBAAgB,EAAA;MAzBrB;QA6BK,aAAa;QACb,8BAA8B;QAC9B,mBAAmB,EAAA;QA/BxB;UAmCS,eAAe,EAAA;UAnCxB;YAsCW,gBAAgB;YAChB,sBAAsB,EAAA;QAvCjC;UA8CO,mBAAmB;UACnB,wBAAwB;UACxB,aAAa;UACb,uBAAuB;UACvB,mBAAmB;UACnB,QAAQ,EAAA;UAnDf;YAsDS,mBAAmB,EAAA;YAtD5B;cAyDW,cAAc,EAAA;MAzDzB;QAkEK,gCAAgC,EAAA;QAlErC;UAqEO,kBAAkB;UAClB,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,gBAAgB;UAChB,kBAAkB,EAAA;QA1EzB;UA8EO,kBAAkB;UAClB,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,gBAAgB;UAChB,kBAAkB,EAAA;QAnFzB;UAuFO,aAAa,EAAA;QAvFpB;UA2FO,YAAY;UACZ,gBAAgB,EAAA;UA5FvB;YA+FS,eAAe,EAAA;MA/FxB;QAqGK,gBAAgB,EAAA;QArGrB;UAwGO,aAAa;UACb,sBAAsB;UACtB,WAAW,EAAA;UA1GlB;YA6GS,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,oBAAoB;YACpB,gBAAgB,EAAA;UAjHzB;YAqHS,eAAe;YACf,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,mBAAmB;YACnB,gBAAgB;YAChB,cAAc,EAAA;QA3HvB;UAgIO,aAAa;UACb,8BAA8B,EAAA;UAjIrC;YAoIS,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,kBAAkB;YAClB,YAAY;YACZ,YAAY;YACZ,eAAe,EAAA;YA1IxB;cA6IW,0CAA0C;cAC1C,kCAA0B;sBAA1B,0BAA0B;cAC1B,qCAAqC,EAAA;cA/IhD;gBAkJa,cAAc,EAAA;YAlJ3B;cAuJW,aAAa;cACb,cAAc;cACd,gBAAgB;cAChB,oBAAoB,EAAA;UA1J/B;YA+JS,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,gBAAgB;YAChB,YAAY,EAAA;QApKrB;UAyKO,aAAa;UACb,8BAA8B;UAC9B,gBAAgB,EAAA;UA3KvB;YA8KS,YAAY;YACZ,aAAa;YACb,eAAe;YAAE,qDAAA;YACjB,eAAe;YAAE,2CAAA;YACjB,SAAS;YAAE,+BAAA;YACX,2BAA2B,EAAA;UAnLpC;YAuLS,aAAa;YACb,eAAe;YAAE,qDAAA;YACjB,eAAe;YAAE,2CAAA;YACjB,SAAS;YAAE,+BAAA;YACX,2BAA2B,EAAA;;AAQvC;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;EANb;IASI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB,EAAA;IAZtB;MAcM,8BAA8B;MAC9B,+BAA+B,EAAA;IAfrC;MAkBM,2BAA2B;MAC3B,4BAA4B,EAAA;IAnBlC;MAsBM,cAAc,EAAA;IAtBpB;MA0BM,oCAAoC,EAAA;IA1B1C;MA8BM,iBAAiB,EAAA;MA9BvB;QAgCQ,YAAY,EAAA;;AAMpB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY,EAAA;EAEZ;IACE,YAAY,EAAA;EAGd;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB,EAAA;IAJpB;MAOG,cAAc;MACd,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY,EAAA;;AC5TlB;EACE,kBAAkB,EAAA;EACjB;IAEG,c3CuBqB;I2CtBrB,eAAe;IACf,gBAAgB;IAChB,QAAQ,EAAA;IALX;MAQK,YAAY,EAAA;MARjB;QAUO,eAAe,EAAA;EAZzB;;IAoBI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc,EAAA;EA9BlB;;IAkCI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc,EAAA;EA1ClB;IA6CI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,SAAS,EAAA;IAjDb;MAmDM,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,UAAU,EAAA;EAtDhB;IA0DI,QAAQ,EAAA;EA1DZ;IA6DI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,WAAW,EAAA;IAhEf;MAkEM,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB,EAAA;IAtEtB;MAyEM,WAAW;MACX,gBAAgB,EAAA;MA1EtB;QA4EQ,aAAa;QACb,qCAAqC;QACrC,kBAAkB,EAAA;QA9E1B;UAgFU,kBAAkB;UAClB,eAAe;UACf,gBAAgB;UAChB,oBAAoB;UACpB,gBAAgB;UAChB,cAAc,EAAA;QArFxB;UAyFU,aAAa;UACb,8BAA8B,EAAA;UA1FxC;YA4FY,UAAU,EAAA;YA5FtB;cA8Fc,kBAAkB;cAClB,eAAe;cACf,kBAAkB;cAClB,gBAAgB;cAChB,oBAAoB;cACpB,gBAAgB;cAChB,cAAc,EAAA;IApG5B;MA4GQ,eAAe,EAAA;IA5GvB;MAgHQ,sBAAsB;MACtB,uBAAuB,EAAA;IAjH/B;MAsHM,WAAW,EAAA;IAtHjB;MA0HM,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;MAChB,cAAc,EAAA;MA/HpB;QAiIQ,gBAAgB,EAAA;IAjIxB;MAqIM,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB,EAAA;IAzIvB;MA4IM,UAAU;MACV,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,c3C3FyB,EAAA;M2CtD/B;QAmJQ,yBAAwC,EAAA;IAnJhD;MAuJM,WAAW;MACX,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,gBAAgB,EAAA;IA9JtB;;MAkKM,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,cAAc,EAAA;MAvKpB;;QAyKQ,WAAW;QACX,YAAY;QACZ,iBAAiB,EAAA;IA3KzB;MA+KM,UAAU;MACV,YAAY,EAAA;MAhLlB;QAkLQ,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;QAChB,cAAc;QACd,qBAAqB,EAAA;MAxL7B;QA2LQ,WAAW;QACX,gBAAgB,EAAA;IA5LxB;MAgMM,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,gBAAgB,EAAA;MAtMtB;QAwMQ,cAAc,EAAA;;ACxMtB;EAEI,aAAa;EACb,8BAA8B;EAC9B,kBAAkB,EAAA;EAJtB;IAOM,UAAU,EAAA;IAPhB;MAUQ,kBAAkB,EAAA;EAV1B;IAeM,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAA;IAlBtB;MAqBQ,mBAAmB,EAAA;IArB3B;MAyBQ,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB,EAAA;EA7B/B;IAkCM,sBAAsB;IACtB,cAAc,EAAA;EAnCpB;IAuCM,yBAAwC;IACxC,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B,EAAA;IA1CjC;MA6CQ,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B,EAAA;IAlDvC;MAsDQ,yBAAwC,EAAA;;AAtDhD;EA4DI,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB,EAAA;EA9DpB;IAiEM,6BAA6B,EAAA;;ACjEnC;;EAGI,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAA;;AALrB;EAQI,sBAAsB;EACtB,eAAe;EACf,gBAAgB,EAAA;;AAVpB;EAcI,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAIvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB,EAAA;EAJlB;IAOM,kBAAkB,EAAA;EAPxB;IAWI,2BAA2B,EAAA;IAX/B;MAaM,YAAY,EAAA;EAblB;IAmBM,YAAY,EAAA;EAnBlB;IAuBI,yBAAyB,EAAA;EAvB7B;IA0BI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B,EAAA;IA9BlC;MAgCM,cAAc;MACd,kBAAkB;MAClB,mBAAmB,EAAA;IAlCzB;MAsCQ,aAAa,EAAA;EAtCrB;IA2CI,mBAAmB;IACnB,kBAAkB,EAAA;IA5CtB;MA+CM,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,sBAAsB,EAAA;EAtD5B;IA0DI,6BAA6B,EAAA;IA1DjC;MA4DM,gBAAgB,EAAA;EA5DtB;IAkFI,wBAAwB;IACxB,WAAW;IACX,kCAAkC;IAClC,qCAAqC;IACrC,oBAAoB,EAAA;IAtFxB;MAwFM,YAAY;MACZ,gBAAgB;MAChB,sBAAsB;MACtB,eAAe,EAAA;IA3FrB;MA8FM,aAAa;MACb,2BAA2B,EAAA;;ACpHjC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB,EAAA;EAHpB;IAKI,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB,EAAA;IAfvB;MAiBM,gBAAgB,EAAA;EAGpB;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW,EAAA;EAxBf;IAmCI,uBAAuB,EAAA;IAnC3B;MA6BM,kBAAkB,EAAA;IA7BxB;MAiCM,wBAAwB,EAAA;IAjC9B;MAwCY,wBAAwB,EAAA;IAxCpC;MAiDY,wBAAwB,EAAA;EAjDpC;IAwDI,6BAA6B;IAC7B,gBAAgB,EAAA;EAElB;IACE,mBAAmB;IACnB,yBAAyB,EAAA;IAF1B;MAIG,mBAAmB,EAAA;MAJtB;QAMK,cAAc,EAAA;IANnB;MAWK,cAAc,EAAA;MAXnB;QAaO,cAAc,EAAA;IAbrB;MAiBK,cAAc,EAAA;IAjBnB;MAwBS,yBAAyB,EAAA;IAxBlC;MA2BS,yBAAyB,EAAA;EAMnC;IACE,yBAAyB,EAAA;IAD1B;MAIG,mBAAmB,EAAA;MAJtB;QAMK,eAAe,EAAA;MANpB;QASK,cAAc,EAAA;IATnB;MAcK,0BAA0B,EAAA;IAd/B;MAkBG,aAAa;MACb,8BAA8B;MAC9B,kBAAkB,EAAA;MApBrB;QAuBK,UAAU,EAAA;QAvBf;UAyBO,kBAAkB,EAAA;MAzBzB;QA8BK,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,gBAAgB,EAAA;QAjCrB;UAoCO,mBAAmB,EAAA;QApC1B;UAwCO,iBAAiB;UACjB,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,uBAAuB,EAAA;MA5C9B;QAiDK,sBAAsB;QACtB,cAAc,EAAA;IAlDnB;MAsDG,gBAAgB;MAChB,6BAA6B;MAC7B,gBAAgB,EAAA;MAxDnB;QA2DK,6BAA6B,EAAA;EAInC;IACE,yBAAyB,EAAA;IAD1B;MAIG,mBAAmB,EAAA;MAJtB;QAMK,eAAe,EAAA;MANpB;QASK,cAAc,EAAA;IATnB;MAcK,0BAA0B,EAAA;IAd/B;MAkBG,aAAa;MACb,8BAA8B;MAC9B,mBAAmB,EAAA;MApBtB;QAsBK,UAAU,EAAA;QAtBf;UAwBO,kBAAkB,EAAA;IAxBzB;MA6BG,gBAAgB;MAChB,6BAA6B;MAC7B,gBAAgB,EAAA;IA/BnB;MAoCO,oCAAoC;MACpC,oCAAoC,EAAA;MArC3C;QAuCS,yBAAyB,EAAA;MAvClC;QA0CS,yBAAyB,EAAA;EArMrC;IA8MM,WAAW,EAAA;EA9MjB;IAoNQ,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;IAC9B,6BAA6B,EAAA;EAxNrC;IA2NQ,aAAa,EAAA;;AC3NrB;EAGM,eAAe;EACf,mBAAmB,EAAA;EAJzB;IAMQ,cAAc;IACd,gBAAgB;IAChB,+BAA+B;IAE/B,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B,EAAA;;AAhBnC;EAoBM,YAAY;EACZ,WAAW;EACX,eAAe,EAAA;EAtBrB;IAwBQ,cAAc,EAAA;;AAxBtB;EA4BM,6BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAjCzB;EAoCM,gBAAgB,EAAA;;AApCtB;EAwCQ,aAAa;EACb,WAAW,EAAA;EAzCnB;IA2CU,WAAW,EAAA;EA3CrB;IA8CU,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW,EAAA;;AAlDrB;EAwDI,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;EA5Db;IA+DM,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA;IAjEf;MAoEQ,cAAc;MACd,gBAAgB;MAChB,kBAAkB,EAAA;IAtE1B;MA0EQ,UAAU;MACV,cAAc;MACd,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,kCAAkC;MAClC,8BAA8B,EAAA;EAnFtC;IAwFM,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB,EAAA;IA7FvB;MAgGQ,gBAAgB;MAChB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,kBAAkB,EAAA;IApG1B;MAyGU,yBAAyB,EAAA;;ACzGnC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB,EAAA;EAHpB;IAKI,cAAc,EAAA;EALlB;IAQI,6BAA6B,EAAA;EAE/B;IACE,yBhDoByB;IgDnB3B,yBhD0BqC,EAAA;EgDvBrC;IACE,yBhDyB0B;IgDxB1B,uBhD+BmC,EAAA;IgDjCpC;MAKG,yBAAsC,EAAA;IALzC;MASG,yBAAsC,EAAA;IATzC;MAaG,yBAAsC,EAAA;EAI1C;IACE,yBhDkBwB;IgDjBxB,yBhDuBkC,EAAA;IgDzBnC;MAKG,yBAAmC,EAAA;IALtC;MASG,yBAAmC,EAAA;IATtC;MAaG,yBAAmC,EAAA;EA7CzC;IAkDI,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB,EAAA;IAtD1B;MAyDM,UAAU;MACV,aAAa;MACb,qBAAqB;MACrB,QAAQ;MACR,gBAAgB,EAAA;MA7DtB;QAgEQ,2BAA2B;QAC3B,yBAAyB,EAAA;IAjEjC;MAsEM,aAAa;MACb,qBAAqB;MACrB,kBAAkB,EAAA;IAxExB;MA4EM,WAAW;MACX,eAAe;MACf,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,aAAa;MACb,uBAAuB,EAAA;IApF7B;MAwFM,sBAAsB,EAAA;IAxF5B;MA4FM,kBAAkB,EAAA;;AC5FxB;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB,EAAA;EAH3B;IAMM,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAA;IATf;MAWQ,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,yBAAyB,EAAA;MAdjC;QAgBU,yBAAyB,EAAA;EAKjC;IACE,yBjDSyB;IiDR3B,yBjDeqC,EAAA;EiDZrC;IACE,yBjDc0B;IiDb1B,uBjDoBmC,EAAA;IiDtBpC;MAKG,yBAAsC,EAAA;IALzC;MASG,yBAAsC,EAAA;IATzC;MAaG,yBAAsC,EAAA;EAI1C;IACE,yBjDOwB;IiDNxB,yBjDYkC,EAAA;IiDdnC;MAKG,yBAAmC,EAAA;IALtC;MASG,yBAAmC,EAAA;IATtC;MAaG,yBAAmC,EAAA;;ACxDzC;EAGM,cAAc;EACd,mBAAmB,EAAA;;AAJzB;EAQQ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc,EAAA;;AAjBtB;;EAwBM,YAAY,EAAA;;ACxBlB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,aAAa,EAAA;EALf;IAOI,cAAc;IACd,kBAAkB;IAClB,mBAAmB,EAAA;EATvB;IAYI,cAAc,EAAA;EAZlB;IAeI,cAAc;IACd,mBAAmB,EAAA;EAhBvB;IAmBI,2BAA2B,EAAA;IAnB/B;MAqBM,UAAU,EAAA;MArBhB;QAuBQ,cAAc,EAAA;EAvBtB;IA4BI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB,EAAA;IAlCvB;MAoCM,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAA;EAzCzB;IAkDI,mBAAmB,EAAA;IAlDvB;MA8CM,eAAe;MACf,kBAAkB;MAClB,gBAAgB,EAAA;;AChDtB;EACE,iBAAiB,EAAA;EADnB;IAKM,yBpD0BuB;IoDzBvB,yBpDgCiC,EAAA;EoDtCvC;IAUM,yBpDyCsB;IoDxCtB,yBpD8CgC,EAAA;EoDzDtC;IAeM,yBpD0BwB;IoDzBxB,uBpDgCiC,EAAA;EoDhDvC;;IAsBQ,YAAY,EAAA;;ACtBpB;EAIM,qBAAqB,EAAA;;AAJ3B;EAQM,qBAAqB,EAAA;EAR3B;IAWQ,qBAAqB,EAAA;;AAX7B;;EAkBI,wBAAwB;EACxB,SAAS,EAAA;;AAnBb;EAuBI,2BAA2B,EAAA;;AAvB/B;;EA8BM,YAAY,EAAA;EA9BlB;;IAkCU,cAAc,EAAA;;AAlCxB;EA2CQ,cAAc,EAAA;;AA3CtB;EAgDM,mBAAmB,EAAA;;AAhDzB;EAqDI,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB,EAAA;EA3DrB;IA8DM,YAAY;IACZ,gBAAgB,EAAA;;AC/DtB;EACE,iBAAiB,EAAA;EADnB;IAII,cAAc;IACd,0BAA0B;IAC1B,gBAAgB,EAAA;EANpB;IAgBM,YAAY;IACZ,cAAc;IACd,qBAAqB,EAAA;IAlB3B;MAYQ,gBAAgB;MAChB,+BAA+B,EAAA;EAbvC;IA2BM,yBAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,qBAAqB,EAAA;IA9B3B;MAuBQ,gBAAgB;MAChB,+BAA+B,EAAA;EAxBvC;IAkCM,aAAa;IACb,8BAA8B;IAC9B,gBAAgB,EAAA;IApCtB;MAuCQ,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,gBAAgB,EAAA;IA3CxB;MA+CQ,aAAa;MACb,gBAAgB;MAChB,SAAS,EAAA;IAjDjB;MAqDQ,WAAW;MACX,YAAY,EAAA;IAtDpB;MA0DQ,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,QAAQ,EAAA;IA7DhB;MAiEQ,yBAAyB;MACzB,sBAAsB,EAAA;EAlE9B;IAwEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB,EAAA;IA/EvB;MAkFM,eAAe,EAAA;IAlFrB;MAsFM,gBAAgB,EAAA;IAtFtB;MA0FM,gBAAgB,EAAA;IA1FtB;MA8FM,mBAAmB;MACnB,YAAY;MACZ,QAAQ,EAAA;MAhGd;QAmGQ,cAAc,EAAA;MAnGtB;QAuGQ,cAAc,EAAA;QAvGtB;UA0GU,yBAAyB,EAAA;MA1GnC;QA+GQ,YAAY,EAAA;IA/GpB;MAoHM,mBAAmB;MACnB,YAAY,EAAA;IArHlB;MAyHM,mBAAmB;MACnB,YAAY,EAAA;IA1HlB;MA8HM,yBAAyB;MACzB,mBAAmB;MACnB,YAAY,EAAA;MAhIlB;QAmIQ,cAAc,EAAA;MAnItB;QAuIQ,cAAc,EAAA;MAvItB;QA2IQ,sBAAsB,EAAA;MA3I9B;QA+IQ,cAAc,EAAA;QA/ItB;UAkJU,yBAAyB,EAAA;IAlJnC;MAwJM,yBAAyB;MACzB,mBAAmB;MACnB,YAAY,EAAA;MA1JlB;QA6JQ,cAAc,EAAA;MA7JtB;QAiKQ,sBAAsB,EAAA;MAjK9B;QAqKQ,cAAc,EAAA;QArKtB;UAwKU,yBAAyB,EAAA;IAxKnC;MA8KM,yBAAyB;MACzB,mBAAmB;MACnB,YAAY,EAAA;MAhLlB;QAmLQ,cAAc,EAAA;MAnLtB;QAuLQ,cAAc,EAAA;MAvLtB;QA2LQ,sBAAsB,EAAA;MA3L9B;QA+LQ,cAAc,EAAA;QA/LtB;UAkMU,yBAAyB,EAAA;;AClMnC;EACE,kBAAkB;EAClB,kBAAkB,EAAA;EAElB;IACE,WAAW;IACX,WAAW;IACX,WAAW,EAAA;EAPf;IAWI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,kBAAkB,EAAA;IAlBtB;MAqBM,YAAY;MACZ,aAAa,EAAA;EAtBnB;IA4BM,mBAAmB,EAAA;EA5BzB;IAiCI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B,EAAA;IA7C/B;MAiDQ,oCAAoC,EAAA;IAjD5C;MAsDM,0BvD3CoB,EAAA;IuDX1B;MA4DU,YAAY,EAAA;IA5DtB;MAgEU,kBAAkB,EAAA;IAhE5B;MAsEM,yBvDvCuB;MuDwCvB,yBvDjCiC,EAAA;MuDtCvC;QA0EQ,oCAAiD;QACjD,oCAA2D,EAAA;MA3EnE;QA+EQ,yBAAqC,EAAA;MA/E7C;QAmFQ,yBAAmC,EAAA;MAnF3C;QAuFQ,yBAAmC,EAAA;MAvF3C;QA4FU,yBAAmC,EAAA;MA5F7C;QAiGQ,yBAAmC,EAAA;MAjG3C;QAqGQ,yBAAoC,EAAA;MArG5C;QA0GU,yBAAoC,EAAA;MA1G9C;QA+GQ,yBAAqC,EAAA;MA/G7C;QAmHQ,yBAAoC,EAAA;QAnH5C;UAsHU,gBAAgB,EAAA;MAtH1B;QA4HU,yBAAmC,EAAA;MA5H7C;QAkIU,yBAAqC,EAAA;MAlI/C;QAwIU,yBAAmC,EAAA;IAxI7C;MA8IM,yBvDrGwB;MuDsGxB,uBvD/FiC,EAAA;MuDhDvC;QAkJQ,oCAAmD;QACnD,kCAA6D,EAAA;MAnJrE;QAuJQ,yBAAsC,EAAA;MAvJ9C;QA2JQ,yBAAsC,EAAA;MA3J9C;QA+JQ,yBAAsC,EAAA;MA/J9C;QAoKU,yBAAsC,EAAA;MApKhD;QAyKQ,yBAAsC,EAAA;MAzK9C;QA6KQ,yBAAsC,EAAA;QA7K9C;UAgLU,gBAAgB,EAAA;MAhL1B;QAqLQ,yBAAsC,EAAA;IArL9C;MA0LM,yBvDvIsB;MuDwItB,uBAAuB,EAAA;MA3L7B;QA8LQ,oCAAgD;QAChD,kCAAkC,EAAA;MA/L1C;QAmMQ,yBvD3IwB,EAAA;MuDxDhC;QA0MQ,yBAAyB,EAAA;MA1MjC;QAiNQ,yBAAyB,EAAA;MAjNjC;QAsNU,yBAAoC,EAAA;MAtN9C;QA2NQ,yBAAmC,EAAA;MA3N3C;QA+NQ,yBAAmC,EAAA;QA/N3C;UAkOU,gBAAgB,EAAA;MAlO1B;QAuOQ,yBAAmC,EAAA;MAvO3C;QA2OQ,qBvDjLmB,EAAA;MuD1D3B;QA+OQ,gCAA2C,EAAA;IA/OnD;MAoPM,aAAa;MACb,8BAA8B;MAC9B,uBAAuB,EAAA;MAtP7B;QAyPQ,aAAa;QACb,UAAU;QACV,sBAAsB,EAAA;QA3P9B;UA8PU,aAAa;UACb,SAAS;UACT,mBAAmB;UACnB,mBAAmB,EAAA;QAjQ7B;UAqQU,aAAa;UACb,SAAS;UACT,kBAAkB,EAAA;UAvQ5B;YA0QY,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,uBAAuB;YACvB,gBAAgB;YAChB,WAAW;YACX,QAAQ,EAAA;YAhRpB;cAmRc,mBAAmB;cACnB,uBAAuB;cACvB,gBAAgB;cAChB,gBAAgB;cAChB,eAAe;cACf,gBAAgB,EAAA;YAxR9B;cA4Rc,eAAe,EAAA;QA5R7B;UAmSY,cvD7QmB,EAAA;QuDtB/B;UAuSY,cvDlPc,EAAA;QuDrD1B;UA2SY,cvDjSU,EAAA;UuDVtB;YA8Sc,wBAAwB,EAAA;UA9StC;YAkTc,cvDxSQ,EAAA;QuDVtB;UAuTY,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,iBAAiB,EAAA;MA3T7B;QAiUQ,aAAa;QACb,sBAAsB;QACtB,gBAAgB,EAAA;QAnUxB;UAsUU,aAAa;UACb,mBAAmB;UACnB,mBAAmB,EAAA;QAxU7B;UA6UY,2BAA2B,EAAA;QA7UvC;UAkVU,eAAe;UACf,6BAA6B,EAAA;QAnVvC;UAuVU,oBAAoB;UACpB,aAAa;UACb,mBAAmB;UACnB,sBAAsB;UACtB,QAAQ;UACR,eAAe;UACf,kBAAkB;UAClB,yBAA8B;UAC9B,gBAAgB;UAChB,gBAAgB,EAAA;QAhW1B;UAoWU,sBAAsB;UACtB,YAAY;UACZ,2BAA2B;UAC3B,eAAe;UACf,oBAAoB;UACpB,mBAAmB;UACnB,YAAY;UACZ,sBAAsB;UACtB,wBAAwB,EAAA;IA5WlC;MAkXM,WAAW;MACX,YAAY;MAEZ,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAElB,aAAa;MACb,kCAAkC;MAClC,iIAIwB,EAAA;MAlY9B;QAqYQ,cAAc,EAAA;MArYtB;QAyYQ,iBAAiB;QACjB,YAAY,EAAA;QA1YpB;UA6YU,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,oBAAoB;UACpB,cvDxYY,EAAA;MuDVtB;QAuZQ,gBAAgB,EAAA;MAvZxB;QA6ZQ,cAAc,EAAA;MA7ZtB;QAiaQ,oBAAoB,EAAA;QAja5B;UAsac,cAAc;UACd,kBAAkB;UAClB,6BAA6B;UAC7B,gBAAgB,EAAA;QAza9B;UA6ac,cAAc,EAAA;MA7a5B;QAobQ,kBAAkB;QAClB,WAAW,EAAA;MArbnB;QAybQ,mBAAmB;QACnB,eAAe;QACf,eAAe;QACf,cAAc;QACd,aAAa;QACb,QAAQ;QACR,oBAAoB;QACpB,eAAe,EAAA;QAhcvB;UAmcU,kBAAkB;UAClB,QAAQ;UACR,QAAQ;UACR,YAAY,EAAA;MAtctB;QA2cQ,gBAAgB,EAAA;MA3cxB;QA+cQ,gBAAgB,EAAA;MA/cxB;QAmdQ,sBAAsB;QACtB,kBAAkB;QAElB,kBAAkB,EAAA;QAtd1B;UAydU,aAAa,EAAA;QAzdvB;UA6dU,WAAW;UACX,wCAAwC;UACxC,uBAAuB;UACvB,2BAA2B;UAC3B,UAAU;UACV,cAAc;UACd,kBAAkB;UAClB,eAAe;UACf,gBAAgB,EAAA;UAre1B;YAweY,cAAc;YACd,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB,EAAA;MA7e7B;QAmfQ,yBAAyB,EAAA;QAnfjC;UAsfU,WAAW,EAAA;QAtfrB;UA0fU,eAAe,EAAA;QA1fzB;UA8fU,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,iBAAiB;UACjB,cAAc,EAAA;MAngBxB;QAwgBQ,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB,EAAA;MA1gBxB;QA8gBQ,aAAa;QACb,SAAS;QACT,mBAAmB,EAAA;QAhhB3B;UAmhBU,kBAAkB;UAClB,8BAAqC;UACrC,gCAAuC,EAAA;UArhBjD;YAwhBY,8BAA8B;YAC9B,gCAAgC,EAAA;UAzhB5C;YA6hBY,YAAY;YACZ,gBAAgB,EAAA;QA9hB5B;UAmiBU,4BAA4B;UAC5B,oCAAoC,EAAA;UApiB9C;YAuiBY,YAAY;YACZ,gBAAgB,EAAA;MAxiB5B;QA8iBQ,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,QAAQ,EAAA;QAjjBhB;UAojBU,cAAc;UACd,gBAAgB,EAAA;QArjB1B;UAyjBU,cAAc;UACd,gBAAgB,EAAA;;AC1jB1B;EAGM,eAAe;EACf,gBAAgB;EAChB,+BAA+B,EAAA;;AALrC;EAaM,YAAY;EACZ,cAAc;EACd,qBAAqB,EAAA;EAf3B;IASQ,eAAe;IACf,gBAAgB;IAChB,+BAA+B,EAAA;;AAXvC;EAmBI,gBAAgB,EAAA;EAnBpB;IAqBM,2BAA2B,EAAA;;AArBjC;EA2BM,yBAAyB,EAAA;EA3B/B;IA6BQ,gBAAgB;IAChB,iBAAiB,EAAA;;AA9BzB;EAoCI,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EAxCb;IA2CM,WAAW;IACX,kBAAkB,EAAA;;AAIxB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,2BAA2B,EAAA;;ACzD7B;EAEI,eAAe;EACf,kBAAkB;EAClB,gBAAgB,EAAA;;AAJpB;EAQI,kBAAkB,EAAA;;AARtB;EAiBI,YAAY;EACZ,cAAc;EACd,qBAAqB,EAAA;EAnBzB;IAaM,eAAe;IACf,gBAAgB;IAChB,+BAA+B,EAAA;;AAfrC;EAuBI,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;EAzBb;IA4BM,WAAW,EAAA;;AA5BjB;EAiCI,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAnCb;EAuCI,aAAa;EACb,8BAA8B;EAE9B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EA9CvB;IAiDM,UAAU,EAAA;EAjDhB;IAqDM,aAAa;IACb,QAAQ;IACR,mBAAmB,EAAA;EAvDzB;IA2DM,aAAa;IACb,SAAS;IACT,mBAAmB,EAAA;IA7DzB;MAgEQ,gBAAgB;MAChB,eAAe,EAAA;IAjEvB;MAqEQ,gBAAgB;MAChB,eAAe,EAAA;IAtEvB;MA2EU,cAAc,EAAA;IA3ExB;MA+EU,cAAc;MACd,kBAAkB,EAAA;;AChF5B;EAEI,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B,EAAA;;AAL9B;EASI,c1D0BwB,EAAA;;A0DnC5B;EAaI,c1D+ByB,EAAA;;A0D5C7B;EAiBI,c1DsCsB,EAAA;;A0DvD1B;EAqBI,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAvBb;EA2BI,aAAa;EACb,8BAA8B;EAE9B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAlCvB;IAqCM,UAAU,EAAA;EArChB;IAyCM,aAAa;IACb,QAAQ;IACR,mBAAmB,EAAA;EA3CzB;IA+CM,aAAa;IACb,SAAS;IACT,mBAAmB,EAAA;IAjDzB;MAoDQ,gBAAgB;MAChB,eAAe,EAAA;IArDvB;MAyDQ,gBAAgB;MAChB,eAAe,EAAA;IA1DvB;MA+DU,cAAc,EAAA;IA/DxB;MAmEU,cAAc;MACd,kBAAkB,EAAA;;ACpE5B;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;EAC/C,YAAY;EAEZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EAEnB,sBAAsB;EAEtB,aAAa;EACb,sCAAsC;EACtC,+TAQuD,EAAA;EA1BzD;IA6BI,cAAc,EAAA;EA7BlB;IAiCI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,kBAAkB,EAAA;EAxCtB;IA4CI,0B3DjCsB,EAAA;I2DX1B;MA8CM,mBAAmB,EAAA;EA9CzB;IAmDI,iBAAiB;IACjB,YAAY,EAAA;IApDhB;MAuDM,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,oBAAoB;MACpB,c3DlDgB,EAAA;E2DVtB;IAiEI,gBAAgB,EAAA;EAjEpB;IAqEI,mBAAmB,EAAA;EArEvB;IAyEI,sBAAsB,EAAA;EAzE1B;IA6EI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,c3DRiB;I2DSjB,gBAAgB,EAAA;EArFpB;IAyFI,gBAAgB,EAAA;EAzFpB;IA6FI,mBAAmB,EAAA;EA7FvB;IAiGI,oBAAoB,EAAA;IAjGxB;MAoGM,eAAe;MACf,8BAA8B,EAAA;IArGpC;MAyGM,sBAAsB;MACtB,YAAY,EAAA;IA1GlB;MA8GM,eAAe,EAAA;MA9GrB;QAgHQ,0BAA0B;QAC1B,wBAAwB,EAAA;IAjHhC;MAsHM,eAAe,EAAA;EAtHrB;IA2HI,cAAc,EAAA;EA3HlB;IA+HI,oBAAoB,EAAA;IA/HxB;MAoIU,cAAc;MACd,kBAAkB;MAClB,6BAA6B;MAC7B,gBAAgB,EAAA;EAvI1B;IA8II,gBAAgB,EAAA;EA9IpB;IAkJI,gBAAgB,EAAA;EAlJpB;IAsJI,kBAAkB;IAMlB,kBAAkB,EAAA;IA5JtB;MAyJM,aAAa,EAAA;IAzJnB;MA+JM,WAAW;MACX,wCAAwC;MACxC,uBAAuB;MACvB,2BAA2B;MAC3B,UAAU;MACV,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,gBAAgB,EAAA;MAvKtB;QAyKQ,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAA;EA9KzB;IAoLI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAA;IAxLZ;MA2LM,YAAY,EAAA;IA3LlB;MA+LM,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,cAAc,EAAA;IApMpB;MAwMM,0BAA0B,EAAA;EAxMhC;IA6MI,iBAAiB,EAAA;IA7MrB;MA+MM,eAAe;MACf,kBAAkB,EAAA;EAhNxB;IAqNI,uBAAuB,EAAA;IArN3B;MAuNM,eAAe;MACf,kBAAkB,EAAA;;ACxNxB;EACE,iBAAiB,EAAA;EADnB;IAUM,YAAY;IACZ,cAAc;IACd,qBAAqB,EAAA;IAZ3B;MAMQ,gBAAgB;MAChB,+BAA+B,EAAA;EAPvC;IAqBM,yBAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,qBAAqB,EAAA;IAxB3B;MAiBQ,gBAAgB;MAChB,+BAA+B,EAAA;EAlBvC;IA4BM,aAAa;IACb,8BAA8B;IAC9B,gBAAgB,EAAA;IA9BtB;MAiCQ,aAAa;MACb,gBAAgB;MAChB,SAAS,EAAA;IAnCjB;MAuCQ,WAAW;MACX,YAAY,EAAA;MAxCpB;QA2CU,qB5DFoB;Q4DGtB,yB5DG2B,EAAA;M4D/CnC;QAgDU,yB5DjBmB;Q4DkBnB,qB5DpBY,EAAA;M4D7BtB;QAqDU,yB5DGsB;Q4DFtB,qB5DHkB,EAAA;;A6DnD5B;EAEI,kBAAkB;EAClB,mBAAmB,EAAA;EAHvB;IAMM,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B,EAAA;IAlBjC;MAqBQ,aAAa;MACb,WAAW;MACX,sBAAsB,EAAA;MAvB9B;QA0BU,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,mBAAmB,EAAA;QAlC7B;UAqCY,mBAAmB;UACnB,uBAAuB;UACvB,gBAAgB;UAChB,gBAAgB;UAChB,eAAe;UACf,gBAAgB,EAAA;MA1C5B;QA+CU,gBAAgB;QAChB,6BAA6B,EAAA;QAhDvC;UAmDY,aAAa;UACb,8BAA8B,EAAA;QApD1C;UAwDY,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB,iBAAiB,EAAA;QA5D7B;UAgEY,eAAe;UACf,cAAc,EAAA;QAjE1B;UAqEY,gBAAgB,EAAA;MArE5B;QA0EU,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,SAAS,EAAA;QA7EnB;UAgFY,aAAa;UACb,8BAA8B;UAC9B,UAAU,EAAA;UAlFtB;YAqFc,eAAe,EAAA;UArF7B;YAyFc,eAAe,EAAA;;ACzF7B;EAIY,0BAA0B,EAAA;;AAJtC;EASQ,cAAc;EACd,YAAY,EAAA;;AAVpB;EAkBQ,yBAA+B;EAC/B,cAAc;EACd,qBAAqB,EAAA;EApB7B;IAeY,+BAA+B,EAAA;;AAf3C;EAwBQ,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;EA1BjB;IA6BY,WAAW,EAAA;;AC7BvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;EAC/C,sBAAsB;EActB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAtBrB;IAOI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,kHAGsB,EAAA;EASxB;IACE,yB/DMyB;I+DLzB,yB/DYmC,EAAA;I+DdpC;MAKG,yBAAoC,EAAA;IALvC;MASG,yBAAoC,EAAA;IATvC;MAaG,yBAAoC,EAAA;EAIxC;IACE,yB/DD0B;I+DE1B,uB/DKmC,EAAA;I+DPpC;MAKG,yBAAsC,EAAA;IALzC;MASG,yBAAsC,EAAA;IATzC;MAaG,yBAAsC,EAAA;EAI1C;IACE,yB/DRwB;I+DSxB,yB/DHkC,EAAA;I+DCnC;MAKG,yBAAmC,EAAA;IALtC;MASG,yBAAmC,EAAA;IATtC;MAaG,yBAAmC,EAAA;EAvEzC;IA4EI,cAAc,EAAA;EA5ElB;IAgFI,iBAAiB;IACjB,YAAY,EAAA;IAjFhB;MAoFM,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,oBAAoB;MACpB,c/D/EgB,EAAA;E+DVtB;IA8FI,gBAAgB,EAAA;EA9FpB;IAkGI,mBAAmB,EAAA;EAlGvB;IA0GI,uBAAuB,EAAA;IA1G3B;MAuGM,0BAA0B,EAAA;EAvGhC;IA8GI,eAAe,EAAA;EA9GnB;IAkHI,gBAAgB,EAAA;EAlHpB;IAsHI,gBAAgB,EAAA;EAtHpB;IA0HI,iBAAiB,EAAA;IA1HrB;MA6HM,kBAAkB,EAAA;;AC7HxB;EAEQ,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB,EAAA;;AAPxB;EAWQ,oCAAoC,EAAA;;ACX5C;EAEQ,cAAc;EACd,qBAAqB;EACrB,uBAAuB,EAAA;EAJ/B;IAMY,kCAAkC;IAClC,yBAA8B;IAC9B,qBAAqB;IACrB,0BAA0B,EAAA;;AATtC;EAcQ,yBAA+B,EAAA;;ACbvC;EAEI,aAAa;EACb,8BAA8B;EAC9B,gBAAgB,EAAA;EAJpB;IAOM,aAAa;IACb,gBAAgB;IAChB,SAAS,EAAA;EATf;IAaM,WAAW;IACX,YAAY,EAAA;IAdlB;MAiBQ,qBlEuBsB;MkEtBtB,yBlE4B2B,EAAA;IkE9CnC;MAsBQ,yBlEQqB;MkEPrB,qBlEKc,EAAA;IkE5BtB;MA2BQ,yBlE4BwB;MkE3BxB,qBlEsBoB,EAAA;;AmEnD5B;EAEI,cAAc,EAAA;EAFlB;IAIM,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB,EAAA;IAPxB;MASQ,YAAY;MACZ,mBAAmB;MACnB,yBAAyB;MACzB,yBAAyB;MACzB,WAAW;MACX,eAAe;MACf,mBAAmB,EAAA;MAf3B;QAkBU,oCAAmD;QACnD,8BAAsC,EAAA;MAnBhD;QAuBU,yBnE4BkB;QmE3BlB,8BAAmC,EAAA;QAxB7C;;UA2BY,yBAAmC,EAAA;MA3B/C;QA+BU,oCAAiD;QACjD,8BAA+C,EAAA;QAhCzD;;UAmCY,yBAAoC,EAAA;IAnChD;MAyCQ,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,QAAQ,EAAA;MA7ChB;QA+CU,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB,EAAA;MAlD1B;QAqDU,eAAe,EAAA;IArDzB;MAyDQ,aAAa;MACb,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ,EAAA;MA5DhB;QA8DU,eAAe,EAAA;MA9DzB;QAiEU,YAAY,EAAA;QAjEtB;UAmEY,6BAA6B,EAAA;IAnEzC;MAwEQ,UAAU;MACV,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,YAAY;MACZ,SAAS,EAAA;MA7EjB;QA+EU,QAAQ,EAAA;IA/ElB;MAmFQ,gBAAgB,EAAA;IAnFxB;MAsFQ,gBAAgB;MAChB,YAAY;MACZ,mBAAmB,EAAA;IAxF3B;MA2FQ,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,yBAAyB;MACzB,aAAa;MACb,kBAAkB;MAClB,OAAO;MACP,uBAAuB;MACvB,mBAAmB,EAAA;MApG3B;QAsGU,WAAW;QACX,YAAY;QACZ,iBAAiB,EAAA;;ACxG3B;EACE,oBAAoB,EAAA;EADtB;IAGI,yBAAyB,EAAA;EAH7B;IAMI,iBAAiB,EAAA;EANrB;IASI,yBAAyB;IACzB,kBAAkB,EAAA;IAVtB;MAYM,2BAA2B,EAAA;;ACZjC;EAIQ,YAAY,EAAA;EAJpB;IAMU,YAAY,EAAA;;AANtB;EAaM,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe,EAAA;;AAhBrB;EAqBM,kBAAkB,EAAA;;AAKxB;EAEI,yBAAyB,EAAA;EAF7B;IAKM,0BAA0B,EAAA;;AC/BhC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;EACV,uBAAuB;EACvB,qBAAqB,EAAA;EAPvB;IAUM,oCAAoC;IACpC,gCAAgC,EAAA;EAXtC;IAeI,eAAe;IACf,YAAY,EAAA;EAhBhB;IAmBI,6BAA6B;IAC7B,aAAa,EAAA;IApBjB;MAsBM,gBAAgB;MAChB,kBAAkB,EAAA;IAvBxB;MA0BM,cAAc,EAAA;IA1BpB;MA6BM,6BAA6B;MAC7B,iBAAiB;MACjB,gBAAgB,EAAA;IA/BtB;MAkCM,gBAAgB,EAAA;IAlCtB;MAqCM,gBAAgB;MAChB,uBAAuB,EAAA;IAtC7B;MAyCM,aAAa,EAAA;EAzCnB;IA6CI,cAAc,EAAA;EA7ClB;IAgDI,gBAAgB,EAAA;IAhDpB;MAkDM,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,sBAAsB,EAAA;EAG1B;IACE,gBAAgB;IAChB,kBAAkB,EAAA;IAFnB;MAIG,cAAc,EAAA;IAJjB;MAQK,cAAc,EAAA;IARnB;MAWK,cAAc,EAAA;IAXnB;MAeO,kBAAkB;MAClB,oCAAmD;MACnD,8BAAiD;MACjD,yBAAyB,EAAA;MAlBhC;QAqBS,oCAA6D;QAC7D,oCAAyD;QACzD,sCAAsC,EAAA;QAvB/C;UA0BW,yBAAyB,EAAA;QA1BpC;UA8BW,oCAA0D;UAC1D,gBAAgB,EAAA;IA/B3B;MAoCO,oCAAoC;MACpC,2BAA2B;MAC3B,yBAAyB,EAAA;;ACjGnC;EAEI,mBAAmB,EAAA;;AAFvB;EAMI,2BAA2B,EAAA;EAN/B;IAQM,gBAAgB;IAChB,eAAe,EAAA;;AATrB;EAcI,gBAAgB;EAChB,eAAe;EACf,cvEWuB,EAAA;;AuE3B3B;EAoBI,UAAU,EAAA;EApBd;IAuBM,yBAAoC,EAAA;;ACvB1C;EAEI,cxEqDsB;EwEpDtB,mBAAmB,EAAA;;AAHvB;EAOI,mBAAmB,EAAA;;AAPvB;EAWI,2BAA2B,EAAA;;ACX/B;EACI;IAAK,wBAAwB,EAAA;EAC7B;IAAM,2BAA2B,EAAA;EACjC;IAAM,0BAA0B,EAAA;EAChC;IAAM,2BAA2B,EAAA;EACjC;IAAO,0BAA0B,EAAA,EAAA;;ACLrC;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B,EAAA;EAC9B;;IAEE,UAAU,EAAA;EAEZ;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB,EAAA;IANnB;MAQG,mBAAmB,EAAA;IARtB;MAWG,mBAAmB,EAAA;IAXtB;MAcG,WAAW,EAAA;IAdd;MAiBG,gBAAgB;MAChB,c1ENe,EAAA;I0EZlB;MAqBG,gBAAgB,EAAA;IArBnB;MAyBK,cAAc,EAAA;IAzBnB;MA4BK,0BAA0B,EAAA;IA5B/B;MAgCG,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,qBAAqB,EAAA;MAnCxB;QAqCK,0BAA0B,EAAA;EA7ClC;IAkDI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB,EAAA;IAzD7B;MA2DM,aAAa;MACb,yBAAyB;MACzB,WAAW;MACX,gBAAgB,EAAA;IA9DtB;MAiEM,mBAAmB;MACnB,gBAAgB,EAAA;IAlEtB;MAqEM,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA;IA1EpB;MA6EM,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAIhB,yBAAyB;MACzB,4BAA4B;MAC5B,WAAW,EAAA;IArFjB;MA0FM,SAAS;MACT,WAAW,EAAA;EAKf;IAhGF;MAkGM,aAAa,EAAA;MAlGnB;QAoGQ,YAAY,EAAA,EAEb;;ACrGL;EACE,aAAa,EAAA;;AAGf;EACE,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,cAAc;EACd,oCAAoC,EAAA;EAHrC;IAMG,0BAA0B,EAAA;;AAI9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa,EAAA;EANd;IAUK,c3EVW;I2EWX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB,EAAA;EAjBvB;IAsBG,kBAAkB,EAAA;EAtBrB;IA0BG,eAAe;IACf,0BAA0B,EAAA;EA3B7B;IA+BG,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,2BAA2B,EAAA;EAG7B;IACE,YAAY;IACZ,mBAAmB,EAAA;;AA1DzB;EA+DI,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB,EAAA;EAnEvB;IAsEM,sBAAsB,EAAA;EAtE5B;IA0EM,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,mBAAmB,EAAA;IA7EzB;MAgFQ,iBAAiB,EAAA;;AAhFzB;EAsFI,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,WAAW;EACX,iBAAiB,EAAA;;AA5FrB;EAgGI,iBAAiB;EACjB,oBAAoB,EAAA;EAjGxB;IAoGM,yBAAyB,EAAA;IApG/B;MAuGQ,c3E5D2B,EAAA;I2E3CnC;MA2GQ,c3EhE2B,EAAA;;A2E3CnC;EAiHI,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B,EAAA;EAnHjC;IAsHM,6BAA6B;IAC7B,yBAAyB,EAAA;IAvH/B;MA0HQ,cAAc,EAAA;IA1HtB;MA8HQ,cAAc,EAAA;EA9HtB;IAmIM,yBAAyB;IACzB,6BAA6B,EAAA;IApInC;MAuIQ,c3E5F2B,EAAA;I2E3CnC;MA2IQ,c3EhG2B,EAAA","sourcesContent":["@import \"./sass/all\";",".container {\n  max-width: 1300px;\n  width: 100%;\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: unset !important;\n}\n\n.cards-step-2 {\n  .body-card {\n    color: #6e7889;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-bottom: 4px;\n  }\n  iframe {\n    width: 100%;\n    height: 120px;\n    border: none;\n    background-color: transparent;\n  }\n  .UploadDocs .input-content {\n    height: 78px;\n\n    input {\n      height: 78px;\n    }\n  }\n}\n.card {\n  &__generic {\n    border-radius: 10px;\n    border: 1px solid #929fb0;\n    box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n    width: 100%;\n    padding: 16px;\n  }\n}\n.form {\n  &-item {\n    &__input,\n    .ant-input {\n      padding: 12px 0;\n      border: 0;\n      border-bottom: 1px solid $grey-title;\n      border-radius: 0;\n      &::placeholder {\n        color: $grey-placeholder;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n  }\n}\n.card-upload {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 12px 16px;\n  box-shadow: 0px 0px 3px 0px rgba(11, 19, 26, 0.18);\n  .link {\n    color: #6e7889;\n    text-align: right;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-decoration-line: underline;\n  }\n  p {\n    margin: 10px 0;\n  }\n}\n.text-modal {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px !important;\n  text-align: left;\n  color: #404859 !important;\n}\n.flex-btw {\n  display: flex;\n  justify-content: space-between;\n}\n.flex-center {\n  display: flex;\n  justify-content: center;\n}\n.flex-end {\n  display: flex;\n  justify-content: flex-end;\n}\n.flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n.flex-col {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\n.mt--10 {\n  margin-top: -20px !important;\n}\n.mt {\n  &-20 {\n    margin-top: 20px;\n  }\n  &-25 {\n    margin-top: 25px;\n  }\n  &-30 {\n    margin-top: 30px;\n  }\n  &-40 {\n    margin-top: 40px;\n  }\n  &-50 {\n    margin-top: 50px;\n  }\n  &-60 {\n    margin-top: 60px;\n  }\n  &-12 {\n    margin-top: 12px;\n  }\n  &-6 {\n    margin-top: 6px;\n  }\n  &-5 {\n    margin-top: 5px;\n  }\n  &-10 {\n    margin-top: 10px;\n  }\n  &-15 {\n    margin-top: 15px;\n  }\n}\n.mb {\n  &-20 {\n    margin-bottom: 20px;\n  }\n  &-25 {\n    margin-bottom: 25px;\n  }\n  &-30 {\n    margin-bottom: 30px;\n  }\n  &-40 {\n    margin-bottom: 40px;\n  }\n  &-50 {\n    margin-bottom: 50px;\n  }\n  &-60 {\n    margin-bottom: 60px;\n  }\n  &-12 {\n    margin-bottom: 12px;\n  }\n  &-6 {\n    margin-bottom: 6px;\n  }\n  &-5 {\n    margin-bottom: 5px;\n  }\n  &-10 {\n    margin-bottom: 10px;\n  }\n  &-15 {\n    margin-bottom: 15px;\n  }\n}\n.divider-top {\n  border-top: 1px solid #afbdcc;\n}\n\n// inputs ******************************************** inputs\n.input {\n  &-transparent {\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0;\n  }\n  &-number {\n    width: 100%;\n    height: 48px;\n    border-radius: 10px;\n    border: 1px solid #2a2f3c;\n    background: #fff;\n    .ant-input-number-input-wrap {\n      height: 45px;\n      .ant-input-number-input {\n        height: 45px;\n      }\n    }\n    .ant-input-prefix {\n      color: #404859;\n      font-family: Inter;\n      font-size: 16px;\n      font-weight: 400;\n    }\n    input {\n      &::placeholder {\n        color: #929fb0;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: italic;\n        font-weight: 400;\n      }\n    }\n  }\n  &-placeholder-bold {\n    &::placeholder {\n      color: #9bbceb;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n}\n.body-placeholder {\n  &::placeholder {\n    color: #929fb0;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 600;\n    line-height: normal;\n  }\n  &-w4 {\n    &::placeholder {\n      font-weight: 400;\n    }\n  }\n}\n.fz-14 {\n  font-size: 14px;\n}\n.fz-12 {\n  font-size: 12px;\n}\n\n.children {\n  padding-bottom: 20px;\n}\n","//sizes\n$small: 440px;\n$s-medium: 570px;\n$medium: 761px;\n$large: 960px;\n$x-large: 1060px;\n$xx-large: 1250px;\n\n//colors\n$grey-title: #404859;\n$grey-text-op: #6e7889;\n$grey-placeholder: #404859;\n$color-primary-button: #162e43;\n$white-button-txt: #f5faff;\n$black-text: #2a2f3c;\n$blue-button-tab: #355c7d;\n$white-button-tab: #dfe4eb;\n$white: #ffffff;\n$black: #000000;\n$red-title: #c94f4a;\n$red-warning: #8f2f2c;\n$grey-border: #ccd3db;\n$green-tab-active-text: #587e5b;\n$green-tab-active: #6eac72;\n\n$state-warning: #775614;\n\n$state-draft-hover: #404859;\n\n$state-review: #AC78B3;\n$state-review-dark: #693B6F;\n$state-review-border: #AC78B3;\n$state-review-border-2: #D7B8E5;\n$state-review-text: #161616;\n$state-review-text-dark: #241226;\n$state-review-label: #855791;\n$state-review-tag: #48244D;\n$state-review-background: #e3ddf0;\n$state-review-background-ligth: #FDFCFF;\n\n$state-approved: #f5faf7;\n$state-approved-border:#92c295;\n$state-approved-border-dark: #4CA852; \n$state-approved-title-dark: #3F9545; \n$state-approved-icon: #466849; \n$state-approved-text: #404859;\n$state-approved-text-dark: #1F4222;\n$state-approved-background: #C2F0C5;\n$state-approved-background-ligth: white;\n\n$state-error: #fff4f3;\n$state-error-border: #c94f4a;\n$state-error-icon: #712220;\n$state-error-text: #404859;\n$state-error-text-dark: #8A130F;\n$state-error-dark: #C13934;\n$state-error-background: #FFD4CF;\n$state-error-background-ligth: #FFFFFF;\n$state-error-input: #E56A5C;\n\n$state-tag-incomplete: #B6DCFC;\n$state-incomplete-text: #122536;\n$state-incomplete-text-2: #48759A;\n$state-incomplete-text-3: #244560;\n$state-incomplete-circle-background: #7FADD4;\n$state-incomplete-circle-border: #5E8EB7;\n$state-incomplete-hover: #48759A;\n$state-card-background: #F5FAFF;\n\n$button-disbaled-background: #EFF3F5;\n$button-disbaled-border: #EFF3F5;\n$button-disabled-color: #6E7889;\n$button-color: #929FB0;\n$button-blue: #5E8EB7;\n$button-red: #A31C17;\n\n$text-yellow: #BB8D2F;\n$button-yellow: #FFEDC8;\n\n$button-primary-background: #162E43;\n$button-primary-border: #162E43;\n$button-primary-hover-background: #EBF6FF;\n$button-primary-hover-border: #97BCF0;\n$button-primary-active-border: #355C7D;","/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0-modified | 20110126\n   License: none (public domain)\n*/\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  height: 100%;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* make sure to set some focus styles for accessibility */\n:focus {\n  outline: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\n/**\n   * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.\n   */\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1;\n  max-width: 100%;\n}\n\n/**\n   * Prevent modern browsers from displaying `audio` without controls.\n   * Remove excess height in iOS 5 devices.\n   */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n   * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n   * Known issue: no IE 6 support.\n   */\n\n[hidden] {\n  display: none;\n}\n\n/**\n   * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using\n   *    `em` units.\n   * 2. Prevent iOS text size adjust after orientation change, without disabling\n   *    user zoom.\n   */\n\nhtml {\n  font-size: 100%; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -ms-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n   * Address `outline` inconsistency between Chrome and other browsers.\n   */\n\na:focus {\n  outline: thin dotted;\n}\n\n/**\n   * Improve readability when focused and also mouse hovered in all browsers.\n   */\n\na:active,\na:hover {\n  outline: 0;\n}\n\n/**\n   * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.\n   * 2. Improve image quality when scaled in IE 7.\n   */\n\nimg {\n  border: 0; /* 1 */\n  -ms-interpolation-mode: bicubic; /* 2 */\n}\n\n/**\n   * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n   */\n\nfigure {\n  margin: 0;\n}\n\n/**\n   * Correct margin displayed oddly in IE 6/7.\n   */\n\nform {\n  margin: 0;\n}\n\n/**\n   * Define consistent border, margin, and padding.\n   */\n\nfieldset {\n  border: 0px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n   * 1. Correct color not being inherited in IE 6/7/8/9.\n   * 2. Correct text not wrapping in Firefox 3.\n   * 3. Correct alignment displayed oddly in IE 6/7.\n   */\n\nlegend {\n  border: 0; /* 1 */\n  padding: 0;\n  white-space: normal; /* 2 */\n  *margin-left: -7px; /* 3 */\n}\n\n/**\n   * 1. Correct font size not being inherited in all browsers.\n   * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n   *    and Chrome.\n   * 3. Improve appearance and consistency in all browsers.\n   */\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%; /* 1 */\n  margin: 0; /* 2 */\n  vertical-align: baseline; /* 3 */\n  *vertical-align: middle; /* 3 */\n}\n\n/**\n   * Address Firefox 3+ setting `line-height` on `input` using `!important` in\n   * the UA stylesheet.\n   */\n\nbutton,\ninput {\n  line-height: normal;\n}\n\n/**\n   * Address inconsistent `text-transform` inheritance for `button` and `select`.\n   * All other form control elements do not inherit `text-transform` values.\n   * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.\n   * Correct `select` style inheritance in Firefox 4+ and Opera.\n   */\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n   * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n   *    and `video` controls.\n   * 2. Correct inability to style clickable `input` types in iOS.\n   * 3. Improve usability and consistency of cursor style between image-type\n   *    `input` and others.\n   * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n   *    Known issue: inner spacing remains in IE 6.\n   */\n\nbutton,\n  html input[type=\"button\"], /* 1 */\n  input[type=\"reset\"],\n  input[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n  *overflow: visible; /* 4 */\n}\n\n/**\n   * Re-set default cursor for disabled elements.\n   */\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n   * 1. Address box sizing set to content-box in IE 8/9.\n   * 2. Remove excess padding in IE 8/9.\n   * 3. Remove excess padding in IE 7.\n   *    Known issue: excess padding remains in IE 6.\n   */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n  *height: 13px; /* 3 */\n  *width: 13px; /* 3 */\n}\n\n/**\n   * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n   * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n   *    (include `-moz` to future-proof).\n   */\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n   * Remove inner padding and search cancel button in Safari 5 and Chrome\n   * on OS X.\n   */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * Remove inner padding and border in Firefox 3+.\n   */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n   * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n   * 2. Improve readability and alignment in all browsers.\n   */\n\ntextarea {\n  overflow: auto; /* 1 */\n  vertical-align: top; /* 2 */\n}\n\n/**\n   * Remove most spacing between table cells.\n   */\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  color: #222;\n}\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.chromeframe {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n    \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n",".h1 {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.h2 {\n  color: $black-text;\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n  &-w8 {\n    font-weight: 800;\n  }\n}\n.h3 {\n  color: #2a2f3c;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 135%;\n}\n.h4 {\n  color: $black-text;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 115%;\n  &-cp {\n    text-transform: capitalize;\n  }\n  &-w4 {\n    font-weight: 400;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n.title-blue-bold {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  color: $blue-button-tab;\n}\n.body-regular {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  &-italic {\n    font-style: italic;\n  }\n  &-up {\n    text-transform: uppercase;\n  }\n  &-bold,\n  &-w6 {\n    font-weight: 600;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n}\n\n.placeholder {\n  color: $grey-placeholder;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  &-w6 {\n    font-weight: 600;\n  }\n}\n.button-txt-big {\n  color: $white-button-txt;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.24px;\n}\n.body-small {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  &-w4 {\n    font-weight: 400;\n  }\n  &-w6 {\n    font-weight: 600;\n  }\n  &-up {\n    text-transform: uppercase;\n  }\n}\n.small-detail {\n  color: #6e7889;\n  font-family: Inter;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.body-card {\n  color: $grey-title;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  &-bold-line {\n    font-weight: 700;\n    text-decoration-line: underline;\n  }\n  &-w6 {\n    font-weight: 600;\n  }\n  &-w7 {\n    font-weight: 700;\n  }\n  &-w5 {\n    font-weight: 500;\n  }\n  &-REVIEW {\n    color: $state-review-dark !important;\n  }\n  &-REQUEST_ERROR {\n    color: $state-error-icon !important;\n  }\n  &-APPROVED {\n    color: $state-approved-text-dark !important;\n  }\n}\n.blue-bold {\n  color: #5e8eb7;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 145%;\n  img {\n    height: 10px;\n    margin-left: 5px;\n  }\n}\n\n.bold {\n  font-weight: 600;\n  color: #2A2F3C !important;\n}\n\n.bold-little {\n  font-weight: 500;\n}\n\n.fw-400 {\n  font-weight: 400;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.text-error-note {\n  color: #8F2F2C;\n  font-size: 14px;\n  font-weight: 600;\n\n  span {\n      color: #C94F4A;\n      font-weight: 400;\n  }\n}\n\n.link {\n  cursor: pointer;\n\n  &-underline {\n    text-decoration: underline !important;\n  }\n}\n\n.disabled {\n  color: #2A2F3C !important;\n\n  div {\n    border-color: #AFBDCC !important;\n  }\n}",".button {\n  height: 32px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n\n  &-empty {\n    background-color: transparent;\n    padding: 0;\n    border: none;\n    box-shadow: none;\n    span {\n      color: #404859 !important;\n      font-family: Inter;\n      font-size: 10px !important;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 16px;\n      letter-spacing: 0.2px;\n    }\n  }\n\n  &-modal-ok {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #ffc857 !important;\n    background: #ffc857 !important;\n    height: 40px;\n    color: #66564d !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.21px;\n  }\n  &-modal-cancel {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #ddaa42 !important;\n    background: #fff9ee !important;\n    height: 40px;\n    color: #3c302a !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.21px;\n  }\n  &-primary {\n    width: 100%;\n    height: 48px;\n    flex-shrink: 0;\n    border-radius: 6px;\n    border: 1px solid $color-primary-button;\n    background: $color-primary-button;\n    border: none;\n    &:hover {\n      border: none;\n      color: $white-button-txt !important;\n      background: $color-primary-button !important;\n    }\n  }\n  &-secondary {\n    width: 179px;\n    border-radius: 6px;\n    border: 1px solid $blue-button-tab;\n    color: $blue-button-tab;\n\n    &:hover {\n      color: $white-button-txt !important;\n      border: 1px solid $blue-button-tab !important;\n      background: $color-primary-button !important;\n    }\n  }\n  &-grey {\n    color: #6e7889 !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    border-radius: 6px;\n    border: 1px solid #eff3f5 !important;\n    background: #eff3f5;\n    width: 100%;\n  }\n  &-transparent {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    color: #48759a;\n    .anticon {\n      color: #48759a;\n    }\n    &:hover {\n      color: #48759a !important;\n    }\n  }\n  &-gray {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    border-radius: 6px;\n    color: #afbdcc;\n    .anticon {\n      color: #afbdcc;\n    }\n    &:hover {\n      color: #afbdcc !important;\n    }\n  }\n  &-card {\n    width: 100%;\n    color: $black;\n    border: 1px solid $grey-border;\n    &:hover {\n      color: $black !important;\n      border: 1px solid $grey-border !important;\n    }\n  }\n  &-submit {\n    border-radius: 6px;\n    border: 1px solid $button-primary-border;\n    background: $button-primary-background;\n    color: #fff;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    width: 100%;\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n      \n      span {\n        color: $button-disabled-color !important;\n      }\n\n      &:hover {\n        background-color: $button-disbaled-background !important;\n        border-color: $button-disbaled-border !important;\n        \n        span {\n          color: $button-disabled-color !important;\n        }\n      }\n    }\n\n    &:hover {\n      background-color: $button-primary-hover-background !important;\n      border: 1px solid $button-primary-hover-border !important;\n      box-shadow: 2px 2px 12px 0px #0B131A1A;\n\n      span {\n        color: #244560 !important;\n      }\n\n      &:active {\n        border: 1px solid $button-primary-active-border !important;\n        box-shadow: none;\n      }\n    }\n\n    &-error {\n      background-color: $state-error-background !important;\n      border-color: $state-error-background !important;\n      b {\n        color: #610805 !important;\n      }\n\n      &:hover {\n        border-color: $state-error-background !important;\n        background-color: $state-error-background !important;\n      }\n    }\n\n    &-red-dark {\n      background-color: $state-error-dark !important;\n      border-color: $state-error-dark !important;\n\n      &:hover {\n        border-color: $state-error-dark !important;\n        background-color: $state-error-dark !important;\n\n        span {\n          color: white !important;\n        }\n      }\n    }\n\n    &-yellow {\n      border-radius: 6px;\n      background: $button-yellow !important;\n      border-color: $button-yellow !important;\n\n      &:hover {\n        background: $button-yellow !important;\n        border-color: $button-yellow !important;\n      }\n\n      &:disabled {\n        background: #EFF3F5 !important;\n        border-color: #EFF3F5 !important;\n      }\n\n      span {\n        color: black;\n        font-weight: 600;\n      }\n    }\n  }\n\n  &-link {\n    width: 100%;\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    font-weight: 400;\n    color: $black;\n\n    &:hover {\n      color: $black !important;\n    }\n\n    &-REVIEW {\n      color: $state-review-text !important;\n    }\n\n    &-REQUEST_ERROR {\n      color: $state-error-text-dark;\n  \n      &:hover {\n        color: $state-error-text-dark !important;\n      }\n    }\n  }\n\n  &-link-border {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #162E43 !important;\n    background: none;\n    color: #3c302a !important;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 0.21px;\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n      color: $button-color !important;\n    }\n  }\n\n  &-link-blue {\n    color: #5E8EB7;\n    span {\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n\n    &:hover {\n      color: #5E8EB7 !important;\n    }\n  }\n\n  &-link-error {\n    color: $state-error-text-dark;\n    border: none;\n\n    span {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n\n    &:hover {\n      color: $state-error-text-dark !important;\n    }\n  }\n\n  &-blue {\n    color: #5E8EB7 !important;\n    span {\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n\n    &:hover {\n      color: #5E8EB7 !important;\n    }\n  }\n\n  &-open-modal {\n    width: 100%;\n\n    span {\n      font-family: Inter;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 14.52px;\n    }\n\n    &:disabled {\n      background-color: $button-disbaled-background !important;\n      border-color: $button-disbaled-border !important;\n      \n      span {\n        color: $button-disabled-color !important;\n        font-weight: 600 !important;\n      }\n      \n      &:hover {\n        background-color: $button-disbaled-background !important;\n        border-color: $button-disbaled-border !important;\n        \n        span {\n          color: $button-disabled-color !important;\n          font-weight: 600 !important;\n        }\n      }\n    }\n\n    &:hover {\n      border-color: $grey-border !important;\n      color: $black !important;\n    }\n\n    &-INCOMPLETE {\n      background-color: #B6DCFC;\n      border-color: #48759A;;\n      color: #122536;\n  \n      &:hover {\n        background-color: #48759A !important;\n        border-color: #48759A !important;\n        color: #F5FAFF !important;\n      }\n    }\n\n    &-REVIEW {\n      background-color: #EAD6FF;\n      border-color: #A278B3;\n\n      span {\n        color: $state-review-text-dark;\n      }\n  \n      &:hover {\n        border-color: #AC78B3 !important;\n        background-color: #A278B3 !important;\n\n        span {\n          color: #FAF9FC !important;\n        }\n      }\n    }\n\n    &-REQUEST_ERROR {\n      background-color: #FFC6BF;\n      border-color: #8A130F;\n      color: #260F0C;\n  \n      &:hover {\n        border-color: #8A130F !important;\n        background-color: #A31C17 !important;\n        color: #FCF8F7 !important;\n      }\n    }\n\n    &-APPROVED {\n      border-color: #3F9545;\n      background-color: #C2F0C5;\n      color: #241226;\n  \n      &:hover {\n        border-color: #3F9545 !important;\n        background-color: #3F9545 !important;\n        color: #FCF8F7 !important;\n      }\n    }\n\n    &-DRAFT {\n      background-color: #FFFFFF;\n      border-color: #6E7889;\n      span {\n        color: #2A2F3C;\n      }\n\n      &:hover {\n        background-color: #404859 !important;\n        border-color: #404859 !important;\n        span {\n          color: white !important;\n        }\n      }\n    }\n  }\n}\n",".select {\n  &-primary {\n    width: 100%;\n    height: 40px;\n    .ant-select-selector {\n      height: 40px !important;\n      padding: 2px 11px !important;\n      border-radius: 10px !important;\n      border: 1px solid #5e8eb7 !important;\n      .ant-select-selection-search-input {\n        height: 40px !important;\n      }\n    }\n  }\n}\n",".circle {\n    background-color: #fff;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 1px solid #2a2f3c;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .upload {\n        width: auto;\n        height: 18px;\n        object-fit: cover;\n    }\n}\n\n.circles-tags {\n    display: flex;\n    align-items: end;\n    gap: 10px;\n}\n\n.circle {\n    width: 20px;\n    height: 20px;\n\n    &-APPROVED {\n        background-color: $state-approved-background;\n        border-color: $state-approved-border;\n\n        &:hover {\n            background-color: $state-approved-border-dark;\n        }\n    }\n\n    &-REVIEW {\n        background-color: $state-review-border;\n        border-color: $state-review;\n\n        &:hover {\n            background-color: $state-review-label;\n        }\n    }\n\n    &-REQUEST_ERROR {\n        background-color: $state-error-background;\n        border-color: $state-error-border;\n\n        &:hover {\n            background-color: $state-error-border;\n        }\n    }\n}\n\n.circle-state-tooltip {\n    padding: 6px 7px !important;\n    opacity: 1 !important;\n\n    b {\n        font-weight: 600;\n    }\n\n    span {\n        margin-top: 10px;\n    }\n\n    &-APPROVED {\n        background-color: $state-approved-border-dark !important;\n    }\n\n    &-DRAFT {\n        background-color: $state-draft-hover !important;\n    }\n\n    &-REQUEST_ERROR {\n        background-color: $state-error-border !important;\n    }\n\n    &-REVIEW {\n        background-color: $state-review-label !important;\n    }\n}\n\n.tag-state-blue {\n    width: max-content;\n    height: 25px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 4px 6px;\n    border-radius: 15px;\n    border: 2px solid #355C7D;\n    color: #355C7D;\n    font-size: 10px !important;\n    font-weight: 700 !important;\n}",".state-tag {\n    width: max-content;\n    border-radius: 76px;\n    padding: 4px 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n\n    .check {\n        margin-right: 2px;\n    }\n\n    .tag-name {\n        font-weight: 600;\n        font-family: Inter;\n        line-height: 11px;\n        letter-spacing: 0.02em;\n        font-size: 10px;\n    }\n\n    &-APPROVED {\n        border-color: $state-approved-background;\n        background: $state-approved-background;\n\n        .tag-name {\n            color: $state-approved-text !important;\n        }\n    }\n\n    &-REVIEW {\n        border-color: $state-review-background;\n        background: $state-review-background;\n\n        .tag-name {\n            color: $state-review-text !important;\n        }\n    }\n\n    &-REQUEST_ERROR {\n        border-color: $state-error-background;\n        background: $state-error-background;\n\n        .tag-name {\n            color: $state-error-icon !important;\n        }\n    }\n\n    &-INCOMPLETE {\n        border-color: $state-draft-hover;\n        background: $state-draft-hover;\n\n        .tag-name {\n            color: white !important;\n        }\n    }\n\n    &-DRAFT {\n        border-color: $button-disbaled-background;\n        background: $button-disbaled-background;\n\n        .tag-name {\n            font-weight: 600;\n            color: $black-text !important;\n        }\n    }\n}",".card-upload-response {\n\tborder-radius: 10px;\n\tborder: 1px solid #2A2F3C;\n\tpadding: 10px 16px;\n\n\t.template {\n\t\tmargin-bottom: 10px;\n\n\t\t.arrow-right {\n\t\t\twidth: 14px;\n\t\t\tmargin-left: 5px;\n\t\t}\n\n\t\tbutton {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 6px;\n\n\t\t.h4 {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t.link {\n\t\t\tpadding: 0;\n\t\t\tcolor: rgba(110, 120, 137, 1);\n\t\t\tfont-size: 12px;\n\n\t\t\tspan {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcolor: rgba(110, 120, 137, 1);\n\t\t\t}\n\t\t}\n\t}\n\n\t.description {\n\t\tfont-family: Inter;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tmargin-bottom: 12px;\n\n    .description-button-link {\n      padding-left: 0;\n      text-decoration: underline;\n\n      &:hover {\n        color:#5e8eb7;\n      }\n    }\n\t}\n\n\t&-REVIEW {\n\t\tborder: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-review-text !important;\n\t\t}\n\t}\n\n\t&-APPROVED {\n\t\tborder: 1px solid $state-approved-border;\n\t\tbackground-color: $state-approved-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-approved-text !important;\n\t\t}\n\t}\n\n\t&-REQUEST_ERROR {\n\t\tborder: 1px solid $state-error-border;\n\t\tbackground-color: $state-error-background-ligth;\n\n\t\t.h4 {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\n\t\t.link {\n\t\t\tcolor: $state-error-text !important;\n\t\t}\n\t}\n}",".DrodownBlue {\n    height: 20px;\n    padding: 1px 3px !important;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n        background-color: $button-blue !important;\n        color: white !important;\n\n        span {\n            text-decoration-line: none !important;\n        }\n    }\n\n    &:disabled {\n        background-color: white !important;\n        color: #6E7889 !important;\n\n        span {\n            text-decoration-line: underline !important;\n        }\n    }\n\n    &-blue {\n        border: 1px solid #9BBCEB;\n        border-radius: 5px;\n\n        .ant-dropdown-menu {\n            padding: 0px;\n        }\n\n        .ant-dropdown-menu-item {\n            &:hover {\n                background-color: #EBF6FF !important;\n\n                .ant-dropdown-menu-title-content {\n                    color: $blue-button-tab;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .ant-dropdown-menu-title-content {\n            color: $button-blue;\n            font-weight: 400;\n\n            &:hover {\n                color: $blue-button-tab;\n                font-weight: 600;\n            }\n        }\n    }\n}",".error-box {\n  width: 100%;\n  height: 53px;\n  top: 615px;\n  left: 126px;\n  border-width: 1px;\n  border-radius: 6px;\n  border: 1px solid #C13934;\n  background: #FCF8F7;\n  padding: 15px 0 15px 0;\n  span {\n    font-family: Inter;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 145%;\n    padding: 15px  24px 15px 16px;\n    color: #610805;\n  }\n  img {\n    padding-left: 22px;\n  }\n}",".Layout {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  .content {\n    width: 100%;\n  }\n  .BarLogin {\n    padding: 16px;\n    background-color: #eff3f5;\n    width: 64px;\n    height: 100vh;\n    border-right: 1px solid #dfe4eb;\n    .logo {\n      width: 32px;\n    }\n  }\n}\n",".BarDashboard-space {\n  width: 64px;\n  height: calc(100vh - 56px);\n}\n\n.BarDashboard {\n  padding: 0px 0px;\n  background-color: #eff3f5;\n  width: 64px;\n  height: calc(100vh - 56px);\n  border-right: 1px solid #dfe4eb;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  position: fixed;\n  top: 56px;\n  left: 0;\n\n  .box {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    height: 33%;\n\n    .notification {\n      position: relative;\n      max-width: 30px;\n      margin-top: 20px;\n\n      .number-ammoint {\n        position: absolute;\n        width: 15.467px;\n        height: 15.469px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: #355c7d;\n        right: -3px;\n        top: -5px;\n        border-radius: 50%;\n\n        span {\n          color: #f9fafb;\n          text-align: center;\n          font-family: Inter;\n          font-size: 10px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 10px;\n        }\n      }\n    }\n\n    .link {\n      width: 100%;\n      text-decoration: none;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n\n      span {\n        color: #929fb0;\n        font-size: 10px;\n        font-weight: 500;\n        line-height: 115%;\n      }\n\n      .avatar {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n\n        span {\n          font-size: 12px;\n          font-weight: 500;\n        }\n\n        &-blue {\n          background-color: #B6DCFC;\n          border-color: #7FADD4;\n\n          span {\n            color: #244560;\n          }\n\n          &:hover {\n            background-color: #97BCF0;\n            border-color: #5E8EB7;\n\n            span {\n              color: #122536;\n            }\n          }\n        }\n\n        &-yellow {\n          background-color: #FFC857;\n          border-color: #DDAA42;\n\n          span {\n            color: #2B1F05;\n          }\n\n          &:hover {\n            background-color: #DDAA42;\n            border-color: #BB8D2F;\n          }\n        }\n\n        &-purple {\n          background-color: #D7B8E5;\n          border-color: #C59ED5;\n\n          span {\n            color: #241226;\n          }\n\n          &:hover {\n            background-color: #C59ED5;\n            border-color: #A278B3;\n          }\n        }\n      }\n    }\n\n    &-medium {\n      justify-content: center;\n      align-items: center;\n    }\n\n    &-end {\n      justify-content: flex-end;\n      align-items: center;\n    }\n\n    .menu-item {\n      width: 100%;\n    }\n\n    .link {\n      height: 63px;\n      border-radius: 10px;\n      outline: none;\n\n      &-with-hover {\n        &:hover {\n          background: #D0E8FD;\n\n          .award,\n          .brief,\n          .icon-logout {\n            background-color: #355C7D;\n          }\n\n          span {\n            color: #355C7D !important;\n          }\n        }\n      }\n    }\n  }\n\n  .award {\n    width: 24px;\n    height: 24px;\n    background-color: #929FB0;\n    -webkit-mask: url(../../../../../assets/images/award.svg) no-repeat center / contain;\n    mask: url(../../../../../assets/images/award.svg) no-repeat center / contain;\n  }\n\n  .brief {\n    width: 24px;\n    height: 24px;\n    background-color: #929FB0;\n    -webkit-mask: url(../../../../../assets/images/briefcase.svg) no-repeat center / contain;\n    mask: url(../../../../../assets/images/briefcase.svg) no-repeat center / contain;\n  }\n\n  .icon-logout {\n    width: 24px;\n    height: 24px;\n    background-color: #929FB0;\n    -webkit-mask: url(../../../../../assets/images/logout.svg) no-repeat center / contain;\n    mask: url(../../../../../assets/images/logout.svg) no-repeat center / contain;\n  }\n\n  .link-active {\n    background: #D0E8FD;\n\n    .award,\n    .brief, \n    .icon-logout {\n      background-color: #355C7D;\n    }\n\n    span {\n      color: #355C7D !important;\n    }\n  }\n}",".right-scenes {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 70px;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &-content {\n    position: relative;\n    width: calc(100% - 70px); /* Ancho de la pantalla menos 70px */\n    background-color: #fff;\n    height: 100%;\n    animation: slideIn 1s forwards;\n  }\n\n  @keyframes slideIn {\n    from {\n      transform: translateX(calc(-100% + 70px));\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  .button-close-mask {\n    width: 30%;\n    height: 100%;\n    background-color: rgba(255, 0, 0, 0);\n    box-shadow: none;\n    border: none;\n\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: rgba(255, 0, 0, 0) !important;\n      box-shadow: none;\n      border: none;\n    }\n  }\n}\n",".Header {\n  height: 56px;\n  padding: 0 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f9fafb;\n  border-bottom: 1px solid #dfe4eb;\n  .box {\n    .logo {\n      height: 36px;\n      width: auto;\n    }\n    .logo-c {\n      height: 32px;\n      width: 32px;\n    }\n  }\n\n  .logo-const {\n    height: 32px;\n    width: auto;\n  }\n}\n",".HeaderHome {\n  left: 0;\n  top: 0;\n  position: fixed;\n  z-index: 200;\n  width: 100%;\n  .content {\n    height: 56px;\n    padding: 0 32px;\n    \n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #f9fafb;\n    border-bottom: 1px solid #dfe4eb;\n    gap: 8px;\n    .logo {\n      height: 32px;\n    }\n    .logo-c {\n      height: 32px;\n      width: 32px;\n    }\n\n    .box {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      gap: 8px;\n      .logo {\n        height: 32px;\n      }\n      .logo-c {\n        height: 32px;\n        width: 32px;\n      }\n    }\n  }\n}\n.HeaderHome-space {\n  height: 56px;\n  &.processing {\n    height: 97px;\n  }\n  width: 100%;\n  button {\n    border-radius: 6px;\n  }\n}\n",".CardProfile {\n  width: 276px;\n  height: 85px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #f9fafb;\n  position: relative;\n  .link {\n    position: absolute;\n    right: 12px;\n    top: 8px;\n  }\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 12px;\n    padding-top: 0;\n    .avatar {\n      width: 24px;\n      height: 24px;\n      border-radius: 100%;\n      margin-top: -5px;\n      margin-bottom: 4px;\n    }\n    .link {\n      color: #5e8eb7;\n      text-align: right;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n    .text {\n      color: $grey-text-op;\n      text-align: center;\n      font-family: Inter;\n      font-style: normal;\n      font-size: 12px;\n      font-weight: 400;\n      line-height: normal;\n      margin-bottom: 2px;\n      &-bold {\n        color: $black-text;\n        font-size: 15px;\n        font-weight: 600;\n        margin-bottom: 6px;\n      }\n      &-small {\n        text-transform: none;\n        text-decoration: none;\n        color: $grey-title;\n        margin-bottom: 0px;\n      }\n    }\n    &--bottom {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n    }\n\n    .tooltip-button-loan-officer {\n      background: #355C7D; \n      opacity: 1;\n      font-family: Inter;\n      line-height: 100%;\n      letter-spacing: 0px;\n      .loan-officer {\n        font-weight: 400;\n        font-size: 8px;\n        color: #B7DDFD;\n      }\n      p {\n        font-weight: 600;\n        font-size: 12px;\n        color: #F5FAFF;\n      }\n    }\n  }\n}\n",".SectionError {\n  border-radius: 10px;\n  border: 1px solid #c94f4a;\n  padding: 12px 15px;\n  background-color: #FCF8F7;\n  \n  .flex-end {\n    button {\n      height: 30px;\n    }\n  }\n\n  .description{\n    overflow: hidden;\n\n    .body-regular {\n      color: #2A2F3C;\n      display: -webkit-box; /* Utiliza el modelo de caja flexible de tipo webkit */\n      -webkit-box-orient: vertical; /* Orientación vertical */\n      -webkit-line-clamp: 2; /* Número máximo de líneas */\n      overflow: hidden; /* Oculta el contenido que sobresale */  \n    }\n  }\n\n  .flex-btw {\n    margin-bottom: 5px;\n  }\n  \n  .body-regular-title {\n    color: #8F2F2C;\n  }\n  .button {\n    color: #712220;\n    text-align: right;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n    .anticon {\n      color: #712220;\n      margin-top: 2px;\n    }\n\n    span {\n      color: #712220; \n    }\n\n    &:hover { \n      border: none; \n    }\n  }\n}\n",".SectionSuccessTask {\n    border-radius: 10px;\n    border: 1px solid #4CA852;\n    padding: 12px 15px;\n    background-color: #FAFCFA;\n\n    .flex-btw {\n        margin-bottom: 0px !important;\n    }\n\n    .body-regular {\n        color: #2A2F3C;\n    }\n\n    .body-regular-title {\n        color: #466849;\n        font-size: 16px;\n    }\n\n    .button {\n        color: #466849;\n        text-align: right;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 140%;\n\n        .anticon {\n            color: #466849;\n            margin-top: 2px;\n        }\n\n        span {\n            color: #466849;\n        }\n\n        &:hover {\n            border: none;\n        }\n    }\n}",".collapse-issues {\n\n  background-color: white;\n  width: 85%;\n  max-width: 640px;\n\n  &-absolute {\n    position: absolute;\n    bottom: 0;\n  }\n\n  &-fixed {\n    position: fixed;\n  }\n\n  .ant-collapse {\n    overflow-x: hidden;\n    \n    &-close {\n      overflow-y: hidden;\n    }\n\n    &-open {\n      .ant-collapse-content-box {\n        padding: 0 16px 0 0;\n      }\n\n      .ant-collapse-header {\n        padding: 15px 0 0 0;\n      }\n    }\n\n    .ant-collapse-header {\n      padding: 15px 0 10px 0;\n    }\n\n    .ant-collapse-header-text {\n      font-weight: 600;\n    }\n\n    &::-webkit-scrollbar {\n      width: 8px;\n      border-radius: 5px;\n    }\n\n    /* Track */\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n    }\n\n    /* Handle */\n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 5px;\n    }\n\n    /* Handle on hover */\n    &::-webkit-scrollbar-thumb:hover {\n      background: #555;\n    }\n  }\n\n  .ant-collapse-expand-icon {\n    gap: 5px;\n  }\n\n  .card-issues {\n    border-radius: 6px;\n    border: 1px solid #929FB0;\n    padding: 12px 15px;\n    background-color: #FFFFFF;\n    height: auto;\n    margin-top: 15px;\n    min-width: 565px;\n\n    .description {\n      height: 40px;\n      overflow: hidden;\n\n      .body-regular {\n        color: #2A2F3C;\n        display: -webkit-box;\n        /* Utiliza el modelo de caja flexible de tipo webkit */\n        -webkit-box-orient: vertical;\n        /* Orientación vertical */\n        -webkit-line-clamp: 2;\n        /* Número máximo de líneas */\n        overflow: hidden;\n        /* Oculta el contenido que sobresale */\n      }\n    }\n\n    .flex-btw {\n      margin-bottom: 5px;\n    }\n\n    .body-regular-title {\n      color: #404859;\n    }\n\n    button {\n      color: #404859;\n      font-size: 14px;\n\n      :hover {\n        color: #404859;\n      }\n    }\n  }\n}",".add-another-doc {\n\n  margin-top: 10px;\n\n  .button-link-blue {\n    padding: 0;\n\n    span {\n      font-weight: 500;\n      display: flex;\n      text-decoration: none;\n    }\n\n    &:disabled {\n      color: rgba(0, 0, 0, 0.25) !important;\n    }\n  }\n\n  .card-create-doc {\n    position: relative;\n    border-radius: 10px;\n    border: 1px solid #929FB0;\n    padding: 10px 16px 0px; \n\n    .form {\n      &-doc-name {\n        input {\n          font-size: 16px !important;\n          font-weight: 400 !important;\n          color: black !important;\n        }\n        \n        &::placeholder {\n          font-size: 16px !important;\n          font-weight: 400 !important;\n        }\n      }\n  \n      &-doc-description {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        font-style: italic !important;\n        color: black !important;\n        \n        &::placeholder {\n          font-size: 14px !important;\n          font-weight: 400 !important;\n          font-style: italic !important;\n        }\n      }\n  \n      .doc-info {\n        .ant-form-item {\n          margin-bottom: 0;\n        }\n        .ant-form-item-control-input {\n          min-height: 25px;\n        }\n      }\n  \n      .placeholder {\n        margin-top: 20px;\n        font-style: italic;\n      }\n    }\n  }\n}",".progress {\n  display: flex;\n  gap: 5px;\n  margin-top: 5px;\n\n  .bar {\n    width: 100%;\n    background-color: #dfe4eb;\n    height: 8px;\n    border-radius: 8px;\n    display: flex;\n    :first-child{\n      border-bottom-left-radius: 8px;\n      border-top-left-radius: 8px;\n    }\n    :last-child{ \n      border-bottom-right-radius: 8px;\n      border-top-right-radius: 8px;\n    }\n    &-percentage {\n      height: 8px;\n\n      &-success {\n        background: $state-approved-border-dark;\n      }\n\n      &-error {\n        background: $state-error-dark;\n      }\n\n      &-progress {\n        background: $state-tag-incomplete;\n      }\n\n      &-review {\n        background: $state-review;\n      }\n    }\n  }\n}",".LoanProgress {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n\n  .tab {\n    margin: 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .popover-label {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n    }\n\n    .bar-status {\n      cursor: pointer;\n      width: 100%;\n      width: calc(100% + 20px);\n      height: 8px;\n      border-radius: 16px;\n      margin-top: 6px;\n      background-color: $white-button-tab;\n    }\n\n    &-complete {\n      .text-status {\n        color: #141F15;\n      }\n\n      .body-small {\n        color: #2D7032;\n      }\n\n      .bar-status {\n        background-color: #4CA852;\n\n        &-selected {\n          background-color: #2D7032;\n\n          &:hover {\n            background-color: #2D7032 !important;\n          }\n        }\n\n        &:hover {\n          background-color: #3F9545;\n\n          .body-small {\n            color: #2D7032;\n          }\n        }\n      }\n    }\n\n    &-blocked {\n      .body-small {\n        color: #8A130F;\n      }\n\n      .text-status {\n        color: #610805;\n      }\n\n      .bar-status {\n        background-color: #C13934;\n\n        &-selected {\n          background-color: #8A130F;\n\n          &:hover {\n            background-color: #8A130F !important;\n          }\n        }\n\n        &:hover {\n          background-color: #A31C17;\n\n          .body-small {\n            color: #8A130F;\n          }\n        }\n      }\n    }\n\n    &-error {\n      .body-small {\n        color: #8A130F;\n      }\n\n      .text-status {\n        color: #610805;\n      }\n\n      .bar-status {\n        background-color: #FFDAD6;\n\n        &-selected {\n          background-color: #8A130F;\n\n          &:hover {\n            background-color: #8A130F !important;\n          }\n        }\n\n        &:hover {\n          background-color: #C13934;\n\n          .body-small {\n            color: #8A130F;\n          }\n        }\n      }\n    }\n\n    &-progress {\n\n      .text-status {\n        color: #122536;\n      }\n\n      .body-small {\n        color: #404859;\n      }\n\n      .bar-status {\n        background-color: #5E8EB7;\n\n        &-selected {\n          background-color: #355C7D;\n\n          &:hover {\n            background-color: #355C7D !important;\n          }\n        }\n\n        &:hover {\n          background-color: #48759A;\n\n          .body-small {\n            color: #404859;\n          }\n        }\n      }\n    }\n\n    &-not-started {\n      .bar-status {\n        background-color: white;\n        border: 1px solid #404859;\n\n        &-selected {\n          background-color: #404859;\n\n          &:hover {\n            background-color: #404859 !important;\n          }\n        }\n\n        &:hover {\n          background-color: #929FB0;\n        }\n      }\n    }\n\n    &-open-content {\n      position: absolute;\n      border: 1px solid #929FB0;\n      box-shadow: 2px 2px 10px 0px #0000001A;\n      height: auto;\n      min-height: 253px;\n      width: 825px;\n      background: white;\n      top: 150px;\n      border-radius: 10px;\n      z-index: 99;\n\n      .content {\n        &-bar-status {\n          width: 823px;\n          height: 68px;\n          background: white;\n          border-radius: 10px;\n          display: flex;\n          justify-content: flex-start;\n          align-items: start;\n          gap: 8px;\n          padding-left: 8px;\n          padding-top: 3px;\n\n          .tab {\n            .body-small {\n              font-size: 12px !important;\n            }\n\n            &-error {\n              span {\n                color: #610805;\n              }\n            }\n          }\n\n          .bar-status {\n            width: -webkit-fill-available;\n            height: 16px;\n            border-radius: 16px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            .text-status {\n              display: flex;\n              align-items: center;\n              gap: 3px;\n\n              span {\n                font-family: Inter;\n                font-size: 10px;\n                font-weight: 600;\n              }\n            }\n\n\n            &:hover {\n              span {\n                display: none;\n              }\n\n              .text-status {\n                display: none;\n              }\n            }\n          }\n\n          .tab {\n            margin: 0 0;\n          }\n\n          .tab:nth-child(1) {\n            width: 10%;\n          }\n\n          .tab:nth-child(2) {\n            width: 22%;\n          }\n\n          .tab:nth-child(3) {\n            width: 38%;\n          }\n\n          .tab:nth-child(4) {\n            width: 14%;\n          }\n\n          .tab:nth-child(5) {\n            width: 11%;\n          }\n        }\n\n        &-phase-select {\n          width: 823px;\n          height: auto;\n          min-height: 183px;\n          border-radius: 10px;\n          background: #F9FAFB;\n          border-top: 1px solid #DFE4EB;\n\n          &-complete {\n            background: #F8FFF8;\n            border-top: 1px solid #C2F0C5;\n\n            .tag-state {\n              background: #C2F0C5;\n\n              b,\n              span {\n                color: #141F15;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #1F4222;\n              }\n\n              p {\n                color: #1F4222 !important;\n              }\n\n              &-first {\n                b {\n                  color: #2D7032;\n                }\n              }\n\n            }\n          }\n\n          &-blocked {\n            background: #FCF8F7;\n            border-top: 1px solid #FFC6BF;\n\n            .tag-state {\n              background: #FFD4CF;\n\n              b,\n              span {\n                color: #610805;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #610805;\n                }\n              }\n            }\n          }\n\n          &-error {\n            background: #FCF8F7;\n            border-top: 1px solid #FFC6BF;\n\n            .tag-state {\n              background: #FFD4CF;\n\n              b,\n              span {\n                color: #610805;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #610805;\n                }\n              }\n            }\n          }\n\n          &-progress {\n            background: #F5FAFF;\n            border-top: 1px solid #B6DCFC;\n\n            .tag-state {\n              background: #B6DCFC;\n\n              b,\n              span {\n                color: #122536;\n              }\n            }\n\n            .content-phase {\n              b {\n                color: #2A2F3C;\n              }\n\n              &-first {\n                b {\n                  color: #244560;\n                }\n              }\n            }\n          }\n\n          &-not-started {\n            .tag-state {\n              border: 1px solid #404859;\n            }\n          }\n\n          .tag-state {\n            height: 16px;\n            width: max-content;\n            display: flex;\n            align-items: center;\n            gap: 3.5px;\n            border-radius: 10px;\n            padding: 3px 7px;\n            margin: 16px 23px;\n\n            b {\n              font-size: 10px;\n              font-weight: 600;\n            }\n\n            span {\n              font-size: 10px;\n              font-weight: 400;\n            }\n          }\n\n          .divider {\n            border: 0.7px solid #929FB0;\n            height: auto;\n          }\n\n          .content-phase {\n            margin: 0px 24px;\n            padding-bottom: 23px;\n\n            b {\n              font-size: 12px;\n              font-weight: 600;\n            }\n\n            p {\n              font-size: 12px;\n              font-weight: 400;\n              color: #2A2F3C;\n              margin-top: 6px;\n            }\n\n            &-first {\n              width: 270px;\n\n              b {\n                font-size: 16px;\n                font-weight: 600;\n              }\n            }\n\n            &-second {\n              width: 240px;\n              margin-left: 20px;\n            }\n\n            .task-item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              margin-top: 4px;\n              width: max-content;\n              border-radius: 4px;\n              padding: 2px 3px;\n\n              span {\n                font-family: Inter;\n                font-size: 12px;\n              }\n\n              b {\n                font-family: Inter;\n                font-weight: 500;\n              }\n\n              .bold {\n                font-weight: 600 !important;\n              }\n\n              .circle {\n                width: 12px;\n                height: 12px;\n                border: 1px solid #6E7889;\n                border-radius: 50%;\n              }\n\n              &-APPROVED {\n                background-color: #D5F7E2;\n\n                span,\n                b,\n                strong {\n                  color: #2D7032;\n                }\n              }\n\n              &-REQUEST_ERROR,\n              &-BLOCKED {\n                background: #FFC6BF;\n\n                span,\n                b,\n                strong {\n                  color: #610805;\n                }\n              }\n\n              &-REVIEW {\n                background: #F7EDFC;\n\n                span,\n                b,\n                strong  {\n                  color: #855791;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}",".TaskProgress {\n  .bar {\n    width: 100%;\n    background-color: #dfe4eb;\n    height: 8px;\n    border-radius: 8px;\n    display: flex;\n    :first-child{\n      border-bottom-left-radius: 8px;\n      border-top-left-radius: 8px;\n    }\n    :last-child{ \n      border-bottom-right-radius: 8px;\n      border-top-right-radius: 8px;\n    }\n    &-percentage {\n      height: 8px;\n    }\n  }\n  .h4 {\n    color: #404859 !important;\n    text-transform: none;\n  }\n}\n",".MinimumProgressVertical {\n\n  margin-top: 24px;\n  height: 90%;\n\n  .content-bar {\n    display: flex;\n    align-items: start;\n    gap: 16px;\n    height: 90%;\n\n    .bar {\n      width: 16px; // Ancho de la barra vertical\n      height: 100%; // Altura completa\n      background-color: #dfe4eb;\n      border-radius: 8px;\n      display: flex;\n      flex-direction: column-reverse;\n      position: relative;\n\n      &-percentage {\n        height: auto;\n        width: 16px;\n        position: relative;\n        padding-top: 10px;\n\n        &:not(:first-child) {}\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: -5px;\n          width: 100%;\n          height: 8px;\n          background-color: inherit;\n          border-top-left-radius: 10px;\n          border-top-right-radius: 10px;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: -8px;\n          width: 100%;\n          height: 8px;\n          background-color: inherit;\n          border-bottom-right-radius: 10px;\n          border-bottom-left-radius: 10px;\n        }\n      }\n    }\n  }\n\n  .h4 {\n    color: #404859 !important;\n    text-transform: none;\n  }\n\n  .label-price {\n    width: 150px;\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n    gap: 4px;\n\n    &-draft {\n      position: absolute;\n      bottom: 20px;\n    }\n\n    &-reject {\n      position: absolute;\n      bottom: 20px;\n\n      span {\n        color: #8A130F !important;\n      }\n    }\n\n    &-approved {\n      position: absolute;\n      bottom: 20px;\n\n      span {\n        color: #2D7032 !important;\n      }\n    }\n\n    &-review {\n      position: absolute;\n      bottom: 20px;\n\n      span {\n        color: #855791 !important;\n      }\n    }\n\n    .label {\n      font-family: Inter;\n      font-weight: 500;\n      font-size: 16px;\n      color: #2A2F3C;\n\n      &-remaining {\n        font-weight: 400;\n        color: #404859;\n      }\n\n      &-rejected {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 20px;\n        letter-spacing: 0%;\n        color: #8A130F;\n      }\n    }\n\n    .price {\n      font-weight: 600 !important;\n      font-style: normal !important;\n      line-height: 100% !important;\n      letter-spacing: 0;\n      color: #2A2F3C !important;\n\n      &-remaining {\n        font-weight: 400 !important;\n        color: #404859 !important;\n      }\n    }\n  }\n}",".ButtonTabsFilters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  .tab {\n    border-radius: 100px;\n    background: $white-button-tab;\n    color: $grey-title;\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px;\n    border: none;\n    box-shadow: none;\n    height: 24px;\n    .number {\n      font-weight: 400;\n      margin-left: 3px;\n    }\n    &:hover {\n      background: #5E8EB7 !important;\n      color: white !important;\n    }\n    &-active {\n      background-color: $blue-button-tab;\n      color: $white;\n      &:hover {\n        background-color: $blue-button-tab !important;\n        color: $white !important;\n      }\n    }\n  }\n  .disabled {\n    pointer-events: none;\n  }\n}\n",".CardLoanTasks {\n  width: 396px;\n  height: 220px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid #6e7889;\n  background: #fdfeff;\n  padding: 12px 20px;\n  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: margin 300ms;\n\n  &-isHighlight {\n    margin-top: -10px;\n    border: 1px solid #e67f73 !important;\n    box-shadow: 2px 2px 16px 0px #2603001f;\n  }\n\n  .state-tooltip {\n    display: flex;\n  }\n\n  .circle-state-tooltip {\n    padding: 6px 7px;\n    opacity: 1;\n\n    b {\n      font-weight: 600;\n    }\n\n    span {\n      margin-top: 10px;\n    }\n\n    &-APPROVED {\n      background-color: $state-approved-border-dark;\n    }\n\n    &-DRAFT {\n      background-color: $state-draft-hover;\n    }\n\n    &-REQUEST_ERROR {\n      background-color: $state-error-border;\n    }\n\n    &-REVIEW {\n      background-color: $state-review-label;\n    }\n  }\n\n  .docs-section {\n    margin-top: 15px;\n\n    .labels {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .circles-tags {\n      display: flex;\n      align-items: end;\n      gap: 20px;\n      margin-top: 5px;\n    }\n\n    .circle {\n      width: 20px;\n      height: 20px;\n      background-image: url('../../../../assets/images/file.svg');\n      background-repeat: no-repeat;\n      background-position: center;\n\n      &:hover {\n        background-image: url('../../../../assets/images/file-white.svg');\n        background-repeat: no-repeat;\n        background-position: center;\n      }\n\n      &-APPROVED {\n        // border-color: $state-approved-border;\n        border: 1px solid #3F9545;\n        background-color: $state-approved-background;\n        background-image: url('../../../../assets/images/file-approved.svg');\n        background-repeat: no-repeat;\n        background-position: center;\n\n        &:hover {\n          // background-color: $state-approved-border-dark;\n          background-color: #3F9545;\n          border: 1px solid #3F9545;\n        }\n      }\n\n      &-REVIEW {\n        background-color: #E0CCE3 !important;\n        border: 1px solid #8A5791;\n        background-image: url('../../../../assets/images/file-review.svg');\n        background-repeat: no-repeat;\n        background-position: center;\n\n        &:hover {\n          background-color: $state-review-label !important;\n          border: 1px solid $state-review-label;\n        }\n      }\n\n      &-REQUEST_ERROR {\n        // background-color: $state-error-background;\n        // border-color: $state-error-border;\n        background-color: #FFC6BF;\n        border: 1px solid #8A130F;\n        background-image: url('../../../../assets/images/file-error.svg');\n        background-repeat: no-repeat;\n        background-position: center;\n\n        &:hover {\n          // background-color: $state-error-border;\n          background-color: #A31C17;\n          border: 1px solid #A31C17;\n        }\n      }\n\n      &-INCOMPLETE {\n        // background-color: $state-incomplete-circle-background;\n        // border: 1px solid $state-incomplete-circle-border;\n        background-color: #B6DCFC;\n        border: 1px solid #48759A;\n        background-image: url('../../../../assets/images/file-incomplete.svg');\n        background-repeat: no-repeat;\n        background-position: center;\n\n        &:hover {\n          background-color: $state-incomplete-hover;\n          border: 1px solid $state-incomplete-hover;\n        }\n      }\n\n      &-DRAFT {\n        &:hover {\n          background-color: $state-draft-hover;\n        }\n      }\n    }\n  }\n\n  .state-name {\n    color: $grey-title;\n    font-family: Inter;\n    font-size: 12px !important;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    &-w6 {\n      font-weight: 600;\n    }\n  }\n\n  .withBorder {\n    width: 100%;\n    border-radius: 4px;\n    border: 1px solid #ccd3db;\n    background: #fff;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .withOutBorder {\n    width: 100%;\n    border-radius: 4px;\n    border: none;\n    background: none;\n    box-shadow: none;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .message-state-error {\n    margin-top: 8px;\n    border-radius: 6px;\n    padding: 7px 8px;\n    background-color: $state-error;\n    color: $state-error-text-dark;\n    border: 1px solid $state-error-background;\n    font-size: 12px;\n  }\n\n  .message-state-success {\n    margin-top: 8px;\n    border-radius: 6px;\n    padding: 7px 8px;\n    background-color: $state-approved;\n    color: $state-approved-text-dark;\n    border: 1px solid $state-approved-border;\n    font-size: 12px;\n  }\n\n  .box-message-state {\n    &-review {\n      margin-top: 8px;\n      padding: 7px 8px;\n      font-size: 12px;\n      background-color: $state-review-background-ligth;\n      color: $state-review-label;\n      border: 1px solid $state-review-border-2;\n    }\n\n    &-approved {\n      margin-top: 8px;\n      padding: 7px 8px;\n      font-size: 12px;\n      color: $state-approved-icon;\n      border: 1px solid $state-approved-border;\n    }\n  }\n\n  .body-card-bold-line {\n    text-decoration-line: unset;\n\n    &-REVIEW {\n      background-color: $state-review-background;\n      color: $state-review-text-dark;\n    }\n\n    &-APPROVED {\n      color: black;\n      background-color: $state-approved-background;\n    }\n\n    &-REQUEST_ERROR {\n      background-color: $state-error-background;\n    }\n  }\n\n  &__top {\n    &__head {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 5px;\n\n      .flex-end {\n        display: flex;\n        justify-content: flex-end;\n        gap: 4px;\n        align-items: center;\n        \n        .body-small {\n          font-size: 12px !important;\n        }\n\n        .circle {\n          width: 20px;\n          height: 20px;\n\n          &:hover {\n            background-color: $state-draft-hover;\n          }\n\n          &-complete {\n            background: #C2F0C5;\n            border: 1px solid #4CA852;\n\n            &:hover {\n              background: #4CA852;\n            }\n          }\n\n          &-incomplete {\n            background: $state-incomplete-circle-background;\n            border: 1px solid $state-incomplete-circle-border;\n\n            &:hover {\n              background: $state-incomplete-hover;\n              border: 1px solid $state-incomplete-hover;\n            }\n          }\n\n          &-error {\n            background: #FFC6BF;\n            border: 1px solid #c94f4a;\n\n            &:hover {\n              background: #c94f4a;\n            }\n          }\n\n          &-review {\n            background: #E9D6FF;\n            border: 1px solid #ac78b3;\n\n            &:hover {\n              background: #ac78b3;\n            }\n          }\n        }\n\n        .svg-grid {\n          height: 12px;\n          width: 12px;\n          fill: none;\n        }\n\n        .quick-task {\n          path {\n            stroke: #6e7889;\n\n            &:first-child {\n              fill: #6e7889;\n            }\n          }\n        }\n\n        .major-task {\n          path {\n            stroke: #6e7889;\n            fill: #6e7889;\n          }\n        }\n      }\n\n      .card-state-tooltip {\n        padding: 6px 7px !important;\n        opacity: 1 !important;\n        background-color: $state-draft-hover;\n\n        b {\n          font-family: Inter;\n          font-style: normal;\n          font-weight: 800;\n        }\n\n        span {\n          font-weight: 600;\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n        }\n\n        &-complete {\n          background-color: $state-approved-border-dark;\n        }\n\n        &-error {\n          background-color: $state-error-border !important;\n        }\n\n        &-review {\n          background-color: $state-review-label;\n        }\n\n        &-incomplete {\n          background-color: $state-incomplete-hover;\n        }\n      }\n    }\n\n    .h4 {\n      margin-bottom: 6px;\n      font-size: 18px !important;\n    }\n\n    .text {\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n\n      .body-card {\n        font-size: 14px !important;\n      }\n    }\n\n    .body-card-full {\n      margin: 0 5px;\n      font-weight: 700;\n      border-radius: 2px;\n    }\n  }\n\n  .TaskProgress {\n    margin-top: 10px;\n  }\n\n  &__bottom {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    .body-small-up {\n      color: #587e5b;\n      margin-bottom: 8px;\n    }\n\n    .flex-betwen {\n      .body-card {\n        color: #587e5b;\n      }\n    }\n  }\n\n  &-buttons-actions {\n    display: flex;\n    justify-content: space-between;\n    \n    .button-open-modal span {\n      font-size: 14px !important;\n    }\n  }\n\n  &-APPROVED {\n    border-color: #6eac72;\n\n    .state {\n      border-radius: 76px;\n      background: #c5f0c8;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .check {\n        margin-right: 2px;\n      }\n\n      .state-name {\n        color: #355137;\n      }\n    }\n\n    .body-card-full {\n      background-color: #c5f0c8;\n      color: #466849;\n    }\n\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: #6eac72;\n\n          &:first-child {\n            fill: #6eac72;\n          }\n        }\n      }\n\n      .major-task {\n        path {\n          stroke: #6eac72;\n          fill: #6eac72;\n        }\n      }\n\n      .state-name {\n        color: #6eac72;\n      }\n    }\n\n    .button-card {\n      border: 1px solid #6eac72;\n      background: #fafcfc;\n      color: #466849;\n      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.02);\n    }\n  }\n\n  &-REVIEW {\n    border-color: #ac78b3;\n    background: $state-review-background-ligth;\n\n    .h4 {\n      color: #241226;\n    }\n\n    .body-card-full {\n      color: #48244d;\n      background: #e3ddf0;\n    }\n\n    .body-card--green {\n      background-color: #e3ddf0;\n    }\n\n    .state-name {\n      color: #8a5791;\n    }\n\n    .body-small-up {\n      color: #8a5791;\n    }\n\n    .CardLoanTasks__top__head .flex-end .major-task path {\n      stroke: #ac78b3;\n      fill: #ac78b3;\n    }\n\n    .state {\n      border-radius: 76px;\n      background: #EAD6FF;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      .state-name {\n        color: #48244d;\n      }\n    }\n\n    .body-card {\n      color: black;\n    }\n\n    .button-card {\n      color: #693b6f;\n      border-radius: 4px;\n      border: 1px solid #ac78b3;\n      background: #fdfcff;\n      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);\n    }\n\n    .docs-section {\n      .labels {\n        p {\n          color: #653B6F;\n        }\n      }\n    }\n\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: $state-review-label;\n\n          &:first-child {\n            fill: $state-review-label;\n          }\n        }\n      }\n\n      .major-task {\n        path {\n          stroke: $state-review-label;\n          fill: $state-review-label;\n        }\n      }\n\n      .state-name {\n        color: $state-review-label;\n      }\n    }\n  }\n\n  &-AWAITING_ACTION {\n    border-color: #ac78b3;\n    background: $state-review-background-ligth;\n\n    .body-card-full {\n      color: #48244d;\n      background: #e3ddf0;\n    }\n\n    .body-card--green {\n      background-color: #e3ddf0;\n    }\n\n    .state-name {\n      color: #8a5791;\n    }\n\n    .body-small-up {\n      color: #8a5791;\n    }\n\n    .CardLoanTasks__top__head .flex-end .major-task path {\n      stroke: #ac78b3;\n      fill: #ac78b3;\n    }\n\n    .state {\n      border-radius: 76px;\n      background: #e3ddf0;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      .state-name {\n        color: #48244d;\n      }\n    }\n\n    .body-card {\n      color: black;\n    }\n\n    .button-card {\n      color: #693b6f;\n      border-radius: 4px;\n      border: 1px solid #ac78b3;\n      background: #fdfcff;\n      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.03);\n    }\n\n    .docs-section {\n      .labels {\n        p {\n          color: #653B6F;\n        }\n      }\n    }\n\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: $state-review-label;\n\n          &:first-child {\n            fill: $state-review-label;\n          }\n        }\n      }\n\n      .major-task {\n        path {\n          stroke: $state-review-label;\n          fill: $state-review-label;\n        }\n      }\n\n      .state-name {\n        color: $state-review-label;\n      }\n    }\n  }\n\n  &-INCOMPLETE {\n    border-color: #929fb0;\n    background-color: $state-card-background;\n\n    .circle-REVIEW {\n      background-color: $state-incomplete-circle-background !important;\n      border-color: #AC78B3 !important;\n\n      &:hover {\n        background-color: $state-incomplete-hover !important;\n        border-color: #AC78B3 !important;\n      }\n    }\n\n    .circle-state-tooltip-REVIEW {\n      background-color: #AC78B3 !important;\n    }\n\n    .state {\n      border-radius: 76px;\n      background: $state-tag-incomplete;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      .state-name {\n        color: $state-incomplete-text;\n      }\n    }\n\n    .h4 {\n      color: $state-incomplete-text-3;\n    }\n\n    .body-small-up {\n      color: $state-incomplete-text-2;\n    }\n\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: $state-incomplete-text-2;\n\n          &:first-child {\n            fill: $state-incomplete-text-2;\n          }\n        }\n      }\n\n      .major-task {\n        path {\n          stroke: $state-incomplete-text-2;\n          fill: $state-incomplete-text-2;\n        }\n      }\n\n      .state-name {\n        color: $state-review-label;\n      }\n    }\n  }\n\n  &-COMING_SOON {\n    .state {\n      border: 1px solid $grey-text-op;\n      border-radius: 76px;\n      background: white;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n    }\n  }\n\n  &-NEW_TASK {\n    .state {\n      .state-name {\n        color: #8f2f2c;\n      }\n\n      border: 1px solid #8f2f2c;\n      border-radius: 76px;\n      background: white;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border-color: #c94f4a;\n\n    .body-card-w5 {\n      color: #ac3e3a;\n    }\n\n    .state {\n      border-radius: 76px;\n      background: #ffd4cf;\n      padding: 4px 8px 4px 7px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      .state-name {\n        color: #712220;\n      }\n    }\n\n    .button-open-modal {\n      border-color: $state-error-border;\n    }\n\n    .body-small-up {\n      color: #712220;\n    }\n\n    .body-card {\n      color: black;\n\n      &-text-2 {\n        color: #ac3e3a;\n      }\n\n      &-text-2 {\n        color: #ac3e3a;\n      }\n    }\n\n    .button-card {\n      border-color: #c94f4a;\n    }\n\n    .flex-betwen {\n\n      .button,\n      .button-link {\n        color: #712220;\n      }\n    }\n\n    .flex-end {\n      .svg-grid {\n        path {\n          stroke: #c94f4a;\n\n          &:first-child {\n            fill: #c94f4a;\n          }\n        }\n      }\n\n      .major-task {\n        path {\n          stroke: #c94f4a;\n          fill: #c94f4a;\n        }\n      }\n\n      .state-name {\n        color: #c94f4a;\n      }\n    }\n  }\n\n  &-beginTask {\n    .ModalCardState {\n      width: 100% !important;\n    }\n  }\n}",".InputAmount {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 13px 16px;\n  .h4 {\n    color: #404859;\n  }\n  .button-operation {\n    padding: 0;\n    height: 23px;\n    border: 0;\n    background: none;\n    box-shadow: none;\n    .anticon {\n      color: #5e8eb7;\n      &-full {\n        display: none;\n      }\n    }\n    &:hover {\n      .anticon {\n        color: #5e8eb7;\n        display: none;\n        &-full {\n          display: block;\n          margin-left: 0;\n        }\n      }\n    }\n  }\n  .flex {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    .h4 {\n      color: #929fb0;\n    }\n    span {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: normal;\n    }\n    .text-bold {\n      color: #5e8eb7;\n      font-weight: 600;\n      font-style: normal;\n    }\n\n    .input-edit {\n      all: unset;\n      color: #6E7889;\n      animation: none;\n      cursor: pointer;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 19.36px;\n      text-align: right;\n      text-underline-position: from-font;\n      text-decoration-skip-ink: none;\n    }\n  }\n  .button-edit {\n    all: unset;\n    border: none;\n    color: #5E8EB7;\n    animation: none;\n    cursor: pointer;\n    margin-left: 10px;\n\n    span {\n      margin-left: 5px;\n      font-weight: 500;\n      color: #5E8EB7;\n      font-family: Inter;\n      font-style: normal;\n    }\n  }\n}\n",".SelectPrimary {\n  .body-regular {\n    color: #2a2f3c;\n    font-weight: 500;\n  }\n  .ant-space-item {\n    width: 100%;\n  }\n}\n",".UploadDocs {\n  position: relative;\n  height: 100%;\n\n  .modal-see-file {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: red;\n  }\n\n  .contenedor-flex {\n    height: 100%;\n  }\n\n  .button-upload {\n    height: 78px;\n    width: 100%;\n    border: 1px dashed #6e7889;\n\n    p {\n      color: #2a2f3c;\n      font-family: Inter;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n\n      span {\n        font-size: 10px;\n        color: #4e8aff;\n      }\n    }\n  }\n\n  .circles {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n\n    .circle {\n      border-radius: 50%;\n      width: 16px;\n      height: 16px;\n      border: 1px solid #404859;\n\n      &:hover {\n        background: $state-draft-hover;\n      }\n\n      &-request_error {\n        background-color: $state-error-background;\n        border-color: $state-error-border;\n\n        &:hover {\n          background-color: $state-error-border;\n        }\n      }\n\n      &-review {\n        background-color: $state-review-border;\n        border-color: $state-review;\n\n        &:hover {\n          background-color: $state-review-label;\n        }\n      }\n\n      &-approved {\n        background-color: $state-approved-background;\n        border-color: $state-approved-border;\n\n        &:hover {\n          background-color: $state-approved-border-dark;\n        }\n      }\n    }\n  }\n\n  .ant-upload {\n    width: 100%;\n    margin-bottom: 12px;\n  }\n\n  .button {\n    border-radius: 6px;\n    border: #122536;\n    background: #122536;\n    width: 100%;\n    height: 32px;\n    color: #fff;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.18px;\n\n    &-transparent {\n      background-color: transparent;\n      border: none !important;\n      box-shadow: none !important;\n    }\n\n    &:disabled {\n      color: $button-color;\n    }\n  }\n\n  .body-small {\n    font-weight: 700 !important;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    text-align: left;\n\n    .blue {\n      color: #4e8aff;\n      text-decoration: underline;\n    }\n  }\n\n  .upload {\n    width: 20px;\n    height: 20px;\n    margin-bottom: 7px;\n  }\n\n  .empty-input {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .small-detail {\n      margin-top: 4px;\n    }\n  }\n\n  &--container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 12px;\n    height: 100%;\n    flex-direction: column;\n  }\n\n  .cont-files {\n    width: 100%;\n  }\n\n  .disabled {\n    opacity: 0.5;\n  }\n\n  .input-content {\n    position: relative;\n    min-height: 128px;\n    height: 100%;\n    width: 100%;\n    border-radius: 10px;\n    background: var(--colors-gradient);\n    padding: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px dashed #6e7889;\n\n    &-drag {\n      border: 2px solid #1f52ca;\n      background: #edf2fe;\n    }\n\n    input {\n      height: 126px;\n      width: 100%;\n      border-radius: 10px;\n      background-color: rgba(255, 0, 0, 0);\n      font-size: 0 !important;\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      cursor: pointer;\n\n      &:disabled {\n        cursor: unset !important;\n      }\n    }\n\n    input[type='file'] {\n      position: absolute;\n      left: 0;\n      top: 0;\n      opacity: 0;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n    }\n\n    .custom-file-input input[type='file'] {\n      position: absolute;\n      left: 0;\n      top: 0;\n      opacity: 0;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n    }\n\n    .cont-img {\n      height: 100%;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #fff;\n\n      img {\n        width: 100px;\n      }\n    }\n\n    &-wh {\n      background: var(--colors-white);\n      box-shadow: -3px 1px 10px -7px var(--colors-black);\n      margin: 30px 40px;\n    }\n\n    .edit {\n      position: absolute;\n      bottom: 0;\n      height: auto;\n      width: 99px;\n      border-radius: 0;\n    }\n  }\n\n  .content-flex {\n    align-items: flex-start;\n    gap: 16px;\n\n    .input-content,\n    .file-ok {\n      width: 50% !important;\n    }\n  }\n\n  .spinner-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .spinner {\n    position: relative;\n    width: 70px;\n    height: 70px;\n  }\n\n  .spinner-ring {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 5px solid #f3f3f3;\n    border-top: 5px solid #3498db;\n    border-radius: 50%;\n    animation: spin 2s linear infinite;\n  }\n\n  .spinner-percentage {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n}",".CustomInput {\n  .ant-input-affix-wrapper {\n    width: 100%;\n    height: 48px;\n    flex-shrink: 0;\n    border-radius: 4px;\n    border: 1px solid #2a2f3c;\n    padding: 8px 16px;\n  }\n  input {\n    color: #929fb0;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: italic;\n    font-weight: 400;\n    line-height: normal;\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic !important;\n      font-weight: 400;\n      line-height: normal;\n    }\n  }\n}\n",".circle-tag {\n  .circle {\n    width: 20px;\n    height: 20px;\n  \n    &-APPROVED {\n      border-color: $state-approved-border;\n      background-color: $state-approved-background;\n\n      &:hover {\n        background-color: $state-approved-border-dark;\n      }\n    }\n  \n    &-REVIEW {\n      background-color: $state-review-border !important;\n      border-color: $state-review !important;\n\n      &:hover {\n        background-color: $state-review-label !important;\n      }\n    }\n  \n    &-REQUEST_ERROR {\n      background-color: $state-error-background;\n      border-color: $state-error-border;\n\n      &:hover {\n        background-color: $state-error-border;\n      }\n    }\n  }\n}",".CardDetailInformationBank {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  background: #fff;\n  padding: 20px 16px;\n  .h4 {\n    margin-bottom: 24px;\n  }\n  .label {\n    color: #6e7889;\n    margin-bottom: 4px;\n  }\n  .info {\n    color: #929fb0;\n    font-style: italic;\n  }\n  .row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .column {\n      width: 50%;\n    }\n  }\n  .column {\n    margin-bottom: 20px;\n    &-line {\n      border-bottom: 1px solid #dfe4eb;\n      padding-bottom: 16px;\n    }\n  }\n}\n",".CardAlertError {\n  border-radius: 6px;\n  border: 1px solid #d7b8e5;\n  background: #f7edfc;\n  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n  padding: 18px 24px;\n  .h4-w5 {\n    color: #241226;\n    margin-bottom: 5px;\n  }\n  .h4-w4 {\n    color: #653b6f;\n    margin-bottom: 30px;\n  }\n}\n",".CardSomeoneElse {\n  margin-top: 10px;\n  width: 100%;\n\n  input {\n    background-color: #ebf6ff !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0;\n    color: #48759a !important;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    &::placeholder {\n      color: #9BBCEB;\n      background-color: #ebf6ff !important;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n  .ant-form-item {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n  .row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .ant-form-item {\n      width: 100%;\n    }\n  }\n}\n",".Switch {\n  background: #afbdcc;\n  .ant-switch-handle {\n    width: 10px;\n    height: 10px;\n  }\n  .ant-switch-handle {\n    inset-inline-start: calc(100% - 20px);\n  }\n  min-width: auto;\n  height: 14px;\n  width: 24px;\n}\nbutton.ant-switch.Switch.css-dev-only-do-not-override-nnuwmp.ant-switch-checked {\n  .ant-switch-handle {\n    inset-inline-start: calc(100% - 13px) !important;\n  }\n}\n.ant-switch.Switch.ant-switch-checked,\n.ant-switch.Switch.ant-switch-checked:hover {\n  background: #5e8eb7;\n}\n",".modal-basic {\n\n  border-radius: 10px;\n  border: 1px solid white;\n  background: white;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  width: 556px !important;\n  top: 202px !important;\n\n  .coin {\n    width: 55px;\n    height: 45px;\n  }\n\n  .ant-modal-content {\n    background-color: transparent;\n    padding: 32px;\n\n    .h2 {\n      margin-top: 15px;\n      margin-bottom: 5px;\n    }\n\n    .buttons {\n      margin-top: 25px;\n    }\n\n    .ant-modal-footer {\n      display: none;\n    }\n  }\n\n  .anticon {\n    color: #6e7889;\n    ;\n  }\n\n  .ant-checkbox-wrapper {\n    margin-top: 10px;\n\n    span {\n      color: #244560;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n\n  .ant-modal-content {\n    .h2 {\n      color: #162e43;\n    }\n\n    .h4 {\n      color: #48759a;\n    }\n\n    .buttons {\n      .button-modal-ok {\n        border: 1px solid $button-primary-border !important;\n        background: $button-primary-background !important;\n        color: #ffffff !important;\n\n        &:hover {\n          background-color: $button-primary-hover-background !important;\n          border: 1px solid $button-primary-hover-border !important;\n          box-shadow: 2px 2px 12px 0px #0B131A1A;\n    \n          span {\n            color: #244560 !important;\n          }\n    \n          &:active {\n            border: 1px solid $button-primary-active-border !important;\n            box-shadow: none;\n          }\n        }\n      }\n\n      .button-modal-cancel {\n        border: 1px solid #162e43 !important;\n        color: #162e43 !important;\n      }\n    }\n  }\n\n  .button {\n    margin-top: 16px;\n    height: 40px !important;\n    width: 100%;\n    border-radius: 6px;\n    height: 40px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 600;\n\n    &--white {\n      color: #122536 !important;\n      background: white !important;\n      border-color: #122536 !important;\n    }\n\n    &--red {\n      color: white !important;\n      background: $button-red !important;\n      border-color: $button-red !important;\n    }\n  }\n}\n\n.modal-basic--small-screen {\n  width: 375px !important;\n  height: 270px !important;\n  background-color: #FFF9EE;\n  border: 1px solid #FFD47D;\n  box-shadow: 0px 0px 4px 0px #00000026;\n\n  .ant-modal-content {\n    background-color: transparent;\n    padding: 24px;\n\n    .ant-modal-close-x {\n      display: none;\n    }\n    .ant-modal-footer {\n      display: none;\n    }\n  }\n\n  .modal-end-submit__content {\n\n    .h2 {\n      font-size: 24px;\n      font-weight: 600;\n      text-align: left;\n      color: #3C302A;\n    }\n\n    .h4 {\n      font-size: 14px;\n      font-weight: 400;\n      text-align: left;\n      margin-top: 6px;\n    }\n\n    .buttons {\n      width: 100%;\n      margin-top: 32px;\n\n      .button {\n        background-color: #FFC857 !important;\n        color: #66564D !important;\n        font-weight: 600;\n        font-size: 14px;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n\n        &::before {\n          content: '';\n          display: inline-block;\n          width: 20px;\n          height: 20px;\n          background-image: url('../../../../assets/images/share.svg');\n          background-size: contain;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n  }\n}\n",".cont-modal {\n  width: 100%;\n}\n\n.ModalTask {\n  position: fixed;\n  background: rgba(42, 47, 60, 0.55);\n  backdrop-filter: blur(2px);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 300;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .content-add {\n    margin-top: 50px;\n  }\n\n  &-content {\n    width: 70%;\n    background-color: #fff;\n    height: 100%;\n  }\n\n  .button-close-mask {\n    width: 30%;\n    height: 100%;\n    background-color: transparent;\n    box-shadow: none;\n    border: none;\n\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: transparent !important;\n      box-shadow: none;\n      border: none;\n    }\n  }\n\n  .content-modal {\n    // padding: 40px;\n    padding-bottom: 0;\n\n    .modal-title {\n      width: 100%;\n      padding: 40px;\n      padding-bottom: 0;\n\n      .flex-btw {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        border-bottom: 1px solid $grey-placeholder;\n      }\n\n      button,\n      button:hover,\n      button:active,\n      button:focus {\n        background-color: transparent;\n        border: none !important;\n        padding: 0 !important;\n        box-shadow: none !important;\n        color: $grey-title !important;\n      }\n\n      .body-card {\n        color: #404859;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px;\n        /* 133.333% */\n        letter-spacing: 0.24px;\n      }\n    }\n\n    .task-tracker-summary {\n      width: 25%;\n      padding: 48px 32px;\n      border-right: 1px solid #DFE4EB;\n\n      .title-summary {\n        font-family: Inter;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19.36px;\n        letter-spacing: 0%;\n        color: #2A2F3C;\n      }\n\n      .task-title {\n        margin-top: 15px;\n        font-family: Inter;\n        font-weight: 500;\n        font-size: 24px;\n        line-height: 29.05px;\n        letter-spacing: 0%;\n        color: #404859;\n      }\n\n      .description {\n        font-family: Inter;\n        font-weight: 500;\n        font-size: 24px;\n        line-height: 36px;\n        color: #404859;\n      }\n\n      .tag-blue {\n        padding: 3px 7px;\n        background: #5E8EB7;\n        border-radius: 8px;\n        color: white;\n      }\n\n      .link-blue {\n        color: $state-incomplete-circle-border;\n        text-decoration: underline;\n        font-size: 24px;\n        font-family: Inter;\n        font-weight: 600;\n\n        span {\n          font-size: 24px;\n          font-family: Inter;\n          font-weight: 600;\n        }\n      }\n\n      .placeholder {\n        font-family: Inter;\n        font-weight: 400;\n        font-size: 24px;\n        line-height: 36px;\n        color: #404859;\n      }\n\n      .price {\n        display: block;\n        font-family: Inter;\n        font-weight: 400;\n        font-style: italic;\n        font-size: 24px;\n        line-height: 29.05px;\n        color: #929FB0;\n      }\n    }\n\n    .modal-container {\n      position: relative;\n      width: 80%;\n      height: 90vh;\n\n      display: flex;\n      flex-grow: 1;\n      justify-content: center;\n      align-items: flex-start;\n\n      overflow-y: auto;\n      scrollbar-width: none;\n      /* Firefox */\n      -ms-overflow-style: none;\n      /* Internet Explorer 10+ */\n\n      &::-webkit-scrollbar {\n        display: none;\n        /* Safari and Chrome */\n      }\n\n      .dots {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        top: 45%;\n        left: 30px;\n        gap: 9px;\n\n        .tooltip-button {\n          opacity: 1;\n          display: flex;\n          border: none;\n          background: transparent;\n          font-family: Inter;\n          font-weight: 600;\n          font-size: 8px;\n          line-height: 10px;\n          letter-spacing: 0.16px;\n\n          &-approved {\n            color: #3F9545;\n          }\n\n          &-draft {\n            color: #3F9545;\n          }\n\n          &-review {\n            color: #855791;\n          }\n\n          &-error {\n            color: #AC3E3A;\n          }\n\n          &-complete-ownerships {\n            color: #3F9545;\n          }\n\n          &-request_error {\n            color: #AC3E3A;\n          }\n        }\n\n        &-button {\n          padding: 0;\n          border: 1.5px solid #6e7889;\n          background: #fff;\n          width: 10px;\n          height: 10px;\n          border-radius: 50%;\n\n          &-disabled-REVIEW:disabled {\n            border: 2px dotted #A278B3 !important;\n          }\n\n          &-prev-hover {\n            &:hover {\n              height: 25px;\n              width: 25px;\n              background: #fff;\n              border: 2px dotted #6eac72;\n            }\n          }\n\n          &-success {\n            border: 1px solid #6eac72;\n            background: #c5f0c8;\n          }\n\n          &-success-review {\n            border: 1px solid #A278B3;\n            background: #A278B3;\n          }\n\n          &-success-error {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #C13934 !important;\n          }\n\n          &-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #ddaa42 !important;\n          }\n\n          &-review-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted $state-review-label !important;\n            color: #855791;\n          }\n\n          &-error-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted #AC3E3A !important;\n          }\n\n          &-approved-active {\n            height: 25px;\n            width: 25px;\n            border: 2px dotted $state-approved-border-dark;\n          }\n        }\n      }\n\n      .modal-title {\n        border-bottom: 0;\n        align-items: flex-end;\n\n        button {\n          height: 18px;\n          text-transform: uppercase;\n          color: #8a5791 !important;\n\n          img {\n            margin-top: -0.9px;\n            margin-right: 3px;\n          }\n        }\n      }\n\n      .text {\n        margin-top: 5px;\n\n        a {\n          margin-left: 6px;\n\n          &:hover {\n            color: $black-text;\n          }\n        }\n      }\n\n      .modal-cards {\n        width: 100%;\n        height: 100%;\n        padding: 64px 50px 20px 70px;\n        overflow: auto;\n        max-width: 576px;\n\n        &--full {\n          max-width: none;\n          display: flex;\n          justify-content: center;\n        }\n\n        &-mx-w {\n          max-width: 576px;\n          width: 100%;\n          padding-bottom: 20px;\n        }\n\n        .flex-btw {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          margin-bottom: 12px;\n\n          .button {\n            text-transform: uppercase;\n            color: #404859;\n            text-align: right;\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 120%;\n            text-transform: uppercase;\n\n            .anticon {\n              color: #404859;\n            }\n          }\n        }\n\n        .title {\n          background: #e3ddf0;\n          border-radius: 140px;\n          display: flex;\n          padding: 5px 12px 5px 10px;\n          justify-content: center;\n          align-items: center;\n          gap: 4px;\n\n          .body-regular {\n            color: #48244d;\n          }\n        }\n\n        .h2 {\n          margin-top: 12px;\n\n          &-lite {\n            font-weight: 600;\n          }\n\n          .bold {\n            font-weight: 800;\n          }\n        }\n\n        .h2-w8 {\n          color: #ac78b3;\n        }\n\n        &::-webkit-scrollbar {\n          width: 8px;\n          border-radius: 5px;\n        }\n\n        /* Track */\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n        }\n\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n          background: #888;\n          border-radius: 5px;\n        }\n\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n          background: #555;\n        }\n      }\n    }\n  }\n\n  .modal-review-task__footer {\n    border-top: 1px solid #dfe4eb;\n    height: 180px;\n\n    .text-footer {\n      .placeholder {\n        color: #6e7889;\n\n        span {\n          color: #f5faff;\n          font-weight: 600;\n          background-color: #5e8eb7;\n          padding: 0 5px;\n          border-radius: 3px;\n        }\n      }\n    }\n\n    .footer-grey {\n      .h4 {\n        color: #6e7889;\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 170%;\n      }\n    }\n\n    .body-regular {\n      color: #6e7889;\n    }\n\n    .footer_dost {\n      .body-regular {\n        color: #404859;\n      }\n\n      align-items: center;\n\n      .circles {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 24px;\n      }\n    }\n\n    .modal-container {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      height: 100%;\n      padding: 0px 50px 0px 70px;\n\n      .modal-cards {\n        width: 100%;\n        height: 100%;\n        max-width: 576px;\n        padding: 20px 0;\n\n        .h4-w4 {\n          color: #ac78b3;\n          margin-bottom: 10px;\n\n          .h4 {\n            color: #6e7889;\n          }\n        }\n\n        .flex {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n\n          .circles {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 24px;\n\n            .circle {\n              border-radius: 100%;\n              border: 1px solid #8a5791;\n              background: #dfb8e5;\n              width: 20px;\n              height: 20px;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n\n              &-active {\n                border: 1px solid #587e5b;\n                background: #6eac72;\n\n                img {\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}",".ModalTask-content-right {\n  width: 35%;\n  background-color: #fff;\n  height: 100%;\n  border-left: 1px solid #ccd3db;\n\n  padding: 60px 45px 25px 30px;\n\n  .w-md-editor .title {\n    line-height: unset !important;\n    font-size: unset !important;\n    font-weight: unset !important;\n  }\n\n  .type {\n    font-size: 14px;\n  }\n\n  .rejected-information {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-bottom: 20px;\n\n    b {\n      font-size: 14px;\n    }\n\n    .content-files {\n      margin-top: 6px;\n    }\n\n    .content-text-data {\n      position: relative;\n      background-color: $state-error-background;\n      border: 1px solid $state-error-dark;\n      border-radius: 10px;\n      margin-top: 10px;\n      \n      .text-data {\n        padding: 5px 27px 12px;\n        display: block;\n\n        .row {\n          display: flex;\n          justify-content: space-between;\n          margin-top: 8px;\n\n          span {\n            font-family: Inter;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 14.52px;\n            letter-spacing: 0px;\n            color: $state-error-text-dark;\n          }\n\n          b {\n            font-family: Inter;\n            font-weight: 600;\n            font-size: 12px;\n            line-height: 14.52px;\n            letter-spacing: 0px;\n            text-align: right;\n            color: #610805;\n          }\n        }\n      }\n\n      .circle-input {\n        display: flex;\n        position: absolute;\n        height: 100%;\n        left: -7px;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n\n    .reject-documents-label {\n      margin-top: 10px;\n      font-size: 14px;\n      color: $state-error-dark;\n    }\n  }\n\n  .button-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: black;\n\n    &:hover {\n      color: black !important;\n    }\n  }\n\n  .quill {\n    height: 350px;\n\n    .ql-editor strong{\n      font-weight: bold;\n    }\n    .ql-editor em{\n      font-style: italic;\n    }\n  }\n}",".QuestionBasic {\n  .body-regular {\n    color: #6e7889;\n  }\n\n  .h3 {\n    margin-bottom: 40px;\n  }\n\n  .options {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 15px;\n    margin-top: 15px;\n\n    .content-left {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .Button-option {\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      flex-direction: column;\n      border-radius: 10px;\n      border: 1px solid #ccd3db;\n      background: #f9fafb;\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n      min-height: 56px;\n      height: auto;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      padding: 19px 24px;\n\n      &-text {\n        color: #2a2f3c !important;\n        display: flex;\n      }\n\n      .flex-btw {\n        margin-bottom: 0 !important;\n\n        &.wide {\n          >* {\n            flex: 1;\n          }\n        }\n      }\n\n      .flex-start {\n        display: none;\n      }\n\n      .ml-3 {\n        margin-left: 4px;\n      }\n\n      .sub-title-no {\n        display: none;\n      }\n    }\n\n    .option-hover-blue {\n        &:hover {\n          .flex-start {\n            display: flex;\n            gap: 6px;\n            align-items: flex-start;\n\n            img {\n              margin-top: 3px;\n            }\n\n            .body-regular {\n              max-width: 300px;\n            }\n          }\n\n          border-radius: 6px;\n          border: 1px solid #9bbceb;\n          background: #ebf6ff;\n          box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n\n          h4 {\n            color: #355c7d !important;\n          }\n\n          .body-regular {\n            color: #5e8eb7;\n          }\n\n          .sub-title {\n            font-weight: 500;\n          }\n        }\n      }\n\n      .option-hover-purpure {\n        &:hover {\n          .flex-start {\n            display: flex;\n            gap: 6px;\n            align-items: flex-start;\n\n            img {\n              margin-top: 3px;\n            }\n\n            .body-regular {\n              max-width: 300px;\n            }\n          }\n\n          border-radius: 6px;\n          border: 1px solid#8A5791;\n          background: #f2edfc;\n          box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n\n          h4 {\n            &-w5 {\n              color: #48244d;\n            }\n\n            &-w4 {\n              color: #693b6f;\n              margin-top: 5px;\n              line-height: 150%;\n              margin-bottom: 4px;\n            }\n          }\n\n          span {\n            color: #8A5791 !important;\n          }\n          p {\n            color: #8A5791 !important;\n          }\n        }\n      }\n\n    .option-active {\n      border-radius: 6px;\n      box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);\n\n      .flex-start {\n        display: flex;\n        gap: 6px;\n        align-items: flex-start;\n\n        img {\n          margin-top: 3px;\n        }\n\n        .body-regular {\n          max-width: 300px;\n        }\n      }\n\n      .sub-title {\n        font-weight: 500;\n      }\n\n      &-blue {\n        border: 1px solid #9bbceb;\n        background: #ebf6ff;\n\n        h4 {\n          color: #355c7d !important;\n        }\n\n        .body-regular {\n          color: #5e8eb7;\n        }\n\n        .Button-option-text {\n          color: $blue-button-tab !important;\n        }\n\n        &-description {\n          color: #5e8eb7 !important;\n          font-size: 14px;\n          // margin-top: 5px;\n        }\n      }\n\n      &-purpure {\n        border: 1px solid #8a5791;\n        background: #f2edfc;\n\n        h4 {\n          color: #48244d;\n        }\n\n        .Button-option-text {\n          color: #48244D !important;\n        }\n      }\n    }\n  }\n\n\n  .list {\n    list-style-type: disc;\n    list-style: disc;\n    padding-left: 25px;\n    margin-top: 15px;\n\n    .h4 {\n      color: #404859;\n      line-height: 145%;\n    }\n  }\n}",".ModalCloseTask {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3000;\n  background-color: transparent;\n  text-align: left;\n\n  &-mask {\n    position: absolute;\n    z-index: 2;\n    background-color: #00000057;\n    border: none !important;\n    border-radius: 0 !important;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n\n    &:hover {\n      background-color: #00000057 !important;\n    }\n  }\n\n  .modal-end-submit__content {\n    position: relative;\n    z-index: 20;\n    background-color: #ffffff;\n    background-clip: padding-box;\n    border: 0;\n    border-radius: 10px;\n    box-shadow:\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05);\n    pointer-events: auto;\n    padding: 25px 24px;\n    padding-bottom: 30px;\n    width: 550px;\n\n    .button-close {\n      padding: 0;\n      position: absolute;\n      right: 15px;\n      border: none;\n      top: 10px;\n    }\n\n    .coin {\n      height: 34px;\n      width: auto;\n      margin-bottom: 15px;\n    }\n\n    h2 {\n      color: #244560 !important;\n    }\n\n    .h4 {\n      color: #404859;\n      margin-top: 5px;\n    }\n\n    .buttons {\n      margin-top: 50px;\n      gap: 15px;\n      display: grid;\n\n      .button-modal-ok {\n        background-color: #162e43 !important;\n        border-color: #162e43 !important;\n        color: #fff !important;\n      }\n\n      .button-modal-cancel {\n        background-color: #fff !important;\n        border: 1px solid #48759a !important;\n      }\n\n    }\n\n    .ant-checkbox-wrapper {\n      color: #244560;\n      \n      &:hover {\n        .ant-checkbox-inner {\n          border: 1px solid #5E8EB7 !important;\n        }\n  \n        .ant-checkbox-checked {\n          .ant-checkbox-inner {\n            background-color: #5E8EB7 !important;\n          }\n        }\n      }\n    }\n  \n    .ant-checkbox,\n    .ant-checkbox-input {\n      border: none;\n  \n      &:hover {\n        .ant-checkbox-inner {\n          border: 1px solid #5E8EB7 !important;\n        }\n  \n        .ant-checkbox-checked {\n          .ant-checkbox-inner {\n            background-color: #5E8EB7 !important;\n          }\n        }\n      }\n    }\n  \n    .ant-checkbox-inner {\n      width: 18px;\n      height: 18px;\n      border: 1px solid #5E8EB7;\n    }\n  \n    .ant-checkbox-disabled {\n      .ant-checkbox-inner {\n        border-radius: 2px;\n        background: #DFE4EB !important;\n        border: 1px solid #DFE4EB;\n      }\n    }\n  \n    .ant-checkbox-checked {\n      &:hover {\n        .ant-checkbox-inner {\n          background-color: #5E8EB7 !important;\n        }\n      }\n  \n      .ant-checkbox-inner {\n        border-radius: 2px;\n        background: #5E8EB7;\n      }\n    }\n  }\n}",".InputBorderNone {\n  .input {\n    color: #775614;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n  .body-placeholder-w4 {\n    color: #775614;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .error {\n    font-weight: 400;\n    color: $state-error-dark;\n    &::placeholder {\n      color: #929fb0;\n      font-size: 14px;\n      font-weight: 400;\n    }\n  }\n\n  .border-error {\n    border-bottom: 1px solid $state-error-dark;\n  }\n\n  .bold-lith {\n    color: #2a2f3c;\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 400;\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 145%;\n    }\n  }\n  .bold {\n    color: #2a2f3c;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .percentage-bottom {\n    border: 0;\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #afbdcc;\n    padding-top: 1px;\n    margin-bottom: 10px !important;\n    width: 90% !important;\n    .body-regular {\n      span {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .ant-input-number-input {\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    line-height: normal;\n    padding: 5px 0px !important;\n\n    .default {\n      font-weight: 400;\n      color: $grey-title;\n    }\n\n    .warning {\n      font-weight: 600;\n      color: $state-warning;\n    }\n\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-style: italic !important;\n      font-weight: 400;\n    }\n  }\n}\n",".view-entities {\n  padding: 24px 25px;\n\n  .title {\n    color: var(--800-grey, #404859);\n    font-family: Inter;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n\n    >span {\n      cursor: pointer;\n\n      color: var(--blue60, #5E8EB7);\n      font-family: Inter;\n      font-size: 32px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n  }\n\n  &-header {\n    display: flex;\n    justify-content: space-between;\n\n    .search-box {\n      cursor: pointer;\n    \n      box-sizing: border-box;\n      width: 384px;\n      padding: 5px 18px 5px 8px;\n    \n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n    \n      border-radius: 10px;\n      border: 1px solid #CCD3DB;\n      background: #F9FAFB;\n    \n      color: #6E7889;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%;\n    \n      >input {\n        all: unset;\n        width: 100%;\n        margin-left: 8px;\n      }\n    }\n  }\n\n  &-content {\n    margin-top: 35px;\n    display: flex; \n    flex-direction: row; \n    gap: 20px;\n\n    .card-entity {\n      width: 510px;\n      background: #FDFEFF;\n      border: 1px solid #929FB0;\n      border-radius: 10px;\n      box-shadow: 2px 2px 8px 0px #00000005;\n      padding: 14px 16px;\n  \n      &-button {\n        border-radius: 6px;\n        margin-top: 10px;\n      }\n\n      &-header {\n  \n        border-bottom: 1px solid #CCD3DB;\n  \n        h3 {\n          font-family: Inter;\n          font-size: 16px;\n          font-weight: 600;\n          line-height: 18.4px;\n          text-align: left;\n          margin-bottom: 6px;\n        }\n  \n        p {\n          font-family: Inter;\n          font-size: 12px;\n          font-weight: 400;\n          line-height: 16.8px;\n          text-align: left;\n          margin-bottom: 8px;\n        }\n\n        &-description {\n          display: flex;\n        }\n\n        .see-loan {\n          height: 15px;\n          margin-left: 3px;\n\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n\n      &-content {\n        margin-top: 12px;\n\n        &-resume {\n          display: flex;\n          flex-direction: column;\n\n          label {\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 14.52px;\n            text-align: left;\n          }\n\n          span {\n            margin-top: 3px;\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 12.1px;\n            text-align: left;\n            color: #6E7889;\n          }\n        }\n\n        &-guarantors {\n          display: flex;\n          justify-content: space-between;\n\n          .box-shadow {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: absolute;\n            width: 475px;\n            height: 32px;\n            cursor: pointer;\n\n            &:hover {\n              background-color: rgba(223, 228, 235, 0.6); \n              backdrop-filter: blur(3px);\n              box-shadow: 2px 1px 5px 0px #00000014;\n\n              span {\n                display: block;\n              }\n            }\n\n            span {\n              display: none;\n              color: #2A2F3C;\n              font-weight: 600;\n              line-height: 14.52px;\n            }\n          }\n\n          .guarantors-names {\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 14px;\n            text-align: left;\n            width: 200px;\n          }\n        }\n\n        &-documents {\n          display: flex;\n          justify-content: space-between;\n          margin-top: 12px;\n\n          .doc-states {\n            width: 200px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.item-loan {\n  display: flex;\n  justify-content: space-between;\n  width: 460px;\n\n  &-state {\n    width: 110px;\n  }\n\n  &-name {\n    font-size: 12px;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n\n    b { \n      color: #355C7D;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      line-height: 1.2;\n      width: 140px;\n\n      &:hover {\n        color: #355C7D !important;\n      }\n    }\n  }\n}\n\n.dropdown-item-loan {\n  display: flex;\n  justify-content: space-between;\n  width: 460px;\n\n  &-state {\n    width: 110px;\n  }\n\n  &-name {\n    font-size: 12px;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n\n    b { \n      color: #355C7D;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      line-height: 1.2;\n      width: 200px;\n\n      &:hover {\n        color: #355C7D !important;\n      }\n    }\n  }\n}",".view-loans {\n  padding: 24px 25px;\n  position: relative;\n  height: 100%;\n\n  .title {\n    color: var(--800-grey, #404859);\n    font-size: 32px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    button {\n      height: 32px;\n\n      span {\n        font-size: 32px;\n      }\n    }\n  }\n\n  &-filters{\n    margin-top: 30px;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &-header {\n    display: flex;\n    justify-content: space-between;\n\n    .search-box {\n      cursor: pointer;\n\n      box-sizing: border-box;\n      width: 384px;\n      padding: 5px 18px 5px 8px;\n\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n\n      border-radius: 10px;\n      border: 1px solid #CCD3DB;\n      background: #F9FAFB;\n\n      color: #6E7889;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%;\n\n      >input {\n        all: unset;\n        width: 100%;\n        margin-left: 8px;\n      }\n    }\n  }\n\n  &-content {\n    margin-top: 25px;\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n\n    .card-loan {\n      width: 510px;\n      background: #FDFEFF;\n      border: 1px solid #929FB0;\n      border-radius: 10px;\n      box-shadow: 2px 2px 8px 0px #00000005;\n      padding: 14px 16px;\n\n      &-error {\n        border: 1px solid #C94F4A;\n\n        .card-loan-button {\n          border: 1px solid #AC3E3A !important;\n          color: #712220 !important;\n        }\n      }\n\n      &-button {\n        border-radius: 6px;\n        margin-top: 10px;\n      }\n\n      &-pre-header {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 12px;\n\n        &-description {\n          p {\n            font-size: 12px;\n\n            b {\n              font-weight: 600;\n              letter-spacing: 0.03em;\n            }\n          }\n\n        }\n\n        .state-tag {\n          border-radius: 76px;\n          padding: 4px 8px 4px 7px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          gap: 4px;\n\n          &-INCOMPLETE {\n            background: #404859;\n\n            .tag-name {\n              color: #f9fafb;\n            }\n          }\n        }\n\n      }\n\n      &-header {\n\n        border-bottom: 1px solid #CCD3DB;\n\n        h3 {\n          font-family: Inter;\n          font-size: 16px;\n          font-weight: 600;\n          line-height: 18.4px;\n          text-align: left;\n          margin-bottom: 6px;\n        }\n\n        p {\n          font-family: Inter;\n          font-size: 12px;\n          font-weight: 400;\n          line-height: 16.8px;\n          text-align: left;\n          margin-bottom: 8px;\n        }\n\n        &-description {\n          display: flex;\n        }\n\n        .see-loan {\n          height: 15px;\n          margin-left: 3px;\n\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n\n      &-content {\n        margin-top: 12px;\n\n        &-resume {\n          display: flex;\n          flex-direction: column;\n          width: 100%;\n\n          label {\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 14.52px;\n            text-align: left;\n          }\n\n          span {\n            margin-top: 3px;\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 12.1px;\n            text-align: left;\n            color: #6E7889;\n          }\n        }\n\n        &-guarantors {\n          display: flex;\n          justify-content: space-between;\n\n          .box-shadow {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: absolute;\n            width: 475px;\n            height: 32px;\n            cursor: pointer;\n\n            &:hover {\n              background-color: rgba(223, 228, 235, 0.6);\n              backdrop-filter: blur(3px);\n              box-shadow: 2px 1px 5px 0px #00000014;\n\n              span {\n                display: block;\n              }\n            }\n\n            span {\n              display: none;\n              color: #2A2F3C;\n              font-weight: 600;\n              line-height: 14.52px;\n            }\n          }\n\n          .guarantors-names {\n            font-family: Inter;\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 14px;\n            text-align: left;\n            width: 200px;\n          }\n        }\n\n        &-documents {\n          display: flex;\n          justify-content: space-between;\n          margin-top: 12px;\n\n          .doc-states {\n            width: 200px;\n            display: flex;\n            flex-wrap: wrap; /* Para que los círculos pasen a la siguiente línea */\n            max-width: 100%; /* Ajusta el ancho máximo si es necesario */\n            gap: 10px; /* Espacio entre los círculos */\n            justify-content: flex-start;\n          }\n\n          .circles-tags {\n            display: flex;\n            flex-wrap: wrap; /* Para que los círculos pasen a la siguiente línea */\n            max-width: 100%; /* Ajusta el ancho máximo si es necesario */\n            gap: 10px; /* Espacio entre los círculos */\n            justify-content: flex-start;\n          }\n        }\n      }\n    }\n  }\n}\n\n.button-actions-pagination {\n  position: absolute;\n  top: 50%;\n  right: -10px;\n  display: flex;\n  flex-direction: column;\n  z-index: 99;\n\n  button {\n    width: 24px;\n    padding: 0;\n    border: 1px solid #CCD3DB;\n    border-radius: 6px;\n    &:first-child {\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n    }\n    &:nth-child(2) {\n      border-top-left-radius: 0px;\n      border-top-right-radius: 0px;\n    }\n    svg {\n      color: #6E7889;\n    }\n\n    &:hover {\n      border: 1px solid #CCD3DB !important;\n    }\n\n    &:disabled {\n      background: white;\n      svg {\n        opacity: 0.2;\n      }\n    }\n  }\n}\n\n.dropdown-item-loan {\n  display: flex;\n  justify-content: space-between;\n  width: 460px;\n\n  &-state {\n    width: 110px;\n  }\n\n  &-name {\n    font-size: 12px;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n\n    b {\n      color: #355C7D;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      line-height: 1.2;\n      width: 200px;\n    }\n  }\n}",".view-profile {\n  padding: 24px 15px;\n  &-header {\n    .title {\n      color: $state-draft-hover;\n      font-size: 32px;\n      font-weight: 600;\n      gap: 5px;\n\n      button {\n        height: 32px;\n        span {\n          font-size: 32px;\n        }\n      }\n    }\n  }\n  \n  .button-r,\n  .button-r:hover {\n    width: 58px;\n    height: 20px;\n    border: 1px solid #bb8d2f;\n    color: #bb8d2f;\n    border-radius: 76px;\n    padding: 0;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    margin: 0 15px;\n  }\n  .button-delete,\n  .button-delete:hover {\n    height: 20px;\n    border: none;\n    color: #c94f4a;\n    padding: 0;\n    font-family: Inter;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12.1px;\n    margin: 0 15px;\n  }\n  .flex-2-col {\n    display: flex;\n    margin-top: 20px;\n    justify-content: space-between;\n    width: 100%;\n    gap: 30px;\n    .box {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      width: 50%;\n    }\n  }\n  .gap-3 {\n    gap: 6px;\n  }\n  .card-profile-generic {\n    border: 1px solid #afbdcc;\n    border-radius: 10px;\n    padding: 15px;\n    width: 100%;\n    .card-title {\n      font-family: Inter;\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 29.05px;\n      text-align: left;\n    }\n    .table {\n      width: 100%;\n      margin-top: 10px;\n      &-row {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        margin-bottom: 7px;\n        .title {\n          font-family: Inter;\n          font-size: 12px;\n          font-weight: 400;\n          line-height: 14.52px;\n          text-align: left;\n          color: #6e7889;\n        }\n\n        .flex {\n          display: flex;\n          justify-content: space-between;\n          .col {\n            width: 50%;\n            .italic {\n              font-family: Inter;\n              font-size: 14px;\n              font-style: italic;\n              font-weight: 400;\n              line-height: 16.94px;\n              text-align: left;\n              color: #929fb0;\n            }\n          }\n        }\n      }\n    }\n    .avatar {\n      .ant-avatar-string {\n        font-size: 25px;\n      }\n\n      .ant-upload {\n        width: 68px !important;\n        height: 68px !important;\n      }\n    }\n\n    .ant-upload-wrapper.ant-upload-picture-circle-wrapper {\n      width: auto;\n    }\n\n    .title-bold {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 16.94px;\n      text-align: left;\n      color: #404859;\n      .bold {\n        font-weight: 600;\n      }\n    }\n    .body-bold {\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 16.94px;\n      text-align: right;\n    }\n    .button-transparent {\n      padding: 0;\n      height: 20px;\n      font-size: 14px;\n      font-weight: 400;\n      text-align: left;\n      color: $state-error-text-dark;\n      &:hover{\n        color: $state-error-text-dark !important;\n      }\n    }\n    .button-round {\n      width: 75px;\n      height: 20px;\n      padding: 0;\n      border-radius: 76px;\n      border: 2px solid #404859;\n      font-family: Inter;\n      font-size: 10px;\n      font-weight: 600;\n    }\n    .button-edit,\n    .button-edit:hover {\n      font-family: Inter;\n      font-size: 10px;\n      font-weight: 500;\n      line-height: 12px;\n      text-align: left;\n      color: #5e8eb7;\n      .edit {\n        width: 10px;\n        height: 10px;\n        margin-right: 3px;\n      }\n    }\n    .link {\n      padding: 0;\n      height: 25px;\n      span {\n        font-family: Inter;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 16.94px;\n        text-align: left;\n        color: #5e8eb7;\n        text-decoration: none;\n      }\n      .arrow {\n        width: 15px;\n        margin-left: 5px;\n      }\n    }\n    .text-footer {\n      font-family: Inter;\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 14.52px;\n      text-align: left;\n      color: #6e7889;\n      margin-top: 14px;\n      span {\n        color: #4e8aff;\n      }\n    }\n  }\n}\n",".issues-task-response {\n  .row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 7px;\n\n    .box {\n      width: 40%;\n\n      .body-card {\n        margin-bottom: 4px;\n      }\n    }\n\n    .issue-text {\n      flex-grow: 1;\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n\n      h3 {\n        white-space: nowrap;\n      }\n\n      span {\n        padding-left: 3px;\n        font-size: 14px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    }\n\n    button {\n      width: auto !important;\n      flex-shrink: 0;\n    }\n\n    .button-link-error {\n      color: $state-error-text-dark !important;\n      background: none !important;\n      border: none !important;\n      box-shadow: none !important;\n  \n      span {\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        text-decoration-line: underline;\n      }\n  \n      &:hover {\n        color: $state-error-text-dark !important;\n      }\n    }\n  }\n\n  .divider {\n    margin-top: 10px;\n    border-top: 1px solid #ffd4cf;\n    padding-top: 8px;\n\n    &-dark {\n      border-top: 1px solid #E87C70;\n    }\n  }\n}",".SectionNewBank {\n  .h4,\n  .body-regular {\n    margin-bottom: 8px;\n    color: #2a2f3c;\n    line-height: 145%;\n  }\n  .button {\n    width: auto !important;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .button-block {\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.card-add-account {\n  border-radius: 10px;\n  border: 1px solid #2a2f3c;\n  padding: 7px 16px;\n  margin-top: 16px;\n  .ModalEndSubmit {\n    .button {\n      margin-bottom: 5px;\n    }\n  }\n  .flex-btw {\n    margin-bottom: 0 !important;\n    .box {\n      height: 100%;\n    }\n  }\n\n  .UploadDocs {\n    .flex-btw {\n      border: none;\n    }\n  }\n  .body-card {\n    color: #404859 !important;\n  }\n  .box {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    justify-content: space-between;\n    .h4 {\n      color: #929fb0;\n      font-style: italic;\n      margin-bottom: 16px;\n    }\n    .ModalEndSubmit {\n      .button {\n        display: none;\n      }\n    }\n  }\n  .button-submit {\n    margin-bottom: 20px;\n    border-radius: 6px;\n\n    span {\n      color: #fff;\n      text-align: center;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n  .top-InfoExpand {\n    border-top: 1px solid #afbdcc;\n    .body-card {\n      max-width: 420px;\n    }\n  }\n  // .item {\n  //   .flex-btw {\n  //     border: 0;\n  //     border-top: 1px solid #afbdcc;\n  //     padding-top: 1px;\n  //     margin-top: -15px;\n  //     margin-bottom: 16px !important;\n  //     align-items: flex-end !important;\n  //     width: 90% !important;\n  //     .body-regular {\n  //       margin-bottom: 0;\n  //       span {\n  //         font-size: 12px;\n  //       }\n  //     }\n  //   }\n  // }\n\n  .setcion-grid {\n    display: grid !important;\n    width: 100%;\n    justify-content: normal !important;\n    grid-template-columns: repeat(2, 1fr);\n    padding-bottom: 10px;\n    .box {\n      height: 100%;\n      min-width: 270px;\n      width: 100% !important;\n      margin-top: 7px;\n    }\n    .box:last-child {\n      margin-top: 0;\n      transform: translateX(10px);\n    }\n  }\n}\n",".CardStateAccount {\n  border-radius: 10px;\n  border: 1px solid #7b7b7b;\n  padding: 12px 16px;\n  .label {\n    border-radius: 100px;\n    min-width: 81px;\n    width: auto;\n    max-width: 95px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 4px;\n    gap: 4px;\n    margin-bottom: 8px;\n    background: #969696;\n    .body-small {\n      margin-bottom: 0;\n    }\n  }\n  &_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n  }\n\n  .box {\n    .body-card {\n      margin-bottom: 6px;\n    }\n\n    .file-ok {\n      margin-top: 0 !important;\n    }\n    width: 300px !important;\n    &-error {\n      .flex {\n        .button {\n          &:last-child {\n            display: none !important;\n          }\n        }\n      }\n    }\n    &-success {\n      .flex {\n        .button {\n          &:last-child {\n            display: none !important;\n          }\n        }\n      }\n    }\n  }\n  .divider {\n    border-top: 1px solid #afbdcc;\n    margin-top: 20px;\n  }\n  &--inReview {\n    background: #fdfcff;\n    border: 1px solid #ac78b3;\n    .label {\n      background: #e3ddf0;\n      .body-small {\n        color: #48244d;\n      }\n    }\n    .box {\n      .body-card {\n        color: #48244d;\n        &-dark {\n          color: #2a2f3c;\n        }\n      }\n      .body-regular {\n        color: #48244d;\n      }\n    }\n    .file-ok {\n      .file {\n        &-content {\n          .name {\n            color: #693b6f !important;\n          }\n          .anticon {\n            color: #693b6f !important;\n          }\n        }\n      }\n    }\n  }\n  &--error {\n    border: 1px solid #c94f4a;\n\n    .label {\n      background: #ffd4cf;\n      img {\n        margin-top: 1px;\n      }\n      .body-small {\n        color: #712220;\n      }\n    }\n    .UploadDocs {\n      .input-content {\n        border: 1px dashed #e67f73;\n      }\n    }\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 7px;\n\n      .box {\n        width: 40%;\n        .body-card {\n          margin-bottom: 4px;\n        }\n      }\n\n      .issue-text {\n        flex-grow: 1;\n        display: flex; \n        align-items: center;\n        overflow: hidden; \n\n        h3 {\n          white-space: nowrap;\n        }\n\n        span {\n          padding-left: 3px;\n          font-size: 14px;\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n        }\n      }\n      \n      button {\n        width: auto !important;\n        flex-shrink: 0;\n      }\n    }\n    .divider {\n      margin-top: 20px;\n      border-top: 1px solid #ffd4cf;\n      padding-top: 8px;\n\n      &-dark {\n        border-top: 1px solid #E87C70;\n      }\n    }\n  }\n  &--approved {\n    border: 1px solid #3F9545;\n\n    .label {\n      background: #C5F0C8;\n      img {\n        margin-top: 1px;\n      }\n      .body-small {\n        color: #355137;\n      }\n    }\n    .UploadDocs {\n      .input-content {\n        border: 1px dashed #C5F0C8;\n      }\n    }\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 10px;\n      .box {\n        width: 40%;\n        .body-card {\n          margin-bottom: 4px;\n        }\n      }\n    }\n    .divider {\n      margin-top: 20px;\n      border-top: 1px solid #C5F0C8;\n      padding-top: 8px;\n    }\n    .file-ok {\n      .file {\n        &-content {\n          border: 1px solid #75C27A !important;\n          background-color: #C5F0C8 !important;\n          .name {\n            color: #355137 !important;\n          }\n          .anticon {\n            color: #355137 !important;\n          }\n        }\n      }\n    }\n    \n  }\n  .row-btw {\n    .box {\n      width: 100%;\n    }\n  }\n  .section-upload {\n    .UploadDocs {\n      .file-content {\n        height: 28px !important;\n        border-radius: 2px;\n        border: 1px solid #eff3f5 !important;\n        background: #eff3f5 !important;\n        padding-left: 12px !important;\n      }\n      .InputUploadedFile .file-ok .file .circle {\n        display: none;\n      }\n    }\n  }\n}\n",".DscrQuestionsAgreements {\n  .Step3 {\n    .h2 {\n      margin-top: 4px;\n      margin-bottom: 10px;\n      .blue-bold {\n        color: #5e8eb7;\n        font-weight: 800;\n        text-decoration-line: underline;\n\n        color: #2A2F3C;\n        font-family: Inter;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 135%;\n        text-decoration-line: unset;\n      }\n    }\n    .rent-input {\n      border: none;\n      width: auto;\n      display: inline;\n      &.touched {\n        color: #404859;\n      }\n    }\n    .month {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n    #rent-button {\n      margin-top: 16px;\n    }\n    .UploadDocs {\n      .contenedor-flex {\n        display: flex;\n        width: 100%;\n        .cont-files {\n          width: 100%;\n        }\n        .UploadDocs--container {\n          gap: 20px;\n          justify-content: center;\n          align-items: flex-start;\n          flex-direction: row;\n          width: 100%;\n        }\n      }\n    }\n  }\n  .InputAmount-edit {\n    margin-bottom: 0px !important;\n    border: none !important;\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n\n    .flex {\n      display: flex;\n      justify-content: flex-end;\n      gap: 16px;\n\n      .text-bold {\n        color: #5e8eb7;\n        font-weight: 600;\n        font-style: normal;\n      }\n      \n      .input-edit {\n        all: unset;\n        color: #6E7889;\n        animation: none;\n        cursor: pointer;\n        font-style: italic;\n        font-weight: 400;\n        line-height: 19.36px;\n        text-align: right;\n        text-underline-position: from-font;\n        text-decoration-skip-ink: none;\n      }\n\n    }\n    .button-edit {\n      all: unset;\n      border: none;\n      color: #5E8EB7;\n      animation: none;\n      cursor: pointer;\n      margin-left: 10px;\n  \n      span {\n        margin-left: 5px;\n        font-weight: 500;\n        color: #5E8EB7;\n        font-family: Inter;\n        font-style: normal;\n      }\n\n      &-disabled {\n        span {\n          color: #6E7889 !important;\n        }\n      }\n    }\n  }\n}\n",".CardMarketRent {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  padding: 12px 16px;\n  .body-regular-italic {\n    color: #929fb0;\n  }\n  .flex-btw {\n    margin-bottom: 9px !important;\n  }\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n\n  .ant-form {\n    all: unset;\n    margin-top: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .form-row {\n      all: unset;\n      display: flex;\n      align-items: baseline;\n      gap: 5px;\n      max-height: 35px;\n\n      .bold {\n        font-weight: 600 !important;\n        color: #404859 !important;\n      }\n    }\n\n    .rent-container {\n      display: flex;\n      align-items: baseline;\n      position: relative;\n    }\n\n    .rent-input {\n      width: auto;\n      min-width: 56px;\n      max-width: 58px;\n      text-align: right;\n      font-weight: 600;\n      color: #404859;\n      border: none;\n      outline: none;\n      background: transparent;\n    }\n\n    .unit-input {\n      width: 25px !important;\n    }\n\n    .ant-form-item-explain-error {\n      display: ruby-text;\n    }\n  }\n  \n}\n",".CardLeaseAgreements {\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  .flex-btw {\n    .flex {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 28px;\n      .circle {\n        border-radius: 50%;\n        width: 16px;\n        height: 16px;\n        border: 1px solid #404859;\n        &--active {\n          background-color: #404859;\n        }\n      }\n    }\n  }\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n\t\tbackground-color: $state-review-background-ligth;\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n}\n",".MortgagePayments {\n  .step1 {\n    .h4-w4 {\n      color: #2a2f3c;\n      margin-bottom: 25px;\n    }\n    .section-isuranse {\n      .button-transparent {\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        text-transform: uppercase;\n        color: #404859;\n        font-family: Inter;\n        font-size: 14px;\n        font-weight: 600;\n        letter-spacing: 0.28px;\n        margin: 10px 0;\n      }\n    }\n  }\n  .UploadDocs {\n    .input-content,\n    .input-content input {\n      height: 78px;\n    }\n  }\n}\n",".CardInsuranceCompanyName {\n  border-radius: 4px;\n  border: 1px solid #929fb0;\n  min-height: 195px;\n  width: 100%;\n  padding: 16px;\n  .h4 {\n    color: #929fb0;\n    font-style: italic;\n    margin-bottom: 16px;\n  }\n  .body-card {\n    color: #6e7889;\n  }\n  .body-regular {\n    color: #2a2f3c;\n    margin-bottom: 12px;\n  }\n  .flex-btw {\n    margin-bottom: 0 !important;\n    .column {\n      width: 50%;\n      .body-regular {\n        color: #929fb0;\n      }\n    }\n  }\n  .input {\n    color: #2A2F3C;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-bottom: 14px;\n    &::placeholder {\n      color: #929fb0;\n      font-family: Inter;\n      font-size: 14px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: normal;\n    }\n  }\n  .input-bold {\n    &::placeholder {\n      font-size: 16px;\n      font-style: italic;\n      font-weight: 600;\n    }\n    margin-bottom: 20px;\n  }\n}\n",".InvestmentExperienceVerification {\n  display: contents;\n\n  .card__generic {\n    &-REVIEW {\n      border: 1px solid $state-review-border;\n      background-color: $state-review-background-ligth;\n    }\n\n    &-REQUEST_ERROR {\n      border: 1px solid $state-error-border;\n      background-color: $state-error-background-ligth;\n    }\n\n    &-APPROVED {\n      border: 1px solid $state-approved-border;\n      background-color: $state-approved-background-ligth;\n    }\n\n    .UploadDocs {\n      .input-content,\n      .input-content input {\n        height: 79px;\n      }\n    }\n  }\n}\n",".ConstructionBudget {\n\n  .input-number {\n    &:hover, &:focus, &:focus-within {\n      border-color: #2a2f3c;\n    }\n\n    &-error {\n      border-color: #c94f4a;\n\n      &:hover, &:focus, &:focus-within {\n        border-color: #c94f4a;\n      }\n    }\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .h2 {\n    margin-top: 30px !important;\n  }\n\n  .UploadDocs {\n\n    .input-content,\n    .input-content input {\n      height: 78px;\n\n      .empty-input {\n        .body-small {\n          color: #2a2f3c;\n        }\n      }\n    }\n  }\n\n  .card__generic {\n    .s-title {\n      .h4 {\n        color: #404859;\n      }\n    }\n\n    .body-regular {\n      margin-bottom: 20px;\n    }\n  }\n\n  .link {\n    color: #5e8eb7;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    text-decoration: none;\n    line-height: 145%;\n\n    .arrow {\n      height: 10px;\n      margin-left: 5px;\n    }\n  }\n}",".EntityGuarantorCreation {\n  display: contents;\n\n  .under-pink {\n    color: #8a5791;\n    text-decoration: underline;\n    font-weight: 600;\n  }\n\n  .task-footer {\n    .dropdown-blue-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .dropdown-review-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      color: $state-review !important;\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .owners-tags {\n      display: flex;\n      justify-content: space-between;\n      align-items: end;\n\n      span {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 19.36px;\n        text-align: left;\n      }\n\n      .circles-tags {\n        display: flex;\n        align-items: end;\n        gap: 10px;\n      }\n\n      .circle {\n        width: 20px;\n        height: 20px;\n      }\n\n      .circle-step3 {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 5px;\n      }\n\n      .remaining-ownerts-tooltip {\n        background-color: #2A2F3C;\n        color: #fff !important;\n      }\n    }\n  }\n\n  .tag-owner-content {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    height: 18px;\n    font-size: 12px;\n    padding-left: 5px;\n    border-radius: 10px;\n    margin-bottom: 10px;\n\n    button {\n      font-size: 12px;\n    }\n\n    b {\n      font-weight: 500;\n    }\n\n    span {\n      font-weight: 400;\n    }\n\n    &-complete {\n      background: #D5F7E2;\n      width: 230px;\n      gap: 5px;\n\n      b {\n        color: #2D7032;\n      }\n\n      button {\n        color: #1F4222;\n\n        &:hover {\n          color: #1F4222 !important;\n        }\n      }\n\n      &-disabled {\n        width: 125px;\n      }\n    }\n\n    &-no-guarantor {\n      background: #EFF3F5;\n      width: 280px;\n    }\n\n    &-next-step {\n      background: #EFF3F5;\n      width: 350px;\n    }\n\n    &-incomplete {\n      border: 1px solid #97BCF0;\n      background: #F5FAFF;\n      width: 235px;\n\n      b {\n        color: #48759A;\n      }\n\n      .tag-description {\n        color: #610805;\n      }\n\n      img {\n        vertical-align: bottom;\n      }\n\n      button {\n        color: #48759A;\n\n        &:hover {\n          color: #48759A !important;\n        }\n      }\n    }\n\n    &-verify {\n      border: 1px solid #97BCF0;\n      background: #F5FAFF;\n      width: 235px;\n\n      b {\n        color: #48759A;\n      }\n\n      img {\n        vertical-align: bottom;\n      }\n\n      button {\n        color: #48759A;\n\n        &:hover {\n          color: #48759A !important;\n        }\n      }\n    }\n\n    &-error{\n      border: 1px solid #FCA095;\n      background: #FCF8F7;\n      width: 330px;\n\n      b {\n        color: #A31C17;\n      }\n\n      .tag-description {\n        color: #610805;\n      }\n\n      img {\n        vertical-align: bottom;\n      }\n\n      button {\n        color: #610805;\n\n        &:hover {\n          color: #610805 !important;\n        }\n      }\n    }\n  }\n}",".card-ownership {\n  position: relative;\n  border-radius: 6px;\n\n  &-expand {\n    width: 42em;\n    z-index: 99;\n    left: -50px;\n  }\n\n  .icon-delete {\n    font-size: 20px;\n    position: absolute;\n    top: 50%;\n    right: -9.5px;\n    transform: translateY(-50%);\n    color: #5e8eb7;\n    cursor: pointer;\n    visibility: hidden;\n\n    &-disabled {\n      opacity: 0.5;\n      cursor: unset;\n    }\n  }\n\n  &:hover {\n    .icon-delete {\n      visibility: visible;\n    }\n  }\n\n  .content-card {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n    border: 1px solid #ccd3db;\n    min-height: 56px;\n    height: auto;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding: 10px 18px 5px 16px;\n\n    &-hover-removed {\n      &:hover {\n        border: 1px solid #ccd3db !important;\n      }\n    }\n\n    &:hover {\n      border: 1px dashed $grey-placeholder;\n    }\n\n    .input-disabled-color {\n      input {\n        &:disabled {\n          color: black;\n        }\n\n        &::placeholder {\n          padding-right: 1px;\n        }\n      }\n    }\n\n    &-REVIEW {\n      border: 1px solid $state-review-border;\n      background-color: $state-review-background-ligth;\n\n      &:hover {\n        border: 1px solid $state-review-border !important;\n        background-color: $state-review-background-ligth !important;\n      }\n\n      .body-regular {\n        color: $state-review-label !important;\n      }\n\n      .bold-lith {\n        color: $state-review-tag !important;\n      }\n\n      .tag-name {\n        color: $state-review-tag !important;\n      }\n\n      .name {\n        span {\n          color: $state-review-tag !important;\n        }\n      }\n\n      .bold-little {\n        color: $state-review-tag !important;\n      }\n\n      .ant-input-number-suffix {\n        color: $state-review-text !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-review-text !important;\n        }\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-review-label !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-review-text !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .section-2 {\n        input {\n          color: $state-review-tag !important;\n        }\n      }\n\n      .identification {\n        label {\n          color: $state-review-label !important;\n        }\n      }\n\n      .address {\n        input {\n          color: $state-review-tag !important;\n        }\n      }\n    }\n\n    &-APPROVED {\n      border: 1px solid $state-approved-border;\n      background-color: $state-approved-background-ligth;\n\n      &:hover {\n        border: 1px solid $state-approved-border !important;\n        background-color: $state-approved-background-ligth !important;\n      }\n\n      .body-regular {\n        color: $state-approved-text !important;\n      }\n\n      .bold-lith {\n        color: $state-approved-text !important;\n      }\n\n      .ant-input-number-suffix {\n        color: $state-approved-text !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-approved-text !important;\n        }\n      }\n\n      .ant-form-item-no-colon {\n        color: $state-approved-text !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-approved-text !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .file-name {\n        color: $state-approved-text !important;\n      }\n    }\n\n    &-REQUEST_ERROR {\n      border: 1px solid $state-error-border;\n      background-color: white;\n\n      &:hover {\n        border: 1px solid $state-error-border !important;\n        background-color: white !important;\n      }\n\n      .ant-divider {\n        background-color: $state-error-background;\n      }\n\n      .ant-input {\n      }\n\n      .body-regular {\n        color: #404859 !important;\n      }\n\n      .bold-lith {\n      }\n\n      .ant-form-item-no-colon {\n        color: #404859 !important;\n      }\n\n      .ant-picker-input {\n        input {\n          color: $state-error-input !important;\n        }\n      }\n\n      .ant-input-number-suffix {\n        color: $state-error-icon !important;\n      }\n\n      .ant-input-number-input-wrap {\n        color: $state-error-icon !important;\n\n        input {\n          font-weight: 500;\n        }\n      }\n\n      .file-name {\n        color: $state-error-icon !important;\n      }\n\n      .input-content{\n        border-color: $state-error-input;\n      }\n\n      .file-content {\n        border-color: $state-error-input !important;\n      }\n    }\n\n    .card-ownership {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      .section-1 {\n        display: flex;\n        width: 70%;\n        flex-direction: column;\n\n        .resume-names {\n          display: flex;\n          gap: 10px;\n          margin-bottom: 10px;\n          align-items: center;\n        }\n\n        .names {\n          display: flex;\n          gap: 30px;\n          margin-bottom: 6px;\n\n          .name {\n            display: flex;\n            flex-direction: column;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            width: auto;\n            gap: 5px;\n\n            span {\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n              line-height: 1.2;\n              font-size: 16px;\n              font-weight: 600;\n            }\n\n            label {\n              font-size: 12px;\n            }\n          }\n        }\n\n        .footer {\n          .approved {\n            color: $green-tab-active-text;\n          }\n\n          .error {\n            color: $state-error-text;\n          }\n\n          button {\n            color: $grey-text-op;\n\n            .anticon {\n              margin-inline-start: 4px;\n            }\n\n            &:hover {\n              color: $grey-text-op;\n            }\n          }\n\n          span {\n            font-family: Inter;\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 15px;\n          }\n        }\n      }\n\n      .section-2 {\n        display: flex;\n        flex-direction: column;\n        align-items: end;\n\n        .ownership-section {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n        }\n\n        .suffix-null {\n          input {\n            padding-right: 0 !important;\n          }\n        }\n\n        input {\n          text-align: end;\n          padding-right: 2px !important;\n        }\n\n        .guarantor {\n          grid-area: guarantor;\n          display: flex;\n          align-items: center;\n          justify-content: right;\n          gap: 3px;\n          font-size: 12px;\n          margin-bottom: 7px;\n          color: $text-yellow !important;\n          font-weight: 500;\n          margin-top: 10px;\n        }\n\n        .ant-input-number-suffix {\n          margin-inline-end: 0px;\n          color: black;\n          margin-left: 2px !important;\n          position: unset;\n          inset-block-start: 0;\n          inset-inline-end: 0;\n          height: auto;\n          margin-inline-end: 0px;\n          margin-inline-start: 0px;\n        }\n      }\n    }\n\n    .form-edit {\n      width: 100%;\n      height: auto;\n\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      position: relative;\n\n      display: grid;\n      grid-template-columns: 25% 30% 45%;\n      grid-template-areas:\n        'ssn datebirth identification'\n        'phone email identification'\n        'address address address'\n        'submit submit submit';\n\n      .ant-form-item-row {\n        display: block;\n      }\n\n      .ant-form-item-label {\n        text-align: start;\n        height: 27px;\n\n        label {\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 14.52px;\n          color: $grey-text-op;\n        }\n      }\n\n      .ant-form-item-control-input {\n        min-height: 20px;\n      }\n\n      .ant-form-item {}\n\n      .ssn {\n        grid-area: ssn;\n      }\n\n      .datebirth {\n        grid-area: datebirth;\n\n        .ant-picker-input {\n          input {\n            &::placeholder {\n              color: #929fb0;\n              font-family: Inter;\n              font-style: italic !important;\n              font-weight: 400;\n            }\n\n            &:disabled {\n              color: #48244d;\n            }\n          }\n        }\n      }\n\n      .form-wrap {\n        position: relative;\n        z-index: 20;\n      }\n\n      .textedit {\n        grid-area: textedit;\n        font-size: 11px;\n        text-align: end;\n        color: #5e8eb7;\n        display: flex;\n        gap: 6px;\n        justify-content: end;\n        margin-top: 5px;\n\n        &-ab {\n          position: absolute;\n          right: 0;\n          top: 1px;\n          z-index: 100;\n        }\n      }\n\n      .phone {\n        grid-area: phone;\n      }\n\n      .email {\n        grid-area: email;\n      }\n\n      .address {\n        width: 100% !important;\n        grid-area: address;\n\n        margin-bottom: 0px;\n\n        .ant-input-group-addon {\n          display: none;\n        }\n\n        input {\n          width: 100%;\n          background-color: transparent !important;\n          border: none !important;\n          box-shadow: none !important;\n          padding: 0;\n          color: #2a2f3c;\n          font-family: Inter;\n          font-size: 14px;\n          font-weight: 400;\n\n          &::placeholder {\n            color: #929fb0;\n            font-family: Inter;\n            font-size: 14px;\n            font-style: italic;\n            font-weight: 400;\n            line-height: 145%;\n          }\n        }\n      }\n\n      .identification {\n        grid-area: identification;\n\n        .UploadDocs {\n          height: 90%;\n        }\n\n        .file-ok {\n          margin-top: 5px;\n        }\n\n        label {\n          font-family: Inter;\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 15px;\n          color: #404859;\n        }\n      }\n\n      .submit {\n        grid-area: submit;\n        margin-bottom: 12px;\n        margin-top: 10px;\n      }\n\n      .verify-submits {\n        display: flex;\n        gap: 21px;\n        margin-bottom: 10px;\n\n        .button-yellow {\n          border-radius: 6px;\n          background: $button-yellow !important;\n          border-color: $button-yellow !important;\n\n          &:disabled {\n            background: #EFF3F5 !important;\n            border-color: #EFF3F5 !important;\n          }\n\n          span {\n            color: black;\n            font-weight: 600;\n          }\n        }\n\n        .button-edit {\n          background: white !important;\n          border: 1px solid #48759A !important;\n\n          span {\n            color: black;\n            font-weight: 600;\n          }\n        }\n      }\n\n      .button-link-border {\n        border-radius: 6px;\n        height: 40px;\n        display: flex;\n        gap: 2px;\n\n        b {\n          color: #244560;\n          font-weight: 600;\n        }\n\n        span {\n          color: #244560;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n}",".step-1 {\n  .h3 {\n    .blue-bold {\n      font-size: 20px;\n      font-weight: 600;\n      text-decoration-line: underline;\n    }\n    .dropdown-blue-bold {\n      span {\n        font-size: 20px;\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n  }\n  .bold-blue {\n    font-weight: 600;\n    span {\n      font-weight: 400 !important;\n    }\n  }\n\n  .section-loand {\n    .text-blue {\n      color: #5e8eb7 !important;\n      img {\n        margin-top: -3px;\n        margin-right: 4px;\n      }\n    }\n  }\n\n  .content-entity-input {\n    margin-top: 8px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    input {\n      width: 100%;\n      margin-bottom: 4px;\n    }\n  }\n}\n.loader {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.item-selected {\n  font-weight: 700 !important;\n}\n",".step-2 {\n  .blue-bold {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n  }\n\n  .lienzo {\n    position: relative;\n  }\n\n  .dropdown-blue-bold {\n    span {\n      font-size: 24px;\n      font-weight: 600;\n      text-decoration-line: underline;\n    }\n    height: 26px;\n    display: unset;\n    padding: 0 !important;\n  }\n\n  .submits {\n    display: flex;\n    justify-content: space-between;\n    gap: 15px;\n\n    section {\n      width: 100%;\n    }\n  }\n    \n  .content-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .content-owner-new {\n    display: flex;\n    justify-content: space-between;\n\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    button {\n      padding: 0;\n    }\n\n    .text-add {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n    }\n\n    .total{\n      display: flex;\n      gap: 10px;\n      align-items: center;\n\n      span {\n        font-weight: 400; \n        font-size: 13px; \n      }\n\n      b {\n        font-weight: 600; \n        font-size: 16px; \n      }\n\n      &-error {\n        span {\n          color: #A31C17;\n        }\n  \n        b {\n          color: #8A130F;\n          font-style: italic;\n        }\n      }\n    }\n  }\n}",".step-3 {\n  .blue-bold {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n    text-decoration: underline;\n  }\n\n  .owner-REVIEW {\n    color: $state-review-label;\n  }\n\n  .owner-APPROVED {\n    color: $state-approved-icon;\n  }\n\n  .owner-REQUEST_ERROR {\n    color: $state-error-dark;\n  }\n    \n  .content-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .content-owner-new {\n    display: flex;\n    justify-content: space-between;\n\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    button {\n      padding: 0;\n    }\n\n    .text-add {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n    }\n\n    .total{\n      display: flex;\n      gap: 10px;\n      align-items: center;\n\n      span {\n        font-weight: 400; \n        font-size: 13px; \n      }\n\n      b {\n        font-weight: 600; \n        font-size: 16px; \n      }\n\n      &-error {\n        span {\n          color: #A31C17;\n        }\n  \n        b {\n          color: #8A130F;\n          font-style: italic;\n        }\n      }\n    }\n  }\n}",".card-ownership-edit {\n  position: relative;\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  height: auto;\n\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  padding: 10px 24px 5px;\n\n  display: grid;\n  grid-template-columns: 20% 20% 40% 20%;\n  grid-template-areas:\n    'names lastname . ownership'\n    'owner-state owner-state owner-state guarantor'\n    'ssn . datebirth .'\n    'phone . email email'\n    'address address address address'\n    'identification identification identification identification'\n    'submit submit submit submit'\n    'submit-draft submit-draft submit-draft submit-draft';\n\n  .ant-form-item-row {\n    display: block;\n  }\n\n  .icon-delete {\n    font-size: 20px;\n    position: absolute;\n    top: 50%;\n    right: -9.5px;\n    transform: translateY(-50%);\n    color: #5e8eb7;\n    cursor: pointer;\n    visibility: hidden;\n  }\n\n  &:hover {\n    border: 1px dashed $grey-placeholder;\n    .icon-delete {\n      visibility: visible;\n    }\n  }\n\n  .ant-form-item-label {\n    text-align: start;\n    height: 27px;\n\n    label {\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 14.52px;\n      color: $grey-text-op;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: 20px;\n  }\n\n  .ant-form-item {\n    margin-bottom: 10px;\n  }\n\n  .tag-owner-state {\n    grid-area: owner-state;\n  }\n\n  .tag-guarantor {\n    grid-area: guarantor;\n    display: flex;\n    align-items: center;\n    justify-content: right;\n    gap: 3px;\n    font-size: 12px;\n    margin-bottom: 7px;\n    color: $text-yellow;\n    font-weight: 500;\n  }\n\n  .name {\n    grid-area: names;\n  }\n\n  .lastname {\n    grid-area: lastname;\n  }\n\n  .ownership {\n    grid-area: ownership;\n\n    input {\n      text-align: end;\n      padding-right: 14px !important;\n    }\n\n    .ant-input-number-suffix {\n      margin-inline-end: 0px;\n      color: black;\n    }\n\n    label {\n      text-align: end;\n      &::after {\n        margin-inline-start: unset;\n        margin-inline-end: unset;\n      }\n    }\n\n    .ant-form-item-label {\n      text-align: end;\n    }\n  }\n\n  .ssn {\n    grid-area: ssn;\n  }\n\n  .datebirth {\n    grid-area: datebirth;\n\n    .ant-picker-input {\n      input {\n        &::placeholder {\n          color: #929fb0;\n          font-family: Inter;\n          font-style: italic !important;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n\n  .phone {\n    grid-area: phone;\n  }\n\n  .email {\n    grid-area: email;\n  }\n\n  .address {\n    grid-area: address;\n\n    .ant-input-group-addon {\n      display: none;\n    }\n\n    margin-bottom: 2px;\n    \n    input {\n      width: 100%;\n      background-color: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n      padding: 0;\n      color: #2a2f3c;\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 400;\n      &::placeholder {\n        color: #929fb0;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: italic;\n        font-weight: 400;\n        line-height: 145%;\n      }\n    }\n  }\n\n  .identification {\n    grid-area: identification;\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    \n    .contenedor-flex {\n      height: auto;\n    }\n\n    label {\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 15px;\n      color: #6e7889;\n    }\n\n    .UploadDocs {\n      margin-top: 0px !important;\n    }\n  }\n\n  .submit {\n    grid-area: submit;\n    button {\n      font-size: 12px;\n      border-radius: 6px;\n    }\n  }\n\n  .submit-draft {\n    grid-area: submit-draft;\n    button {\n      font-size: 12px;\n      border-radius: 6px;\n    }\n  }\n}\n",".EntityDocs {\n  display: contents;\n\n  .task-footer {\n    .dropdown-blue-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .dropdown-review-bold {\n      span {\n        font-weight: 600;\n        text-decoration-line: underline;\n      }\n\n      color: $state-review !important;\n      height: 26px;\n      display: unset;\n      padding: 0 !important;\n    }\n\n    .owners-tags {\n      display: flex;\n      justify-content: space-between;\n      align-items: end;\n\n      .circles-tags {\n        display: flex;\n        align-items: end;\n        gap: 10px;\n      }\n\n      .circle {\n        width: 20px;\n        height: 20px;\n\n        &-APPROVED {\n          border-color: $state-approved-border;\n\t\t      background-color: $state-approved-background;\n        }\n\n        &-REVIEW {\n          background-color: $state-review-border;\n          border-color: $state-review;\n        }\n\n        &-REQUEST_ERROR {\n          background-color: $state-error-background;\n          border-color: $state-error-border;\n        }\n      }\n    }\n  }\n}\n",".step-1 {\n  .main {\n    position: relative;\n    border-radius: 10px;\n\n    .content-card {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      border-radius: 10px;\n      border: 1px solid #ccd3db;\n      min-height: 56px;\n      height: auto;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      padding: 10px 18px 5px 16px;\n\n      .section-1 {\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n\n        .name {\n          display: flex;\n          flex-direction: column;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          line-height: 1.2;\n          overflow: hidden;\n          width: auto;\n          margin-top: 10px;\n          margin-bottom: 18px;\n\n          span {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            line-height: 1.2;\n            overflow: hidden;\n            font-size: 16px;\n            font-weight: 600;\n          }\n        }\n\n        .footer {\n          padding-top: 3px;\n          border-top: 1px solid #dfe4eb;\n\n          &-info {\n            display: flex;\n            justify-content: space-between;\n          }\n\n          span {\n            font-family: Inter;\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 15px;\n          }\n\n          .guarantor {\n            margin-top: 7px;\n            color: #5e8eb7;\n          }\n\n          .owners {\n            margin-left: 5px;\n          }\n        }\n\n        .list-owners {\n          display: flex;\n          flex-direction: column;\n          margin: 15px auto;\n          gap: 10px;\n\n          .owner {\n            display: flex;\n            justify-content: space-between;\n            padding: 0;\n\n            .owner-name {\n              font-size: 15px;\n            }\n\n            .owner-percentage {\n              font-size: 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".entity-docs-step-2 {\n\n    .section-1 {\n        span {\n            font-size: 20px !important;\n        }\n    }\n\n    .dropdown-blue-bold {\n        display: unset;\n        height: auto;\n    }\n\n    .dropdown-review-bold {\n        span {\n            text-decoration-line: underline;\n        }\n\n        color: $state-review !important;\n        display: unset;\n        padding: 0 !important;\n    }\n\n    .submits {\n        display: flex;\n        justify-content: space-between;\n        gap: 15px;\n\n        section {\n            width: 100%;\n        }\n    }\n}",".title-company-step-1 {\n  border-radius: 10px;\n  border: 1px solid #ccd3db;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px 24px 5px;\n  \n  .ant-form {\n    margin-top: 10px;\n    width: 100%;\n    height: auto;\n    display: grid;\n    grid-template-columns: 50% 5% 45%;\n    grid-template-areas: 'titleCompany titleCompany titleCompany'\n    'name name .'\n    'phone . email'\n    'submit submit submit';\n  }\n\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  &-REVIEW {\n    border: 1px solid $state-review-border;\n    background-color: $state-review-background-ligth;\n\n    .h4 {\n      color: $state-review-text !important;\n    }\n\n    .description {\n      color: $state-review-text !important;\n    }\n\n    .link {\n      color: $state-review-text !important;\n    }\n  }\n\n  &-APPROVED {\n    border: 1px solid $state-approved-border;\n    background-color: $state-approved-background-ligth;\n\n    .h4 {\n      color: $state-approved-text !important;\n    }\n\n    .description {\n      color: $state-approved-text !important;\n    }\n\n    .link {\n      color: $state-approved-text !important;\n    }\n  }\n\n  &-REQUEST_ERROR {\n    border: 1px solid $state-error-border;\n    background-color: $state-error-background-ligth;\n\n    .h4 {\n      color: $state-error-text !important;\n    }\n\n    .description {\n      color: $state-error-text !important;\n    }\n\n    .link {\n      color: $state-error-text !important;\n    }\n  }\n\n  .ant-form-item-row {\n    display: block;\n  }\n\n  .ant-form-item-label {\n    text-align: start;\n    height: 27px;\n\n    label {\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 14.52px;\n      color: $grey-text-op;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: 20px;\n  }\n\n  .ant-form-item {\n    margin-bottom: 15px;\n  }\n\n  .titleCompany {\n    input {\n      font-size: 16px !important;\n    }\n\n    grid-area: titleCompany;\n  }\n\n  .name {\n    grid-area: name;\n  }\n\n  .phone {\n    grid-area: phone;\n  }\n\n  .email {\n    grid-area: email;\n  }\n\n  .submit {\n    grid-area: submit;\n\n    button {\n      border-radius: 6px;\n    }\n  }\n}",".insurance-step-2 {\n    .ant-collapse-header-text {\n        max-width: 335px;\n        margin-inline-end: unset !important;\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n    }\n\n    .ant-collapse-expand-icon {\n        padding-inline-start: 0px !important;\n    }\n}",".payoff-footer {\n    .dropdown-blue-bold {\n        display: unset;\n        padding: 0 !important;\n        border: none !important;\n        span {\n            background-color: white !important;\n            color: $button-blue !important;\n            padding: 0 !important;\n            font-size: 24px !important;\n        }\n    }\n\n    .is-review {\n        color: $state-review !important;\n      }\n}","\n.purchase-footer {\n  .owners-tags {\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n\n    .circles-tags {\n      display: flex;\n      align-items: end;\n      gap: 10px;\n    }\n\n    .circle {\n      width: 20px;\n      height: 20px;\n\n      &-APPROVED {\n        border-color: $state-approved-border;\n        background-color: $state-approved-background;\n      }\n\n      &-REVIEW {\n        background-color: $state-review-border;\n        border-color: $state-review;\n      }\n\n      &-REQUEST_ERROR {\n        background-color: $state-error-background;\n        border-color: $state-error-border;\n      }\n    }\n  }\n  }\n",".InputUploadedFile {\n  .file-ok {\n    margin: 10px 0;\n    .file {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      &-content {\n        height: 28px;\n        border-radius: 10px;\n        border: 1px solid #2a2f3c;\n        background-color: #f9fafb;\n        width: 100%;\n        padding: 0 20px;\n        padding-right: 12px;\n\n        &-approved {\n          border: 1px solid $state-approved-border !important;\n          background: $state-approved !important;\n        }\n\n        &-request_error {\n          border: 1px solid $state-error-border;\n          background: $state-error !important;\n          .name,\n          .anticon {\n            color: $state-error-icon !important;\n          }\n        }\n        &-review {\n          border: 1px solid $state-review-border !important;\n          background: $state-review-background !important;\n          .name,\n          .anticon {\n            color: $state-review-dark !important;\n          }\n        }\n      }\n      \n      .file-name {\n        width: 80%;\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        gap: 7px;\n        .name {\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden; \n          line-height: 1.2;\n        }\n        .anticon {\n          font-size: 15px;\n        }\n      }\n      .content-buttons {\n        display: flex;\n        justify-content: end;\n        align-items: center;\n        gap: 7px;\n        .anticon {\n          font-size: 15px;\n        }\n        button {\n          height: auto;\n          &:hover {\n            background-color: transparent;\n          }\n        }\n      }\n      .flex {\n        width: 80%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100%;\n        gap: 12px;\n        &:first-child {\n          gap: 4px;\n        }\n      }\n      .upload {\n        margin-bottom: 0;\n      }\n      .flex-btw {\n        margin-bottom: 0;\n        height: 100%;\n        border-bottom: none;\n      }\n      .circle-input {\n        background-color: #fff;\n        width: 18px;\n        height: 18px;\n        border-radius: 50%;\n        border: 1px solid #2a2f3c;\n        display: flex;\n        position: absolute;\n        left: 0;\n        justify-content: center;\n        align-items: center;\n        .upload {\n          width: auto;\n          height: 20px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n}\n",".MinimumLiquidity {\n  padding-bottom: 30px;\n  .h4 {\n    color: #404859 !important;\n  }\n  .divider-top {\n    padding-top: 10px;\n  }\n  .h4-error {\n    color: #8F2F2C !important;\n    margin-bottom: 7px;\n    span {\n      font-weight: 400 !important;\n    }\n  }\n}\n",".AddAdditionalDocument {\n  .UploadDocs {\n    &--container {\n      .input-content {\n        height: 80px;\n        input {\n          height: 80px;\n        }\n      }\n    }\n  }\n  .button {\n    &-transparent {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      font-size: 16px;\n    }\n  }\n  .InputBorderNone {\n    .input {\n      margin-bottom: 6px;\n    }\n  }\n}\n\n.link-add-additional-document {\n  &:hover {\n    color: #355C7D !important;\n\n    path {\n      stroke: #355C7D !important;\n    }\n  }\n}\n",".modal-end-submit {\n  border-radius: 10px;\n  border: 1px solid #FFC857;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0;\n  width: 556px !important;\n  top: 202px !important;\n  .ant-checkbox-checked {\n    .ant-checkbox-inner {\n      background-color: #162e43 !important;\n      border-color: #162e43 !important;\n    }\n  }\n  .coin {\n    width: 49.334px;\n    height: 34px;\n  }\n  .ant-modal-content {\n    background-color: transparent;\n    padding: 32px;\n    .h2 {\n      margin-top: 15px;\n      margin-bottom: 5px;\n    }\n    .h4 {\n      color: #66564d;\n    }\n    .divider {\n      border-top: 1px solid #ddaa42;\n      padding-top: 20px;\n      margin-top: 26px;\n    }\n    .buttons {\n      margin-top: 25px;\n    }\n    .button {\n      margin-top: 16px;\n      height: 40px !important;\n    }\n    .ant-modal-footer {\n      display: none;\n    }\n  }\n  .anticon {\n    color: #997120;\n  }\n  .ant-checkbox-wrapper {\n    margin-top: 10px;\n    span {\n      color: #244560;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: 0.18px;\n    }\n  }\n  &--white {\n    background: #fff;\n    border-color: #fff;\n    .anticon {\n      color: #6e7889;\n    }\n    .ant-modal-content {\n      .h2 {\n        color: #162e43;\n      }\n      .h4 {\n        color: #48759a;\n      }\n      .buttons {\n        .button-modal-ok {\n          border-radius: 6px;\n          border: 1px solid $button-primary-border !important;\n          background: $button-primary-background !important;\n          color: #ffffff !important;\n\n          &:hover {\n            background-color: $button-primary-hover-background !important;\n            border: 1px solid $button-primary-hover-border !important;\n            box-shadow: 2px 2px 12px 0px #0B131A1A;\n      \n            span {\n              color: #355D7D !important;\n            }\n\n            &:active {\n              border: 1px solid $button-primary-active-border !important;\n              box-shadow: none;\n            }\n          }\n        }\n        .button-modal-cancel {\n          border: 1px solid #162e43 !important;\n          background: #fff !important;\n          color: #162e43 !important;\n        }\n      }\n    }\n  }\n}\n",".view-change-password {\n  .ant-form-item {\n    margin-bottom: 15px;\n  }\n\n  .button {\n    margin-top: 50px !important;\n    span {\n      font-weight: 600;\n      font-size: 16px;\n    }\n  }\n\n  .description {\n    font-weight: 400;\n    font-size: 20px;\n    color: $state-draft-hover;\n  }\n  \n  .link {\n    padding: 0;\n\n    &:hover {\n      color: $state-draft-hover !important;\n    }\n  }\n}\n",".ResetPassword {\n  .message-error {\n    color: $state-error-dark;\n    margin-bottom: 10px;\n  }\n\n  .ant-form-item {\n    margin-bottom: 10px;\n  }\n\n  button {\n    margin-top: 60px !important;\n  }\n}\n","@keyframes horizontal-shaking {\n    0% { transform: translateX(0); }\n    25% { transform: translateX(-3px); }\n    50% { transform: translateX(3px); }\n    75% { transform: translateX(-1px); }\n    100% { transform: translateX(1px); }\n  }\n  ",".Login {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 56px);\n  &-form,\n  .rigth {\n    width: 50%;\n  }\n  &-form {\n    padding: 32px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    .coin {\n      margin-bottom: 13px;\n    }\n    .h1 {\n      margin-bottom: 24px;\n    }\n    .ant-form {\n      width: 100%;\n    }\n    .error-message {\n      margin-top: 50px;\n      color: $red-warning;\n    }\n    .button {\n      margin-top: 10px;\n    }\n    .link {\n      &:hover {\n        color: #404859;\n      }\n      .body-regular-bold {\n        text-decoration: underline;\n      }\n    }\n    .link-absolute {\n      position: absolute;\n      bottom: 30px;\n      left: 32px;\n      text-decoration: none;\n      .body-regular-bold {\n        text-decoration: underline;\n      }\n    }\n  }\n  .rigth {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    padding-left: 60px;\n    padding-top: 64px;\n    background-color: #f9fafb;\n    .bottom-flex {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      max-width: 700px;\n    }\n    .h2 {\n      margin-bottom: 12px;\n      max-width: 520px;\n    }\n    .body-regular {\n      max-width: 520px;\n      margin-bottom: 30px;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 125%;\n      color: #777b83;\n    }\n    .back {\n      padding: 7px;\n      padding-bottom: 0;\n      padding-right: 0;\n      // position: absolute;\n      // bottom: 0;\n      // right: 0;\n      background-color: #355c7d;\n      border-top-left-radius: 10px;\n      width: 100%;\n      // max-height: 450px;\n      // max-width: 600px;\n    }\n    img {\n      bottom: 0;\n      width: 100%;\n      // max-height: 441px;\n    }\n  }\n\n  @media (min-height: 735px) {\n    .bottom-flex {\n      height: 470px;\n      img {\n        height: 100%;\n        // object-fit: cover;\n      }\n    }\n  }\n}\n",".Dashboard {\n  &--container {\n    display: flex;\n  }\n\n  &__column {\n    width: 100%;\n  }\n\n  &__label {\n    padding: 12px 32px;\n    padding-top: 0;\n    border-bottom: 1px solid grey-border;\n\n    .body-small {\n      font-size: 14px !important;\n    }\n  }\n\n  &__head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0px 32px;\n    height: 153px;\n\n    .box-title {\n      .red-title {\n        color: $red-title;\n        font-family: Inter;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 16px;\n        letter-spacing: 0.36px;\n        margin-bottom: 5px;\n      }\n    }\n\n    .body-regular {\n      margin-bottom: 5px;\n    }\n\n    .body-small {\n      margin-top: 5px;\n      font-size: 14px !important;\n    }\n\n    .content-progress {\n      display: flex;\n      gap: 19px;\n      align-items: flex-start;\n      justify-content: flex-start;\n    }\n\n    &-tabs {\n      height: auto;\n      margin-bottom: 20px;\n    }\n  }\n\n  .content-link {\n    padding: 0 32px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-bottom: 10px;\n\n    .cont-modal {\n      width: auto !important;\n    }\n\n    .link {\n      text-decoration: none;\n      color: #5e8eb7;\n      display: flex;\n      align-items: center;\n\n      .plus {\n        margin-right: 8px;\n      }\n    }\n  }\n\n  .content-flex-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 24px;\n    width: 100%;\n    padding: 0px 32px;\n  }\n\n  .first-section {\n    padding-top: 32px;\n    padding-bottom: 32px;\n    \n    &-DONE {\n      background-color: #FAFCFA;\n\n      .h2 {\n        color: $state-approved-title-dark;\n      }\n\n      .red-title {\n        color: $state-approved-title-dark;\n      }\n    }\n  }\n\n  .second-section {\n    padding-top: 32px;\n    padding-bottom: 32px;\n    border-top: 1px solid #CCD3DB;\n    \n    &-DO_LATER {\n      border-top: 1px solid #CCD3DB;\n      background-color: #F9FAFB;\n\n      .h2 {\n        color: #6E7889;\n      }\n\n      .red-title {\n        color: #6E7889;\n      }\n    }\n\n    &-DONE {\n      background-color: #FAFCFA;\n      border-top: 1px solid #91D997;\n\n      .h2 {\n        color: $state-approved-title-dark;\n      }\n\n      .red-title {\n        color: $state-approved-title-dark;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
